import { createNS } from "@ontologies/core";
/** Function to create arbitrary terms within the 'Schema.org' ontology */
export const ns = createNS("http://schema.org/");
/** A radio channel that uses AM. */
export const AMRadioChannel = ns("AMRadioChannel");
/** Reference documentation for application programming interfaces (APIs). */
export const APIReference = ns("APIReference");
/** Web page type: About page. */
export const AboutPage = ns("AboutPage");
/** The act of committing to/adopting an object.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/RejectAction">RejectAction</a>: The antonym of AcceptAction.</li>
</ul>
 */
export const AcceptAction = ns("AcceptAction");
/** An accommodation is a place that can accommodate human beings, e.g. a hotel room, a camping pitch, or a meeting room. Many accommodations are for overnight stays, but this is not a mandatory requirement.
For more specific types of accommodations not defined in schema.org, one can use additionalType with external vocabularies.
<br /><br />
See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const Accommodation = ns("Accommodation");
/** Accountancy business.<br/><br/>

As a <a class="localLink" href="http://schema.org/LocalBusiness">LocalBusiness</a> it can be described as a <a class="localLink" href="http://schema.org/provider">provider</a> of one or more <a class="localLink" href="http://schema.org/Service">Service</a>(s). */
export const AccountingService = ns("AccountingService");
/** The act of accomplishing something via previous efforts. It is an instantaneous action rather than an ongoing process. */
export const AchieveAction = ns("AchieveAction");
/** An action performed by a direct agent and indirect participants upon a direct object. Optionally happens at a location with the help of an inanimate instrument. The execution of the action may produce a result. Specific action sub-type documentation specifies the exact expectation of each argument/role.<br/><br/>

See also <a href="http://blog.schema.org/2014/04/announcing-schemaorg-actions.html">blog post</a> and <a href="http://schema.org/docs/actions.html">Actions overview document</a>. */
export const Action = ns("Action");
/** A set of requirements that a must be fulfilled in order to perform an Action. */
export const ActionAccessSpecification = ns("ActionAccessSpecification");
/** The status of an Action. */
export const ActionStatusType = ns("ActionStatusType");
/** The act of starting or activating a device or application (e.g. starting a timer or turning on a flashlight). */
export const ActivateAction = ns("ActivateAction");
/** The act of editing by adding an object to a collection. */
export const AddAction = ns("AddAction");
/** A geographical region, typically under the jurisdiction of a particular government. */
export const AdministrativeArea = ns("AdministrativeArea");
/** An adult entertainment establishment. */
export const AdultEntertainment = ns("AdultEntertainment");
/** When a single product is associated with multiple offers (for example, the same pair of shoes is offered by different merchants), then AggregateOffer can be used. */
export const AggregateOffer = ns("AggregateOffer");
/** The average rating based on multiple ratings or reviews. */
export const AggregateRating = ns("AggregateRating");
/** The act of expressing a consistency of opinion with the object. An agent agrees to/about an object (a proposition, topic or theme) with participants. */
export const AgreeAction = ns("AgreeAction");
/** An organization that provides flights for passengers. */
export const Airline = ns("Airline");
/** An airport. */
export const Airport = ns("Airport");
/** An intangible item that describes an alignment between a learning resource and a node in an educational framework. */
export const AlignmentObject = ns("AlignmentObject");
/** The act of organizing tasks/objects/events by associating resources to it. */
export const AllocateAction = ns("AllocateAction");
/** An amusement park. */
export const AmusementPark = ns("AmusementPark");
/** Animal shelter. */
export const AnimalShelter = ns("AnimalShelter");
/** An answer offered to a question; perhaps correct, perhaps opinionated or wrong. */
export const Answer = ns("Answer");
/** An apartment (in American English) or flat (in British English) is a self-contained housing unit (a type of residential real estate) that occupies only part of a building (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/Apartment">http://en.wikipedia.org/wiki/Apartment</a>). */
export const Apartment = ns("Apartment");
/** Residence type: Apartment complex. */
export const ApartmentComplex = ns("ApartmentComplex");
/** The act of inserting at the end if an ordered collection. */
export const AppendAction = ns("AppendAction");
/** The act of registering to an organization/service without the guarantee to receive it.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/RegisterAction">RegisterAction</a>: Unlike RegisterAction, ApplyAction has no guarantees that the application will be accepted.</li>
</ul>
 */
export const ApplyAction = ns("ApplyAction");
/** Aquarium. */
export const Aquarium = ns("Aquarium");
/** The act of arriving at a place. An agent arrives at a destination from a fromLocation, optionally with participants. */
export const ArriveAction = ns("ArriveAction");
/** An art gallery. */
export const ArtGallery = ns("ArtGallery");
/** An article, such as a news article or piece of investigative report. Newspapers and magazines have articles of many different types and this is intended to cover them all.<br/><br/>

See also <a href="http://blog.schema.org/2014/09/schemaorg-support-for-bibliographic_2.html">blog post</a>. */
export const Article = ns("Article");
/** The act of posing a question / favor to someone.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/ReplyAction">ReplyAction</a>: Appears generally as a response to AskAction.</li>
</ul>
 */
export const AskAction = ns("AskAction");
/** The act of forming one's opinion, reaction or sentiment. */
export const AssessAction = ns("AssessAction");
/** The act of allocating an action/event/task to some destination (someone or something). */
export const AssignAction = ns("AssignAction");
/** Professional service: Attorney. <br/><br/>

This type is deprecated - <a class="localLink" href="http://schema.org/LegalService">LegalService</a> is more inclusive and less ambiguous. */
export const Attorney = ns("Attorney");
/** Intended audience for an item, i.e. the group for whom the item was created. */
export const Audience = ns("Audience");
/** An audio file. */
export const AudioObject = ns("AudioObject");
/** The act of granting permission to an object. */
export const AuthorizeAction = ns("AuthorizeAction");
/** Auto body shop. */
export const AutoBodyShop = ns("AutoBodyShop");
/** An car dealership. */
export const AutoDealer = ns("AutoDealer");
/** An auto parts store. */
export const AutoPartsStore = ns("AutoPartsStore");
/** A car rental business. */
export const AutoRental = ns("AutoRental");
/** Car repair business. */
export const AutoRepair = ns("AutoRepair");
/** A car wash business. */
export const AutoWash = ns("AutoWash");
/** ATM/cash machine. */
export const AutomatedTeller = ns("AutomatedTeller");
/** Car repair, sales, or parts. */
export const AutomotiveBusiness = ns("AutomotiveBusiness");
/** A bakery. */
export const Bakery = ns("Bakery");
/** A product or service offered by a bank whereby one may deposit, withdraw or transfer money and in some cases be paid interest. */
export const BankAccount = ns("BankAccount");
/** Bank or credit union. */
export const BankOrCreditUnion = ns("BankOrCreditUnion");
/** A bar or pub. */
export const BarOrPub = ns("BarOrPub");
/** An image of a visual machine-readable code such as a barcode or QR code. */
export const Barcode = ns("Barcode");
/** Beach. */
export const Beach = ns("Beach");
/** Beauty salon. */
export const BeautySalon = ns("BeautySalon");
/** Bed and breakfast.
<br /><br />
See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const BedAndBreakfast = ns("BedAndBreakfast");
/** An entity holding detailed information about the available bed types, e.g. the quantity of twin beds for a hotel room. For the single case of just one bed of a certain type, you can use bed directly with a text. See also <a class="localLink" href="http://schema.org/BedType">BedType</a> (under development). */
export const BedDetails = ns("BedDetails");
/** A type of bed. This is used for indicating the bed or beds available in an accommodation. */
export const BedType = ns("BedType");
/** The act of forming a personal connection with someone (object) mutually/bidirectionally/symmetrically.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/FollowAction">FollowAction</a>: Unlike FollowAction, BefriendAction implies that the connection is reciprocal.</li>
</ul>
 */
export const BefriendAction = ns("BefriendAction");
/** A bike store. */
export const BikeStore = ns("BikeStore");
/** A blog. */
export const Blog = ns("Blog");
/** A blog post. */
export const BlogPosting = ns("BlogPosting");
/** A type of boarding policy used by an airline. */
export const BoardingPolicyType = ns("BoardingPolicyType");
/** A body of water, such as a sea, ocean, or lake. */
export const BodyOfWater = ns("BodyOfWater");
/** A book. */
export const Book = ns("Book");
/** The publication format of the book. */
export const BookFormatType = ns("BookFormatType");
/** A series of books. Included books can be indicated with the hasPart property. */
export const BookSeries = ns("BookSeries");
/** A bookstore. */
export const BookStore = ns("BookStore");
/** An agent bookmarks/flags/labels/tags/marks an object. */
export const BookmarkAction = ns("BookmarkAction");
/** Boolean: True or False. */
export const Boolean = ns("Boolean");
/** The act of obtaining an object under an agreement to return it at a later date. Reciprocal of LendAction.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/LendAction">LendAction</a>: Reciprocal of BorrowAction.</li>
</ul>
 */
export const BorrowAction = ns("BorrowAction");
/** A bowling alley. */
export const BowlingAlley = ns("BowlingAlley");
/** A brand is a name used by an organization or business person for labeling a product, product group, or similar. */
export const Brand = ns("Brand");
/** A BreadcrumbList is an ItemList consisting of a chain of linked Web pages, typically described using at least their URL and their name, and typically ending with the current page.<br/><br/>

The <a class="localLink" href="http://schema.org/position">position</a> property is used to reconstruct the order of the items in a BreadcrumbList The convention is that a breadcrumb list has an <a class="localLink" href="http://schema.org/itemListOrder">itemListOrder</a> of <a class="localLink" href="http://schema.org/ItemListOrderAscending">ItemListOrderAscending</a> (lower values listed first), and that the first items in this list correspond to the "top" or beginning of the breadcrumb trail, e.g. with a site or section homepage. The specific values of 'position' are not assigned meaning for a BreadcrumbList, but they should be integers, e.g. beginning with '1' for the first item in the list. */
export const BreadcrumbList = ns("BreadcrumbList");
/** Brewery. */
export const Brewery = ns("Brewery");
/** A bridge. */
export const Bridge = ns("Bridge");
/** A unique instance of a BroadcastService on a CableOrSatelliteService lineup. */
export const BroadcastChannel = ns("BroadcastChannel");
/** An over the air or online broadcast event. */
export const BroadcastEvent = ns("BroadcastEvent");
/** The frequency in MHz and the modulation used for a particular BroadcastService. */
export const BroadcastFrequencySpecification = ns("BroadcastFrequencySpecification");
/** A delivery service through which content is provided via broadcast over the air or online. */
export const BroadcastService = ns("BroadcastService");
/** A Buddhist temple. */
export const BuddhistTemple = ns("BuddhistTemple");
/** A reservation for bus travel. <br/><br/>

Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
export const BusReservation = ns("BusReservation");
/** A bus station. */
export const BusStation = ns("BusStation");
/** A bus stop. */
export const BusStop = ns("BusStop");
/** A trip on a commercial bus line. */
export const BusTrip = ns("BusTrip");
/** A set of characteristics belonging to businesses, e.g. who compose an item's target audience. */
export const BusinessAudience = ns("BusinessAudience");
/** A business entity type is a conceptual entity representing the legal form, the size, the main line of business, the position in the value chain, or any combination thereof, of an organization or business person.<br/><br/>

Commonly used values:<br/><br/>

<ul>
<li>http://purl.org/goodrelations/v1#Business</li>
<li>http://purl.org/goodrelations/v1#Enduser</li>
<li>http://purl.org/goodrelations/v1#PublicInstitution</li>
<li>http://purl.org/goodrelations/v1#Reseller</li>
</ul>
 */
export const BusinessEntityType = ns("BusinessEntityType");
/** Event type: Business event. */
export const BusinessEvent = ns("BusinessEvent");
/** The business function specifies the type of activity or access (i.e., the bundle of rights) offered by the organization or business person through the offer. Typical are sell, rental or lease, maintenance or repair, manufacture / produce, recycle / dispose, engineering / construction, or installation. Proprietary specifications of access rights are also instances of this class.<br/><br/>

Commonly used values:<br/><br/>

<ul>
<li>http://purl.org/goodrelations/v1#ConstructionInstallation</li>
<li>http://purl.org/goodrelations/v1#Dispose</li>
<li>http://purl.org/goodrelations/v1#LeaseOut</li>
<li>http://purl.org/goodrelations/v1#Maintain</li>
<li>http://purl.org/goodrelations/v1#ProvideService</li>
<li>http://purl.org/goodrelations/v1#Repair</li>
<li>http://purl.org/goodrelations/v1#Sell</li>
<li>http://purl.org/goodrelations/v1#Buy</li>
</ul>
 */
export const BusinessFunction = ns("BusinessFunction");
/** The act of giving money to a seller in exchange for goods or services rendered. An agent buys an object, product, or service from a seller for a price. Reciprocal of SellAction. */
export const BuyAction = ns("BuyAction");
/** A service which provides access to media programming like TV or radio. Access may be via cable or satellite. */
export const CableOrSatelliteService = ns("CableOrSatelliteService");
/** A cafe or coffee shop. */
export const CafeOrCoffeeShop = ns("CafeOrCoffeeShop");
/** A camping site, campsite, or <a class="localLink" href="http://schema.org/Campground">Campground</a> is a place used for overnight stay in the outdoors, typically containing individual <a class="localLink" href="http://schema.org/CampingPitch">CampingPitch</a> locations. <br/><br/>

In British English a campsite is an area, usually divided into a number of pitches, where people can camp overnight using tents or camper vans or caravans; this British English use of the word is synonymous with the American English expression campground. In American English the term campsite generally means an area where an individual, family, group, or military unit can pitch a tent or park a camper; a campground may contain many campsites (Source: Wikipedia see <a href="https://en.wikipedia.org/wiki/Campsite">https://en.wikipedia.org/wiki/Campsite</a>).<br/><br/>

See also the dedicated <a href="/docs/hotels.html">document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const Campground = ns("Campground");
/** A <a class="localLink" href="http://schema.org/CampingPitch">CampingPitch</a> is an individual place for overnight stay in the outdoors, typically being part of a larger camping site, or <a class="localLink" href="http://schema.org/Campground">Campground</a>.<br/><br/>

In British English a campsite, or campground, is an area, usually divided into a number of pitches, where people can camp overnight using tents or camper vans or caravans; this British English use of the word is synonymous with the American English expression campground. In American English the term campsite generally means an area where an individual, family, group, or military unit can pitch a tent or park a camper; a campground may contain many campsites.
(Source: Wikipedia see <a href="https://en.wikipedia.org/wiki/Campsite">https://en.wikipedia.org/wiki/Campsite</a>).<br/><br/>

See also the dedicated <a href="/docs/hotels.html">document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const CampingPitch = ns("CampingPitch");
/** A canal, like the Panama Canal. */
export const Canal = ns("Canal");
/** The act of asserting that a future event/action is no longer going to happen.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/ConfirmAction">ConfirmAction</a>: The antonym of CancelAction.</li>
</ul>
 */
export const CancelAction = ns("CancelAction");
/** A car is a wheeled, self-powered motor vehicle used for transportation. */
export const Car = ns("Car");
/** A casino. */
export const Casino = ns("Casino");
/** A Catholic church. */
export const CatholicChurch = ns("CatholicChurch");
/** A graveyard. */
export const Cemetery = ns("Cemetery");
/** An agent inspects, determines, investigates, inquires, or examines an object's accuracy, quality, condition, or state. */
export const CheckAction = ns("CheckAction");
/** The act of an agent communicating (service provider, social media, etc) their arrival by registering/confirming for a previously reserved service (e.g. flight check in) or at a place (e.g. hotel), possibly resulting in a result (boarding pass, etc).<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/CheckOutAction">CheckOutAction</a>: The antonym of CheckInAction.</li>
<li><a class="localLink" href="http://schema.org/ArriveAction">ArriveAction</a>: Unlike ArriveAction, CheckInAction implies that the agent is informing/confirming the start of a previously reserved service.</li>
<li><a class="localLink" href="http://schema.org/ConfirmAction">ConfirmAction</a>: Unlike ConfirmAction, CheckInAction implies that the agent is informing/confirming the <em>start</em> of a previously reserved service rather than its validity/existence.</li>
</ul>
 */
export const CheckInAction = ns("CheckInAction");
/** The act of an agent communicating (service provider, social media, etc) their departure of a previously reserved service (e.g. flight check in) or place (e.g. hotel).<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/CheckInAction">CheckInAction</a>: The antonym of CheckOutAction.</li>
<li><a class="localLink" href="http://schema.org/DepartAction">DepartAction</a>: Unlike DepartAction, CheckOutAction implies that the agent is informing/confirming the end of a previously reserved service.</li>
<li><a class="localLink" href="http://schema.org/CancelAction">CancelAction</a>: Unlike CancelAction, CheckOutAction implies that the agent is informing/confirming the end of a previously reserved service.</li>
</ul>
 */
export const CheckOutAction = ns("CheckOutAction");
/** Web page type: Checkout page. */
export const CheckoutPage = ns("CheckoutPage");
/** A Childcare center. */
export const ChildCare = ns("ChildCare");
/** Event type: Children's event. */
export const ChildrensEvent = ns("ChildrensEvent");
/** The act of expressing a preference from a set of options or a large or unbounded set of choices/options. */
export const ChooseAction = ns("ChooseAction");
/** A church. */
export const Church = ns("Church");
/** A city or town. */
export const City = ns("City");
/** A city hall. */
export const CityHall = ns("CityHall");
/** A public structure, such as a town hall or concert hall. */
export const CivicStructure = ns("CivicStructure");
/** A fact-checking review of claims made (or reported) in some creative work (referenced via itemReviewed). */
export const ClaimReview = ns("ClaimReview");
/** A short TV or radio program or a segment/part of a program. */
export const Clip = ns("Clip");
/** A clothing store. */
export const ClothingStore = ns("ClothingStore");
/** Computer programming source code. Example: Full (compile ready) solutions, code snippet samples, scripts, templates. */
export const Code = ns("Code");
/** Web page type: Collection page. */
export const CollectionPage = ns("CollectionPage");
/** A college, university, or other third-level educational institution. */
export const CollegeOrUniversity = ns("CollegeOrUniversity");
/** A comedy club. */
export const ComedyClub = ns("ComedyClub");
/** Event type: Comedy event. */
export const ComedyEvent = ns("ComedyEvent");
/** A comment on an item - for example, a comment on a blog post. The comment's content is expressed via the <a class="localLink" href="http://schema.org/text">text</a> property, and its topic via <a class="localLink" href="http://schema.org/about">about</a>, properties shared with all CreativeWorks. */
export const Comment = ns("Comment");
/** The act of generating a comment about a subject. */
export const CommentAction = ns("CommentAction");
/** The act of conveying information to another person via a communication medium (instrument) such as speech, email, or telephone conversation. */
export const CommunicateAction = ns("CommunicateAction");
/** A compound price specification is one that bundles multiple prices that all apply in combination for different dimensions of consumption. Use the name property of the attached unit price specification for indicating the dimension of a price component (e.g. "electricity" or "final cleaning"). */
export const CompoundPriceSpecification = ns("CompoundPriceSpecification");
/** This type covers computer programming languages such as Scheme and Lisp, as well as other language-like computer representations. Natural languages are best represented with the <a class="localLink" href="http://schema.org/Language">Language</a> type. */
export const ComputerLanguage = ns("ComputerLanguage");
/** A computer store. */
export const ComputerStore = ns("ComputerStore");
/** The act of notifying someone that a future event/action is going to happen as expected.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/CancelAction">CancelAction</a>: The antonym of ConfirmAction.</li>
</ul>
 */
export const ConfirmAction = ns("ConfirmAction");
/** The act of ingesting information/resources/food. */
export const ConsumeAction = ns("ConsumeAction");
/** Web page type: Contact page. */
export const ContactPage = ns("ContactPage");
/** A contact point&#x2014;for example, a Customer Complaints department. */
export const ContactPoint = ns("ContactPoint");
/** Enumerated options related to a ContactPoint. */
export const ContactPointOption = ns("ContactPointOption");
/** One of the continents (for example, Europe or Africa). */
export const Continent = ns("Continent");
/** An agent controls a device or application. */
export const ControlAction = ns("ControlAction");
/** A convenience store. */
export const ConvenienceStore = ns("ConvenienceStore");
/** One or more messages between organizations or people on a particular topic. Individual messages can be linked to the conversation with isPartOf or hasPart properties. */
export const Conversation = ns("Conversation");
/** The act of producing/preparing food. */
export const CookAction = ns("CookAction");
/** Organization: A business corporation. */
export const Corporation = ns("Corporation");
/** A country. */
export const Country = ns("Country");
/** A description of an educational course which may be offered as distinct instances at which take place at different times or take place at different locations, or be offered through different media or modes of study. An educational course is a sequence of one or more educational events and/or creative works which aims to build knowledge, competence or ability of learners. */
export const Course = ns("Course");
/** An instance of a <a class="localLink" href="http://schema.org/Course">Course</a> which is distinct from other instances because it is offered at a different time or location or through different media or modes of study or to a specific section of students. */
export const CourseInstance = ns("CourseInstance");
/** A courthouse. */
export const Courthouse = ns("Courthouse");
/** The act of deliberately creating/producing/generating/building a result out of the agent. */
export const CreateAction = ns("CreateAction");
/** The most generic kind of creative work, including books, movies, photographs, software programs, etc. */
export const CreativeWork = ns("CreativeWork");
/** A media season e.g. tv, radio, video game etc. */
export const CreativeWorkSeason = ns("CreativeWorkSeason");
/** A CreativeWorkSeries in schema.org is a group of related items, typically but not necessarily of the same kind. CreativeWorkSeries are usually organized into some order, often chronological. Unlike <a class="localLink" href="http://schema.org/ItemList">ItemList</a> which is a general purpose data structure for lists of things, the emphasis with CreativeWorkSeries is on published materials (written e.g. books and periodicals, or media such as tv, radio and games).<br/><br/>

Specific subtypes are available for describing <a class="localLink" href="http://schema.org/TVSeries">TVSeries</a>, <a class="localLink" href="http://schema.org/RadioSeries">RadioSeries</a>, <a class="localLink" href="http://schema.org/MovieSeries">MovieSeries</a>, <a class="localLink" href="http://schema.org/BookSeries">BookSeries</a>, <a class="localLink" href="http://schema.org/Periodical">Periodical</a> and <a class="localLink" href="http://schema.org/VideoGameSeries">VideoGameSeries</a>. In each case, the <a class="localLink" href="http://schema.org/hasPart">hasPart</a> / <a class="localLink" href="http://schema.org/isPartOf">isPartOf</a> properties can be used to relate the CreativeWorkSeries to its parts. The general CreativeWorkSeries type serves largely just to organize these more specific and practical subtypes.<br/><br/>

It is common for properties applicable to an item from the series to be usefully applied to the containing group. Schema.org attempts to anticipate some of these cases, but publishers should be free to apply properties of the series parts to the series as a whole wherever they seem appropriate. */
export const CreativeWorkSeries = ns("CreativeWorkSeries");
/** A card payment method of a particular brand or name.  Used to mark up a particular payment method and/or the financial product/service that supplies the card account.<br/><br/>

Commonly used values:<br/><br/>

<ul>
<li>http://purl.org/goodrelations/v1#AmericanExpress</li>
<li>http://purl.org/goodrelations/v1#DinersClub</li>
<li>http://purl.org/goodrelations/v1#Discover</li>
<li>http://purl.org/goodrelations/v1#JCB</li>
<li>http://purl.org/goodrelations/v1#MasterCard</li>
<li>http://purl.org/goodrelations/v1#VISA</li>
</ul>
 */
export const CreditCard = ns("CreditCard");
/** A crematorium. */
export const Crematorium = ns("Crematorium");
/** A service to convert funds from one currency to another currency. */
export const CurrencyConversionService = ns("CurrencyConversionService");
/** Event type: A social dance. */
export const DanceEvent = ns("DanceEvent");
/** A dance group&#x2014;for example, the Alvin Ailey Dance Theater or Riverdance. */
export const DanceGroup = ns("DanceGroup");
/** A collection of datasets. */
export const DataCatalog = ns("DataCatalog");
/** A dataset in downloadable form. */
export const DataDownload = ns("DataDownload");
/** A single feed providing structured information about one or more entities or topics. */
export const DataFeed = ns("DataFeed");
/** A single item within a larger data feed. */
export const DataFeedItem = ns("DataFeedItem");
/** The basic data types such as Integers, Strings, etc. */
export const DataType = ns("DataType");
/** A body of structured information describing some topic(s) of interest. */
export const Dataset = ns("Dataset");
/** A date value in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 date format</a>. */
export const Date = ns("Date");
/** A combination of date and time of day in the form [-]CCYY-MM-DDThh:mm:ss[Z|(+|-)hh:mm] (see Chapter 5.4 of ISO 8601). */
export const DateTime = ns("DateTime");
/** A DatedMoneySpecification represents monetary values with optional start and end dates. For example, this could represent an employee's salary over a specific period of time. <strong>Note:</strong> This type has been superseded by <a class="localLink" href="http://schema.org/MonetaryAmount">MonetaryAmount</a> use of that type is recommended */
export const DatedMoneySpecification = ns("DatedMoneySpecification");
/** The day of the week, e.g. used to specify to which day the opening hours of an OpeningHoursSpecification refer.<br/><br/>

Originally, URLs from <a href="http://purl.org/goodrelations/v1">GoodRelations</a> were used (for <a class="localLink" href="http://schema.org/Monday">Monday</a>, <a class="localLink" href="http://schema.org/Tuesday">Tuesday</a>, <a class="localLink" href="http://schema.org/Wednesday">Wednesday</a>, <a class="localLink" href="http://schema.org/Thursday">Thursday</a>, <a class="localLink" href="http://schema.org/Friday">Friday</a>, <a class="localLink" href="http://schema.org/Saturday">Saturday</a>, <a class="localLink" href="http://schema.org/Sunday">Sunday</a> plus a special entry for <a class="localLink" href="http://schema.org/PublicHolidays">PublicHolidays</a>); these have now been integrated directly into schema.org. */
export const DayOfWeek = ns("DayOfWeek");
/** A day spa. */
export const DaySpa = ns("DaySpa");
/** The act of stopping or deactivating a device or application (e.g. stopping a timer or turning off a flashlight). */
export const DeactivateAction = ns("DeactivateAction");
/** A defence establishment, such as an army or navy base. */
export const DefenceEstablishment = ns("DefenceEstablishment");
/** The act of editing a recipient by removing one of its objects. */
export const DeleteAction = ns("DeleteAction");
/** The price for the delivery of an offer using a particular delivery method. */
export const DeliveryChargeSpecification = ns("DeliveryChargeSpecification");
/** An event involving the delivery of an item. */
export const DeliveryEvent = ns("DeliveryEvent");
/** A delivery method is a standardized procedure for transferring the product or service to the destination of fulfillment chosen by the customer. Delivery methods are characterized by the means of transportation used, and by the organization or group that is the contracting party for the sending organization or person.<br/><br/>

Commonly used values:<br/><br/>

<ul>
<li>http://purl.org/goodrelations/v1#DeliveryModeDirectDownload</li>
<li>http://purl.org/goodrelations/v1#DeliveryModeFreight</li>
<li>http://purl.org/goodrelations/v1#DeliveryModeMail</li>
<li>http://purl.org/goodrelations/v1#DeliveryModeOwnFleet</li>
<li>http://purl.org/goodrelations/v1#DeliveryModePickUp</li>
<li>http://purl.org/goodrelations/v1#DHL</li>
<li>http://purl.org/goodrelations/v1#FederalExpress</li>
<li>http://purl.org/goodrelations/v1#UPS</li>
</ul>
 */
export const DeliveryMethod = ns("DeliveryMethod");
/** A demand entity represents the public, not necessarily binding, not necessarily exclusive, announcement by an organization or person to seek a certain type of goods or services. For describing demand using this type, the very same properties used for Offer apply. */
export const Demand = ns("Demand");
/** A dentist. */
export const Dentist = ns("Dentist");
/** The act of  departing from a place. An agent departs from an fromLocation for a destination, optionally with participants. */
export const DepartAction = ns("DepartAction");
/** A department store. */
export const DepartmentStore = ns("DepartmentStore");
/** A type of Bank Account with a main purpose of depositing funds to gain interest or other benefits. */
export const DepositAccount = ns("DepositAccount");
/** An electronic file or document. */
export const DigitalDocument = ns("DigitalDocument");
/** A permission for a particular person or group to access a particular file. */
export const DigitalDocumentPermission = ns("DigitalDocumentPermission");
/** A type of permission which can be granted for accessing a digital document. */
export const DigitalDocumentPermissionType = ns("DigitalDocumentPermissionType");
/** The act of expressing a difference of opinion with the object. An agent disagrees to/about an object (a proposition, topic or theme) with participants. */
export const DisagreeAction = ns("DisagreeAction");
/** The act of discovering/finding an object. */
export const DiscoverAction = ns("DiscoverAction");
/** A posting to a discussion forum. */
export const DiscussionForumPosting = ns("DiscussionForumPosting");
/** The act of expressing a negative sentiment about the object. An agent dislikes an object (a proposition, topic or theme) with participants. */
export const DislikeAction = ns("DislikeAction");
/** Properties that take Distances as values are of the form '&lt;Number&gt; &lt;Length unit of measure&gt;'. E.g., '7 ft'. */
export const Distance = ns("Distance");
/** A distillery. */
export const Distillery = ns("Distillery");
/** The act of providing goods, services, or money without compensation, often for philanthropic reasons. */
export const DonateAction = ns("DonateAction");
/** The act of downloading an object. */
export const DownloadAction = ns("DownloadAction");
/** The act of producing a visual/graphical representation of an object, typically with a pen/pencil and paper as instruments. */
export const DrawAction = ns("DrawAction");
/** The act of swallowing liquids. */
export const DrinkAction = ns("DrinkAction");
/** A value indicating which roadwheels will receive torque. */
export const DriveWheelConfigurationValue = ns("DriveWheelConfigurationValue");
/** A dry-cleaning business. */
export const DryCleaningOrLaundry = ns("DryCleaningOrLaundry");
/** Quantity: Duration (use <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 duration format</a>). */
export const Duration = ns("Duration");
/** The act of swallowing solid objects. */
export const EatAction = ns("EatAction");
/** Event type: Education event. */
export const EducationEvent = ns("EducationEvent");
/** An EducationalAudience. */
export const EducationalAudience = ns("EducationalAudience");
/** An educational organization. */
export const EducationalOrganization = ns("EducationalOrganization");
/** An electrician. */
export const Electrician = ns("Electrician");
/** An electronics store. */
export const ElectronicsStore = ns("ElectronicsStore");
/** An elementary school. */
export const ElementarySchool = ns("ElementarySchool");
/** An email message. */
export const EmailMessage = ns("EmailMessage");
/** An embassy. */
export const Embassy = ns("Embassy");
/** An emergency service, such as a fire station or ER. */
export const EmergencyService = ns("EmergencyService");
/** A subclass of OrganizationRole used to describe employee relationships. */
export const EmployeeRole = ns("EmployeeRole");
/** An aggregate rating of an Organization related to its role as an employer. */
export const EmployerAggregateRating = ns("EmployerAggregateRating");
/** An employment agency. */
export const EmploymentAgency = ns("EmploymentAgency");
/** An agent approves/certifies/likes/supports/sanction an object. */
export const EndorseAction = ns("EndorseAction");
/** An EndorsementRating is a rating that expresses some level of endorsement, for example inclusion in a "critic's pick" blog, a
"Like" or "+1" on a social network. It can be considered the <a class="localLink" href="http://schema.org/result">result</a> of an <a class="localLink" href="http://schema.org/EndorseAction">EndorseAction</a> in which the <a class="localLink" href="http://schema.org/object">object</a> of the action is rated positively by
some <a class="localLink" href="http://schema.org/agent">agent</a>. As is common elsewhere in schema.org, it is sometimes more useful to describe the results of such an action without explicitly describing the <a class="localLink" href="http://schema.org/Action">Action</a>.<br/><br/>

An <a class="localLink" href="http://schema.org/EndorsementRating">EndorsementRating</a> may be part of a numeric scale or organized system, but this is not required: having an explicit type for indicating a positive,
endorsement rating is particularly useful in the absence of numeric scales as it helps consumers understand that the rating is broadly positive. */
export const EndorsementRating = ns("EndorsementRating");
/** Properties that take Energy as values are of the form '&lt;Number&gt; &lt;Energy unit of measure&gt;'. */
export const Energy = ns("Energy");
/** Information about the engine of the vehicle. A vehicle can have multiple engines represented by multiple engine specification entities. */
export const EngineSpecification = ns("EngineSpecification");
/** A business providing entertainment. */
export const EntertainmentBusiness = ns("EntertainmentBusiness");
/** An entry point, within some Web-based protocol. */
export const EntryPoint = ns("EntryPoint");
/** Lists or enumerations—for example, a list of cuisines or music genres, etc. */
export const Enumeration = ns("Enumeration");
/** A media episode (e.g. TV, radio, video game) which can be part of a series or season. */
export const Episode = ns("Episode");
/** An event happening at a certain time and location, such as a concert, lecture, or festival. Ticketing information may be added via the <a class="localLink" href="http://schema.org/offers">offers</a> property. Repeated events may be structured as separate Event objects. */
export const Event = ns("Event");
/** A reservation for an event like a concert, sporting event, or lecture.<br/><br/>

Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
export const EventReservation = ns("EventReservation");
/** EventStatusType is an enumeration type whose instances represent several states that an Event may be in. */
export const EventStatusType = ns("EventStatusType");
/** An event venue. */
export const EventVenue = ns("EventVenue");
/** The act of participating in exertive activity for the purposes of improving health and fitness. */
export const ExerciseAction = ns("ExerciseAction");
/** A gym. */
export const ExerciseGym = ns("ExerciseGym");
/** Event type: Exhibition event, e.g. at a museum, library, archive, tradeshow, ... */
export const ExhibitionEvent = ns("ExhibitionEvent");
/** A <a class="localLink" href="http://schema.org/FAQPage">FAQPage</a> is a <a class="localLink" href="http://schema.org/WebPage">WebPage</a> presenting one or more "<a href="https://en.wikipedia.org/wiki/FAQ">Frequently asked questions</a>" (see also <a class="localLink" href="http://schema.org/QAPage">QAPage</a>). */
export const FAQPage = ns("FAQPage");
/** A radio channel that uses FM. */
export const FMRadioChannel = ns("FMRadioChannel");
/** A fast-food restaurant. */
export const FastFoodRestaurant = ns("FastFoodRestaurant");
/** Event type: Festival. */
export const Festival = ns("Festival");
/** The act of capturing sound and moving images on film, video, or digitally. */
export const FilmAction = ns("FilmAction");
/** A product provided to consumers and businesses by financial institutions such as banks, insurance companies, brokerage firms, consumer finance companies, and investment companies which comprise the financial services industry. */
export const FinancialProduct = ns("FinancialProduct");
/** Financial services business. */
export const FinancialService = ns("FinancialService");
/** The act of finding an object.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/SearchAction">SearchAction</a>: FindAction is generally lead by a SearchAction, but not necessarily.</li>
</ul>
 */
export const FindAction = ns("FindAction");
/** A fire station. With firemen. */
export const FireStation = ns("FireStation");
/** An airline flight. */
export const Flight = ns("Flight");
/** A reservation for air travel.<br/><br/>

Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
export const FlightReservation = ns("FlightReservation");
/** Data type: Floating number. */
export const Float = ns("Float");
/** A florist. */
export const Florist = ns("Florist");
/** The act of forming a personal connection with someone/something (object) unidirectionally/asymmetrically to get updates polled from.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/BefriendAction">BefriendAction</a>: Unlike BefriendAction, FollowAction implies that the connection is <em>not</em> necessarily reciprocal.</li>
<li><a class="localLink" href="http://schema.org/SubscribeAction">SubscribeAction</a>: Unlike SubscribeAction, FollowAction implies that the follower acts as an active agent constantly/actively polling for updates.</li>
<li><a class="localLink" href="http://schema.org/RegisterAction">RegisterAction</a>: Unlike RegisterAction, FollowAction implies that the agent is interested in continuing receiving updates from the object.</li>
<li><a class="localLink" href="http://schema.org/JoinAction">JoinAction</a>: Unlike JoinAction, FollowAction implies that the agent is interested in getting updates from the object.</li>
<li><a class="localLink" href="http://schema.org/TrackAction">TrackAction</a>: Unlike TrackAction, FollowAction refers to the polling of updates of all aspects of animate objects rather than the location of inanimate objects (e.g. you track a package, but you don't follow it).</li>
</ul>
 */
export const FollowAction = ns("FollowAction");
/** A food-related business. */
export const FoodEstablishment = ns("FoodEstablishment");
/** A reservation to dine at a food-related business.<br/><br/>

Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. */
export const FoodEstablishmentReservation = ns("FoodEstablishmentReservation");
/** Event type: Food event. */
export const FoodEvent = ns("FoodEvent");
/** A food service, like breakfast, lunch, or dinner. */
export const FoodService = ns("FoodService");
/** A furniture store. */
export const FurnitureStore = ns("FurnitureStore");
/** The Game type represents things which are games. These are typically rule-governed recreational activities, e.g. role-playing games in which players assume the role of characters in a fictional setting. */
export const Game = ns("Game");
/** Indicates whether this game is multi-player, co-op or single-player. */
export const GamePlayMode = ns("GamePlayMode");
/** Server that provides game interaction in a multiplayer game. */
export const GameServer = ns("GameServer");
/** Status of a game server. */
export const GameServerStatus = ns("GameServerStatus");
/** A garden store. */
export const GardenStore = ns("GardenStore");
/** A gas station. */
export const GasStation = ns("GasStation");
/** Residence type: Gated community. */
export const GatedResidenceCommunity = ns("GatedResidenceCommunity");
/** An enumeration of genders. */
export const GenderType = ns("GenderType");
/** A general contractor. */
export const GeneralContractor = ns("GeneralContractor");
/** A GeoCircle is a GeoShape representing a circular geographic area. As it is a GeoShape
          it provides the simple textual property 'circle', but also allows the combination of postalCode alongside geoRadius.
          The center of the circle can be indicated via the 'geoMidpoint' property, or more approximately using 'address', 'postalCode'. */
export const GeoCircle = ns("GeoCircle");
/** The geographic coordinates of a place or event. */
export const GeoCoordinates = ns("GeoCoordinates");
/** The geographic shape of a place. A GeoShape can be described using several properties whose values are based on latitude/longitude pairs. Either whitespace or commas can be used to separate latitude and longitude; whitespace should be used when writing a list of several such points. */
export const GeoShape = ns("GeoShape");
/** The act of transferring ownership of an object to a destination. Reciprocal of TakeAction.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/TakeAction">TakeAction</a>: Reciprocal of GiveAction.</li>
<li><a class="localLink" href="http://schema.org/SendAction">SendAction</a>: Unlike SendAction, GiveAction implies that ownership is being transferred (e.g. I may send my laptop to you, but that doesn't mean I'm giving it to you).</li>
</ul>
 */
export const GiveAction = ns("GiveAction");
/** A golf course. */
export const GolfCourse = ns("GolfCourse");
/** A government building. */
export const GovernmentBuilding = ns("GovernmentBuilding");
/** A government office&#x2014;for example, an IRS or DMV office. */
export const GovernmentOffice = ns("GovernmentOffice");
/** A governmental organization or agency. */
export const GovernmentOrganization = ns("GovernmentOrganization");
/** A permit issued by a government agency. */
export const GovernmentPermit = ns("GovernmentPermit");
/** A service provided by a government organization, e.g. food stamps, veterans benefits, etc. */
export const GovernmentService = ns("GovernmentService");
/** A grocery store. */
export const GroceryStore = ns("GroceryStore");
/** A business that provide Heating, Ventilation and Air Conditioning services. */
export const HVACBusiness = ns("HVACBusiness");
/** A hair salon. */
export const HairSalon = ns("HairSalon");
/** A hardware store. */
export const HardwareStore = ns("HardwareStore");
/** Health and beauty. */
export const HealthAndBeautyBusiness = ns("HealthAndBeautyBusiness");
/** A health club. */
export const HealthClub = ns("HealthClub");
/** A high school. */
export const HighSchool = ns("HighSchool");
/** A Hindu temple. */
export const HinduTemple = ns("HinduTemple");
/** A store that sells materials useful or necessary for various hobbies. */
export const HobbyShop = ns("HobbyShop");
/** A construction business.<br/><br/>

A HomeAndConstructionBusiness is a <a class="localLink" href="http://schema.org/LocalBusiness">LocalBusiness</a> that provides services around homes and buildings.<br/><br/>

As a <a class="localLink" href="http://schema.org/LocalBusiness">LocalBusiness</a> it can be described as a <a class="localLink" href="http://schema.org/provider">provider</a> of one or more <a class="localLink" href="http://schema.org/Service">Service</a>(s). */
export const HomeAndConstructionBusiness = ns("HomeAndConstructionBusiness");
/** A home goods store. */
export const HomeGoodsStore = ns("HomeGoodsStore");
/** A hospital. */
export const Hospital = ns("Hospital");
/** A hostel - cheap accommodation, often in shared dormitories.
<br /><br />
See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const Hostel = ns("Hostel");
/** A hotel is an establishment that provides lodging paid on a short-term basis (Source: Wikipedia, the free encyclopedia, see http://en.wikipedia.org/wiki/Hotel).
<br /><br />
See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const Hotel = ns("Hotel");
/** A hotel room is a single room in a hotel.
<br /><br />
See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const HotelRoom = ns("HotelRoom");
/** A house is a building or structure that has the ability to be occupied for habitation by humans or other creatures (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/House">http://en.wikipedia.org/wiki/House</a>). */
export const House = ns("House");
/** A house painting service. */
export const HousePainter = ns("HousePainter");
/** Instructions that explain how to achieve a result by performing a sequence of steps. */
export const HowTo = ns("HowTo");
/** A direction indicating a single action to do in the instructions for how to achieve a result. */
export const HowToDirection = ns("HowToDirection");
/** An item used as either a tool or supply when performing the instructions for how to to achieve a result. */
export const HowToItem = ns("HowToItem");
/** A sub-grouping of steps in the instructions for how to achieve a result (e.g. steps for making a pie crust within a pie recipe). */
export const HowToSection = ns("HowToSection");
/** A step in the instructions for how to achieve a result. It is an ordered list with HowToDirection and/or HowToTip items. */
export const HowToStep = ns("HowToStep");
/** A supply consumed when performing the instructions for how to achieve a result. */
export const HowToSupply = ns("HowToSupply");
/** An explanation in the instructions for how to achieve a result. It provides supplementary information about a technique, supply, author's preference, etc. It can explain what could be done, or what should not be done, but doesn't specify what should be done (see HowToDirection). */
export const HowToTip = ns("HowToTip");
/** A tool used (but not consumed) when performing instructions for how to achieve a result. */
export const HowToTool = ns("HowToTool");
/** An ice cream shop. */
export const IceCreamShop = ns("IceCreamShop");
/** The act of intentionally disregarding the object. An agent ignores an object. */
export const IgnoreAction = ns("IgnoreAction");
/** Web page type: Image gallery page. */
export const ImageGallery = ns("ImageGallery");
/** An image file. */
export const ImageObject = ns("ImageObject");
/** A single, identifiable product instance (e.g. a laptop with a particular serial number). */
export const IndividualProduct = ns("IndividualProduct");
/** The act of notifying someone of information pertinent to them, with no expectation of a response. */
export const InformAction = ns("InformAction");
/** The act of adding at a specific location in an ordered collection. */
export const InsertAction = ns("InsertAction");
/** The act of installing an application. */
export const InstallAction = ns("InstallAction");
/** An Insurance agency. */
export const InsuranceAgency = ns("InsuranceAgency");
/** A utility class that serves as the umbrella for a number of 'intangible' things such as quantities, structured values, etc. */
export const Intangible = ns("Intangible");
/** Data type: Integer. */
export const Integer = ns("Integer");
/** The act of interacting with another person or organization. */
export const InteractAction = ns("InteractAction");
/** A summary of how users have interacted with this CreativeWork. In most cases, authors will use a subtype to specify the specific type of interaction. */
export const InteractionCounter = ns("InteractionCounter");
/** An internet cafe. */
export const InternetCafe = ns("InternetCafe");
/** A type of financial product that typically requires the client to transfer funds to a financial service in return for potential beneficial financial return. */
export const InvestmentOrDeposit = ns("InvestmentOrDeposit");
/** The act of asking someone to attend an event. Reciprocal of RsvpAction. */
export const InviteAction = ns("InviteAction");
/** A statement of the money due for goods or services; a bill. */
export const Invoice = ns("Invoice");
/** A list of possible product availability options. */
export const ItemAvailability = ns("ItemAvailability");
/** A list of items of any sort&#x2014;for example, Top 10 Movies About Weathermen, or Top 100 Party Songs. Not to be confused with HTML lists, which are often used only for formatting. */
export const ItemList = ns("ItemList");
/** Enumerated for values for itemListOrder for indicating how an ordered ItemList is organized. */
export const ItemListOrderType = ns("ItemListOrderType");
/** A page devoted to a single item, such as a particular product or hotel. */
export const ItemPage = ns("ItemPage");
/** A jewelry store. */
export const JewelryStore = ns("JewelryStore");
/** A listing that describes a job opening in a certain organization. */
export const JobPosting = ns("JobPosting");
/** An agent joins an event/group with participants/friends at a location.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/RegisterAction">RegisterAction</a>: Unlike RegisterAction, JoinAction refers to joining a group/team of people.</li>
<li><a class="localLink" href="http://schema.org/SubscribeAction">SubscribeAction</a>: Unlike SubscribeAction, JoinAction does not imply that you'll be receiving updates.</li>
<li><a class="localLink" href="http://schema.org/FollowAction">FollowAction</a>: Unlike FollowAction, JoinAction does not imply that you'll be polling for updates.</li>
</ul>
 */
export const JoinAction = ns("JoinAction");
/** A lake (for example, Lake Pontrachain). */
export const LakeBodyOfWater = ns("LakeBodyOfWater");
/** A landform or physical feature.  Landform elements include mountains, plains, lakes, rivers, seascape and oceanic waterbody interface features such as bays, peninsulas, seas and so forth, including sub-aqueous terrain features such as submersed mountain ranges, volcanoes, and the great ocean basins. */
export const Landform = ns("Landform");
/** An historical landmark or building. */
export const LandmarksOrHistoricalBuildings = ns("LandmarksOrHistoricalBuildings");
/** Natural languages such as Spanish, Tamil, Hindi, English, etc. Formal language code tags expressed in <a href="https://en.wikipedia.org/wiki/IETF_language_tag">BCP 47</a> can be used via the <a class="localLink" href="http://schema.org/alternateName">alternateName</a> property. The Language type previously also covered programming languages such as Scheme and Lisp, which are now best represented using <a class="localLink" href="http://schema.org/ComputerLanguage">ComputerLanguage</a>. */
export const Language = ns("Language");
/** An agent leaves an event / group with participants/friends at a location.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/JoinAction">JoinAction</a>: The antonym of LeaveAction.</li>
<li><a class="localLink" href="http://schema.org/UnRegisterAction">UnRegisterAction</a>: Unlike UnRegisterAction, LeaveAction implies leaving a group/team of people rather than a service.</li>
</ul>
 */
export const LeaveAction = ns("LeaveAction");
/** A LegalService is a business that provides legally-oriented services, advice and representation, e.g. law firms.<br/><br/>

As a <a class="localLink" href="http://schema.org/LocalBusiness">LocalBusiness</a> it can be described as a <a class="localLink" href="http://schema.org/provider">provider</a> of one or more <a class="localLink" href="http://schema.org/Service">Service</a>(s). */
export const LegalService = ns("LegalService");
/** A legislative building&#x2014;for example, the state capitol. */
export const LegislativeBuilding = ns("LegislativeBuilding");
/** The act of providing an object under an agreement that it will be returned at a later date. Reciprocal of BorrowAction.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/BorrowAction">BorrowAction</a>: Reciprocal of LendAction.</li>
</ul>
 */
export const LendAction = ns("LendAction");
/** A library. */
export const Library = ns("Library");
/** The act of expressing a positive sentiment about the object. An agent likes an object (a proposition, topic or theme) with participants. */
export const LikeAction = ns("LikeAction");
/** A shop that sells alcoholic drinks such as wine, beer, whisky and other spirits. */
export const LiquorStore = ns("LiquorStore");
/** An list item, e.g. a step in a checklist or how-to description. */
export const ListItem = ns("ListItem");
/** The act of consuming audio content. */
export const ListenAction = ns("ListenAction");
/** Event type: Literary event. */
export const LiteraryEvent = ns("LiteraryEvent");
/** A blog post intended to provide a rolling textual coverage of an ongoing event through continuous updates. */
export const LiveBlogPosting = ns("LiveBlogPosting");
/** A financial product for the loaning of an amount of money under agreed terms and charges. */
export const LoanOrCredit = ns("LoanOrCredit");
/** A particular physical business or branch of an organization. Examples of LocalBusiness include a restaurant, a particular branch of a restaurant chain, a branch of a bank, a medical practice, a club, a bowling alley, etc. */
export const LocalBusiness = ns("LocalBusiness");
/** Specifies a location feature by providing a structured value representing a feature of an accommodation as a property-value pair of varying degrees of formality. */
export const LocationFeatureSpecification = ns("LocationFeatureSpecification");
/** A DeliveryMethod in which an item is made available via locker. */
export const LockerDelivery = ns("LockerDelivery");
/** A locksmith. */
export const Locksmith = ns("Locksmith");
/** A lodging business, such as a motel, hotel, or inn. */
export const LodgingBusiness = ns("LodgingBusiness");
/** A reservation for lodging at a hotel, motel, inn, etc.<br/><br/>

Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. */
export const LodgingReservation = ns("LodgingReservation");
/** The act of being defeated in a competitive activity. */
export const LoseAction = ns("LoseAction");
/** A map. */
export const Map = ns("Map");
/** An enumeration of several kinds of Map. */
export const MapCategoryType = ns("MapCategoryType");
/** The act of marrying a person. */
export const MarryAction = ns("MarryAction");
/** Properties that take Mass as values are of the form '&lt;Number&gt; &lt;Mass unit of measure&gt;'. E.g., '7 kg'. */
export const Mass = ns("Mass");
/** A media object, such as an image, video, or audio object embedded in a web page or a downloadable dataset i.e. DataDownload. Note that a creative work may have many media objects associated with it on the same web page. For example, a page about a single song (MusicRecording) may have a music video (VideoObject), and a high and low bandwidth audio stream (2 AudioObject's). */
export const MediaObject = ns("MediaObject");
/** A subscription which allows a user to access media including audio, video, books, etc. */
export const MediaSubscription = ns("MediaSubscription");
/** A medical organization (physical or not), such as hospital, institution or clinic. */
export const MedicalOrganization = ns("MedicalOrganization");
/** A meeting room, conference room, or conference hall is a room provided for singular events such as business conferences and meetings (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/Conference_hall">http://en.wikipedia.org/wiki/Conference_hall</a>).
<br /><br />
See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const MeetingRoom = ns("MeetingRoom");
/** A men's clothing store. */
export const MensClothingStore = ns("MensClothingStore");
/** A structured representation of food or drink items available from a FoodEstablishment. */
export const Menu = ns("Menu");
/** A food or drink item listed in a menu or menu section. */
export const MenuItem = ns("MenuItem");
/** A sub-grouping of food or drink items in a menu. E.g. courses (such as 'Dinner', 'Breakfast', etc.), specific type of dishes (such as 'Meat', 'Vegan', 'Drinks', etc.), or some other classification made by the menu provider. */
export const MenuSection = ns("MenuSection");
/** A single message from a sender to one or more organizations or people. */
export const Message = ns("Message");
/** A middle school (typically for children aged around 11-14, although this varies somewhat). */
export const MiddleSchool = ns("MiddleSchool");
/** A software application designed specifically to work well on a mobile device such as a telephone. */
export const MobileApplication = ns("MobileApplication");
/** A store that sells mobile phones and related accessories. */
export const MobilePhoneStore = ns("MobilePhoneStore");
/** A monetary value or range. This type can be used to describe an amount of money such as $50 USD, or a range as in describing a bank account being suitable for a balance between £1,000 and £1,000,000 GBP, or the value of a salary, etc. It is recommended to use <a class="localLink" href="http://schema.org/PriceSpecification">PriceSpecification</a> Types to describe the price of an Offer, Invoice, etc. */
export const MonetaryAmount = ns("MonetaryAmount");
/** A statistical distribution of monetary amounts. */
export const MonetaryAmountDistribution = ns("MonetaryAmountDistribution");
/** A mosque. */
export const Mosque = ns("Mosque");
/** A motel.
<br /><br />
See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const Motel = ns("Motel");
/** A motorcycle dealer. */
export const MotorcycleDealer = ns("MotorcycleDealer");
/** A motorcycle repair shop. */
export const MotorcycleRepair = ns("MotorcycleRepair");
/** A mountain, like Mount Whitney or Mount Everest. */
export const Mountain = ns("Mountain");
/** The act of an agent relocating to a place.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/TransferAction">TransferAction</a>: Unlike TransferAction, the subject of the move is a living Person or Organization rather than an inanimate object.</li>
</ul>
 */
export const MoveAction = ns("MoveAction");
/** A movie. */
export const Movie = ns("Movie");
/** A short segment/part of a movie. */
export const MovieClip = ns("MovieClip");
/** A movie rental store. */
export const MovieRentalStore = ns("MovieRentalStore");
/** A series of movies. Included movies can be indicated with the hasPart property. */
export const MovieSeries = ns("MovieSeries");
/** A movie theater. */
export const MovieTheater = ns("MovieTheater");
/** A moving company. */
export const MovingCompany = ns("MovingCompany");
/** A museum. */
export const Museum = ns("Museum");
/** A collection of music tracks. */
export const MusicAlbum = ns("MusicAlbum");
/** Classification of the album by it's type of content: soundtrack, live album, studio album, etc. */
export const MusicAlbumProductionType = ns("MusicAlbumProductionType");
/** The kind of release which this album is: single, EP or album. */
export const MusicAlbumReleaseType = ns("MusicAlbumReleaseType");
/** A musical composition. */
export const MusicComposition = ns("MusicComposition");
/** Event type: Music event. */
export const MusicEvent = ns("MusicEvent");
/** A musical group, such as a band, an orchestra, or a choir. Can also be a solo musician. */
export const MusicGroup = ns("MusicGroup");
/** A collection of music tracks in playlist form. */
export const MusicPlaylist = ns("MusicPlaylist");
/** A music recording (track), usually a single song. */
export const MusicRecording = ns("MusicRecording");
/** A MusicRelease is a specific release of a music album. */
export const MusicRelease = ns("MusicRelease");
/** Format of this release (the type of recording media used, ie. compact disc, digital media, LP, etc.). */
export const MusicReleaseFormatType = ns("MusicReleaseFormatType");
/** A music store. */
export const MusicStore = ns("MusicStore");
/** A music venue. */
export const MusicVenue = ns("MusicVenue");
/** A music video file. */
export const MusicVideoObject = ns("MusicVideoObject");
/** Organization: Non-governmental Organization. */
export const NGO = ns("NGO");
/** A nail salon. */
export const NailSalon = ns("NailSalon");
/** A NewsArticle is an article whose content reports news, or provides background context and supporting materials for understanding the news.<br/><br/>

A more detailed overview of <a href="/docs/news.html">schema.org News markup</a> is also available. */
export const NewsArticle = ns("NewsArticle");
/** A nightclub or discotheque. */
export const NightClub = ns("NightClub");
/** A notary. */
export const Notary = ns("Notary");
/** A file containing a note, primarily for the author. */
export const NoteDigitalDocument = ns("NoteDigitalDocument");
/** Data type: Number.<br/><br/>

Usage guidelines:<br/><br/>

<ul>
<li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
<li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
</ul>
 */
export const Number = ns("Number");
/** Nutritional information about the recipe. */
export const NutritionInformation = ns("NutritionInformation");
/** A profession, may involve prolonged training and/or a formal qualification. */
export const Occupation = ns("Occupation");
/** An ocean (for example, the Pacific). */
export const OceanBodyOfWater = ns("OceanBodyOfWater");
/** An offer to transfer some rights to an item or to provide a service — for example, an offer to sell tickets to an event, to rent the DVD of a movie, to stream a TV show over the internet, to repair a motorcycle, or to loan a book.<br/><br/>

For <a href="http://www.gs1.org/barcodes/technical/idkeys/gtin">GTIN</a>-related fields, see <a href="http://www.gs1.org/barcodes/support/check_digit_calculator">Check Digit calculator</a> and <a href="http://www.gs1us.org/resources/standards/gtin-validation-guide">validation guide</a> from <a href="http://www.gs1.org/">GS1</a>. */
export const Offer = ns("Offer");
/** An OfferCatalog is an ItemList that contains related Offers and/or further OfferCatalogs that are offeredBy the same provider. */
export const OfferCatalog = ns("OfferCatalog");
/** A list of possible conditions for the item. */
export const OfferItemCondition = ns("OfferItemCondition");
/** An office equipment store. */
export const OfficeEquipmentStore = ns("OfficeEquipmentStore");
/** A publication event e.g. catch-up TV or radio podcast, during which a program is available on-demand. */
export const OnDemandEvent = ns("OnDemandEvent");
/** A structured value providing information about the opening hours of a place or a certain service inside a place.<br/><br/>

The place is <strong>open</strong> if the <a class="localLink" href="http://schema.org/opens">opens</a> property is specified, and <strong>closed</strong> otherwise.<br/><br/>

If the value for the <a class="localLink" href="http://schema.org/closes">closes</a> property is less than the value for the <a class="localLink" href="http://schema.org/opens">opens</a> property then the hour range is assumed to span over the next day. */
export const OpeningHoursSpecification = ns("OpeningHoursSpecification");
/** An order is a confirmation of a transaction (a receipt), which can contain multiple line items, each represented by an Offer that has been accepted by the customer. */
export const Order = ns("Order");
/** An agent orders an object/product/service to be delivered/sent. */
export const OrderAction = ns("OrderAction");
/** An order item is a line of an order. It includes the quantity and shipping details of a bought offer. */
export const OrderItem = ns("OrderItem");
/** Enumerated status values for Order. */
export const OrderStatus = ns("OrderStatus");
/** An organization such as a school, NGO, corporation, club, etc. */
export const Organization = ns("Organization");
/** A subclass of Role used to describe roles within organizations. */
export const OrganizationRole = ns("OrganizationRole");
/** The act of manipulating/administering/supervising/controlling one or more objects. */
export const OrganizeAction = ns("OrganizeAction");
/** An outlet store. */
export const OutletStore = ns("OutletStore");
/** A structured value providing information about when a certain organization or person owned a certain product. */
export const OwnershipInfo = ns("OwnershipInfo");
/** The act of producing a painting, typically with paint and canvas as instruments. */
export const PaintAction = ns("PaintAction");
/** A painting. */
export const Painting = ns("Painting");
/** The delivery of a parcel either via the postal service or a commercial service. */
export const ParcelDelivery = ns("ParcelDelivery");
/** A private parcel service as the delivery mode available for a certain offer.<br/><br/>

Commonly used values:<br/><br/>

<ul>
<li>http://purl.org/goodrelations/v1#DHL</li>
<li>http://purl.org/goodrelations/v1#FederalExpress</li>
<li>http://purl.org/goodrelations/v1#UPS</li>
</ul>
 */
export const ParcelService = ns("ParcelService");
/** A set of characteristics describing parents, who can be interested in viewing some content. */
export const ParentAudience = ns("ParentAudience");
/** A park. */
export const Park = ns("Park");
/** A parking lot or other parking facility. */
export const ParkingFacility = ns("ParkingFacility");
/** A shop that will buy, or lend money against the security of, personal possessions. */
export const PawnShop = ns("PawnShop");
/** An agent pays a price to a participant. */
export const PayAction = ns("PayAction");
/** A payment method using a credit, debit, store or other card to associate the payment with an account. */
export const PaymentCard = ns("PaymentCard");
/** The costs of settling the payment using a particular payment method. */
export const PaymentChargeSpecification = ns("PaymentChargeSpecification");
/** A payment method is a standardized procedure for transferring the monetary amount for a purchase. Payment methods are characterized by the legal and technical structures used, and by the organization or group carrying out the transaction.<br/><br/>

Commonly used values:<br/><br/>

<ul>
<li>http://purl.org/goodrelations/v1#ByBankTransferInAdvance</li>
<li>http://purl.org/goodrelations/v1#ByInvoice</li>
<li>http://purl.org/goodrelations/v1#Cash</li>
<li>http://purl.org/goodrelations/v1#CheckInAdvance</li>
<li>http://purl.org/goodrelations/v1#COD</li>
<li>http://purl.org/goodrelations/v1#DirectDebit</li>
<li>http://purl.org/goodrelations/v1#GoogleCheckout</li>
<li>http://purl.org/goodrelations/v1#PayPal</li>
<li>http://purl.org/goodrelations/v1#PaySwarm</li>
</ul>
 */
export const PaymentMethod = ns("PaymentMethod");
/** A Service to transfer funds from a person or organization to a beneficiary person or organization. */
export const PaymentService = ns("PaymentService");
/** A specific payment status. For example, PaymentDue, PaymentComplete, etc. */
export const PaymentStatusType = ns("PaymentStatusType");
/** A set of characteristics belonging to people, e.g. who compose an item's target audience. */
export const PeopleAudience = ns("PeopleAudience");
/** The act of participating in performance arts. */
export const PerformAction = ns("PerformAction");
/** A PerformanceRole is a Role that some entity places with regard to a theatrical performance, e.g. in a Movie, TVSeries etc. */
export const PerformanceRole = ns("PerformanceRole");
/** A theater or other performing art center. */
export const PerformingArtsTheater = ns("PerformingArtsTheater");
/** A performance group, such as a band, an orchestra, or a circus. */
export const PerformingGroup = ns("PerformingGroup");
/** A publication in any medium issued in successive parts bearing numerical or chronological designations and intended, such as a magazine, scholarly journal, or newspaper to continue indefinitely.<br/><br/>

See also <a href="http://blog.schema.org/2014/09/schemaorg-support-for-bibliographic_2.html">blog post</a>. */
export const Periodical = ns("Periodical");
/** A permit issued by an organization, e.g. a parking pass. */
export const Permit = ns("Permit");
/** A person (alive, dead, undead, or fictional). */
export const Person = ns("Person");
/** A pet store. */
export const PetStore = ns("PetStore");
/** A pharmacy or drugstore. */
export const Pharmacy = ns("Pharmacy");
/** A photograph. */
export const Photograph = ns("Photograph");
/** The act of capturing still images of objects using a camera. */
export const PhotographAction = ns("PhotographAction");
/** A doctor's office. */
export const Physician = ns("Physician");
/** Entities that have a somewhat fixed, physical extension. */
export const Place = ns("Place");
/** Place of worship, such as a church, synagogue, or mosque. */
export const PlaceOfWorship = ns("PlaceOfWorship");
/** The act of planning the execution of an event/task/action/reservation/plan to a future date. */
export const PlanAction = ns("PlanAction");
/** The act of playing/exercising/training/performing for enjoyment, leisure, recreation, Competition or exercise.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/ListenAction">ListenAction</a>: Unlike ListenAction (which is under ConsumeAction), PlayAction refers to performing for an audience or at an event, rather than consuming music.</li>
<li><a class="localLink" href="http://schema.org/WatchAction">WatchAction</a>: Unlike WatchAction (which is under ConsumeAction), PlayAction refers to showing/displaying for an audience or at an event, rather than consuming visual content.</li>
</ul>
 */
export const PlayAction = ns("PlayAction");
/** A playground. */
export const Playground = ns("Playground");
/** A plumbing service. */
export const Plumber = ns("Plumber");
/** A police station. */
export const PoliceStation = ns("PoliceStation");
/** A pond. */
export const Pond = ns("Pond");
/** A post office. */
export const PostOffice = ns("PostOffice");
/** The mailing address. */
export const PostalAddress = ns("PostalAddress");
/** An agent orders a (not yet released) object/product/service to be delivered/sent. */
export const PreOrderAction = ns("PreOrderAction");
/** The act of inserting at the beginning if an ordered collection. */
export const PrependAction = ns("PrependAction");
/** A preschool. */
export const Preschool = ns("Preschool");
/** A file containing slides or used for a presentation. */
export const PresentationDigitalDocument = ns("PresentationDigitalDocument");
/** A structured value representing a price or price range. Typically, only the subclasses of this type are used for markup. It is recommended to use <a class="localLink" href="http://schema.org/MonetaryAmount">MonetaryAmount</a> to describe independent amounts of money such as a salary, credit card limits, etc. */
export const PriceSpecification = ns("PriceSpecification");
/** Any offered product or service. For example: a pair of shoes; a concert ticket; the rental of a car; a haircut; or an episode of a TV show streamed online. */
export const Product = ns("Product");
/** A datasheet or vendor specification of a product (in the sense of a prototypical description). */
export const ProductModel = ns("ProductModel");
/** Original definition: "provider of professional services."<br/><br/>

The general <a class="localLink" href="http://schema.org/ProfessionalService">ProfessionalService</a> type for local businesses was deprecated due to confusion with <a class="localLink" href="http://schema.org/Service">Service</a>. For reference, the types that it included were: <a class="localLink" href="http://schema.org/Dentist">Dentist</a>,
        <a class="localLink" href="http://schema.org/AccountingService">AccountingService</a>, <a class="localLink" href="http://schema.org/Attorney">Attorney</a>, <a class="localLink" href="http://schema.org/Notary">Notary</a>, as well as types for several kinds of <a class="localLink" href="http://schema.org/HomeAndConstructionBusiness">HomeAndConstructionBusiness</a>: <a class="localLink" href="http://schema.org/Electrician">Electrician</a>, <a class="localLink" href="http://schema.org/GeneralContractor">GeneralContractor</a>,
        <a class="localLink" href="http://schema.org/HousePainter">HousePainter</a>, <a class="localLink" href="http://schema.org/Locksmith">Locksmith</a>, <a class="localLink" href="http://schema.org/Plumber">Plumber</a>, <a class="localLink" href="http://schema.org/RoofingContractor">RoofingContractor</a>. <a class="localLink" href="http://schema.org/LegalService">LegalService</a> was introduced as a more inclusive supertype of <a class="localLink" href="http://schema.org/Attorney">Attorney</a>. */
export const ProfessionalService = ns("ProfessionalService");
/** Web page type: Profile page. */
export const ProfilePage = ns("ProfilePage");
/** Used to describe membership in a loyalty programs (e.g. "StarAliance"), traveler clubs (e.g. "AAA"), purchase clubs ("Safeway Club"), etc. */
export const ProgramMembership = ns("ProgramMembership");
/** A property-value pair, e.g. representing a feature of a product or place. Use the 'name' property for the name of the property. If there is an additional human-readable version of the value, put that into the 'description' property.<br/><br/>

Always use specific schema.org properties when a) they exist and b) you can populate them. Using PropertyValue as a substitute will typically not trigger the same effect as using the original, specific property. */
export const PropertyValue = ns("PropertyValue");
/** A Property value specification. */
export const PropertyValueSpecification = ns("PropertyValueSpecification");
/** A public swimming pool. */
export const PublicSwimmingPool = ns("PublicSwimmingPool");
/** A PublicationEvent corresponds indifferently to the event of publication for a CreativeWork of any type e.g. a broadcast event, an on-demand event, a book/journal publication via a variety of delivery media. */
export const PublicationEvent = ns("PublicationEvent");
/** A part of a successively published publication such as a periodical or publication volume, often numbered, usually containing a grouping of works such as articles.<br/><br/>

See also <a href="http://blog.schema.org/2014/09/schemaorg-support-for-bibliographic_2.html">blog post</a>. */
export const PublicationIssue = ns("PublicationIssue");
/** A part of a successively published publication such as a periodical or multi-volume work, often numbered. It may represent a time span, such as a year.<br/><br/>

See also <a href="http://blog.schema.org/2014/09/schemaorg-support-for-bibliographic_2.html">blog post</a>. */
export const PublicationVolume = ns("PublicationVolume");
/** A QAPage is a WebPage focussed on a specific Question and its Answer(s), e.g. in a question answering site or documenting Frequently Asked Questions (FAQs). */
export const QAPage = ns("QAPage");
/** A predefined value for a product characteristic, e.g. the power cord plug type 'US' or the garment sizes 'S', 'M', 'L', and 'XL'. */
export const QualitativeValue = ns("QualitativeValue");
/** A point value or interval for product characteristics and other purposes. */
export const QuantitativeValue = ns("QuantitativeValue");
/** A statistical distribution of values. */
export const QuantitativeValueDistribution = ns("QuantitativeValueDistribution");
/** Quantities such as distance, time, mass, weight, etc. Particular instances of say Mass are entities like '3 Kg' or '4 milligrams'. */
export const Quantity = ns("Quantity");
/** A specific question - e.g. from a user seeking answers online, or collected in a Frequently Asked Questions (FAQ) document. */
export const Question = ns("Question");
/** An agent quotes/estimates/appraises an object/product/service with a price at a location/store. */
export const QuoteAction = ns("QuoteAction");
/** A place offering space for "Recreational Vehicles", Caravans, mobile homes and the like. */
export const RVPark = ns("RVPark");
/** A unique instance of a radio BroadcastService on a CableOrSatelliteService lineup. */
export const RadioChannel = ns("RadioChannel");
/** A short radio program or a segment/part of a radio program. */
export const RadioClip = ns("RadioClip");
/** A radio episode which can be part of a series or season. */
export const RadioEpisode = ns("RadioEpisode");
/** Season dedicated to radio broadcast and associated online delivery. */
export const RadioSeason = ns("RadioSeason");
/** CreativeWorkSeries dedicated to radio broadcast and associated online delivery. */
export const RadioSeries = ns("RadioSeries");
/** A radio station. */
export const RadioStation = ns("RadioStation");
/** A rating is an evaluation on a numeric scale, such as 1 to 5 stars. */
export const Rating = ns("Rating");
/** The act of responding instinctively and emotionally to an object, expressing a sentiment. */
export const ReactAction = ns("ReactAction");
/** The act of consuming written content. */
export const ReadAction = ns("ReadAction");
/** A real-estate agent. */
export const RealEstateAgent = ns("RealEstateAgent");
/** The act of physically/electronically taking delivery of an object thathas been transferred from an origin to a destination. Reciprocal of SendAction.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/SendAction">SendAction</a>: The reciprocal of ReceiveAction.</li>
<li><a class="localLink" href="http://schema.org/TakeAction">TakeAction</a>: Unlike TakeAction, ReceiveAction does not imply that the ownership has been transfered (e.g. I can receive a package, but it does not mean the package is now mine).</li>
</ul>
 */
export const ReceiveAction = ns("ReceiveAction");
/** A recipe. For dietary restrictions covered by the recipe, a few common restrictions are enumerated via <a class="localLink" href="http://schema.org/suitableForDiet">suitableForDiet</a>. The <a class="localLink" href="http://schema.org/keywords">keywords</a> property can also be used to add more detail. */
export const Recipe = ns("Recipe");
/** A recycling center. */
export const RecyclingCenter = ns("RecyclingCenter");
/** The act of registering to be a user of a service, product or web page.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/JoinAction">JoinAction</a>: Unlike JoinAction, RegisterAction implies you are registering to be a user of a service, <em>not</em> a group/team of people.</li>
<li>[FollowAction]]: Unlike FollowAction, RegisterAction doesn't imply that the agent is expecting to poll for updates from the object.</li>
<li><a class="localLink" href="http://schema.org/SubscribeAction">SubscribeAction</a>: Unlike SubscribeAction, RegisterAction doesn't imply that the agent is expecting updates from the object.</li>
</ul>
 */
export const RegisterAction = ns("RegisterAction");
/** The act of rejecting to/adopting an object.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/AcceptAction">AcceptAction</a>: The antonym of RejectAction.</li>
</ul>
 */
export const RejectAction = ns("RejectAction");
/** The act of giving money in return for temporary use, but not ownership, of an object such as a vehicle or property. For example, an agent rents a property from a landlord in exchange for a periodic payment. */
export const RentAction = ns("RentAction");
/** A reservation for a rental car.<br/><br/>

Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. */
export const RentalCarReservation = ns("RentalCarReservation");
/** The act of editing a recipient by replacing an old object with a new object. */
export const ReplaceAction = ns("ReplaceAction");
/** The act of responding to a question/message asked/sent by the object. Related to <a class="localLink" href="http://schema.org/AskAction">AskAction</a><br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/AskAction">AskAction</a>: Appears generally as an origin of a ReplyAction.</li>
</ul>
 */
export const ReplyAction = ns("ReplyAction");
/** A Report generated by governmental or non-governmental organization. */
export const Report = ns("Report");
/** Describes a reservation for travel, dining or an event. Some reservations require tickets. <br/><br/>

Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, restaurant reservations, flights, or rental cars, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
export const Reservation = ns("Reservation");
/** A group of multiple reservations with common values for all sub-reservations. */
export const ReservationPackage = ns("ReservationPackage");
/** Enumerated status values for Reservation. */
export const ReservationStatusType = ns("ReservationStatusType");
/** Reserving a concrete object.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/ScheduleAction">ScheduleAction</a></a>: Unlike ScheduleAction, ReserveAction reserves concrete objects (e.g. a table, a hotel) towards a time slot / spatial allocation.</li>
</ul>
 */
export const ReserveAction = ns("ReserveAction");
/** A reservoir of water, typically an artificially created lake, like the Lake Kariba reservoir. */
export const Reservoir = ns("Reservoir");
/** The place where a person lives. */
export const Residence = ns("Residence");
/** A resort is a place used for relaxation or recreation, attracting visitors for holidays or vacations. Resorts are places, towns or sometimes commercial establishment operated by a single company (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/Resort">http://en.wikipedia.org/wiki/Resort</a>).
<br /><br />
See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const Resort = ns("Resort");
/** A restaurant. */
export const Restaurant = ns("Restaurant");
/** A diet restricted to certain foods or preparations for cultural, religious, health or lifestyle reasons. */
export const RestrictedDiet = ns("RestrictedDiet");
/** The act of resuming a device or application which was formerly paused (e.g. resume music playback or resume a timer). */
export const ResumeAction = ns("ResumeAction");
/** The act of returning to the origin that which was previously received (concrete objects) or taken (ownership). */
export const ReturnAction = ns("ReturnAction");
/** A review of an item - for example, of a restaurant, movie, or store. */
export const Review = ns("Review");
/** The act of producing a balanced opinion about the object for an audience. An agent reviews an object with participants resulting in a review. */
export const ReviewAction = ns("ReviewAction");
/** A river (for example, the broad majestic Shannon). */
export const RiverBodyOfWater = ns("RiverBodyOfWater");
/** Represents additional information about a relationship or property. For example a Role can be used to say that a 'member' role linking some SportsTeam to a player occurred during a particular time period. Or that a Person's 'actor' role in a Movie was for some particular characterName. Such properties can be attached to a Role entity, which is then associated with the main entities using ordinary properties like 'member' or 'actor'.<br/><br/>

See also <a href="http://blog.schema.org/2014/06/introducing-role.html">blog post</a>. */
export const Role = ns("Role");
/** A roofing contractor. */
export const RoofingContractor = ns("RoofingContractor");
/** A room is a distinguishable space within a structure, usually separated from other spaces by interior walls. (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/Room">http://en.wikipedia.org/wiki/Room</a>).
<br /><br />
See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const Room = ns("Room");
/** The act of notifying an event organizer as to whether you expect to attend the event. */
export const RsvpAction = ns("RsvpAction");
/** RsvpResponseType is an enumeration type whose instances represent responding to an RSVP request. */
export const RsvpResponseType = ns("RsvpResponseType");
/** Event type: Sales event. */
export const SaleEvent = ns("SaleEvent");
/** Scheduling future actions, events, or tasks.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/ReserveAction">ReserveAction</a>: Unlike ReserveAction, ScheduleAction allocates future actions (e.g. an event, a task, etc) towards a time slot / spatial allocation.</li>
</ul>
 */
export const ScheduleAction = ns("ScheduleAction");
/** A scholarly article. */
export const ScholarlyArticle = ns("ScholarlyArticle");
/** A school. */
export const School = ns("School");
/** A screening of a movie or other video. */
export const ScreeningEvent = ns("ScreeningEvent");
/** A piece of sculpture. */
export const Sculpture = ns("Sculpture");
/** A sea (for example, the Caspian sea). */
export const SeaBodyOfWater = ns("SeaBodyOfWater");
/** The act of searching for an object.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/FindAction">FindAction</a>: SearchAction generally leads to a FindAction, but not necessarily.</li>
</ul>
 */
export const SearchAction = ns("SearchAction");
/** Web page type: Search results page. */
export const SearchResultsPage = ns("SearchResultsPage");
/** A media season e.g. tv, radio, video game etc. */
export const Season = ns("Season");
/** Used to describe a seat, such as a reserved seat in an event reservation. */
export const Seat = ns("Seat");
/** A self-storage facility. */
export const SelfStorage = ns("SelfStorage");
/** The act of taking money from a buyer in exchange for goods or services rendered. An agent sells an object, product, or service to a buyer for a price. Reciprocal of BuyAction. */
export const SellAction = ns("SellAction");
/** The act of physically/electronically dispatching an object for transfer from an origin to a destination.Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/ReceiveAction">ReceiveAction</a>: The reciprocal of SendAction.</li>
<li><a class="localLink" href="http://schema.org/GiveAction">GiveAction</a>: Unlike GiveAction, SendAction does not imply the transfer of ownership (e.g. I can send you my laptop, but I'm not necessarily giving it to you).</li>
</ul>
 */
export const SendAction = ns("SendAction");
/** A Series in schema.org is a group of related items, typically but not necessarily of the same kind. See also <a class="localLink" href="http://schema.org/CreativeWorkSeries">CreativeWorkSeries</a>, <a class="localLink" href="http://schema.org/EventSeries">EventSeries</a>. */
export const Series = ns("Series");
/** A service provided by an organization, e.g. delivery service, print services, etc. */
export const Service = ns("Service");
/** A means for accessing a service, e.g. a government office location, web site, or phone number. */
export const ServiceChannel = ns("ServiceChannel");
/** The act of distributing content to people for their amusement or edification. */
export const ShareAction = ns("ShareAction");
/** A shoe store. */
export const ShoeStore = ns("ShoeStore");
/** A shopping center or mall. */
export const ShoppingCenter = ns("ShoppingCenter");
/** Residence type: Single-family home. */
export const SingleFamilyResidence = ns("SingleFamilyResidence");
/** A navigation element of the page. */
export const SiteNavigationElement = ns("SiteNavigationElement");
/** A ski resort. */
export const SkiResort = ns("SkiResort");
/** Event type: Social event. */
export const SocialEvent = ns("SocialEvent");
/** A post to a social media platform, including blog posts, tweets, Facebook posts, etc. */
export const SocialMediaPosting = ns("SocialMediaPosting");
/** A software application. */
export const SoftwareApplication = ns("SoftwareApplication");
/** Computer programming source code. Example: Full (compile ready) solutions, code snippet samples, scripts, templates. */
export const SoftwareSourceCode = ns("SoftwareSourceCode");
/** A placeholder for multiple similar products of the same kind. */
export const SomeProducts = ns("SomeProducts");
/** A SpeakableSpecification indicates (typically via <a class="localLink" href="http://schema.org/xpath">xpath</a> or <a class="localLink" href="http://schema.org/cssSelector">cssSelector</a>) sections of a document that are highlighted as particularly <a class="localLink" href="http://schema.org/speakable">speakable</a>. Instances of this type are expected to be used primarily as values of the <a class="localLink" href="http://schema.org/speakable">speakable</a> property. */
export const SpeakableSpecification = ns("SpeakableSpecification");
/** Any branch of a field in which people typically develop specific expertise, usually after significant study, time, and effort. */
export const Specialty = ns("Specialty");
/** A sporting goods store. */
export const SportingGoodsStore = ns("SportingGoodsStore");
/** A sports location, such as a playing field. */
export const SportsActivityLocation = ns("SportsActivityLocation");
/** A sports club. */
export const SportsClub = ns("SportsClub");
/** Event type: Sports event. */
export const SportsEvent = ns("SportsEvent");
/** Represents the collection of all sports organizations, including sports teams, governing bodies, and sports associations. */
export const SportsOrganization = ns("SportsOrganization");
/** Organization: Sports team. */
export const SportsTeam = ns("SportsTeam");
/** A spreadsheet file. */
export const SpreadsheetDigitalDocument = ns("SpreadsheetDigitalDocument");
/** A stadium. */
export const StadiumOrArena = ns("StadiumOrArena");
/** A state or province of a country. */
export const State = ns("State");
/** A value indicating a steering position. */
export const SteeringPositionValue = ns("SteeringPositionValue");
/** A retail good store. */
export const Store = ns("Store");
/** Structured values are used when the value of a property has a more complex structure than simply being a textual value or a reference to another thing. */
export const StructuredValue = ns("StructuredValue");
/** The act of forming a personal connection with someone/something (object) unidirectionally/asymmetrically to get updates pushed to.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/FollowAction">FollowAction</a>: Unlike FollowAction, SubscribeAction implies that the subscriber acts as a passive agent being constantly/actively pushed for updates.</li>
<li><a class="localLink" href="http://schema.org/RegisterAction">RegisterAction</a>: Unlike RegisterAction, SubscribeAction implies that the agent is interested in continuing receiving updates from the object.</li>
<li><a class="localLink" href="http://schema.org/JoinAction">JoinAction</a>: Unlike JoinAction, SubscribeAction implies that the agent is interested in continuing receiving updates from the object.</li>
</ul>
 */
export const SubscribeAction = ns("SubscribeAction");
/** A subway station. */
export const SubwayStation = ns("SubwayStation");
/** A suite in a hotel or other public accommodation, denotes a class of luxury accommodations, the key feature of which is multiple rooms (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/Suite_(hotel)">http://en.wikipedia.org/wiki/Suite_(hotel)</a>).
<br /><br />
See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
export const Suite = ns("Suite");
/** The act of momentarily pausing a device or application (e.g. pause music playback or pause a timer). */
export const SuspendAction = ns("SuspendAction");
/** A synagogue. */
export const Synagogue = ns("Synagogue");
/** A short TV program or a segment/part of a TV program. */
export const TVClip = ns("TVClip");
/** A TV episode which can be part of a series or season. */
export const TVEpisode = ns("TVEpisode");
/** Season dedicated to TV broadcast and associated online delivery. */
export const TVSeason = ns("TVSeason");
/** CreativeWorkSeries dedicated to TV broadcast and associated online delivery. */
export const TVSeries = ns("TVSeries");
/** A table on a Web page. */
export const Table = ns("Table");
/** The act of gaining ownership of an object from an origin. Reciprocal of GiveAction.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/GiveAction">GiveAction</a>: The reciprocal of TakeAction.</li>
<li><a class="localLink" href="http://schema.org/ReceiveAction">ReceiveAction</a>: Unlike ReceiveAction, TakeAction implies that ownership has been transfered.</li>
</ul>
 */
export const TakeAction = ns("TakeAction");
/** A tattoo parlor. */
export const TattooParlor = ns("TattooParlor");
/** A taxi. */
export const Taxi = ns("Taxi");
/** A reservation for a taxi.<br/><br/>

Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
export const TaxiReservation = ns("TaxiReservation");
/** A service for a vehicle for hire with a driver for local travel. Fares are usually calculated based on distance traveled. */
export const TaxiService = ns("TaxiService");
/** A taxi stand. */
export const TaxiStand = ns("TaxiStand");
/** A technical article - Example: How-to (task) topics, step-by-step, procedural troubleshooting, specifications, etc. */
export const TechArticle = ns("TechArticle");
/** A unique instance of a television BroadcastService on a CableOrSatelliteService lineup. */
export const TelevisionChannel = ns("TelevisionChannel");
/** A television station. */
export const TelevisionStation = ns("TelevisionStation");
/** A tennis complex. */
export const TennisComplex = ns("TennisComplex");
/** Data type: Text. */
export const Text = ns("Text");
/** A file composed primarily of text. */
export const TextDigitalDocument = ns("TextDigitalDocument");
/** Event type: Theater performance. */
export const TheaterEvent = ns("TheaterEvent");
/** A theater group or company, for example, the Royal Shakespeare Company or Druid Theatre. */
export const TheaterGroup = ns("TheaterGroup");
/** The most generic type of item. */
export const Thing = ns("Thing");
/** Used to describe a ticket to an event, a flight, a bus ride, etc. */
export const Ticket = ns("Ticket");
/** The act of reaching a draw in a competitive activity. */
export const TieAction = ns("TieAction");
/** A point in time recurring on multiple days in the form hh:mm:ss[Z|(+|-)hh:mm] (see <a href="http://www.w3.org/TR/xmlschema-2/#time">XML schema for details</a>). */
export const Time = ns("Time");
/** The act of giving money voluntarily to a beneficiary in recognition of services rendered. */
export const TipAction = ns("TipAction");
/** A tire shop. */
export const TireShop = ns("TireShop");
/** A tourist attraction.  In principle any Thing can be a <a class="localLink" href="http://schema.org/TouristAttraction">TouristAttraction</a>, from a <a class="localLink" href="http://schema.org/Mountain">Mountain</a> and <a class="localLink" href="http://schema.org/LandmarksOrHistoricalBuildings">LandmarksOrHistoricalBuildings</a> to a <a class="localLink" href="http://schema.org/LocalBusiness">LocalBusiness</a>.  This Type can be used on its own to describe a general <a class="localLink" href="http://schema.org/TouristAttraction">TouristAttraction</a>, or be used as an <a class="localLink" href="http://schema.org/additionalType">additionalType</a> to add tourist attraction properties to any other type.  (See examples below) */
export const TouristAttraction = ns("TouristAttraction");
/** A tourist information center. */
export const TouristInformationCenter = ns("TouristInformationCenter");
/** A toy store. */
export const ToyStore = ns("ToyStore");
/** An agent tracks an object for updates.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/FollowAction">FollowAction</a>: Unlike FollowAction, TrackAction refers to the interest on the location of innanimates objects.</li>
<li><a class="localLink" href="http://schema.org/SubscribeAction">SubscribeAction</a>: Unlike SubscribeAction, TrackAction refers to  the interest on the location of innanimate objects.</li>
</ul>
 */
export const TrackAction = ns("TrackAction");
/** The act of participating in an exchange of goods and services for monetary compensation. An agent trades an object, product or service with a participant in exchange for a one time or periodic payment. */
export const TradeAction = ns("TradeAction");
/** A reservation for train travel.<br/><br/>

Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
export const TrainReservation = ns("TrainReservation");
/** A train station. */
export const TrainStation = ns("TrainStation");
/** A trip on a commercial train line. */
export const TrainTrip = ns("TrainTrip");
/** The act of transferring/moving (abstract or concrete) animate or inanimate objects from one place to another. */
export const TransferAction = ns("TransferAction");
/** The act of traveling from an fromLocation to a destination by a specified mode of transport, optionally with participants. */
export const TravelAction = ns("TravelAction");
/** A travel agency. */
export const TravelAgency = ns("TravelAgency");
/** A trip or journey. An itinerary of visits to one or more places. */
export const Trip = ns("Trip");
/** A structured value indicating the quantity, unit of measurement, and business function of goods included in a bundle offer. */
export const TypeAndQuantityNode = ns("TypeAndQuantityNode");
/** Data type: URL. */
export const URL = ns("URL");
/** The act of un-registering from a service.<br/><br/>

Related actions:<br/><br/>

<ul>
<li><a class="localLink" href="http://schema.org/RegisterAction">RegisterAction</a>: antonym of UnRegisterAction.</li>
<li><a class="localLink" href="http://schema.org/LeaveAction">LeaveAction</a>: Unlike LeaveAction, UnRegisterAction implies that you are unregistering from a service you werer previously registered, rather than leaving a team/group of people.</li>
</ul>
 */
export const UnRegisterAction = ns("UnRegisterAction");
/** The price asked for a given offer by the respective organization or person. */
export const UnitPriceSpecification = ns("UnitPriceSpecification");
/** The act of managing by changing/editing the state of the object. */
export const UpdateAction = ns("UpdateAction");
/** The act of applying an object to its intended purpose. */
export const UseAction = ns("UseAction");
/** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
export const UserBlocks = ns("UserBlocks");
/** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
export const UserCheckins = ns("UserCheckins");
/** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
export const UserComments = ns("UserComments");
/** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
export const UserDownloads = ns("UserDownloads");
/** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
export const UserInteraction = ns("UserInteraction");
/** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
export const UserLikes = ns("UserLikes");
/** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
export const UserPageVisits = ns("UserPageVisits");
/** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
export const UserPlays = ns("UserPlays");
/** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
export const UserPlusOnes = ns("UserPlusOnes");
/** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
export const UserTweets = ns("UserTweets");
/** A vehicle is a device that is designed or used to transport people or cargo over land, water, air, or through space. */
export const Vehicle = ns("Vehicle");
/** Web page type: Video gallery page. */
export const VideoGallery = ns("VideoGallery");
/** A video game is an electronic game that involves human interaction with a user interface to generate visual feedback on a video device. */
export const VideoGame = ns("VideoGame");
/** A short segment/part of a video game. */
export const VideoGameClip = ns("VideoGameClip");
/** A video game series. */
export const VideoGameSeries = ns("VideoGameSeries");
/** A video file. */
export const VideoObject = ns("VideoObject");
/** The act of consuming static visual content. */
export const ViewAction = ns("ViewAction");
/** Event type: Visual arts event. */
export const VisualArtsEvent = ns("VisualArtsEvent");
/** A work of art that is primarily visual in character. */
export const VisualArtwork = ns("VisualArtwork");
/** A volcano, like Fuji san. */
export const Volcano = ns("Volcano");
/** The act of expressing a preference from a fixed/finite/structured set of choices/options. */
export const VoteAction = ns("VoteAction");
/** An advertising section of the page. */
export const WPAdBlock = ns("WPAdBlock");
/** The footer section of the page. */
export const WPFooter = ns("WPFooter");
/** The header section of the page. */
export const WPHeader = ns("WPHeader");
/** A sidebar section of the page. */
export const WPSideBar = ns("WPSideBar");
/** The act of expressing a desire about the object. An agent wants an object. */
export const WantAction = ns("WantAction");
/** A structured value representing the duration and scope of services that will be provided to a customer free of charge in case of a defect or malfunction of a product. */
export const WarrantyPromise = ns("WarrantyPromise");
/** A range of of services that will be provided to a customer free of charge in case of a defect or malfunction of a product.<br/><br/>

Commonly used values:<br/><br/>

<ul>
<li>http://purl.org/goodrelations/v1#Labor-BringIn</li>
<li>http://purl.org/goodrelations/v1#PartsAndLabor-BringIn</li>
<li>http://purl.org/goodrelations/v1#PartsAndLabor-PickUp</li>
</ul>
 */
export const WarrantyScope = ns("WarrantyScope");
/** The act of consuming dynamic/moving visual content. */
export const WatchAction = ns("WatchAction");
/** A waterfall, like Niagara. */
export const Waterfall = ns("Waterfall");
/** The act of dressing oneself in clothing. */
export const WearAction = ns("WearAction");
/** Web applications. */
export const WebApplication = ns("WebApplication");
/** A web page. Every web page is implicitly assumed to be declared to be of type WebPage, so the various properties about that webpage, such as <code>breadcrumb</code> may be used. We recommend explicit declaration if these properties are specified, but if they are found outside of an itemscope, they will be assumed to be about the page. */
export const WebPage = ns("WebPage");
/** A web page element, like a table or an image. */
export const WebPageElement = ns("WebPageElement");
/** A WebSite is a set of related web pages and other items typically served from a single web domain and accessible via URLs. */
export const WebSite = ns("WebSite");
/** A wholesale store. */
export const WholesaleStore = ns("WholesaleStore");
/** The act of achieving victory in a competitive activity. */
export const WinAction = ns("WinAction");
/** A winery. */
export const Winery = ns("Winery");
/** A Workers Union (also known as a Labor Union, Labour Union, or Trade Union) is an organization that promotes the interests of its worker members by collectively bargaining with management, organizing, and political lobbying. */
export const WorkersUnion = ns("WorkersUnion");
/** The act of authoring written creative content. */
export const WriteAction = ns("WriteAction");
/** A zoo. */
export const Zoo = ns("Zoo");
/** The answer(s) that has been accepted as best, typically on a Question/Answer site. Sites vary in their selection mechanisms, e.g. drawing on community opinion and/or the view of the Question author. */
export const acceptedAnswer = ns("acceptedAnswer");
/** The offer(s) -- e.g., product, quantity and price combinations -- included in the order. */
export const acceptedOffer = ns("acceptedOffer");
/** The payment method(s) accepted by seller for this offer. */
export const acceptedPaymentMethod = ns("acceptedPaymentMethod");
/** Indicates whether a FoodEstablishment accepts reservations. Values can be Boolean, an URL at which reservations can be made or (for backwards compatibility) the strings <code>Yes</code> or <code>No</code>. */
export const acceptsReservations = ns("acceptsReservations");
/** Password, PIN, or access code needed for delivery (e.g. from a locker). */
export const accessCode = ns("accessCode");
/** The human sensory perceptual system or cognitive faculty through which a person may process or perceive information. Expected values include: auditory, tactile, textual, visual, colorDependent, chartOnVisual, chemOnVisual, diagramOnVisual, mathOnVisual, musicOnVisual, textOnVisual. */
export const accessMode = ns("accessMode");
/** A list of single or combined accessModes that are sufficient to understand all the intellectual content of a resource. Expected values include:  auditory, tactile, textual, visual. */
export const accessModeSufficient = ns("accessModeSufficient");
/** Indicates that the resource is compatible with the referenced accessibility API (<a href="http://www.w3.org/wiki/WebSchemas/Accessibility">WebSchemas wiki lists possible values</a>). */
export const accessibilityAPI = ns("accessibilityAPI");
/** Identifies input methods that are sufficient to fully control the described resource (<a href="http://www.w3.org/wiki/WebSchemas/Accessibility">WebSchemas wiki lists possible values</a>). */
export const accessibilityControl = ns("accessibilityControl");
/** Content features of the resource, such as accessible media, alternatives and supported enhancements for accessibility (<a href="http://www.w3.org/wiki/WebSchemas/Accessibility">WebSchemas wiki lists possible values</a>). */
export const accessibilityFeature = ns("accessibilityFeature");
/** A characteristic of the described resource that is physiologically dangerous to some users. Related to WCAG 2.0 guideline 2.3 (<a href="http://www.w3.org/wiki/WebSchemas/Accessibility">WebSchemas wiki lists possible values</a>). */
export const accessibilityHazard = ns("accessibilityHazard");
/** A human-readable summary of specific accessibility features or deficiencies, consistent with the other accessibility metadata but expressing subtleties such as "short descriptions are present but long descriptions will be needed for non-visual users" or "short descriptions are present and no long descriptions are needed." */
export const accessibilitySummary = ns("accessibilitySummary");
/** The identifier for the account the payment will be applied to. */
export const accountId = ns("accountId");
/** Specifies the Person that is legally accountable for the CreativeWork. */
export const accountablePerson = ns("accountablePerson");
/** The organization or person from which the product was acquired. */
export const acquiredFrom = ns("acquiredFrom");
/** A set of requirements that a must be fulfilled in order to perform an Action. If more than one value is specied, fulfilling one set of requirements will allow the Action to be performed. */
export const actionAccessibilityRequirement = ns("actionAccessibilityRequirement");
/** The high level platform(s) where the Action can be performed for the given URL. To specify a specific application or operating system instance, use actionApplication. */
export const actionPlatform = ns("actionPlatform");
/** Indicates the current disposition of the Action. */
export const actionStatus = ns("actionStatus");
/** An actor, e.g. in tv, radio, movie, video games etc. Actors can be associated with individual items or with a series, episode, clip. */
export const actors = ns("actors");
/** An additional offer that can only be obtained in combination with the first base offer (e.g. supplements and extensions that are available for a surcharge). */
export const addOn = ns("addOn");
/** An additional name for a Person, can be used for a middle name. */
export const additionalName = ns("additionalName");
/** If responding yes, the number of guests who will attend in addition to the invitee. */
export const additionalNumberOfGuests = ns("additionalNumberOfGuests");
/** A property-value pair representing an additional characteristics of the entitity, e.g. a product feature or another characteristic for which there is no matching property in schema.org.<br/><br/>

Note: Publishers should be aware that applications designed to use specific schema.org properties (e.g. http://schema.org/width, http://schema.org/color, http://schema.org/gtin13, ...) will typically expect such data to be provided using those properties, rather than using the generic property/value mechanism. */
export const additionalProperty = ns("additionalProperty");
/** An additional type for the item, typically used for adding more specific types from external vocabularies in microdata syntax. This is a relationship between something and a class that the thing is in. In RDFa syntax, it is better to use the native RDFa syntax - the 'typeof' attribute - for multiple types. Schema.org tools may have only weaker understanding of extra types, in particular those defined externally. */
export const additionalType = ns("additionalType");
/** Physical address of the item. */
export const address = ns("address");
/** The country. For example, USA. You can also provide the two-letter <a href="http://en.wikipedia.org/wiki/ISO_3166-1">ISO 3166-1 alpha-2 country code</a>. */
export const addressCountry = ns("addressCountry");
/** The locality in which the street address is, and which is in the region. For example, Mountain View. */
export const addressLocality = ns("addressLocality");
/** The region in which the locality is, and which is in the country. For example, California or another appropriate first-level <a href="https://en.wikipedia.org/wiki/List_of_administrative_divisions_by_country">Administrative division</a> */
export const addressRegion = ns("addressRegion");
/** The amount of time that is required between accepting the offer and the actual usage of the resource or service. */
export const advanceBookingRequirement = ns("advanceBookingRequirement");
/** An organization that this person is affiliated with. For example, a school/university, a club, or a team. */
export const affiliation = ns("affiliation");
/** A media object representing the circumstances after performing this direction. */
export const afterMedia = ns("afterMedia");
/** The direct performer or driver of the action (animate or inanimate). e.g. <em>John</em> wrote a book. */
export const agent = ns("agent");
/** The overall rating, based on a collection of reviews or ratings, of the item. */
export const aggregateRating = ns("aggregateRating");
/** The kind of aircraft (e.g., "Boeing 747"). */
export const aircraft = ns("aircraft");
/** Classification of the album by it's type of content: soundtrack, live album, studio album, etc. */
export const albumProductionType = ns("albumProductionType");
/** The kind of release which this album is: single, EP or album. */
export const albumReleaseType = ns("albumReleaseType");
/** A collection of music albums. */
export const albums = ns("albums");
/** A category of alignment between the learning resource and the framework node. Recommended values include: 'assesses', 'teaches', 'requires', 'textComplexity', 'readingLevel', 'educationalSubject', and 'educationalLevel'. */
export const alignmentType = ns("alignmentType");
/** An alias for the item. */
export const alternateName = ns("alternateName");
/** A secondary title of the CreativeWork. */
export const alternativeHeadline = ns("alternativeHeadline");
/** An amenity feature (e.g. a characteristic or service) of the Accommodation. This generic property does not make a statement about whether the feature is included in an offer for the main accommodation or available at extra costs. */
export const amenityFeature = ns("amenityFeature");
/** The amount of money. */
export const amount = ns("amount");
/** The quantity of the goods included in the offer. */
export const amountOfThisGood = ns("amountOfThisGood");
/** The annual rate that is charged for borrowing (or made by investing), expressed as a single percentage number that represents the actual yearly cost of funds over the term of a loan. This includes any fees or additional costs associated with the transaction. */
export const annualPercentageRate = ns("annualPercentageRate");
/** The number of answers this question has received. */
export const answerCount = ns("answerCount");
/** An application that can complete the request. */
export const application = ns("application");
/** Type of software application, e.g. 'Game, Multimedia'. */
export const applicationCategory = ns("applicationCategory");
/** Subcategory of the application, e.g. 'Arcade Game'. */
export const applicationSubCategory = ns("applicationSubCategory");
/** The name of the application suite to which the application belongs (e.g. Excel belongs to Office). */
export const applicationSuite = ns("applicationSuite");
/** The delivery method(s) to which the delivery charge or payment charge specification applies. */
export const appliesToDeliveryMethod = ns("appliesToDeliveryMethod");
/** The payment method(s) to which the payment charge specification applies. */
export const appliesToPaymentMethod = ns("appliesToPaymentMethod");
/** The area within which users can expect to reach the broadcast service. */
export const area = ns("area");
/** The airport where the flight terminates. */
export const arrivalAirport = ns("arrivalAirport");
/** The stop or station from which the bus arrives. */
export const arrivalBusStop = ns("arrivalBusStop");
/** Identifier of the flight's arrival gate. */
export const arrivalGate = ns("arrivalGate");
/** The platform where the train arrives. */
export const arrivalPlatform = ns("arrivalPlatform");
/** The station where the train trip ends. */
export const arrivalStation = ns("arrivalStation");
/** Identifier of the flight's arrival terminal. */
export const arrivalTerminal = ns("arrivalTerminal");
/** The expected arrival time. */
export const arrivalTime = ns("arrivalTime");
/** The number of copies when multiple copies of a piece of artwork are produced - e.g. for a limited edition of 20 prints, 'artEdition' refers to the total number of copies (in this example "20"). */
export const artEdition = ns("artEdition");
/** The material used. (e.g. Oil, Watercolour, Acrylic, Linoprint, Marble, Cyanotype, Digital, Lithograph, DryPoint, Intaglio, Pastel, Woodcut, Pencil, Mixed Media, etc.) */
export const artMedium = ns("artMedium");
/** e.g. Painting, Drawing, Sculpture, Print, Photograph, Assemblage, Collage, etc. */
export const artform = ns("artform");
/** The actual body of the article. */
export const articleBody = ns("articleBody");
/** Articles may belong to one or more 'sections' in a magazine or newspaper, such as Sports, Lifestyle, etc. */
export const articleSection = ns("articleSection");
/** Library file name e.g., mscorlib.dll, system.web.dll. */
export const assembly = ns("assembly");
/** Associated product/technology version. e.g., .NET Framework 4.5. */
export const assemblyVersion = ns("assemblyVersion");
/** A NewsArticle associated with the Media Object. */
export const associatedArticle = ns("associatedArticle");
/** A media object that encodes this CreativeWork. This property is a synonym for encoding. */
export const associatedMedia = ns("associatedMedia");
/** A person that acts as performing member of a sports team; a player as opposed to a coach. */
export const athlete = ns("athlete");
/** A person attending the event. */
export const attendees = ns("attendees");
/** The target group associated with a given audience (e.g. veterans, car owners, musicians, etc.). */
export const audienceType = ns("audienceType");
/** An embedded audio object. */
export const audio = ns("audio");
/** The Organization responsible for authenticating the user's subscription. For example, many media apps require a cable/satellite provider to authenticate your subscription before playing media. */
export const authenticator = ns("authenticator");
/** The author of this content or rating. Please note that author is special in that HTML 5 provides a special mechanism for indicating authorship via the rel tag. That is equivalent to this and may be used interchangeably. */
export const author = ns("author");
/** The availability of this item&#x2014;for example In stock, Out of stock, Pre-order, etc. */
export const availability = ns("availability");
/** The end of the availability of the product or service included in the offer. */
export const availabilityEnds = ns("availabilityEnds");
/** The beginning of the availability of the product or service included in the offer. */
export const availabilityStarts = ns("availabilityStarts");
/** The place(s) from which the offer can be obtained (e.g. store locations). */
export const availableAtOrFrom = ns("availableAtOrFrom");
/** A means of accessing the service (e.g. a phone bank, a web site, a location, etc.). */
export const availableChannel = ns("availableChannel");
/** The delivery method(s) available for this offer. */
export const availableDeliveryMethod = ns("availableDeliveryMethod");
/** When the item is available for pickup from the store, locker, etc. */
export const availableFrom = ns("availableFrom");
/** A language someone may use with or at the item, service or place. Please use one of the language codes from the <a href="http://tools.ietf.org/html/bcp47">IETF BCP 47 standard</a>. See also <a class="localLink" href="http://schema.org/inLanguage">inLanguage</a> */
export const availableLanguage = ns("availableLanguage");
/** After this date, the item will no longer be available for pickup. */
export const availableThrough = ns("availableThrough");
/** Awards won by or for this item. */
export const awards = ns("awards");
/** The away team in a sports event. */
export const awayTeam = ns("awayTeam");
/** The base salary of the job or of an employee in an EmployeeRole. */
export const baseSalary = ns("baseSalary");
/** A sub property of recipient. The recipient blind copied on a message. */
export const bccRecipient = ns("bccRecipient");
/** The type of bed or beds included in the accommodation. For the single case of just one bed of a certain type, you use bed directly with a text.
      If you want to indicate the quantity of a certain kind of bed, use an instance of BedDetails. For more detailed information, use the amenityFeature property. */
export const bed = ns("bed");
/** A media object representing the circumstances before performing this direction. */
export const beforeMedia = ns("beforeMedia");
/** Description of benefits associated with the job. */
export const benefits = ns("benefits");
/** The highest value allowed in this rating system. If bestRating is omitted, 5 is assumed. */
export const bestRating = ns("bestRating");
/** The billing address for the order. */
export const billingAddress = ns("billingAddress");
/** This property specifies the minimal quantity and rounding increment that will be the basis for the billing. The unit of measurement is specified by the unitCode property. */
export const billingIncrement = ns("billingIncrement");
/** The time interval used to compute the invoice. */
export const billingPeriod = ns("billingPeriod");
/** Date of birth. */
export const birthDate = ns("birthDate");
/** The place where the person was born. */
export const birthPlace = ns("birthPlace");
/** The bitrate of the media object. */
export const bitrate = ns("bitrate");
/** The postings that are part of this blog. */
export const blogPosts = ns("blogPosts");
/** The airline-specific indicator of boarding order / preference. */
export const boardingGroup = ns("boardingGroup");
/** The type of boarding policy used by the airline (e.g. zone-based or group-based). */
export const boardingPolicy = ns("boardingPolicy");
/** The edition of the book. */
export const bookEdition = ns("bookEdition");
/** The format of the book. */
export const bookFormat = ns("bookFormat");
/** 'bookingAgent' is an out-dated term indicating a 'broker' that serves as a booking agent. */
export const bookingAgent = ns("bookingAgent");
/** The date and time the reservation was booked. */
export const bookingTime = ns("bookingTime");
/** A sub property of participant. The person that borrows the object being lent. */
export const borrower = ns("borrower");
/** A box is the area enclosed by the rectangle formed by two points. The first point is the lower corner, the second point is the upper corner. A box is expressed as two points separated by a space character. */
export const box = ns("box");
/** A short textual code (also called "store code") that uniquely identifies a place of business. The code is typically assigned by the parentOrganization and used in structured URLs.<br/><br/>

For example, in the URL http://www.starbucks.co.uk/store-locator/etc/detail/3047 the code "3047" is a branchCode for a particular branch. */
export const branchCode = ns("branchCode");
/** The larger organization that this local business is a branch of, if any. Not to be confused with (anatomical)<a class="localLink" href="http://schema.org/branch">branch</a>. */
export const branchOf = ns("branchOf");
/** The brand(s) associated with a product or service, or the brand(s) maintained by an organization or business person. */
export const brand = ns("brand");
/** A set of links that can help a user understand and navigate a website hierarchy. */
export const breadcrumb = ns("breadcrumb");
/** The media network(s) whose content is broadcast on this station. */
export const broadcastAffiliateOf = ns("broadcastAffiliateOf");
/** The unique address by which the BroadcastService can be identified in a provider lineup. In US, this is typically a number. */
export const broadcastChannelId = ns("broadcastChannelId");
/** The name displayed in the channel guide. For many US affiliates, it is the network name. */
export const broadcastDisplayName = ns("broadcastDisplayName");
/** The frequency used for over-the-air broadcasts. Numeric values or simple ranges e.g. 87-99. In addition a shortcut idiom is supported for frequences of AM and FM radio channels, e.g. "87 FM". */
export const broadcastFrequency = ns("broadcastFrequency");
/** The frequency in MHz for a particular broadcast. */
export const broadcastFrequencyValue = ns("broadcastFrequencyValue");
/** The event being broadcast such as a sporting event or awards ceremony. */
export const broadcastOfEvent = ns("broadcastOfEvent");
/** The type of service required to have access to the channel (e.g. Standard or Premium). */
export const broadcastServiceTier = ns("broadcastServiceTier");
/** The timezone in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 format</a> for which the service bases its broadcasts */
export const broadcastTimezone = ns("broadcastTimezone");
/** The organization owning or operating the broadcast service. */
export const broadcaster = ns("broadcaster");
/** Specifies browser requirements in human-readable text. For example, 'requires HTML5 support'. */
export const browserRequirements = ns("browserRequirements");
/** The name of the bus (e.g. Bolt Express). */
export const busName = ns("busName");
/** The unique identifier for the bus. */
export const busNumber = ns("busNumber");
/** The business function (e.g. sell, lease, repair, dispose) of the offer or component of a bundle (TypeAndQuantityNode). The default is http://purl.org/goodrelations/v1#Sell. */
export const businessFunction = ns("businessFunction");
/** A sub property of participant. The participant/person/organization that bought the object. */
export const buyer = ns("buyer");
/** The artist that performed this album or recording. */
export const byArtist = ns("byArtist");
/** The number of calories. */
export const calories = ns("calories");
/** A sub property of object. The candidate subject of this action. */
export const candidate = ns("candidate");
/** The caption for this object. For downloadable machine formats (closed caption, subtitles etc.) use MediaObject and indicate the <a class="localLink" href="http://schema.org/encodingFormat">encodingFormat</a>. */
export const caption = ns("caption");
/** The number of grams of carbohydrates. */
export const carbohydrateContent = ns("carbohydrateContent");
/** The available volume for cargo or luggage. For automobiles, this is usually the trunk volume.<br/><br/>

Typical unit code(s): LTR for liters, FTQ for cubic foot/feet<br/><br/>

Note: You can use <a class="localLink" href="http://schema.org/minValue">minValue</a> and <a class="localLink" href="http://schema.org/maxValue">maxValue</a> to indicate ranges. */
export const cargoVolume = ns("cargoVolume");
/** 'carrier' is an out-dated term indicating the 'provider' for parcel delivery and flights. */
export const carrier = ns("carrier");
/** Specifies specific carrier(s) requirements for the application (e.g. an application may only work on a specific carrier network). */
export const carrierRequirements = ns("carrierRequirements");
/** A data catalog which contains this dataset. */
export const catalog = ns("catalog");
/** The catalog number for the release. */
export const catalogNumber = ns("catalogNumber");
/** A category for the item. Greater signs or slashes can be used to informally indicate a category hierarchy. */
export const category = ns("category");
/** A sub property of recipient. The recipient copied on a message. */
export const ccRecipient = ns("ccRecipient");
/** Fictional person connected with a creative work. */
export const character = ns("character");
/** A piece of data that represents a particular aspect of a fictional character (skill, power, character points, advantage, disadvantage). */
export const characterAttribute = ns("characterAttribute");
/** The name of a character played in some acting or performing role, i.e. in a PerformanceRole. */
export const characterName = ns("characterName");
/** Cheat codes to the game. */
export const cheatCode = ns("cheatCode");
/** The earliest someone may check into a lodging establishment. */
export const checkinTime = ns("checkinTime");
/** The latest someone may check out of a lodging establishment. */
export const checkoutTime = ns("checkoutTime");
/** Maximal age of the child. */
export const childMaxAge = ns("childMaxAge");
/** Minimal age of the child. */
export const childMinAge = ns("childMinAge");
/** A child of the person. */
export const children = ns("children");
/** The number of milligrams of cholesterol. */
export const cholesterolContent = ns("cholesterolContent");
/** A circle is the circular region of a specified radius centered at a specified latitude and longitude. A circle is expressed as a pair followed by a radius in meters. */
export const circle = ns("circle");
/** A citation or reference to another creative work, such as another publication, web page, scholarly article, etc. */
export const citation = ns("citation");
/** A short summary of the specific claims reviewed in a ClaimReview. */
export const claimReviewed = ns("claimReviewed");
/** Position of the clip within an ordered group of clips. */
export const clipNumber = ns("clipNumber");
/** The closing hour of the place or service on the given day(s) of the week. */
export const closes = ns("closes");
/** A person that acts in a coaching role for a sports team. */
export const coach = ns("coach");
/** Link to the repository where the un-compiled, human readable code and related code is located (SVN, github, CodePlex). */
export const codeRepository = ns("codeRepository");
/** A colleague of the person. */
export const colleagues = ns("colleagues");
/** A sub property of object. The collection target of the action. */
export const collection = ns("collection");
/** The color of the product. */
export const color = ns("color");
/** Comments, typically from users. */
export const comment = ns("comment");
/** The number of comments this CreativeWork (e.g. Article, Question or Answer) has received. This is most applicable to works published in Web sites with commenting system; additional comments may exist elsewhere. */
export const commentCount = ns("commentCount");
/** The text of the UserComment. */
export const commentText = ns("commentText");
/** The time at which the UserComment was made. */
export const commentTime = ns("commentTime");
/** The person or organization who wrote a composition, or who is the composer of a work performed at some event. */
export const composer = ns("composer");
/** A number that confirms the given order or payment has been received. */
export const confirmationNumber = ns("confirmationNumber");
/** An option available on this contact point (e.g. a toll-free number or support for hearing-impaired callers). */
export const contactOption = ns("contactOption");
/** A contact point for a person or organization. */
export const contactPoints = ns("contactPoints");
/** A person or organization can have different contact points, for different purposes. For example, a sales contact point, a PR contact point and so on. This property is used to specify the kind of contact point. */
export const contactType = ns("contactType");
/** The basic containment relation between a place and one that contains it. */
export const containedIn = ns("containedIn");
/** Official rating of a piece of content&#x2014;for example,'MPAA PG-13'. */
export const contentRating = ns("contentRating");
/** File size in (mega/kilo) bytes. */
export const contentSize = ns("contentSize");
/** The supported content type(s) for an EntryPoint response. */
export const contentType = ns("contentType");
/** Actual bytes of the media object, for example the image file or video file. */
export const contentUrl = ns("contentUrl");
/** A secondary contributor to the CreativeWork or Event. */
export const contributor = ns("contributor");
/** The time it takes to actually cook the dish, in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 duration format</a>. */
export const cookTime = ns("cookTime");
/** The method of cooking, such as Frying, Steaming, ... */
export const cookingMethod = ns("cookingMethod");
/** The party holding the legal copyright to the CreativeWork. */
export const copyrightHolder = ns("copyrightHolder");
/** The year during which the claimed copyright for the CreativeWork was first asserted. */
export const copyrightYear = ns("copyrightYear");
/** Countries for which the application is not supported. You can also provide the two-letter ISO 3166-1 alpha-2 country code. */
export const countriesNotSupported = ns("countriesNotSupported");
/** Countries for which the application is supported. You can also provide the two-letter ISO 3166-1 alpha-2 country code. */
export const countriesSupported = ns("countriesSupported");
/** The country of the principal offices of the production company or individual responsible for the movie or program. */
export const countryOfOrigin = ns("countryOfOrigin");
/** A sub property of location. The course where this action was taken. */
export const course = ns("course");
/** The identifier for the <a class="localLink" href="http://schema.org/Course">Course</a> used by the course <a class="localLink" href="http://schema.org/provider">provider</a> (e.g. CS101 or 6.001). */
export const courseCode = ns("courseCode");
/** The medium or means of delivery of the course instance or the mode of study, either as a text label (e.g. "online", "onsite" or "blended"; "synchronous" or "asynchronous"; "full-time" or "part-time") or as a URL reference to a term from a controlled vocabulary (e.g. https://ceds.ed.gov/element/001311#Asynchronous ). */
export const courseMode = ns("courseMode");
/** Requirements for taking the Course. May be completion of another <a class="localLink" href="http://schema.org/Course">Course</a> or a textual description like "permission of instructor". Requirements may be a pre-requisite competency, referenced using <a class="localLink" href="http://schema.org/AlignmentObject">AlignmentObject</a>. */
export const coursePrerequisites = ns("coursePrerequisites");
/** The time when the live blog will stop covering the Event. Note that coverage may continue after the Event concludes. */
export const coverageEndTime = ns("coverageEndTime");
/** The time when the live blog will begin covering the Event. Note that coverage may begin before the Event's start time. The LiveBlogPosting may also be created before coverage begins. */
export const coverageStartTime = ns("coverageStartTime");
/** The creator/author of this CreativeWork. This is the same as the Author property for CreativeWork. */
export const creator = ns("creator");
/** The group the release is credited to if different than the byArtist. For example, Red and Blue is credited to "Stefani Germanotta Band", but by Lady Gaga. */
export const creditedTo = ns("creditedTo");
/** A CSS selector, e.g. of a <a class="localLink" href="http://schema.org/SpeakableSpecification">SpeakableSpecification</a> or <a class="localLink" href="http://schema.org/WebPageElement">WebPageElement</a>. In the latter case, multiple matches within a page can constitute a single conceptual "Web page element". */
export const cssSelector = ns("cssSelector");
/** The currency accepted.<br/><br/>

Use standard formats: <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217 currency format</a> e.g. "USD"; <a href="https://en.wikipedia.org/wiki/List_of_cryptocurrencies">Ticker symbol</a> for cryptocurrencies e.g. "BTC"; well known names for <a href="https://en.wikipedia.org/wiki/Local_exchange_trading_system">Local Exchange Tradings Systems</a> (LETS) and other currency types e.g. "Ithaca HOUR". */
export const currenciesAccepted = ns("currenciesAccepted");
/** The currency in which the monetary amount is expressed.<br/><br/>

Use standard formats: <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217 currency format</a> e.g. "USD"; <a href="https://en.wikipedia.org/wiki/List_of_cryptocurrencies">Ticker symbol</a> for cryptocurrencies e.g. "BTC"; well known names for <a href="https://en.wikipedia.org/wiki/Local_exchange_trading_system">Local Exchange Tradings Systems</a> (LETS) and other currency types e.g. "Ithaca HOUR". */
export const currency = ns("currency");
/** Party placing the order or paying the invoice. */
export const customer = ns("customer");
/** An item within in a data feed. Data feeds may have many elements. */
export const dataFeedElement = ns("dataFeedElement");
/** The range of temporal applicability of a dataset, e.g. for a 2011 census dataset, the year 2011 (in ISO 8601 time interval format). */
export const datasetTimeInterval = ns("datasetTimeInterval");
/** The date on which the CreativeWork was created or the item was added to a DataFeed. */
export const dateCreated = ns("dateCreated");
/** The datetime the item was removed from the DataFeed. */
export const dateDeleted = ns("dateDeleted");
/** The date the ticket was issued. */
export const dateIssued = ns("dateIssued");
/** The date on which the CreativeWork was most recently modified or when the item's entry was modified within a DataFeed. */
export const dateModified = ns("dateModified");
/** Publication date for the job posting. */
export const datePosted = ns("datePosted");
/** Date of first broadcast/publication. */
export const datePublished = ns("datePublished");
/** The date/time at which the message has been read by the recipient if a single recipient exists. */
export const dateRead = ns("dateRead");
/** The date/time the message was received if a single recipient exists. */
export const dateReceived = ns("dateReceived");
/** The date/time at which the message was sent. */
export const dateSent = ns("dateSent");
/** The date of the first registration of the vehicle with the respective public authorities. */
export const dateVehicleFirstRegistered = ns("dateVehicleFirstRegistered");
/** A <a href="https://en.wikipedia.org/wiki/Dateline">dateline</a> is a brief piece of text included in news articles that describes where and when the story was written or filed though the date is often omitted. Sometimes only a placename is provided.<br/><br/>

Structured representations of dateline-related information can also be expressed more explicitly using <a class="localLink" href="http://schema.org/locationCreated">locationCreated</a> (which represents where a work was created e.g. where a news report was written).  For location depicted or described in the content, use <a class="localLink" href="http://schema.org/contentLocation">contentLocation</a>.<br/><br/>

Dateline summaries are oriented more towards human readers than towards automated processing, and can vary substantially. Some examples: "BEIRUT, Lebanon, June 2.", "Paris, France", "December 19, 2017 11:43AM Reporting from Washington", "Beijing/Moscow", "QUEZON CITY, Philippines". */
export const dateline = ns("dateline");
/** The day of the week for which these opening hours are valid. */
export const dayOfWeek = ns("dayOfWeek");
/** Date of death. */
export const deathDate = ns("deathDate");
/** The place where the person died. */
export const deathPlace = ns("deathPlace");
/** The default value of the input.  For properties that expect a literal, the default is a literal value, for properties that expect an object, it's an ID reference to one of the current values. */
export const defaultValue = ns("defaultValue");
/** Destination address. */
export const deliveryAddress = ns("deliveryAddress");
/** The typical delay between the receipt of the order and the goods either leaving the warehouse or being prepared for pickup, in case the delivery method is on site pickup. */
export const deliveryLeadTime = ns("deliveryLeadTime");
/** A sub property of instrument. The method of delivery. */
export const deliveryMethod = ns("deliveryMethod");
/** New entry added as the package passes through each leg of its journey (from shipment to final delivery). */
export const deliveryStatus = ns("deliveryStatus");
/** A relationship between an organization and a department of that organization, also described as an organization (allowing different urls, logos, opening hours). For example: a store with a pharmacy, or a bakery with a cafe. */
export const department = ns("department");
/** The airport where the flight originates. */
export const departureAirport = ns("departureAirport");
/** The stop or station from which the bus departs. */
export const departureBusStop = ns("departureBusStop");
/** Identifier of the flight's departure gate. */
export const departureGate = ns("departureGate");
/** The platform from which the train departs. */
export const departurePlatform = ns("departurePlatform");
/** The station from which the train departs. */
export const departureStation = ns("departureStation");
/** Identifier of the flight's departure terminal. */
export const departureTerminal = ns("departureTerminal");
/** The expected departure time. */
export const departureTime = ns("departureTime");
/** Prerequisites needed to fulfill steps in article. */
export const dependencies = ns("dependencies");
/** The depth of the item. */
export const depth = ns("depth");
/** Device required to run the application. Used in cases where a specific make/model is required to run the application. */
export const device = ns("device");
/** A director of e.g. tv, radio, movie, video games etc. content. Directors can be associated with individual items or with a series, episode, clip. */
export const directors = ns("directors");
/** A sub property of description. A short description of the item used to disambiguate from other, similar items. Information from other properties (in particular, name) may be necessary for the description to be useful for disambiguation. */
export const disambiguatingDescription = ns("disambiguatingDescription");
/** Any discount applied (to an Order). */
export const discount = ns("discount");
/** Code used to redeem a discount. */
export const discountCode = ns("discountCode");
/** The currency of the discount.<br/><br/>

Use standard formats: <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217 currency format</a> e.g. "USD"; <a href="https://en.wikipedia.org/wiki/List_of_cryptocurrencies">Ticker symbol</a> for cryptocurrencies e.g. "BTC"; well known names for <a href="https://en.wikipedia.org/wiki/Local_exchange_trading_system">Local Exchange Tradings Systems</a> (LETS) and other currency types e.g. "Ithaca HOUR". */
export const discountCurrency = ns("discountCurrency");
/** Specifies the CreativeWork associated with the UserComment. */
export const discusses = ns("discusses");
/** A link to the page containing the comments of the CreativeWork. */
export const discussionUrl = ns("discussionUrl");
/** The date that this organization was dissolved. */
export const dissolutionDate = ns("dissolutionDate");
/** The distance travelled, e.g. exercising or travelling. */
export const distance = ns("distance");
/** A downloadable form of this dataset, at a specific location, in a specific format. */
export const distribution = ns("distribution");
/** The time admission will commence. */
export const doorTime = ns("doorTime");
/** If the file can be downloaded, URL to download the binary. */
export const downloadUrl = ns("downloadUrl");
/** The number of downvotes this question, answer or comment has received from the community. */
export const downvoteCount = ns("downvoteCount");
/** The drive wheel configuration, i.e. which roadwheels will receive torque from the vehicle's engine via the drivetrain. */
export const driveWheelConfiguration = ns("driveWheelConfiguration");
/** Where a rental car can be dropped off. */
export const dropoffLocation = ns("dropoffLocation");
/** When a rental car can be dropped off. */
export const dropoffTime = ns("dropoffTime");
/** The Dun &amp; Bradstreet DUNS number for identifying an organization or business person. */
export const duns = ns("duns");
/** The duration of the warranty promise. Common unitCode values are ANN for year, MON for months, or DAY for days. */
export const durationOfWarranty = ns("durationOfWarranty");
/** A media object representing the circumstances while performing this direction. */
export const duringMedia = ns("duringMedia");
/** Specifies the Person who edited the CreativeWork. */
export const editor = ns("editor");
/** An alignment to an established educational framework. */
export const educationalAlignment = ns("educationalAlignment");
/** A description of the qualification, award, certificate, diploma or other educational credential awarded as a consequence of successful completion of this course or program. */
export const educationalCredentialAwarded = ns("educationalCredentialAwarded");
/** The framework to which the resource being described is aligned. */
export const educationalFramework = ns("educationalFramework");
/** An educationalRole of an EducationalAudience. */
export const educationalRole = ns("educationalRole");
/** The purpose of a work in the context of education; for example, 'assignment', 'group work'. */
export const educationalUse = ns("educationalUse");
/** The elevation of a location (<a href="https://en.wikipedia.org/wiki/World_Geodetic_System">WGS 84</a>). Values may be of the form 'NUMBER UNIT<em>OF</em>MEASUREMENT' (e.g., '1,000 m', '3,200 ft') while numbers alone should be assumed to be a value in meters. */
export const elevation = ns("elevation");
/** The type(s) of customers for which the given offer is valid. */
export const eligibleCustomerType = ns("eligibleCustomerType");
/** The duration for which the given offer is valid. */
export const eligibleDuration = ns("eligibleDuration");
/** The interval and unit of measurement of ordering quantities for which the offer or price specification is valid. This allows e.g. specifying that a certain freight charge is valid only for a certain quantity. */
export const eligibleQuantity = ns("eligibleQuantity");
/** The ISO 3166-1 (ISO 3166-1 alpha-2) or ISO 3166-2 code, the place, or the GeoShape for the geo-political region(s) for which the offer or delivery charge specification is valid.<br/><br/>

See also <a class="localLink" href="http://schema.org/ineligibleRegion">ineligibleRegion</a>. */
export const eligibleRegion = ns("eligibleRegion");
/** The transaction volume, in a monetary unit, for which the offer or price specification is valid, e.g. for indicating a minimal purchasing volume, to express free shipping above a certain order volume, or to limit the acceptance of credit cards to purchases to a certain minimal amount. */
export const eligibleTransactionVolume = ns("eligibleTransactionVolume");
/** Email address. */
export const email = ns("email");
/** A URL pointing to a player for a specific video. In general, this is the information in the <code>src</code> element of an <code>embed</code> tag and should not be the same as the content of the <code>loc</code> tag. */
export const embedUrl = ns("embedUrl");
/** People working for this organization. */
export const employees = ns("employees");
/** Type of employment (e.g. full-time, part-time, contract, temporary, seasonal, internship). */
export const employmentType = ns("employmentType");
/** The supported encoding type(s) for an EntryPoint request. */
export const encodingType = ns("encodingType");
/** A media object that encodes this CreativeWork. */
export const encodings = ns("encodings");
/** The end date and time of the item (in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 date format</a>). */
export const endDate = ns("endDate");
/** The endTime of something. For a reserved event or service (e.g. FoodEstablishmentReservation), the time that it is expected to end. For actions that span a period of time, when the action was performed. e.g. John wrote a book from January to <em>December</em>. For media, including audio and video, it's the time offset of the end of a clip within a larger file.<br/><br/>

Note that Event uses startDate/endDate instead of startTime/endTime, even when describing dates with times. This situation may be clarified in future revisions. */
export const endTime = ns("endTime");
/** A sub property of participant. The person/organization being supported. */
export const endorsee = ns("endorsee");
/** A sub property of location. The entertainment business where the action occurred. */
export const entertainmentBusiness = ns("entertainmentBusiness");
/** Position of the episode within an ordered group of episodes. */
export const episodeNumber = ns("episodeNumber");
/** An episode of a TV/radio series or season. */
export const episodes = ns("episodes");
/** This ordering relation for qualitative values indicates that the subject is equal to the object. */
export const equal = ns("equal");
/** For failed actions, more information on the cause of the failure. */
export const error = ns("error");
/** The estimated cost of the supply or supplies consumed when performing instructions. */
export const estimatedCost = ns("estimatedCost");
/** The estimated time the flight will take. */
export const estimatedFlightDuration = ns("estimatedFlightDuration");
/** An estimated salary for a job posting or occupation, based on a variety of variables including, but not limited to industry, job title, and location. Estimated salaries  are often computed by outside organizations rather than the hiring organization, who may not have committed to the estimated value. */
export const estimatedSalary = ns("estimatedSalary");
/** An eventStatus of an event represents its status; particularly useful when an event is cancelled or rescheduled. */
export const eventStatus = ns("eventStatus");
/** Upcoming or past events associated with this place or organization. */
export const events = ns("events");
/** exif data for this object. */
export const exifData = ns("exifData");
/** The earliest date the package may arrive. */
export const expectedArrivalFrom = ns("expectedArrivalFrom");
/** The latest date the package may arrive. */
export const expectedArrivalUntil = ns("expectedArrivalUntil");
/** An Offer which must be accepted before the user can perform the Action. For example, the user may need to buy a movie before being able to watch it. */
export const expectsAcceptanceOf = ns("expectsAcceptanceOf");
/** Description of skills and experience needed for the position or Occupation. */
export const experienceRequirements = ns("experienceRequirements");
/** Date the content expires and is no longer useful or available. For example a <a class="localLink" href="http://schema.org/VideoObject">VideoObject</a> or <a class="localLink" href="http://schema.org/NewsArticle">NewsArticle</a> whose availability or relevance is time-limited, or a <a class="localLink" href="http://schema.org/ClaimReview">ClaimReview</a> fact check whose publisher wants to indicate that it may no longer be relevant (or helpful to highlight) after some date. */
export const expires = ns("expires");
/** Family name. In the U.S., the last name of an Person. This can be used along with givenName instead of the name property. */
export const familyName = ns("familyName");
/** The number of grams of fat. */
export const fatContent = ns("fatContent");
/** The fax number. */
export const faxNumber = ns("faxNumber");
/** Features or modules provided by this application (and possibly required by other applications). */
export const featureList = ns("featureList");
/** Description of fees, commissions, and other terms applied either to a class of financial product, or by a financial service organization. */
export const feesAndCommissionsSpecification = ns("feesAndCommissionsSpecification");
/** The number of grams of fiber. */
export const fiberContent = ns("fiberContent");
/** Media type, typically MIME format (see <a href="http://www.iana.org/assignments/media-types/media-types.xhtml">IANA site</a>) of the content e.g. application/zip of a SoftwareApplication binary. In cases where a CreativeWork has several media type representations, 'encoding' can be used to indicate each MediaObject alongside particular fileFormat information. Unregistered or niche file formats can be indicated instead via the most appropriate URL, e.g. defining Web page or a Wikipedia entry. */
export const fileFormat = ns("fileFormat");
/** Size of the application / package (e.g. 18MB). In the absence of a unit (MB, KB etc.), KB will be assumed. */
export const fileSize = ns("fileSize");
/** The date and place the work was first performed. */
export const firstPerformance = ns("firstPerformance");
/** The distance of the flight. */
export const flightDistance = ns("flightDistance");
/** The unique identifier for a flight including the airline IATA code. For example, if describing United flight 110, where the IATA code for United is 'UA', the flightNumber is 'UA110'. */
export const flightNumber = ns("flightNumber");
/** The size of the accommodation, e.g. in square meter or squarefoot.
Typical unit code(s): MTK for square meter, FTK for square foot, or YDK for square yard */
export const floorSize = ns("floorSize");
/** A sub property of object. The person or organization being followed. */
export const followee = ns("followee");
/** The most generic uni-directional social relation. */
export const follows = ns("follows");
/** A sub property of location. The specific food establishment where the action occurred. */
export const foodEstablishment = ns("foodEstablishment");
/** A sub property of location. The specific food event where the action occurred. */
export const foodEvent = ns("foodEvent");
/** A person who founded this organization. */
export const founders = ns("founders");
/** The date that this organization was founded. */
export const foundingDate = ns("foundingDate");
/** The place where the Organization was founded. */
export const foundingLocation = ns("foundingLocation");
/** A flag to signal that the item, event, or place is accessible for free. */
export const free = ns("free");
/** A sub property of location. The original location of the object or the agent before the action. */
export const fromLocation = ns("fromLocation");
/** The amount of fuel consumed for traveling a particular distance or temporal duration with the given vehicle (e.g. liters per 100 km).<br/><br/>

<ul>
<li>Note 1: There are unfortunately no standard unit codes for liters per 100 km.  Use <a class="localLink" href="http://schema.org/unitText">unitText</a> to indicate the unit of measurement, e.g. L/100 km.</li>
<li>Note 2: There are two ways of indicating the fuel consumption, <a class="localLink" href="http://schema.org/fuelConsumption">fuelConsumption</a> (e.g. 8 liters per 100 km) and <a class="localLink" href="http://schema.org/fuelEfficiency">fuelEfficiency</a> (e.g. 30 miles per gallon). They are reciprocal.</li>
<li>Note 3: Often, the absolute value is useful only when related to driving speed ("at 80 km/h") or usage pattern ("city traffic"). You can use <a class="localLink" href="http://schema.org/valueReference">valueReference</a> to link the value for the fuel consumption to another value.</li>
</ul>
 */
export const fuelConsumption = ns("fuelConsumption");
/** The distance traveled per unit of fuel used; most commonly miles per gallon (mpg) or kilometers per liter (km/L).<br/><br/>

<ul>
<li>Note 1: There are unfortunately no standard unit codes for miles per gallon or kilometers per liter. Use <a class="localLink" href="http://schema.org/unitText">unitText</a> to indicate the unit of measurement, e.g. mpg or km/L.</li>
<li>Note 2: There are two ways of indicating the fuel consumption, <a class="localLink" href="http://schema.org/fuelConsumption">fuelConsumption</a> (e.g. 8 liters per 100 km) and <a class="localLink" href="http://schema.org/fuelEfficiency">fuelEfficiency</a> (e.g. 30 miles per gallon). They are reciprocal.</li>
<li>Note 3: Often, the absolute value is useful only when related to driving speed ("at 80 km/h") or usage pattern ("city traffic"). You can use <a class="localLink" href="http://schema.org/valueReference">valueReference</a> to link the value for the fuel economy to another value.</li>
</ul>
 */
export const fuelEfficiency = ns("fuelEfficiency");
/** The type of fuel suitable for the engine or engines of the vehicle. If the vehicle has only one engine, this property can be attached directly to the vehicle. */
export const fuelType = ns("fuelType");
/** A person or organization that supports (sponsors) something through some kind of financial contribution. */
export const funder = ns("funder");
/** An item is an object within the game world that can be collected by a player or, occasionally, a non-player character. */
export const gameItem = ns("gameItem");
/** Real or fictional location of the game (or part of game). */
export const gameLocation = ns("gameLocation");
/** The electronic systems used to play <a href="http://en.wikipedia.org/wiki/Category:Video_game_platforms">video games</a>. */
export const gamePlatform = ns("gamePlatform");
/** Links to tips, tactics, etc. */
export const gameTip = ns("gameTip");
/** Gender of the person. While http://schema.org/Male and http://schema.org/Female may be used, text strings are also acceptable for people who do not identify as a binary gender. */
export const gender = ns("gender");
/** Genre of the creative work, broadcast channel or group. */
export const genre = ns("genre");
/** The geo coordinates of the place. */
export const geo = ns("geo");
/** Represents a relationship between two geometries (or the places they represent), relating a containing geometry to a contained geometry. "a contains b iff no points of b lie in the exterior of a, and at least one point of the interior of b lies in the interior of a". As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
export const geoContains = ns("geoContains");
/** Represents a relationship between two geometries (or the places they represent), relating a geometry to another that covers it. As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
export const geoCoveredBy = ns("geoCoveredBy");
/** Represents a relationship between two geometries (or the places they represent), relating a covering geometry to a covered geometry. "Every point of b is a point of (the interior or boundary of) a". As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
export const geoCovers = ns("geoCovers");
/** Represents a relationship between two geometries (or the places they represent), relating a geometry to another that crosses it: "a crosses b: they have some but not all interior points in common, and the dimension of the intersection is less than that of at least one of them". As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
export const geoCrosses = ns("geoCrosses");
/** Represents spatial relations in which two geometries (or the places they represent) are topologically disjoint: they have no point in common. They form a set of disconnected geometries." (a symmetric relationship, as defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>) */
export const geoDisjoint = ns("geoDisjoint");
/** Represents spatial relations in which two geometries (or the places they represent) are topologically equal, as defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. "Two geometries are topologically equal if their interiors intersect and no part of the interior or boundary of one geometry intersects the exterior of the other" (a symmetric relationship) */
export const geoEquals = ns("geoEquals");
/** Represents spatial relations in which two geometries (or the places they represent) have at least one point in common. As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
export const geoIntersects = ns("geoIntersects");
/** Indicates the GeoCoordinates at the centre of a GeoShape e.g. GeoCircle. */
export const geoMidpoint = ns("geoMidpoint");
/** Represents a relationship between two geometries (or the places they represent), relating a geometry to another that geospatially overlaps it, i.e. they have some but not all points in common. As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
export const geoOverlaps = ns("geoOverlaps");
/** Indicates the approximate radius of a GeoCircle (metres unless indicated otherwise via Distance notation). */
export const geoRadius = ns("geoRadius");
/** Represents spatial relations in which two geometries (or the places they represent) touch: they have at least one boundary point in common, but no interior points." (a symmetric relationship, as defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a> ) */
export const geoTouches = ns("geoTouches");
/** Represents a relationship between two geometries (or the places they represent), relating a geometry to one that contains it, i.e. it is inside (i.e. within) its interior. As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
export const geoWithin = ns("geoWithin");
/** The geographic area associated with the audience. */
export const geographicArea = ns("geographicArea");
/** Given name. In the U.S., the first name of a Person. This can be used along with familyName instead of the name property. */
export const givenName = ns("givenName");
/** The <a href="http://www.gs1.org/gln">Global Location Number</a> (GLN, sometimes also referred to as International Location Number or ILN) of the respective organization, person, or place. The GLN is a 13-digit number used to identify parties and physical locations. */
export const globalLocationNumber = ns("globalLocationNumber");
/** The person, organization, contact point, or audience that has been granted this permission. */
export const grantee = ns("grantee");
/** This ordering relation for qualitative values indicates that the subject is greater than the object. */
export const greater = ns("greater");
/** This ordering relation for qualitative values indicates that the subject is greater than or equal to the object. */
export const greaterOrEqual = ns("greaterOrEqual");
/** The GTIN-12 code of the product, or the product to which the offer refers. The GTIN-12 is the 12-digit GS1 Identification Key composed of a U.P.C. Company Prefix, Item Reference, and Check Digit used to identify trade items. See <a href="http://www.gs1.org/barcodes/technical/idkeys/gtin">GS1 GTIN Summary</a> for more details. */
export const gtin12 = ns("gtin12");
/** The GTIN-13 code of the product, or the product to which the offer refers. This is equivalent to 13-digit ISBN codes and EAN UCC-13. Former 12-digit UPC codes can be converted into a GTIN-13 code by simply adding a preceeding zero. See <a href="http://www.gs1.org/barcodes/technical/idkeys/gtin">GS1 GTIN Summary</a> for more details. */
export const gtin13 = ns("gtin13");
/** The GTIN-14 code of the product, or the product to which the offer refers. See <a href="http://www.gs1.org/barcodes/technical/idkeys/gtin">GS1 GTIN Summary</a> for more details. */
export const gtin14 = ns("gtin14");
/** The <a href="http://apps.gs1.org/GDD/glossary/Pages/GTIN-8.aspx">GTIN-8</a> code of the product, or the product to which the offer refers. This code is also known as EAN/UCC-8 or 8-digit EAN. See <a href="http://www.gs1.org/barcodes/technical/idkeys/gtin">GS1 GTIN Summary</a> for more details. */
export const gtin8 = ns("gtin8");
/** An offering of the course at a specific time and place or through specific media or mode of study or to a specific section of students. */
export const hasCourseInstance = ns("hasCourseInstance");
/** Method used for delivery or shipping. */
export const hasDeliveryMethod = ns("hasDeliveryMethod");
/** A permission related to the access to this document (e.g. permission to read or write an electronic document). For a public document, specify a grantee with an Audience with audienceType equal to "public". */
export const hasDigitalDocumentPermission = ns("hasDigitalDocumentPermission");
/** A food or drink item contained in a menu or menu section. */
export const hasMenuItem = ns("hasMenuItem");
/** A subgrouping of the menu (by dishes, course, serving time period, etc.). */
export const hasMenuSection = ns("hasMenuSection");
/** The Person's occupation. For past professions, use Role for expressing dates. */
export const hasOccupation = ns("hasOccupation");
/** Indicates an OfferCatalog listing for this Organization, Person, or Service. */
export const hasOfferCatalog = ns("hasOfferCatalog");
/** Points-of-Sales operated by the organization or person. */
export const hasPOS = ns("hasPOS");
/** Headline of the article. */
export const headline = ns("headline");
/** The height of the item. */
export const height = ns("height");
/** The highest price of all offers available.<br/><br/>

Usage guidelines:<br/><br/>

<ul>
<li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
<li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
</ul>
 */
export const highPrice = ns("highPrice");
/** Organization offering the job position. */
export const hiringOrganization = ns("hiringOrganization");
/** A contact location for a person's residence. */
export const homeLocation = ns("homeLocation");
/** The home team in a sports event. */
export const homeTeam = ns("homeTeam");
/** An honorific prefix preceding a Person's name such as Dr/Mrs/Mr. */
export const honorificPrefix = ns("honorificPrefix");
/** An honorific suffix preceding a Person's name such as M.D. /PhD/MSCSW. */
export const honorificSuffix = ns("honorificSuffix");
/** The organization (airline, travelers' club, etc.) the membership is made with. */
export const hostingOrganization = ns("hostingOrganization");
/** The hours during which this service or contact is available. */
export const hoursAvailable = ns("hoursAvailable");
/** An HTTP method that specifies the appropriate HTTP method for a request to an HTTP EntryPoint. Values are capitalized strings as used in HTTP. */
export const httpMethod = ns("httpMethod");
/** IATA identifier for an airline or airport. */
export const iataCode = ns("iataCode");
/** ICAO identifier for an airport. */
export const icaoCode = ns("icaoCode");
/** The illustrator of the book. */
export const illustrator = ns("illustrator");
/** The album to which this recording belongs. */
export const inAlbum = ns("inAlbum");
/** The CableOrSatelliteService offering the channel. */
export const inBroadcastLineup = ns("inBroadcastLineup");
/** The playlist to which this recording belongs. */
export const inPlaylist = ns("inPlaylist");
/** Description of bonus and commission compensation aspects of the job. */
export const incentives = ns("incentives");
/** Smaller compositions included in this work (e.g. a movement in a symphony). */
export const includedComposition = ns("includedComposition");
/** A data catalog which contains this dataset (this property was previously 'catalog', preferred name is now 'includedInDataCatalog'). */
export const includedDataCatalog = ns("includedDataCatalog");
/** This links to a node or nodes indicating the exact quantity of the products included in the offer. */
export const includesObject = ns("includesObject");
/** The industry associated with the job position. */
export const industry = ns("industry");
/** The ISO 3166-1 (ISO 3166-1 alpha-2) or ISO 3166-2 code, the place, or the GeoShape for the geo-political region(s) for which the offer or delivery charge specification is not valid, e.g. a region where the transaction is not allowed.<br/><br/>

See also <a class="localLink" href="http://schema.org/eligibleRegion">eligibleRegion</a>. */
export const ineligibleRegion = ns("ineligibleRegion");
/** A single ingredient used in the recipe, e.g. sugar, flour or garlic. */
export const ingredients = ns("ingredients");
/** URL at which the app may be installed, if different from the URL of the item. */
export const installUrl = ns("installUrl");
/** A person assigned to instruct or provide instructional assistance for the <a class="localLink" href="http://schema.org/CourseInstance">CourseInstance</a>. */
export const instructor = ns("instructor");
/** This property is deprecated, alongside the UserInteraction types on which it depended. */
export const interactionCount = ns("interactionCount");
/** The WebSite or SoftwareApplication where the interactions took place. */
export const interactionService = ns("interactionService");
/** The Action representing the type of interaction. For up votes, +1s, etc. use <a class="localLink" href="http://schema.org/LikeAction">LikeAction</a>. For down votes use <a class="localLink" href="http://schema.org/DislikeAction">DislikeAction</a>. Otherwise, use the most specific Action. */
export const interactionType = ns("interactionType");
/** The predominant mode of learning supported by the learning resource. Acceptable values are 'active', 'expositive', or 'mixed'. */
export const interactivityType = ns("interactivityType");
/** The interest rate, charged or paid, applicable to the financial product. Note: This is different from the calculated annualPercentageRate. */
export const interestRate = ns("interestRate");
/** The current approximate inventory level for the item or items. */
export const inventoryLevel = ns("inventoryLevel");
/** A pointer to another product (or multiple products) for which this product is an accessory or spare part. */
export const isAccessoryOrSparePartFor = ns("isAccessoryOrSparePartFor");
/** A resource that was used in the creation of this resource. This term can be repeated for multiple sources. For example, http://example.com/great-multiplication-intro.html. */
export const isBasedOnUrl = ns("isBasedOnUrl");
/** A pointer to another product (or multiple products) for which this product is a consumable. */
export const isConsumableFor = ns("isConsumableFor");
/** Indicates whether this content is family friendly. */
export const isFamilyFriendly = ns("isFamilyFriendly");
/** Was the offer accepted as a gift for someone other than the buyer. */
export const isGift = ns("isGift");
/** True is the broadcast is of a live event. */
export const isLiveBroadcast = ns("isLiveBroadcast");
/** A pointer to another, somehow related product (or multiple products). */
export const isRelatedTo = ns("isRelatedTo");
/** A pointer to another, functionally similar product (or multiple products). */
export const isSimilarTo = ns("isSimilarTo");
/** A pointer to a base product from which this product is a variant. It is safe to infer that the variant inherits all product features from the base model, unless defined locally. This is not transitive. */
export const isVariantOf = ns("isVariantOf");
/** The ISBN of the book. */
export const isbn = ns("isbn");
/** The International Standard of Industrial Classification of All Economic Activities (ISIC), Revision 4 code for a particular organization, business person, or place. */
export const isicV4 = ns("isicV4");
/** The International Standard Recording Code for the recording. */
export const isrcCode = ns("isrcCode");
/** The International Standard Serial Number (ISSN) that identifies this serial publication. You can repeat this property to identify different formats of, or the linking ISSN (ISSN-L) for, this serial publication. */
export const issn = ns("issn");
/** Identifies the issue of publication; for example, "iii" or "2". */
export const issueNumber = ns("issueNumber");
/** The organization issuing the ticket or permit. */
export const issuedBy = ns("issuedBy");
/** The service through with the permit was granted. */
export const issuedThrough = ns("issuedThrough");
/** The International Standard Musical Work Code for the composition. */
export const iswcCode = ns("iswcCode");
/** An entity represented by an entry in a list or data feed (e.g. an 'artist' in a list of 'artists')’. */
export const item = ns("item");
/** A predefined value from OfferItemCondition or a textual description of the condition of the product or service, or the products or services included in the offer. */
export const itemCondition = ns("itemCondition");
/** For itemListElement values, you can use simple strings (e.g. "Peter", "Paul", "Mary"), existing entities, or use ListItem.<br/><br/>

Text values are best if the elements in the list are plain strings. Existing entities are best for a simple, unordered list of existing things in your data. ListItem is used with ordered lists when you want to provide additional context about the element in that list or when the same item might be in different places in different lists.<br/><br/>

Note: The order of elements in your mark-up is not sufficient for indicating the order or elements.  Use ListItem with a 'position' property in such cases. */
export const itemListElement = ns("itemListElement");
/** Type of ordering (e.g. Ascending, Descending, Unordered). */
export const itemListOrder = ns("itemListOrder");
/** The item being offered. */
export const itemOffered = ns("itemOffered");
/** The item that is being reviewed/rated. */
export const itemReviewed = ns("itemReviewed");
/** Item(s) being shipped. */
export const itemShipped = ns("itemShipped");
/** A (typically single) geographic location associated with the job position. */
export const jobLocation = ns("jobLocation");
/** Keywords or tags used to describe this content. Multiple entries in a keywords list are typically delimited by commas. */
export const keywords = ns("keywords");
/** A textual description of known damages, both repaired and unrepaired. */
export const knownVehicleDamages = ns("knownVehicleDamages");
/** The most generic bi-directional social/work relation. */
export const knows = ns("knows");
/** A sub property of participant. The owner of the real estate property. */
export const landlord = ns("landlord");
/** A sub property of instrument. The language used on this action. */
export const language = ns("language");
/** Date on which the content on this web page was last reviewed for accuracy and/or completeness. */
export const lastReviewed = ns("lastReviewed");
/** The latitude of a location. For example <code>37.42242</code> (<a href="https://en.wikipedia.org/wiki/World_Geodetic_System">WGS 84</a>). */
export const latitude = ns("latitude");
/** The predominant type or kind characterizing the learning resource. For example, 'presentation', 'handout'. */
export const learningResourceType = ns("learningResourceType");
/** The official name of the organization, e.g. the registered company name. */
export const legalName = ns("legalName");
/** An organization identifier that uniquely identifies a legal entity as defined in ISO 17442. */
export const leiCode = ns("leiCode");
/** A sub property of participant. The person that lends the object being borrowed. */
export const lender = ns("lender");
/** This ordering relation for qualitative values indicates that the subject is lesser than the object. */
export const lesser = ns("lesser");
/** This ordering relation for qualitative values indicates that the subject is lesser than or equal to the object. */
export const lesserOrEqual = ns("lesserOrEqual");
/** A license document that applies to this content, typically indicated by URL. */
export const license = ns("license");
/** A line is a point-to-point path consisting of two or more points. A line is expressed as a series of two or more point objects separated by space. */
export const line = ns("line");
/** An update to the LiveBlog. */
export const liveBlogUpdate = ns("liveBlogUpdate");
/** The duration of the loan or credit agreement. */
export const loanTerm = ns("loanTerm");
/** The location where the CreativeWork was created, which may not be the same as the location depicted in the CreativeWork. */
export const locationCreated = ns("locationCreated");
/** A full description of the lodging unit. */
export const lodgingUnitDescription = ns("lodgingUnitDescription");
/** Textual description of the unit type (including suite vs. room, size of bed, etc.). */
export const lodgingUnitType = ns("lodgingUnitType");
/** An associated logo. */
export const logo = ns("logo");
/** The longitude of a location. For example <code>-122.08585</code> (<a href="https://en.wikipedia.org/wiki/World_Geodetic_System">WGS 84</a>). */
export const longitude = ns("longitude");
/** A sub property of participant. The loser of the action. */
export const loser = ns("loser");
/** The lowest price of all offers available.<br/><br/>

Usage guidelines:<br/><br/>

<ul>
<li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
<li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
</ul>
 */
export const lowPrice = ns("lowPrice");
/** The person who wrote the words. */
export const lyricist = ns("lyricist");
/** The words in the song. */
export const lyrics = ns("lyrics");
/** Indicates if this web page element is the main subject of the page. */
export const mainContentOfPage = ns("mainContentOfPage");
/** The manufacturer of the product. */
export const manufacturer = ns("manufacturer");
/** A URL to a map of the place. */
export const map = ns("map");
/** Indicates the kind of Map, from the MapCategoryType Enumeration. */
export const mapType = ns("mapType");
/** A URL to a map of the place. */
export const maps = ns("maps");
/** The highest price if the price is a range. */
export const maxPrice = ns("maxPrice");
/** The upper value of some characteristic or property. */
export const maxValue = ns("maxValue");
/** The total number of individuals that may attend an event or venue. */
export const maximumAttendeeCapacity = ns("maximumAttendeeCapacity");
/** Description of the meals that will be provided or available for purchase. */
export const mealService = ns("mealService");
/** The median value. */
export const median = ns("median");
/** A member of this organization. */
export const members = ns("members");
/** A unique identifier for the membership. */
export const membershipNumber = ns("membershipNumber");
/** Minimum memory requirements. */
export const memoryRequirements = ns("memoryRequirements");
/** Indicates that the CreativeWork contains a reference to, but is not necessarily about a concept. */
export const mentions = ns("mentions");
/** Either the actual menu as a structured representation, as text, or a URL of the menu. */
export const menu = ns("menu");
/** Additional menu item(s) such as a side dish of salad or side order of fries that can be added to this menu item. Additionally it can be a menu section containing allowed add-on menu items for this menu item. */
export const menuAddOn = ns("menuAddOn");
/** 'merchant' is an out-dated term for 'seller'. */
export const merchant = ns("merchant");
/** A CreativeWork attached to the message. */
export const messageAttachment = ns("messageAttachment");
/** The total distance travelled by the particular vehicle since its initial production, as read from its odometer.<br/><br/>

Typical unit code(s): KMT for kilometers, SMI for statute miles */
export const mileageFromOdometer = ns("mileageFromOdometer");
/** The lowest price if the price is a range. */
export const minPrice = ns("minPrice");
/** The lower value of some characteristic or property. */
export const minValue = ns("minValue");
/** The minimum payment required at this time. */
export const minimumPaymentDue = ns("minimumPaymentDue");
/** The model of the product. Use with the URL of a ProductModel or a textual representation of the model identifier. The URL of the ProductModel can be from an external source. It is recommended to additionally provide strong product identifiers via the gtin8/gtin13/gtin14 and mpn properties. */
export const model = ns("model");
/** The date and time the reservation was modified. */
export const modifiedTime = ns("modifiedTime");
/** The Manufacturer Part Number (MPN) of the product, or the product to which the offer refers. */
export const mpn = ns("mpn");
/** Whether multiple values are allowed for the property.  Default is false. */
export const multipleValues = ns("multipleValues");
/** An arrangement derived from the composition. */
export const musicArrangement = ns("musicArrangement");
/** The composer of the soundtrack. */
export const musicBy = ns("musicBy");
/** The type of composition (e.g. overture, sonata, symphony, etc.). */
export const musicCompositionForm = ns("musicCompositionForm");
/** A member of a music group&#x2014;for example, John, Paul, George, or Ringo. */
export const musicGroupMember = ns("musicGroupMember");
/** Format of this release (the type of recording media used, ie. compact disc, digital media, LP, etc.). */
export const musicReleaseFormat = ns("musicReleaseFormat");
/** The key, mode, or scale this composition uses. */
export const musicalKey = ns("musicalKey");
/** The North American Industry Classification System (NAICS) code for a particular organization or business person. */
export const naics = ns("naics");
/** The name of the item. */
export const name = ns("name");
/** A position played, performed or filled by a person or organization, as part of an organization. For example, an athlete in a SportsTeam might play in the position named 'Quarterback'. */
export const namedPosition = ns("namedPosition");
/** Nationality of the person. */
export const nationality = ns("nationality");
/** The total financial value of the person as calculated by subtracting assets from liabilities. */
export const netWorth = ns("netWorth");
/** A link to the ListItem that follows the current one. */
export const nextItem = ns("nextItem");
/** This ordering relation for qualitative values indicates that the subject is not equal to the object. */
export const nonEqual = ns("nonEqual");
/** The number of adults staying in the unit. */
export const numAdults = ns("numAdults");
/** The number of children staying in the unit. */
export const numChildren = ns("numChildren");
/** The number of tracks in this album or playlist. */
export const numTracks = ns("numTracks");
/** The number or type of airbags in the vehicle. */
export const numberOfAirbags = ns("numberOfAirbags");
/** The number of axles.<br/><br/>

Typical unit code(s): C62 */
export const numberOfAxles = ns("numberOfAxles");
/** The quantity of the given bed type available in the HotelRoom, Suite, House, or Apartment. */
export const numberOfBeds = ns("numberOfBeds");
/** The number of doors.<br/><br/>

Typical unit code(s): C62 */
export const numberOfDoors = ns("numberOfDoors");
/** The number of employees in an organization e.g. business. */
export const numberOfEmployees = ns("numberOfEmployees");
/** The number of episodes in this season or series. */
export const numberOfEpisodes = ns("numberOfEpisodes");
/** The total number of forward gears available for the transmission system of the vehicle.<br/><br/>

Typical unit code(s): C62 */
export const numberOfForwardGears = ns("numberOfForwardGears");
/** The number of items in an ItemList. Note that some descriptions might not fully describe all items in a list (e.g., multi-page pagination); in such cases, the numberOfItems would be for the entire list. */
export const numberOfItems = ns("numberOfItems");
/** The number of pages in the book. */
export const numberOfPages = ns("numberOfPages");
/** Indicate how many people can play this game (minimum, maximum, or range). */
export const numberOfPlayers = ns("numberOfPlayers");
/** The number of owners of the vehicle, including the current one.<br/><br/>

Typical unit code(s): C62 */
export const numberOfPreviousOwners = ns("numberOfPreviousOwners");
/** The number of rooms (excluding bathrooms and closets) of the accommodation or lodging business.
Typical unit code(s): ROM for room or C62 for no unit. The type of room can be put in the unitText property of the QuantitativeValue. */
export const numberOfRooms = ns("numberOfRooms");
/** The number of seasons in this series. */
export const numberOfSeasons = ns("numberOfSeasons");
/** A number associated with a role in an organization, for example, the number on an athlete's jersey. */
export const numberedPosition = ns("numberedPosition");
/** Nutrition information about the recipe or menu item. */
export const nutrition = ns("nutrition");
/** The allowed total occupancy for the accommodation in persons (including infants etc). For individual accommodations, this is not necessarily the legal maximum but defines the permitted usage as per the contractual agreement (e.g. a double room used by a single person).
Typical unit code(s): C62 for person */
export const occupancy = ns("occupancy");
/** The region/country for which this occupational description is appropriate. Note that educational requirements and qualifications can vary between jurisdictions. */
export const occupationLocation = ns("occupationLocation");
/** A category describing the job, preferably using a term from a taxonomy such as <a href="http://www.onetcenter.org/taxonomy.html">BLS O*NET-SOC</a>, <a href="https://www.ilo.org/public/english/bureau/stat/isco/isco08/">ISCO-08</a> or similar, with the property repeated for each applicable value. Ideally the taxonomy should be identified, and both the textual label and formal code for the category should be provided.<br/><br/>

Note: for historical reasons, any textual label and formal code provided as a literal may be assumed to be from O*NET-SOC. */
export const occupationalCategory = ns("occupationalCategory");
/** The number of offers for the product. */
export const offerCount = ns("offerCount");
/** An offer to provide this item&#x2014;for example, an offer to sell a product, rent the DVD of a movie, perform a service, or give away tickets to an event. */
export const offers = ns("offers");
/** The general opening hours for a business. Opening hours can be specified as a weekly time range, starting with days, then times per day. Multiple days can be listed with commas ',' separating each day. Day or time ranges are specified using a hyphen '-'.<br/><br/>

<ul>
<li>Days are specified using the following two-letter combinations: <code>Mo</code>, <code>Tu</code>, <code>We</code>, <code>Th</code>, <code>Fr</code>, <code>Sa</code>, <code>Su</code>.</li>
<li>Times are specified using 24:00 time. For example, 3pm is specified as <code>15:00</code>. </li>
<li>Here is an example: <code>&lt;time itemprop="openingHours" datetime=&quot;Tu,Th 16:00-20:00&quot;&gt;Tuesdays and Thursdays 4-8pm&lt;/time&gt;</code>.</li>
<li>If a business is open 7 days a week, then it can be specified as <code>&lt;time itemprop=&quot;openingHours&quot; datetime=&quot;Mo-Su&quot;&gt;Monday through Sunday, all day&lt;/time&gt;</code>.</li>
</ul>
 */
export const openingHours = ns("openingHours");
/** The opening hours of a certain place. */
export const openingHoursSpecification = ns("openingHoursSpecification");
/** The opening hour of the place or service on the given day(s) of the week. */
export const opens = ns("opens");
/** Operating systems supported (Windows 7, OSX 10.6, Android 1.6). */
export const operatingSystem = ns("operatingSystem");
/** A sub property of participant. The opponent on this action. */
export const opponent = ns("opponent");
/** A sub property of object. The options subject to this action. */
export const option = ns("option");
/** Date order was placed. */
export const orderDate = ns("orderDate");
/** The delivery of the parcel related to this order or order item. */
export const orderDelivery = ns("orderDelivery");
/** The identifier of the order item. */
export const orderItemNumber = ns("orderItemNumber");
/** The current status of the order item. */
export const orderItemStatus = ns("orderItemStatus");
/** The identifier of the transaction. */
export const orderNumber = ns("orderNumber");
/** The number of the item ordered. If the property is not set, assume the quantity is one. */
export const orderQuantity = ns("orderQuantity");
/** The current status of the order. */
export const orderStatus = ns("orderStatus");
/** The item ordered. */
export const orderedItem = ns("orderedItem");
/** An organizer of an Event. */
export const organizer = ns("organizer");
/** Shipper's address. */
export const originAddress = ns("originAddress");
/** The date and time of obtaining the product. */
export const ownedFrom = ns("ownedFrom");
/** The date and time of giving up ownership on the product. */
export const ownedThrough = ns("ownedThrough");
/** Products owned by the organization or person. */
export const owns = ns("owns");
/** The page on which the work ends; for example "138" or "xvi". */
export const pageEnd = ns("pageEnd");
/** The page on which the work starts; for example "135" or "xiii". */
export const pageStart = ns("pageStart");
/** Any description of pages that is not separated into pageStart and pageEnd; for example, "1-6, 9, 55" or "10-12, 46-49". */
export const pagination = ns("pagination");
/** The parent of a question, answer or item in general. */
export const parentItem = ns("parentItem");
/** A broadcast service to which the broadcast service may belong to such as regional variations of a national channel. */
export const parentService = ns("parentService");
/** A parents of the person. */
export const parents = ns("parents");
/** The episode to which this clip belongs. */
export const partOfEpisode = ns("partOfEpisode");
/** The order is being paid as part of the referenced Invoice. */
export const partOfInvoice = ns("partOfInvoice");
/** The overall order the items in this delivery were included in. */
export const partOfOrder = ns("partOfOrder");
/** The season to which this episode belongs. */
export const partOfSeason = ns("partOfSeason");
/** The TV series to which this episode or season belongs. */
export const partOfTVSeries = ns("partOfTVSeries");
/** Number of people the reservation should accommodate. */
export const partySize = ns("partySize");
/** The priority status assigned to a passenger for security or boarding (e.g. FastTrack or Priority). */
export const passengerPriorityStatus = ns("passengerPriorityStatus");
/** The passenger's sequence number as assigned by the airline. */
export const passengerSequenceNumber = ns("passengerSequenceNumber");
/** Cash, Credit Card, Cryptocurrency, Local Exchange Tradings System, etc. */
export const paymentAccepted = ns("paymentAccepted");
/** The date that payment is due. */
export const paymentDue = ns("paymentDue");
/** The name of the credit card or other method of payment for the order. */
export const paymentMethod = ns("paymentMethod");
/** An identifier for the method of payment used (e.g. the last 4 digits of the credit card). */
export const paymentMethodId = ns("paymentMethodId");
/** The status of payment; whether the invoice has been paid or not. */
export const paymentStatus = ns("paymentStatus");
/** The URL for sending a payment. */
export const paymentUrl = ns("paymentUrl");
/** The 10th percentile value. */
export const percentile10 = ns("percentile10");
/** The 25th percentile value. */
export const percentile25 = ns("percentile25");
/** The 75th percentile value. */
export const percentile75 = ns("percentile75");
/** The 90th percentile value. */
export const percentile90 = ns("percentile90");
/** Event that this person is a performer or participant in. */
export const performerIn = ns("performerIn");
/** The main performer or performers of the event&#x2014;for example, a presenter, musician, or actor. */
export const performers = ns("performers");
/** The type of permission granted the person, organization, or audience. */
export const permissionType = ns("permissionType");
/** Permission(s) required to run the app (for example, a mobile app may require full internet access or may run only on wifi). */
export const permissions = ns("permissions");
/** The target audience for this permit. */
export const permitAudience = ns("permitAudience");
/** Indications regarding the permitted usage of the accommodation. */
export const permittedUsage = ns("permittedUsage");
/** Indicates whether pets are allowed to enter the accommodation or lodging business. More detailed information can be put in a text value. */
export const petsAllowed = ns("petsAllowed");
/** Photographs of this place. */
export const photos = ns("photos");
/** Where a taxi will pick up a passenger or a rental car can be picked up. */
export const pickupLocation = ns("pickupLocation");
/** When a taxi will pickup a passenger or a rental car can be picked up. */
export const pickupTime = ns("pickupTime");
/** Indicates whether this game is multi-player, co-op or single-player.  The game can be marked as multi-player, co-op and single-player at the same time. */
export const playMode = ns("playMode");
/** Player type required&#x2014;for example, Flash or Silverlight. */
export const playerType = ns("playerType");
/** Number of players on the server. */
export const playersOnline = ns("playersOnline");
/** A polygon is the area enclosed by a point-to-point path for which the starting and ending points are the same. A polygon is expressed as a series of four or more space delimited points where the first and final points are identical. */
export const polygon = ns("polygon");
/** The post office box number for PO box addresses. */
export const postOfficeBoxNumber = ns("postOfficeBoxNumber");
/** The postal code. For example, 94043. */
export const postalCode = ns("postalCode");
/** Indicates a potential Action, which describes an idealized action in which this thing would play an 'object' role. */
export const potentialAction = ns("potentialAction");
/** A pointer from a previous, often discontinued variant of the product to its newer variant. */
export const predecessorOf = ns("predecessorOf");
/** The length of time it takes to prepare the items to be used in instructions or a direction, in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 duration format</a>. */
export const prepTime = ns("prepTime");
/** A link to the ListItem that preceeds the current one. */
export const previousItem = ns("previousItem");
/** Used in conjunction with eventStatus for rescheduled or cancelled events. This property contains the previously scheduled start date. For rescheduled events, the startDate property should be used for the newly scheduled start date. In the (rare) case of an event that has been postponed and rescheduled multiple times, this field may be repeated. */
export const previousStartDate = ns("previousStartDate");
/** The offer price of a product, or of a price component when attached to PriceSpecification and its subtypes.<br/><br/>

Usage guidelines:<br/><br/>

<ul>
<li>Use the <a class="localLink" href="http://schema.org/priceCurrency">priceCurrency</a> property (with standard formats: <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217 currency format</a> e.g. "USD"; <a href="https://en.wikipedia.org/wiki/List_of_cryptocurrencies">Ticker symbol</a> for cryptocurrencies e.g. "BTC"; well known names for <a href="https://en.wikipedia.org/wiki/Local_exchange_trading_system">Local Exchange Tradings Systems</a> (LETS) and other currency types e.g. "Ithaca HOUR") instead of including <a href="http://en.wikipedia.org/wiki/Dollar_sign#Currencies_that_use_the_dollar_or_peso_sign">ambiguous symbols</a> such as '$' in the value.</li>
<li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
<li>Note that both <a href="http://www.w3.org/TR/xhtml-rdfa-primer/#using-the-content-attribute">RDFa</a> and Microdata syntax allow the use of a "content=" attribute for publishing simple machine-readable values alongside more human-friendly formatting.</li>
<li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
</ul>
 */
export const price = ns("price");
/** This property links to all <a class="localLink" href="http://schema.org/UnitPriceSpecification">UnitPriceSpecification</a> nodes that apply in parallel for the <a class="localLink" href="http://schema.org/CompoundPriceSpecification">CompoundPriceSpecification</a> node. */
export const priceComponent = ns("priceComponent");
/** The currency of the price, or a price component when attached to <a class="localLink" href="http://schema.org/PriceSpecification">PriceSpecification</a> and its subtypes.<br/><br/>

Use standard formats: <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217 currency format</a> e.g. "USD"; <a href="https://en.wikipedia.org/wiki/List_of_cryptocurrencies">Ticker symbol</a> for cryptocurrencies e.g. "BTC"; well known names for <a href="https://en.wikipedia.org/wiki/Local_exchange_trading_system">Local Exchange Tradings Systems</a> (LETS) and other currency types e.g. "Ithaca HOUR". */
export const priceCurrency = ns("priceCurrency");
/** The price range of the business, for example <code>$$$</code>. */
export const priceRange = ns("priceRange");
/** One or more detailed price specifications, indicating the unit price and delivery or payment charges. */
export const priceSpecification = ns("priceSpecification");
/** A short text or acronym indicating multiple price specifications for the same offer, e.g. SRP for the suggested retail price or INVOICE for the invoice price, mostly used in the car industry. */
export const priceType = ns("priceType");
/** The date after which the price is no longer available. */
export const priceValidUntil = ns("priceValidUntil");
/** Indicates the main image on the page. */
export const primaryImageOfPage = ns("primaryImageOfPage");
/** The number of the column in which the NewsArticle appears in the print edition. */
export const printColumn = ns("printColumn");
/** The edition of the print product in which the NewsArticle appears. */
export const printEdition = ns("printEdition");
/** If this NewsArticle appears in print, this field indicates the name of the page on which the article is found. Please note that this field is intended for the exact page name (e.g. A5, B18). */
export const printPage = ns("printPage");
/** If this NewsArticle appears in print, this field indicates the print section in which the article appeared. */
export const printSection = ns("printSection");
/** Estimated processing time for the service using this channel. */
export const processingTime = ns("processingTime");
/** Processor architecture required to run the application (e.g. IA64). */
export const processorRequirements = ns("processorRequirements");
/** The person or organization who produced the work (e.g. music album, movie, tv/radio series etc.). */
export const producer = ns("producer");
/** The tangible thing generated by the service, e.g. a passport, permit, etc. */
export const produces = ns("produces");
/** The product identifier, such as ISBN. For example: <code>meta itemprop="productID" content="isbn:123-456-789"</code>. */
export const productID = ns("productID");
/** The product or service this support contact point is related to (such as product support for a particular product line). This can be a specific product or product line (e.g. "iPhone") or a general category of products or services (e.g. "smartphones"). */
export const productSupported = ns("productSupported");
/** The production company or studio responsible for the item e.g. series, video game, episode etc. */
export const productionCompany = ns("productionCompany");
/** The date of production of the item, e.g. vehicle. */
export const productionDate = ns("productionDate");
/** Proficiency needed for this content; expected values: 'Beginner', 'Expert'. */
export const proficiencyLevel = ns("proficiencyLevel");
/** Any membership in a frequent flyer, hotel loyalty program, etc. being applied to the reservation. */
export const programMembershipUsed = ns("programMembershipUsed");
/** The program providing the membership. */
export const programName = ns("programName");
/** The computer programming language. */
export const programmingLanguage = ns("programmingLanguage");
/** Indicates whether API is managed or unmanaged. */
export const programmingModel = ns("programmingModel");
/** A commonly used identifier for the characteristic represented by the property, e.g. a manufacturer or a standard code for a property. propertyID can be
(1) a prefixed string, mainly meant to be used with standards for product properties; (2) a site-specific, non-prefixed string (e.g. the primary key of the property or the vendor-specific id of the property), or (3)
a URL indicating the type of the property, either pointing to an external vocabulary, or a Web resource that describes the property (e.g. a glossary entry).
Standards bodies should promote a standard prefix for the identifiers of properties from their standards. */
export const propertyID = ns("propertyID");
/** The number of grams of protein. */
export const proteinContent = ns("proteinContent");
/** Indicates the mobility of a provided service (e.g. 'static', 'dynamic'). */
export const providerMobility = ns("providerMobility");
/** The service provided by this channel. */
export const providesService = ns("providesService");
/** A flag to signal that the <a class="localLink" href="http://schema.org/Place">Place</a> is open to public visitors.  If this property is omitted there is no assumed default boolean value */
export const publicAccess = ns("publicAccess");
/** A publication event associated with the item. */
export const publication = ns("publication");
/** A broadcast service associated with the publication event. */
export const publishedOn = ns("publishedOn");
/** The publisher of the creative work. */
export const publisher = ns("publisher");
/** The publishingPrinciples property indicates (typically via <a class="localLink" href="http://schema.org/URL">URL</a>) a document describing the editorial principles of an <a class="localLink" href="http://schema.org/Organization">Organization</a> (or individual e.g. a <a class="localLink" href="http://schema.org/Person">Person</a> writing a blog) that relate to their activities as a publisher, e.g. ethics or diversity policies. When applied to a <a class="localLink" href="http://schema.org/CreativeWork">CreativeWork</a> (e.g. <a class="localLink" href="http://schema.org/NewsArticle">NewsArticle</a>) the principles are those of the party primarily responsible for the creation of the <a class="localLink" href="http://schema.org/CreativeWork">CreativeWork</a>.<br/><br/>

While such policies are most typically expressed in natural language, sometimes related information (e.g. indicating a <a class="localLink" href="http://schema.org/funder">funder</a>) can be expressed using schema.org terminology. */
export const publishingPrinciples = ns("publishingPrinciples");
/** The date the item e.g. vehicle was purchased by the current owner. */
export const purchaseDate = ns("purchaseDate");
/** A sub property of instrument. The query used on this action. */
export const query = ns("query");
/** The task that a player-controlled character, or group of characters may complete in order to gain a reward. */
export const quest = ns("quest");
/** A sub property of object. A question. */
export const question = ns("question");
/** The count of total number of ratings. */
export const ratingCount = ns("ratingCount");
/** The rating for the content.<br/><br/>

Usage guidelines:<br/><br/>

<ul>
<li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
<li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
</ul>
 */
export const ratingValue = ns("ratingValue");
/** Whether or not a property is mutable.  Default is false. Specifying this for a property that also has a value makes it act similar to a "hidden" input in an HTML form. */
export const readonlyValue = ns("readonlyValue");
/** A sub property of participant. The real estate agent involved in the action. */
export const realEstateAgent = ns("realEstateAgent");
/** A sub property of instrument. The recipe/instructions used to perform the action. */
export const recipe = ns("recipe");
/** The category of the recipe—for example, appetizer, entree, etc. */
export const recipeCategory = ns("recipeCategory");
/** The cuisine of the recipe (for example, French or Ethiopian). */
export const recipeCuisine = ns("recipeCuisine");
/** A step in making the recipe, in the form of a single item (document, video, etc.) or an ordered list with HowToStep and/or HowToSection items. */
export const recipeInstructions = ns("recipeInstructions");
/** The quantity produced by the recipe (for example, number of people served, number of servings, etc). */
export const recipeYield = ns("recipeYield");
/** The label that issued the release. */
export const recordLabel = ns("recordLabel");
/** The reference quantity for which a certain price applies, e.g. 1 EUR per 4 kWh of electricity. This property is a replacement for unitOfMeasurement for the advanced cases where the price does not relate to a standard unit. */
export const referenceQuantity = ns("referenceQuantity");
/** The Order(s) related to this Invoice. One or more Orders may be combined into a single Invoice. */
export const referencesOrder = ns("referencesOrder");
/** The regions where the media is allowed. If not specified, then it's assumed to be allowed everywhere. Specify the countries in <a href="http://en.wikipedia.org/wiki/ISO_3166">ISO 3166 format</a>. */
export const regionsAllowed = ns("regionsAllowed");
/** A link related to this web page, for example to other related web pages. */
export const relatedLink = ns("relatedLink");
/** The most generic familial relation. */
export const relatedTo = ns("relatedTo");
/** The release date of a product or product model. This can be used to distinguish the exact variant of a product. */
export const releaseDate = ns("releaseDate");
/** Description of what changed in this version. */
export const releaseNotes = ns("releaseNotes");
/** The place and time the release was issued, expressed as a PublicationEvent. */
export const releasedEvent = ns("releasedEvent");
/** The Occupation for the JobPosting. */
export const relevantOccupation = ns("relevantOccupation");
/** The number of attendee places for an event that remain unallocated. */
export const remainingAttendeeCapacity = ns("remainingAttendeeCapacity");
/** A sub property of object. The object that is being replaced. */
export const replacee = ns("replacee");
/** A sub property of object. The object that replaces. */
export const replacer = ns("replacer");
/** The URL at which a reply may be posted to the specified UserComment. */
export const replyToUrl = ns("replyToUrl");
/** The number or other unique designator assigned to a Report by the publishing organization. */
export const reportNumber = ns("reportNumber");
/** Indicates whether this image is representative of the content of the page. */
export const representativeOfPage = ns("representativeOfPage");
/** Assets required to secure loan or credit repayments. It may take form of third party pledge, goods, financial instruments (cash, securities, etc.) */
export const requiredCollateral = ns("requiredCollateral");
/** Audiences defined by a person's gender. */
export const requiredGender = ns("requiredGender");
/** Audiences defined by a person's maximum age. */
export const requiredMaxAge = ns("requiredMaxAge");
/** Audiences defined by a person's minimum age. */
export const requiredMinAge = ns("requiredMinAge");
/** The required quantity of the item(s). */
export const requiredQuantity = ns("requiredQuantity");
/** Component dependency requirements for application. This includes runtime environments and shared libraries that are not included in the application distribution package, but required to run the application (Examples: DirectX, Java or .NET runtime). */
export const requirements = ns("requirements");
/** Indicates if use of the media require a subscription  (either paid or free). Allowed values are <code>true</code> or <code>false</code> (note that an earlier version had 'yes', 'no'). */
export const requiresSubscription = ns("requiresSubscription");
/** The thing -- flight, event, restaurant,etc. being reserved. */
export const reservationFor = ns("reservationFor");
/** A unique identifier for the reservation. */
export const reservationId = ns("reservationId");
/** The current status of the reservation. */
export const reservationStatus = ns("reservationStatus");
/** A ticket associated with the reservation. */
export const reservedTicket = ns("reservedTicket");
/** Responsibilities associated with this role or Occupation. */
export const responsibilities = ns("responsibilities");
/** A sub property of result. The Comment created or sent as a result of this action. */
export const resultComment = ns("resultComment");
/** A sub property of result. The review that resulted in the performing of the action. */
export const resultReview = ns("resultReview");
/** This Review or Rating is relevant to this part or facet of the itemReviewed. */
export const reviewAspect = ns("reviewAspect");
/** The actual body of the review. */
export const reviewBody = ns("reviewBody");
/** The count of total number of reviews. */
export const reviewCount = ns("reviewCount");
/** The rating given in this review. Note that reviews can themselves be rated. The <code>reviewRating</code> applies to rating given by the review. The <a class="localLink" href="http://schema.org/aggregateRating">aggregateRating</a> property applies to the review itself, as a creative work. */
export const reviewRating = ns("reviewRating");
/** People or organizations that have reviewed the content on this web page for accuracy and/or completeness. */
export const reviewedBy = ns("reviewedBy");
/** Review of the item. */
export const reviews = ns("reviews");
/** The response (yes, no, maybe) to the RSVP. */
export const rsvpResponse = ns("rsvpResponse");
/** Runtime platform or script interpreter dependencies (Example - Java v1, Python2.3, .Net Framework 3.0). */
export const runtime = ns("runtime");
/** The currency (coded using <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217</a> ) used for the main salary information in this job posting or for this employee. */
export const salaryCurrency = ns("salaryCurrency");
/** URL of a reference Web page that unambiguously indicates the item's identity. E.g. the URL of the item's Wikipedia page, Wikidata entry, or official website. */
export const sameAs = ns("sameAs");
/** What type of code sample: full (compile ready) solution, code snippet, inline code, scripts, template. */
export const sampleType = ns("sampleType");
/** The number of grams of saturated fat. */
export const saturatedFatContent = ns("saturatedFatContent");
/** The date the invoice is scheduled to be paid. */
export const scheduledPaymentDate = ns("scheduledPaymentDate");
/** The time the object is scheduled to. */
export const scheduledTime = ns("scheduledTime");
/** Indicates (by URL or string) a particular version of a schema used in some CreativeWork. For example, a document could declare a schemaVersion using an URL such as http://schema.org/version/2.0/ if precise indication of schema version was required by some application. */
export const schemaVersion = ns("schemaVersion");
/** The number of screens in the movie theater. */
export const screenCount = ns("screenCount");
/** A link to a screenshot image of the app. */
export const screenshot = ns("screenshot");
/** Position of the season within an ordered group of seasons. */
export const seasonNumber = ns("seasonNumber");
/** A season in a media series. */
export const seasons = ns("seasons");
/** The location of the reserved seat (e.g., 27). */
export const seatNumber = ns("seatNumber");
/** The row location of the reserved seat (e.g., B). */
export const seatRow = ns("seatRow");
/** The section location of the reserved seat (e.g. Orchestra). */
export const seatSection = ns("seatSection");
/** The type/class of the seat. */
export const seatingType = ns("seatingType");
/** The type of security screening the passenger is subject to. */
export const securityScreening = ns("securityScreening");
/** A pointer to products or services sought by the organization or person (demand). */
export const seeks = ns("seeks");
/** A sub property of participant. The participant who is at the sending end of the action. */
export const sender = ns("sender");
/** Status of a game server. */
export const serverStatus = ns("serverStatus");
/** The cuisine of the restaurant. */
export const servesCuisine = ns("servesCuisine");
/** The audience eligible for this service. */
export const serviceAudience = ns("serviceAudience");
/** The location (e.g. civic structure, local business, etc.) where a person can go to access the service. */
export const serviceLocation = ns("serviceLocation");
/** The operating organization, if different from the provider.  This enables the representation of services that are provided by an organization, but operated by another organization like a subcontractor. */
export const serviceOperator = ns("serviceOperator");
/** The phone number to use to access the service. */
export const servicePhone = ns("servicePhone");
/** The address for accessing the service by mail. */
export const servicePostalAddress = ns("servicePostalAddress");
/** The number to access the service by text message. */
export const serviceSmsNumber = ns("serviceSmsNumber");
/** The type of service being offered, e.g. veterans' benefits, emergency relief, etc. */
export const serviceType = ns("serviceType");
/** The website to access the service. */
export const serviceUrl = ns("serviceUrl");
/** The serving size, in terms of the number of volume or mass. */
export const servingSize = ns("servingSize");
/** A CreativeWork such as an image, video, or audio clip shared as part of this posting. */
export const sharedContent = ns("sharedContent");
/** A sibling of the person. */
export const siblings = ns("siblings");
/** The most significant URLs on the page. Typically, these are the non-navigation links that are clicked on the most. */
export const significantLinks = ns("significantLinks");
/** Skills required to fulfill this role or in this Occupation. */
export const skills = ns("skills");
/** The Stock Keeping Unit (SKU), i.e. a merchant-specific identifier for a product or service, or the product to which the offer refers. */
export const sku = ns("sku");
/** A slogan or motto associated with the item. */
export const slogan = ns("slogan");
/** Indicates whether it is allowed to smoke in the place, e.g. in the restaurant, hotel or hotel room. */
export const smokingAllowed = ns("smokingAllowed");
/** The number of milligrams of sodium. */
export const sodiumContent = ns("sodiumContent");
/** Additional content for a software application. */
export const softwareAddOn = ns("softwareAddOn");
/** Software application help. */
export const softwareHelp = ns("softwareHelp");
/** Version of the software instance. */
export const softwareVersion = ns("softwareVersion");
/** The Organization on whose behalf the creator was working. */
export const sourceOrganization = ns("sourceOrganization");
/** The "spatial" property can be used in cases when more specific properties
(e.g. <a class="localLink" href="http://schema.org/locationCreated">locationCreated</a>, <a class="localLink" href="http://schema.org/spatialCoverage">spatialCoverage</a>, <a class="localLink" href="http://schema.org/contentLocation">contentLocation</a>) are not known to be appropriate. */
export const spatial = ns("spatial");
/** The spatialCoverage of a CreativeWork indicates the place(s) which are the focus of the content. It is a subproperty of
      contentLocation intended primarily for more technical and detailed materials. For example with a Dataset, it indicates
      areas that the dataset describes: a dataset of New York weather would have spatialCoverage which was the place: the state of New York. */
export const spatialCoverage = ns("spatialCoverage");
/** Indicates sections of a Web page that are particularly 'speakable' in the sense of being highlighted as being especially appropriate for text-to-speech conversion. Other sections of a page may also be usefully spoken in particular circumstances; the 'speakable' property serves to indicate the parts most likely to be generally useful for speech.<br/><br/>

The <em>speakable</em> property can be repeated an arbitrary number of times, with three kinds of possible 'content-locator' values:<br/><br/>

1.) <em>id-value</em> URL references - uses <em>id-value</em> of an element in the page being annotated. The simplest use of <em>speakable</em> has (potentially relative) URL values, referencing identified sections of the document concerned.<br/><br/>

2.) CSS Selectors - addresses content in the annotated page, eg. via class attribute. Use the <a class="localLink" href="http://schema.org/cssSelector">cssSelector</a> property.<br/><br/>

3.)  XPaths - addresses content via XPaths (assuming an XML view of the content). Use the <a class="localLink" href="http://schema.org/xpath">xpath</a> property.<br/><br/>

For more sophisticated markup of speakable sections beyond simple ID references, either CSS selectors or XPath expressions to pick out document section(s) as speakable. For this
we define a supporting type, <a class="localLink" href="http://schema.org/SpeakableSpecification">SpeakableSpecification</a>  which is defined to be a possible value of the <em>speakable</em> property. */
export const speakable = ns("speakable");
/** Any special commitments associated with this job posting. Valid entries include VeteranCommit, MilitarySpouseCommit, etc. */
export const specialCommitments = ns("specialCommitments");
/** The special opening hours of a certain place.<br/><br/>

Use this to explicitly override general opening hours brought in scope by <a class="localLink" href="http://schema.org/openingHoursSpecification">openingHoursSpecification</a> or <a class="localLink" href="http://schema.org/openingHours">openingHours</a>. */
export const specialOpeningHoursSpecification = ns("specialOpeningHoursSpecification");
/** One of the domain specialities to which this web page's content applies. */
export const specialty = ns("specialty");
/** A type of sport (e.g. Baseball). */
export const sport = ns("sport");
/** A sub property of location. The sports activity location where this action occurred. */
export const sportsActivityLocation = ns("sportsActivityLocation");
/** A sub property of location. The sports event where this action occurred. */
export const sportsEvent = ns("sportsEvent");
/** A sub property of participant. The sports team that participated on this action. */
export const sportsTeam = ns("sportsTeam");
/** The person's spouse. */
export const spouse = ns("spouse");
/** An official rating for a lodging business or food establishment, e.g. from national associations or standards bodies. Use the author property to indicate the rating organization, e.g. as an Organization with name such as (e.g. HOTREC, DEHOGA, WHR, or Hotelstars). */
export const starRating = ns("starRating");
/** The start date and time of the item (in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 date format</a>). */
export const startDate = ns("startDate");
/** The startTime of something. For a reserved event or service (e.g. FoodEstablishmentReservation), the time that it is expected to start. For actions that span a period of time, when the action was performed. e.g. John wrote a book from <em>January</em> to December. For media, including audio and video, it's the time offset of the start of a clip within a larger file.<br/><br/>

Note that Event uses startDate/endDate instead of startTime/endTime, even when describing dates with times. This situation may be clarified in future revisions. */
export const startTime = ns("startTime");
/** The position of the steering wheel or similar device (mostly for cars). */
export const steeringPosition = ns("steeringPosition");
/** The stepValue attribute indicates the granularity that is expected (and required) of the value in a PropertyValueSpecification. */
export const stepValue = ns("stepValue");
/** A single step item (as HowToStep, text, document, video, etc.) or a HowToSection (originally misnamed 'steps'; 'step' is preferred). */
export const steps = ns("steps");
/** Storage requirements (free space required). */
export const storageRequirements = ns("storageRequirements");
/** The street address. For example, 1600 Amphitheatre Pkwy. */
export const streetAddress = ns("streetAddress");
/** Events that are a part of this event. For example, a conference event includes many presentations, each subEvents of the conference. */
export const subEvents = ns("subEvents");
/** The individual reservations included in the package. Typically a repeated property. */
export const subReservation = ns("subReservation");
/** Languages in which subtitles/captions are available, in <a href="http://tools.ietf.org/html/bcp47">IETF BCP 47 standard format</a>. */
export const subtitleLanguage = ns("subtitleLanguage");
/** A pointer from a newer variant of a product  to its previous, often discontinued predecessor. */
export const successorOf = ns("successorOf");
/** The number of grams of sugar. */
export const sugarContent = ns("sugarContent");
/** The gender of the person or audience. */
export const suggestedGender = ns("suggestedGender");
/** Maximal age recommended for viewing content. */
export const suggestedMaxAge = ns("suggestedMaxAge");
/** Minimal age recommended for viewing content. */
export const suggestedMinAge = ns("suggestedMinAge");
/** Indicates a dietary restriction or guideline for which this recipe or menu item is suitable, e.g. diabetic, halal etc. */
export const suitableForDiet = ns("suitableForDiet");
/** Supporting data for a SoftwareApplication. */
export const supportingData = ns("supportingData");
/** A material used as a surface in some artwork, e.g. Canvas, Paper, Wood, Board, etc. */
export const surface = ns("surface");
/** Indicates a target EntryPoint for an Action. */
export const target = ns("target");
/** The description of a node in an established educational framework. */
export const targetDescription = ns("targetDescription");
/** The name of a node in an established educational framework. */
export const targetName = ns("targetName");
/** Type of app development: phone, Metro style, desktop, XBox, etc. */
export const targetPlatform = ns("targetPlatform");
/** Target Operating System / Product to which the code applies.  If applies to several versions, just the product name can be used. */
export const targetProduct = ns("targetProduct");
/** The URL of a node in an established educational framework. */
export const targetUrl = ns("targetUrl");
/** The Tax / Fiscal ID of the organization or person, e.g. the TIN in the US or the CIF/NIF in Spain. */
export const taxID = ns("taxID");
/** The telephone number. */
export const telephone = ns("telephone");
/** The "temporal" property can be used in cases where more specific properties
(e.g. <a class="localLink" href="http://schema.org/temporalCoverage">temporalCoverage</a>, <a class="localLink" href="http://schema.org/dateCreated">dateCreated</a>, <a class="localLink" href="http://schema.org/dateModified">dateModified</a>, <a class="localLink" href="http://schema.org/datePublished">datePublished</a>) are not known to be appropriate. */
export const temporal = ns("temporal");
/** The textual content of this CreativeWork. */
export const text = ns("text");
/** Thumbnail image for an image or video. */
export const thumbnail = ns("thumbnail");
/** A thumbnail image relevant to the Thing. */
export const thumbnailUrl = ns("thumbnailUrl");
/** The exchange traded instrument associated with a Corporation object. The tickerSymbol is expressed as an exchange and an instrument name separated by a space character. For the exchange component of the tickerSymbol attribute, we recommend using the controlled vocabulary of Market Identifier Codes (MIC) specified in ISO15022. */
export const tickerSymbol = ns("tickerSymbol");
/** The unique identifier for the ticket. */
export const ticketNumber = ns("ticketNumber");
/** Reference to an asset (e.g., Barcode, QR code image or PDF) usable for entrance. */
export const ticketToken = ns("ticketToken");
/** The seat associated with the ticket. */
export const ticketedSeat = ns("ticketedSeat");
/** Approximate or typical time it takes to work with or through this learning resource for the typical intended target audience, e.g. 'PT30M', 'PT1H25M'. */
export const timeRequired = ns("timeRequired");
/** The title of the job. */
export const title = ns("title");
/** A sub property of location. The final location of the object or the agent after the action. */
export const toLocation = ns("toLocation");
/** A sub property of recipient. The recipient who was directly sent the message. */
export const toRecipient = ns("toRecipient");
/** A sub property of instrument. An object used (but not consumed) when performing instructions or a direction. */
export const tool = ns("tool");
/** The total amount due. */
export const totalPaymentDue = ns("totalPaymentDue");
/** The total price for the reservation or ticket, including applicable taxes, shipping, etc.<br/><br/>

Usage guidelines:<br/><br/>

<ul>
<li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
<li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
</ul>
 */
export const totalPrice = ns("totalPrice");
/** The total time required to perform instructions or a direction (including time to prepare the supplies), in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 duration format</a>. */
export const totalTime = ns("totalTime");
/** Attraction suitable for type(s) of tourist. eg. Children, visitors from a particular country, etc. */
export const touristType = ns("touristType");
/** Shipper tracking number. */
export const trackingNumber = ns("trackingNumber");
/** Tracking url for the parcel delivery. */
export const trackingUrl = ns("trackingUrl");
/** A music recording (track)&#x2014;usually a single song. */
export const tracks = ns("tracks");
/** The trailer of a movie or tv/radio series, season, episode, etc. */
export const trailer = ns("trailer");
/** The name of the train (e.g. The Orient Express). */
export const trainName = ns("trainName");
/** The unique identifier for the train. */
export const trainNumber = ns("trainNumber");
/** The number of grams of trans fat. */
export const transFatContent = ns("transFatContent");
/** If this MediaObject is an AudioObject or VideoObject, the transcript of that object. */
export const transcript = ns("transcript");
/** Organization or person who adapts a creative work to different languages, regional differences and technical requirements of a target market, or that translates during some event. */
export const translator = ns("translator");
/** The type of bed to which the BedDetail refers, i.e. the type of bed available in the quantity indicated by quantity. */
export const typeOfBed = ns("typeOfBed");
/** The product that this structured value is referring to. */
export const typeOfGood = ns("typeOfGood");
/** The typical expected age range, e.g. '7-9', '11-'. */
export const typicalAgeRange = ns("typicalAgeRange");
/** The person or organization the reservation or ticket is for. */
export const underName = ns("underName");
/** The unit of measurement given using the UN/CEFACT Common Code (3 characters) or a URL. Other codes than the UN/CEFACT Common Code may be used with a prefix followed by a colon. */
export const unitCode = ns("unitCode");
/** A string or text indicating the unit of measurement. Useful if you cannot provide a standard unit code for
<a href='unitCode'>unitCode</a>. */
export const unitText = ns("unitText");
/** The number of grams of unsaturated fat. */
export const unsaturatedFatContent = ns("unsaturatedFatContent");
/** Date when this media object was uploaded to this site. */
export const uploadDate = ns("uploadDate");
/** The number of upvotes this question, answer or comment has received from the community. */
export const upvoteCount = ns("upvoteCount");
/** URL of the item. */
export const url = ns("url");
/** An url template (RFC6570) that will be used to construct the target of the execution of the action. */
export const urlTemplate = ns("urlTemplate");
/** The number of interactions for the CreativeWork using the WebSite or SoftwareApplication. */
export const userInteractionCount = ns("userInteractionCount");
/** The duration of validity of a permit or similar thing. */
export const validFor = ns("validFor");
/** The date when the item becomes valid. */
export const validFrom = ns("validFrom");
/** The geographic area where a permit or similar thing is valid. */
export const validIn = ns("validIn");
/** The date after when the item is not valid. For example the end of an offer, salary period, or a period of opening hours. */
export const validThrough = ns("validThrough");
/** The date when the item is no longer valid. */
export const validUntil = ns("validUntil");
/** The value of the quantitative value or property value node.<br/><br/>

<ul>
<li>For <a class="localLink" href="http://schema.org/QuantitativeValue">QuantitativeValue</a> and <a class="localLink" href="http://schema.org/MonetaryAmount">MonetaryAmount</a>, the recommended type for values is 'Number'.</li>
<li>For <a class="localLink" href="http://schema.org/PropertyValue">PropertyValue</a>, it can be 'Text;', 'Number', 'Boolean', or 'StructuredValue'.</li>
<li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
<li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
</ul>
 */
export const value = ns("value");
/** Specifies whether the applicable value-added tax (VAT) is included in the price specification or not. */
export const valueAddedTaxIncluded = ns("valueAddedTaxIncluded");
/** Specifies the allowed range for number of characters in a literal value. */
export const valueMaxLength = ns("valueMaxLength");
/** Specifies the minimum allowed range for number of characters in a literal value. */
export const valueMinLength = ns("valueMinLength");
/** Indicates the name of the PropertyValueSpecification to be used in URL templates and form encoding in a manner analogous to HTML's input@name. */
export const valueName = ns("valueName");
/** Specifies a regular expression for testing literal values according to the HTML spec. */
export const valuePattern = ns("valuePattern");
/** A pointer to a secondary value that provides additional information on the original value, e.g. a reference temperature. */
export const valueReference = ns("valueReference");
/** Whether the property must be filled in to complete the action.  Default is false. */
export const valueRequired = ns("valueRequired");
/** The Value-added Tax ID of the organization or person. */
export const vatID = ns("vatID");
/** A short text indicating the configuration of the vehicle, e.g. '5dr hatchback ST 2.5 MT 225 hp' or 'limited edition'. */
export const vehicleConfiguration = ns("vehicleConfiguration");
/** Information about the engine or engines of the vehicle. */
export const vehicleEngine = ns("vehicleEngine");
/** The Vehicle Identification Number (VIN) is a unique serial number used by the automotive industry to identify individual motor vehicles. */
export const vehicleIdentificationNumber = ns("vehicleIdentificationNumber");
/** The color or color combination of the interior of the vehicle. */
export const vehicleInteriorColor = ns("vehicleInteriorColor");
/** The type or material of the interior of the vehicle (e.g. synthetic fabric, leather, wood, etc.). While most interior types are characterized by the material used, an interior type can also be based on vehicle usage or target audience. */
export const vehicleInteriorType = ns("vehicleInteriorType");
/** The release date of a vehicle model (often used to differentiate versions of the same make and model). */
export const vehicleModelDate = ns("vehicleModelDate");
/** The number of passengers that can be seated in the vehicle, both in terms of the physical space available, and in terms of limitations set by law.<br/><br/>

Typical unit code(s): C62 for persons. */
export const vehicleSeatingCapacity = ns("vehicleSeatingCapacity");
/** The type of component used for transmitting the power from a rotating power source to the wheels or other relevant component(s) ("gearbox" for cars). */
export const vehicleTransmission = ns("vehicleTransmission");
/** 'vendor' is an earlier term for 'seller'. */
export const vendor = ns("vendor");
/** The version of the CreativeWork embodied by a specified resource. */
export const version = ns("version");
/** An embedded video object. */
export const video = ns("video");
/** The type of screening or video broadcast used (e.g. IMAX, 3D, SD, HD, etc.). */
export const videoFormat = ns("videoFormat");
/** The frame size of the video. */
export const videoFrameSize = ns("videoFrameSize");
/** The quality of the video. */
export const videoQuality = ns("videoQuality");
/** Identifies the volume of publication or multi-part work; for example, "iii" or "2". */
export const volumeNumber = ns("volumeNumber");
/** The warranty promise(s) included in the offer. */
export const warrantyPromise = ns("warrantyPromise");
/** The scope of the warranty promise. */
export const warrantyScope = ns("warrantyScope");
/** The time when a passenger can check into the flight online. */
export const webCheckinTime = ns("webCheckinTime");
/** The weight of the product or person. */
export const weight = ns("weight");
/** The width of the item. */
export const width = ns("width");
/** A sub property of participant. The winner of the action. */
export const winner = ns("winner");
/** The number of words in the text of the Article. */
export const wordCount = ns("wordCount");
/** The typical working hours for this job (e.g. 1st shift, night shift, 8am-5pm). */
export const workHours = ns("workHours");
/** A contact location for a person's place of work. */
export const workLocation = ns("workLocation");
/** A work performed in some event, for example a play performed in a TheaterEvent. */
export const workPerformed = ns("workPerformed");
/** The movie presented during this event. */
export const workPresented = ns("workPresented");
/** Organizations that the person works for. */
export const worksFor = ns("worksFor");
/** The lowest value allowed in this rating system. If worstRating is omitted, 1 is assumed. */
export const worstRating = ns("worstRating");
/** An XPath, e.g. of a <a class="localLink" href="http://schema.org/SpeakableSpecification">SpeakableSpecification</a> or <a class="localLink" href="http://schema.org/WebPageElement">WebPageElement</a>. In the latter case, multiple matches within a page can constitute a single conceptual "Web page element". */
export const xpath = ns("xpath");
/** The size of the business in annual revenue. */
export const yearlyRevenue = ns("yearlyRevenue");
/** The age of the business. */
export const yearsInOperation = ns("yearsInOperation");
/** An application that can complete the request. */
export const actionApplication = ns("actionApplication");
/** A sub property of object. The options subject to this action. */
export const actionOption = ns("actionOption");
/** An actor, e.g. in tv, radio, movie, video games etc., or in an event. Actors can be associated with individual items or with a series, episode, clip. */
export const actor = ns("actor");
/** A music album. */
export const album = ns("album");
/** A release of this album. */
export const albumRelease = ns("albumRelease");
/** Alumni of an organization. */
export const alumni = ns("alumni");
/** An organization that the person is an alumni of. */
export const alumniOf = ns("alumniOf");
/** The supporting materials for the artwork, e.g. Canvas, Paper, Wood, Board, etc. */
export const artworkSurface = ns("artworkSurface");
/** A person or organization attending the event. */
export const attendee = ns("attendee");
/** An intended audience, i.e. a group for whom something was created. */
export const audience = ns("audience");
/** Device required to run the application. Used in cases where a specific make/model is required to run the application. */
export const availableOnDevice = ns("availableOnDevice");
/** An award won by or for this item. */
export const award = ns("award");
/** A posting that is part of this blog. */
export const blogPost = ns("blogPost");
/** An entity that arranges for an exchange between a buyer and a seller.  In most cases a broker never acquires or releases ownership of a product or service involved in an exchange.  If it is not clear whether an entity is a broker, seller, or buyer, the latter two terms are preferred. */
export const broker = ns("broker");
/** What type of code sample: full (compile ready) solution, code snippet, inline code, scripts, template. */
export const codeSampleType = ns("codeSampleType");
/** A colleague of the person. */
export const colleague = ns("colleague");
/** A contact point for a person or organization. */
export const contactPoint = ns("contactPoint");
/** The basic containment relation between a place and another that it contains. */
export const containsPlace = ns("containsPlace");
/** A season that is part of the media series. */
export const containsSeason = ns("containsSeason");
/** The location depicted or described in the content. For example, the location in a photograph or painting. */
export const contentLocation = ns("contentLocation");
/** A dataset contained in this catalog. */
export const dataset = ns("dataset");
/** A description of the item. */
export const description = ns("description");
/** A director of e.g. tv, radio, movie, video gaming etc. content, or of an event. Directors can be associated with individual items or with a series, episode, clip. */
export const director = ns("director");
/** The duration of the item (movie, audio recording, event, etc.) in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 date format</a>. */
export const duration = ns("duration");
/** Someone working for this organization. */
export const employee = ns("employee");
/** The CreativeWork encoded by this media object. */
export const encodesCreativeWork = ns("encodesCreativeWork");
/** Media type typically expressed using a MIME format (see <a href="http://www.iana.org/assignments/media-types/media-types.xhtml">IANA site</a> and <a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types">MDN reference</a>) e.g. application/zip for a SoftwareApplication binary, audio/mpeg for .mp3 etc.).<br/><br/>

In cases where a <a class="localLink" href="http://schema.org/CreativeWork">CreativeWork</a> has several media type representations, <a class="localLink" href="http://schema.org/encoding">encoding</a> can be used to indicate each <a class="localLink" href="http://schema.org/MediaObject">MediaObject</a> alongside particular <a class="localLink" href="http://schema.org/encodingFormat">encodingFormat</a> information.<br/><br/>

Unregistered or niche encoding and file formats can be indicated instead via the most appropriate URL, e.g. defining Web page or a Wikipedia/Wikidata entry. */
export const encodingFormat = ns("encodingFormat");
/** An episode of a tv, radio or game media within a series or season. */
export const episode = ns("episode");
/** Upcoming or past event associated with this place, organization, or action. */
export const event = ns("event");
/** A creative work that this work is an example/instance/realization/derivation of. */
export const exampleOfWork = ns("exampleOfWork");
/** Library file name e.g., mscorlib.dll, system.web.dll. */
export const executableLibraryName = ns("executableLibraryName");
/** A sub property of location. The course where this action was taken. */
export const exerciseCourse = ns("exerciseCourse");
/** A person who founded this organization. */
export const founder = ns("founder");
/** Video game which is played on this server. */
export const game = ns("game");
/** The server on which  it is possible to play the game. */
export const gameServer = ns("gameServer");
/** A broadcast channel of a broadcast service. */
export const hasBroadcastChannel = ns("hasBroadcastChannel");
/** Either the actual menu as a structured representation, as text, or a URL of the menu. */
export const hasMenu = ns("hasMenu");
/** The language of the content or performance or used in an action. Please use one of the language codes from the <a href="http://tools.ietf.org/html/bcp47">IETF BCP 47 standard</a>. See also <a class="localLink" href="http://schema.org/availableLanguage">availableLanguage</a>. */
export const inLanguage = ns("inLanguage");
/** Description of bonus and commission compensation aspects of the job. */
export const incentiveCompensation = ns("incentiveCompensation");
/** The number of interactions for the CreativeWork using the WebSite or SoftwareApplication. The most specific child type of InteractionCounter should be used. */
export const interactionStatistic = ns("interactionStatistic");
/** A flag to signal that the item, event, or place is accessible for free. */
export const isAccessibleForFree = ns("isAccessibleForFree");
/** A resource from which this work is derived or from which it is a modification or adaption. */
export const isBasedOn = ns("isBasedOn");
/** Description of benefits associated with the job. */
export const jobBenefits = ns("jobBenefits");
/** Indicates the primary entity described in some page or other CreativeWork. */
export const mainEntity = ns("mainEntity");
/** Indicates a page (or other CreativeWork) for which this thing is the main entity being described. See <a href="/docs/datamodel.html#mainEntityBackground">background notes</a> for details. */
export const mainEntityOfPage = ns("mainEntityOfPage");
/** A pointer to products or services offered by the organization or person. */
export const makesOffer = ns("makesOffer");
/** A pointer to the organization or person making the offer. */
export const offeredBy = ns("offeredBy");
/** A parent of this person. */
export const parent = ns("parent");
/** The series to which this episode or season belongs. */
export const partOfSeries = ns("partOfSeries");
/** The date that payment is due. */
export const paymentDueDate = ns("paymentDueDate");
/** The length of time it takes to perform instructions or a direction (not including time to prepare the supplies), in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 duration format</a>. */
export const performTime = ns("performTime");
/** A performer at the event&#x2014;for example, a presenter, musician, musical group or actor. */
export const performer = ns("performer");
/** A photograph of this place. */
export const photo = ns("photo");
/** The service provider, service operator, or service performer; the goods producer. Another party (a seller) may offer those services or goods on behalf of the provider. A provider may also serve as the seller. */
export const provider = ns("provider");
/** The BroadcastService offered on this channel. */
export const providesBroadcastService = ns("providesBroadcastService");
/** A single ingredient used in the recipe, e.g. sugar, flour or garlic. */
export const recipeIngredient = ns("recipeIngredient");
/** An audio recording of the work. */
export const recordedAs = ns("recordedAs");
/** The Event where the CreativeWork was recorded. The CreativeWork may capture all or part of the event. */
export const recordedAt = ns("recordedAt");
/** The CreativeWork that captured all or part of this Event. */
export const recordedIn = ns("recordedIn");
/** The composition this track is a recording of. */
export const recordingOf = ns("recordingOf");
/** The album this is a release of. */
export const releaseOf = ns("releaseOf");
/** A review of the item. */
export const review = ns("review");
/** A role played, performed or filled by a person or organization. For example, the team of creators for a comic book might fill the roles named 'inker', 'penciller', and 'letterer'; or an athlete in a SportsTeam might play in the position named 'Quarterback'. */
export const roleName = ns("roleName");
/** Runtime platform or script interpreter dependencies (Example - Java v1, Python2.3, .Net Framework 3.0). */
export const runtimePlatform = ns("runtimePlatform");
/** A season in a media series. */
export const season = ns("season");
/** The serial number or any alphanumeric identifier of a particular product. When attached to an offer, it is a shortcut for the serial number of the product included in the offer. */
export const serialNumber = ns("serialNumber");
/** The geographic area where the service is provided. */
export const serviceArea = ns("serviceArea");
/** The tangible thing generated by the service, e.g. a passport, permit, etc. */
export const serviceOutput = ns("serviceOutput");
/** A sibling of the person. */
export const sibling = ns("sibling");
/** One of the more significant URLs on the page. Typically, these are the non-navigation links that are clicked on the most. */
export const significantLink = ns("significantLink");
/** Component dependency requirements for application. This includes runtime environments and shared libraries that are not included in the application distribution package, but required to run the application (Examples: DirectX, Java or .NET runtime). */
export const softwareRequirements = ns("softwareRequirements");
/** A person or organization that supports a thing through a pledge, promise, or financial contribution. e.g. a sponsor of a Medical Study or a corporate sponsor of an event. */
export const sponsor = ns("sponsor");
/** A relationship between two organizations where the first includes the second, e.g., as a subsidiary. See also: the more specific 'department' property. */
export const subOrganization = ns("subOrganization");
/** A CreativeWork or Event about this Thing. */
export const subjectOf = ns("subjectOf");
/** An answer (possibly one of several, possibly incorrect) to a Question, e.g. on a Question/Answer site. */
export const suggestedAnswer = ns("suggestedAnswer");
/** An event that this event is a part of. For example, a collection of individual music performances might each have a music festival as their superEvent. */
export const superEvent = ns("superEvent");
/** A sub property of object. The collection target of the action. */
export const targetCollection = ns("targetCollection");
/** The temporalCoverage of a CreativeWork indicates the period that the content applies to, i.e. that it describes, either as a DateTime or as a textual string indicating a time period in <a href="https://en.wikipedia.org/wiki/ISO_8601#Time_intervals">ISO 8601 time interval format</a>. In
      the case of a Dataset it will typically indicate the relevant time period in a precise notation (e.g. for a 2011 census dataset, the year 2011 would be written "2011/2012"). Other forms of content e.g. ScholarlyArticle, Book, TVSeries or TVEpisode may indicate their temporalCoverage in broader terms - textually or via well-known URL.
      Written works such as books may sometimes have precise temporal coverage too, e.g. a work set in 1939 - 1945 can be indicated in ISO 8601 interval format format via "1939/1945".<br/><br/>

Open-ended date ranges can be written with ".." in place of the end date. For example, "2015-11/.." indicates a range beginning in November 2015 and with no specified final date. This is tentative and might be updated in future when ISO 8601 is officially updated. */
export const temporalCoverage = ns("temporalCoverage");
/** A music recording (track)&#x2014;usually a single song. If an ItemList is given, the list should contain items of type MusicRecording. */
export const track = ns("track");
/** The warranty promise(s) included in the offer. */
export const warranty = ns("warranty");
/** Example/instance/realization/derivation of the concept of this creative work. eg. The paperback edition, first edition, or eBook. */
export const workExample = ns("workExample");
/** The quantity that results by performing instructions. For example, a paper airplane, 10 personalized candles. */
export const schemayield = ns("yield");
/** The subject matter of the content. */
export const about = ns("about");
/** A competitor in a sports event. */
export const competitor = ns("competitor");
/** The basic containment relation between a place and one that contains it. */
export const containedInPlace = ns("containedInPlace");
/** A media object that encodes this CreativeWork. This property is a synonym for associatedMedia. */
export const encoding = ns("encoding");
/** A URL to a map of the place. */
export const hasMap = ns("hasMap");
/** An image of the item. This can be a <a class="localLink" href="http://schema.org/URL">URL</a> or a fully described <a class="localLink" href="http://schema.org/ImageObject">ImageObject</a>. */
export const image = ns("image");
/** A material that something is made from, e.g. leather, wool, cotton, paper. */
export const material = ns("material");
/** An Organization (or ProgramMembership) to which this Person or Organization belongs. */
export const memberOf = ns("memberOf");
/** The larger organization that this organization is a <a class="localLink" href="http://schema.org/subOrganization">subOrganization</a> of, if any. */
export const parentOrganization = ns("parentOrganization");
/** The result produced in the action. e.g. John wrote <em>a book</em>. */
export const result = ns("result");
/** An entity which offers (sells / leases / lends / loans) the services / goods.  A seller may also be a provider. */
export const seller = ns("seller");
/** A single step item (as HowToStep, text, document, video, etc.) or a HowToSection. */
export const step = ns("step");
/** An Event that is part of this event. For example, a conference event includes many presentations, each of which is a subEvent of the conference. */
export const subEvent = ns("subEvent");
/** A sub-property of instrument. A supply consumed when performing instructions or a direction. */
export const supply = ns("supply");
/** A work featured in some event, e.g. exhibited in an ExhibitionEvent.
       Specific subproperties are available for workPerformed (e.g. a play), or a workPresented (a Movie at a ScreeningEvent). */
export const workFeatured = ns("workFeatured");
/** The geographic area where a service or offered item is provided. */
export const areaServed = ns("areaServed");
/** A data catalog which contains this dataset. */
export const includedInDataCatalog = ns("includedInDataCatalog");
/** A member of an Organization or a ProgramMembership. Organizations can be members of organizations; ProgramMembership is typically for individuals. */
export const member = ns("member");
/** A sub property of participant. The participant who is at the receiving end of the action. */
export const recipient = ns("recipient");
/** Indicates an item or CreativeWork that is part of this item, or CreativeWork (in some sense). */
export const hasPart = ns("hasPart");
/** Indicates an item or CreativeWork that this item, or CreativeWork (in some sense), is part of. */
export const isPartOf = ns("isPartOf");
/** The position of an item in a series or sequence of items. */
export const position = ns("position");
/** The object that helped the agent perform the action. e.g. John wrote a book with <em>a pen</em>. */
export const instrument = ns("instrument");
/** The object upon which the action is carried out, whose state is kept intact or changed. Also known as the semantic roles patient, affected or undergoer (which change their state) or theme (which doesn't). e.g. John read <em>a book</em>. */
export const object = ns("object");
/** The location of for example where the event is happening, an organization is located, or where an action takes place. */
export const location = ns("location");
/** Other co-agents that participated in the action indirectly. e.g. John wrote a book with <em>Steve</em>. */
export const participant = ns("participant");
/** The identifier property represents any kind of identifier for any kind of <a class="localLink" href="http://schema.org/Thing">Thing</a>, such as ISBNs, GTIN codes, UUIDs etc. Schema.org provides dedicated properties for representing many of these, either as textual strings or as URL (URI) links. See <a href="/docs/datamodel.html#identifierBg">background notes</a> for more details. */
export const identifier = ns("identifier");
/** An in-progress action (e.g, while watching the movie, or driving to a location). */
export const ActiveActionStatus = ns("ActiveActionStatus");
/** AlbumRelease. */
export const AlbumRelease = ns("AlbumRelease");
/** All-wheel Drive is a transmission layout where the engine drives all four wheels. */
export const AllWheelDriveConfiguration = ns("AllWheelDriveConfiguration");
/** Book format: Audiobook. This is an enumerated value for use with the bookFormat property. There is also a type 'Audiobook' in the bib extension which includes Audiobook specific properties. */
export const AudiobookFormat = ns("AudiobookFormat");
/** BroadcastRelease. */
export const BroadcastRelease = ns("BroadcastRelease");
/** CDFormat. */
export const CDFormat = ns("CDFormat");
/** CassetteFormat. */
export const CassetteFormat = ns("CassetteFormat");
/** Play mode: CoOp. Co-operative games, where you play on the same team with friends. */
export const CoOp = ns("CoOp");
/** Permission to add comments to the document. */
export const CommentPermission = ns("CommentPermission");
/** CompilationAlbum. */
export const CompilationAlbum = ns("CompilationAlbum");
/** An action that has already taken place. */
export const CompletedActionStatus = ns("CompletedActionStatus");
/** DJMixAlbum. */
export const DJMixAlbum = ns("DJMixAlbum");
/** DVDFormat. */
export const DVDFormat = ns("DVDFormat");
/** Indicates that the item is damaged. */
export const DamagedCondition = ns("DamagedCondition");
/** DemoAlbum. */
export const DemoAlbum = ns("DemoAlbum");
/** A diet appropriate for people with diabetes. */
export const DiabeticDiet = ns("DiabeticDiet");
/** DigitalAudioTapeFormat. */
export const DigitalAudioTapeFormat = ns("DigitalAudioTapeFormat");
/** DigitalFormat. */
export const DigitalFormat = ns("DigitalFormat");
/** Indicates that the item has been discontinued. */
export const Discontinued = ns("Discontinued");
/** Book format: Ebook. */
export const EBook = ns("EBook");
/** EPRelease. */
export const EPRelease = ns("EPRelease");
/** The event has been cancelled. If the event has multiple startDate values, all are assumed to be cancelled. Either startDate or previousStartDate may be used to specify the event's cancelled date(s). */
export const EventCancelled = ns("EventCancelled");
/** The event has been postponed and no new date has been set. The event's previousStartDate should be set. */
export const EventPostponed = ns("EventPostponed");
/** The event has been rescheduled. The event's previousStartDate should be set to the old date and the startDate should be set to the event's new date. (If the event has been rescheduled multiple times, the previousStartDate property may be repeated). */
export const EventRescheduled = ns("EventRescheduled");
/** The event is taking place or has taken place on the startDate as scheduled. Use of this value is optional, as it is assumed by default. */
export const EventScheduled = ns("EventScheduled");
/** An action that failed to complete. The action's error property and the HTTP return code contain more information about the failure. */
export const FailedActionStatus = ns("FailedActionStatus");
/** The boolean value false. */
export const False = ns("False");
/** The female gender. */
export const Female = ns("Female");
/** Four-wheel drive is a transmission layout where the engine primarily drives two wheels with a part-time four-wheel drive capability. */
export const FourWheelDriveConfiguration = ns("FourWheelDriveConfiguration");
/** The day of the week between Thursday and Saturday. */
export const Friday = ns("Friday");
/** Front-wheel drive is a transmission layout where the engine drives the front wheels. */
export const FrontWheelDriveConfiguration = ns("FrontWheelDriveConfiguration");
/** A diet exclusive of gluten. */
export const GlutenFreeDiet = ns("GlutenFreeDiet");
/** The airline boards by groups based on check-in time, priority, etc. */
export const GroupBoardingPolicy = ns("GroupBoardingPolicy");
/** A diet conforming to Islamic dietary practices. */
export const HalalDiet = ns("HalalDiet");
/** Book format: Hardcover. */
export const Hardcover = ns("Hardcover");
/** Uses devices to support users with hearing impairments. */
export const HearingImpairedSupported = ns("HearingImpairedSupported");
/** A diet conforming to Hindu dietary practices, in particular, beef-free. */
export const HinduDiet = ns("HinduDiet");
/** Indicates that the item is in stock. */
export const InStock = ns("InStock");
/** Indicates that the item is available only at physical locations. */
export const InStoreOnly = ns("InStoreOnly");
/** An ItemList ordered with lower values listed first. */
export const ItemListOrderAscending = ns("ItemListOrderAscending");
/** An ItemList ordered with higher values listed first. */
export const ItemListOrderDescending = ns("ItemListOrderDescending");
/** An ItemList ordered with no explicit order. */
export const ItemListUnordered = ns("ItemListUnordered");
/** A diet conforming to Jewish dietary practices. */
export const KosherDiet = ns("KosherDiet");
/** LaserDiscFormat. */
export const LaserDiscFormat = ns("LaserDiscFormat");
/** The steering position is on the left side of the vehicle (viewed from the main direction of driving). */
export const LeftHandDriving = ns("LeftHandDriving");
/** Indicates that the item has limited availability. */
export const LimitedAvailability = ns("LimitedAvailability");
/** LiveAlbum. */
export const LiveAlbum = ns("LiveAlbum");
/** A diet focused on reduced calorie intake. */
export const LowCalorieDiet = ns("LowCalorieDiet");
/** A diet focused on reduced fat and cholesterol intake. */
export const LowFatDiet = ns("LowFatDiet");
/** A diet appropriate for people with lactose intolerance. */
export const LowLactoseDiet = ns("LowLactoseDiet");
/** A diet focused on reduced sodium intake. */
export const LowSaltDiet = ns("LowSaltDiet");
/** The male gender. */
export const Male = ns("Male");
/** MixtapeAlbum. */
export const MixtapeAlbum = ns("MixtapeAlbum");
/** The day of the week between Sunday and Tuesday. */
export const Monday = ns("Monday");
/** Play mode: MultiPlayer. Requiring or allowing multiple human players to play simultaneously. */
export const MultiPlayer = ns("MultiPlayer");
/** Indicates that the item is new. */
export const NewCondition = ns("NewCondition");
/** Game server status: OfflinePermanently. Server is offline and not available. */
export const OfflinePermanently = ns("OfflinePermanently");
/** Game server status: OfflineTemporarily. Server is offline now but it can be online soon. */
export const OfflineTemporarily = ns("OfflineTemporarily");
/** A DeliveryMethod in which an item is collected on site, e.g. in a store or at a box office. */
export const OnSitePickup = ns("OnSitePickup");
/** Game server status: Online. Server is available. */
export const Online = ns("Online");
/** Game server status: OnlineFull. Server is online but unavailable. The maximum number of players has reached. */
export const OnlineFull = ns("OnlineFull");
/** Indicates that the item is available only online. */
export const OnlineOnly = ns("OnlineOnly");
/** OrderStatus representing cancellation of an order. */
export const OrderCancelled = ns("OrderCancelled");
/** OrderStatus representing successful delivery of an order. */
export const OrderDelivered = ns("OrderDelivered");
/** OrderStatus representing that an order is in transit. */
export const OrderInTransit = ns("OrderInTransit");
/** OrderStatus representing that payment is due on an order. */
export const OrderPaymentDue = ns("OrderPaymentDue");
/** OrderStatus representing availability of an order for pickup. */
export const OrderPickupAvailable = ns("OrderPickupAvailable");
/** OrderStatus representing that there is a problem with the order. */
export const OrderProblem = ns("OrderProblem");
/** OrderStatus representing that an order is being processed. */
export const OrderProcessing = ns("OrderProcessing");
/** OrderStatus representing that an order has been returned. */
export const OrderReturned = ns("OrderReturned");
/** Indicates that the item is out of stock. */
export const OutOfStock = ns("OutOfStock");
/** Book format: Paperback. */
export const Paperback = ns("Paperback");
/** A parking map. */
export const ParkingMap = ns("ParkingMap");
/** An automatic payment system is in place and will be used. */
export const PaymentAutomaticallyApplied = ns("PaymentAutomaticallyApplied");
/** The payment has been received and processed. */
export const PaymentComplete = ns("PaymentComplete");
/** The payee received the payment, but it was declined for some reason. */
export const PaymentDeclined = ns("PaymentDeclined");
/** The payment is due, but still within an acceptable time to be received. */
export const PaymentDue = ns("PaymentDue");
/** The payment is due and considered late. */
export const PaymentPastDue = ns("PaymentPastDue");
/** A description of an action that is supported. */
export const PotentialActionStatus = ns("PotentialActionStatus");
/** Indicates that the item is available for pre-order, but will be delivered when generally available. */
export const PreOrder = ns("PreOrder");
/** Indicates that the item is available for ordering and delivery before general availability. */
export const PreSale = ns("PreSale");
/** This stands for any day that is a public holiday; it is a placeholder for all official public holidays in some particular location. While not technically a "day of the week", it can be used with <a class="localLink" href="http://schema.org/OpeningHoursSpecification">OpeningHoursSpecification</a>. In the context of an opening hours specification it can be used to indicate opening hours on public holidays, overriding general opening hours for the day of the week on which a public holiday occurs. */
export const PublicHolidays = ns("PublicHolidays");
/** Permission to read or view the document. */
export const ReadPermission = ns("ReadPermission");
/** Real-wheel drive is a transmission layout where the engine drives the rear wheels. */
export const RearWheelDriveConfiguration = ns("RearWheelDriveConfiguration");
/** Indicates that the item is refurbished. */
export const RefurbishedCondition = ns("RefurbishedCondition");
/** RemixAlbum. */
export const RemixAlbum = ns("RemixAlbum");
/** Researchers. */
export const Researcher = ns("Researcher");
/** The status for a previously confirmed reservation that is now cancelled. */
export const ReservationCancelled = ns("ReservationCancelled");
/** The status of a confirmed reservation. */
export const ReservationConfirmed = ns("ReservationConfirmed");
/** The status of a reservation on hold pending an update like credit card number or flight changes. */
export const ReservationHold = ns("ReservationHold");
/** The status of a reservation when a request has been sent, but not confirmed. */
export const ReservationPending = ns("ReservationPending");
/** The steering position is on the right side of the vehicle (viewed from the main direction of driving). */
export const RightHandDriving = ns("RightHandDriving");
/** The invitee may or may not attend. */
export const RsvpResponseMaybe = ns("RsvpResponseMaybe");
/** The invitee will not attend. */
export const RsvpResponseNo = ns("RsvpResponseNo");
/** The invitee will attend. */
export const RsvpResponseYes = ns("RsvpResponseYes");
/** The day of the week between Friday and Sunday. */
export const Saturday = ns("Saturday");
/** A seating map. */
export const SeatingMap = ns("SeatingMap");
/** Play mode: SinglePlayer. Which is played by a lone player. */
export const SinglePlayer = ns("SinglePlayer");
/** SingleRelease. */
export const SingleRelease = ns("SingleRelease");
/** Indicates that the item has sold out. */
export const SoldOut = ns("SoldOut");
/** SoundtrackAlbum. */
export const SoundtrackAlbum = ns("SoundtrackAlbum");
/** SpokenWordAlbum. */
export const SpokenWordAlbum = ns("SpokenWordAlbum");
/** StudioAlbum. */
export const StudioAlbum = ns("StudioAlbum");
/** The day of the week between Saturday and Monday. */
export const Sunday = ns("Sunday");
/** The day of the week between Wednesday and Friday. */
export const Thursday = ns("Thursday");
/** The associated telephone number is toll free. */
export const TollFree = ns("TollFree");
/** A transit map. */
export const TransitMap = ns("TransitMap");
/** The boolean value true. */
export const True = ns("True");
/** The day of the week between Monday and Wednesday. */
export const Tuesday = ns("Tuesday");
/** Indicates that the item is used. */
export const UsedCondition = ns("UsedCondition");
/** A diet exclusive of all animal products. */
export const VeganDiet = ns("VeganDiet");
/** A diet exclusive of animal meat. */
export const VegetarianDiet = ns("VegetarianDiet");
/** A venue map (e.g. for malls, auditoriums, museums, etc.). */
export const VenueMap = ns("VenueMap");
/** VinylFormat. */
export const VinylFormat = ns("VinylFormat");
/** The day of the week between Tuesday and Thursday. */
export const Wednesday = ns("Wednesday");
/** Permission to write or edit the document. */
export const WritePermission = ns("WritePermission");
/** The airline boards by zones of the plane. */
export const ZoneBoardingPolicy = ns("ZoneBoardingPolicy");
export default {
    /** Function to create arbitrary terms within the 'Schema.org' ontology */
    ns,
    /** A radio channel that uses AM. */
    AMRadioChannel,
    /** Reference documentation for application programming interfaces (APIs). */
    APIReference,
    /** Web page type: About page. */
    AboutPage,
    /** The act of committing to/adopting an object.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/RejectAction">RejectAction</a>: The antonym of AcceptAction.</li>
    </ul>
     */
    AcceptAction,
    /** An accommodation is a place that can accommodate human beings, e.g. a hotel room, a camping pitch, or a meeting room. Many accommodations are for overnight stays, but this is not a mandatory requirement.
    For more specific types of accommodations not defined in schema.org, one can use additionalType with external vocabularies.
    <br /><br />
    See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    Accommodation,
    /** Accountancy business.<br/><br/>
    
    As a <a class="localLink" href="http://schema.org/LocalBusiness">LocalBusiness</a> it can be described as a <a class="localLink" href="http://schema.org/provider">provider</a> of one or more <a class="localLink" href="http://schema.org/Service">Service</a>(s). */
    AccountingService,
    /** The act of accomplishing something via previous efforts. It is an instantaneous action rather than an ongoing process. */
    AchieveAction,
    /** An action performed by a direct agent and indirect participants upon a direct object. Optionally happens at a location with the help of an inanimate instrument. The execution of the action may produce a result. Specific action sub-type documentation specifies the exact expectation of each argument/role.<br/><br/>
    
    See also <a href="http://blog.schema.org/2014/04/announcing-schemaorg-actions.html">blog post</a> and <a href="http://schema.org/docs/actions.html">Actions overview document</a>. */
    Action,
    /** A set of requirements that a must be fulfilled in order to perform an Action. */
    ActionAccessSpecification,
    /** The status of an Action. */
    ActionStatusType,
    /** The act of starting or activating a device or application (e.g. starting a timer or turning on a flashlight). */
    ActivateAction,
    /** The act of editing by adding an object to a collection. */
    AddAction,
    /** A geographical region, typically under the jurisdiction of a particular government. */
    AdministrativeArea,
    /** An adult entertainment establishment. */
    AdultEntertainment,
    /** When a single product is associated with multiple offers (for example, the same pair of shoes is offered by different merchants), then AggregateOffer can be used. */
    AggregateOffer,
    /** The average rating based on multiple ratings or reviews. */
    AggregateRating,
    /** The act of expressing a consistency of opinion with the object. An agent agrees to/about an object (a proposition, topic or theme) with participants. */
    AgreeAction,
    /** An organization that provides flights for passengers. */
    Airline,
    /** An airport. */
    Airport,
    /** An intangible item that describes an alignment between a learning resource and a node in an educational framework. */
    AlignmentObject,
    /** The act of organizing tasks/objects/events by associating resources to it. */
    AllocateAction,
    /** An amusement park. */
    AmusementPark,
    /** Animal shelter. */
    AnimalShelter,
    /** An answer offered to a question; perhaps correct, perhaps opinionated or wrong. */
    Answer,
    /** An apartment (in American English) or flat (in British English) is a self-contained housing unit (a type of residential real estate) that occupies only part of a building (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/Apartment">http://en.wikipedia.org/wiki/Apartment</a>). */
    Apartment,
    /** Residence type: Apartment complex. */
    ApartmentComplex,
    /** The act of inserting at the end if an ordered collection. */
    AppendAction,
    /** The act of registering to an organization/service without the guarantee to receive it.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/RegisterAction">RegisterAction</a>: Unlike RegisterAction, ApplyAction has no guarantees that the application will be accepted.</li>
    </ul>
     */
    ApplyAction,
    /** Aquarium. */
    Aquarium,
    /** The act of arriving at a place. An agent arrives at a destination from a fromLocation, optionally with participants. */
    ArriveAction,
    /** An art gallery. */
    ArtGallery,
    /** An article, such as a news article or piece of investigative report. Newspapers and magazines have articles of many different types and this is intended to cover them all.<br/><br/>
    
    See also <a href="http://blog.schema.org/2014/09/schemaorg-support-for-bibliographic_2.html">blog post</a>. */
    Article,
    /** The act of posing a question / favor to someone.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/ReplyAction">ReplyAction</a>: Appears generally as a response to AskAction.</li>
    </ul>
     */
    AskAction,
    /** The act of forming one's opinion, reaction or sentiment. */
    AssessAction,
    /** The act of allocating an action/event/task to some destination (someone or something). */
    AssignAction,
    /** Professional service: Attorney. <br/><br/>
    
    This type is deprecated - <a class="localLink" href="http://schema.org/LegalService">LegalService</a> is more inclusive and less ambiguous. */
    Attorney,
    /** Intended audience for an item, i.e. the group for whom the item was created. */
    Audience,
    /** An audio file. */
    AudioObject,
    /** The act of granting permission to an object. */
    AuthorizeAction,
    /** Auto body shop. */
    AutoBodyShop,
    /** An car dealership. */
    AutoDealer,
    /** An auto parts store. */
    AutoPartsStore,
    /** A car rental business. */
    AutoRental,
    /** Car repair business. */
    AutoRepair,
    /** A car wash business. */
    AutoWash,
    /** ATM/cash machine. */
    AutomatedTeller,
    /** Car repair, sales, or parts. */
    AutomotiveBusiness,
    /** A bakery. */
    Bakery,
    /** A product or service offered by a bank whereby one may deposit, withdraw or transfer money and in some cases be paid interest. */
    BankAccount,
    /** Bank or credit union. */
    BankOrCreditUnion,
    /** A bar or pub. */
    BarOrPub,
    /** An image of a visual machine-readable code such as a barcode or QR code. */
    Barcode,
    /** Beach. */
    Beach,
    /** Beauty salon. */
    BeautySalon,
    /** Bed and breakfast.
    <br /><br />
    See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    BedAndBreakfast,
    /** An entity holding detailed information about the available bed types, e.g. the quantity of twin beds for a hotel room. For the single case of just one bed of a certain type, you can use bed directly with a text. See also <a class="localLink" href="http://schema.org/BedType">BedType</a> (under development). */
    BedDetails,
    /** A type of bed. This is used for indicating the bed or beds available in an accommodation. */
    BedType,
    /** The act of forming a personal connection with someone (object) mutually/bidirectionally/symmetrically.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/FollowAction">FollowAction</a>: Unlike FollowAction, BefriendAction implies that the connection is reciprocal.</li>
    </ul>
     */
    BefriendAction,
    /** A bike store. */
    BikeStore,
    /** A blog. */
    Blog,
    /** A blog post. */
    BlogPosting,
    /** A type of boarding policy used by an airline. */
    BoardingPolicyType,
    /** A body of water, such as a sea, ocean, or lake. */
    BodyOfWater,
    /** A book. */
    Book,
    /** The publication format of the book. */
    BookFormatType,
    /** A series of books. Included books can be indicated with the hasPart property. */
    BookSeries,
    /** A bookstore. */
    BookStore,
    /** An agent bookmarks/flags/labels/tags/marks an object. */
    BookmarkAction,
    /** Boolean: True or False. */
    Boolean,
    /** The act of obtaining an object under an agreement to return it at a later date. Reciprocal of LendAction.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/LendAction">LendAction</a>: Reciprocal of BorrowAction.</li>
    </ul>
     */
    BorrowAction,
    /** A bowling alley. */
    BowlingAlley,
    /** A brand is a name used by an organization or business person for labeling a product, product group, or similar. */
    Brand,
    /** A BreadcrumbList is an ItemList consisting of a chain of linked Web pages, typically described using at least their URL and their name, and typically ending with the current page.<br/><br/>
    
    The <a class="localLink" href="http://schema.org/position">position</a> property is used to reconstruct the order of the items in a BreadcrumbList The convention is that a breadcrumb list has an <a class="localLink" href="http://schema.org/itemListOrder">itemListOrder</a> of <a class="localLink" href="http://schema.org/ItemListOrderAscending">ItemListOrderAscending</a> (lower values listed first), and that the first items in this list correspond to the "top" or beginning of the breadcrumb trail, e.g. with a site or section homepage. The specific values of 'position' are not assigned meaning for a BreadcrumbList, but they should be integers, e.g. beginning with '1' for the first item in the list. */
    BreadcrumbList,
    /** Brewery. */
    Brewery,
    /** A bridge. */
    Bridge,
    /** A unique instance of a BroadcastService on a CableOrSatelliteService lineup. */
    BroadcastChannel,
    /** An over the air or online broadcast event. */
    BroadcastEvent,
    /** The frequency in MHz and the modulation used for a particular BroadcastService. */
    BroadcastFrequencySpecification,
    /** A delivery service through which content is provided via broadcast over the air or online. */
    BroadcastService,
    /** A Buddhist temple. */
    BuddhistTemple,
    /** A reservation for bus travel. <br/><br/>
    
    Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
    BusReservation,
    /** A bus station. */
    BusStation,
    /** A bus stop. */
    BusStop,
    /** A trip on a commercial bus line. */
    BusTrip,
    /** A set of characteristics belonging to businesses, e.g. who compose an item's target audience. */
    BusinessAudience,
    /** A business entity type is a conceptual entity representing the legal form, the size, the main line of business, the position in the value chain, or any combination thereof, of an organization or business person.<br/><br/>
    
    Commonly used values:<br/><br/>
    
    <ul>
    <li>http://purl.org/goodrelations/v1#Business</li>
    <li>http://purl.org/goodrelations/v1#Enduser</li>
    <li>http://purl.org/goodrelations/v1#PublicInstitution</li>
    <li>http://purl.org/goodrelations/v1#Reseller</li>
    </ul>
     */
    BusinessEntityType,
    /** Event type: Business event. */
    BusinessEvent,
    /** The business function specifies the type of activity or access (i.e., the bundle of rights) offered by the organization or business person through the offer. Typical are sell, rental or lease, maintenance or repair, manufacture / produce, recycle / dispose, engineering / construction, or installation. Proprietary specifications of access rights are also instances of this class.<br/><br/>
    
    Commonly used values:<br/><br/>
    
    <ul>
    <li>http://purl.org/goodrelations/v1#ConstructionInstallation</li>
    <li>http://purl.org/goodrelations/v1#Dispose</li>
    <li>http://purl.org/goodrelations/v1#LeaseOut</li>
    <li>http://purl.org/goodrelations/v1#Maintain</li>
    <li>http://purl.org/goodrelations/v1#ProvideService</li>
    <li>http://purl.org/goodrelations/v1#Repair</li>
    <li>http://purl.org/goodrelations/v1#Sell</li>
    <li>http://purl.org/goodrelations/v1#Buy</li>
    </ul>
     */
    BusinessFunction,
    /** The act of giving money to a seller in exchange for goods or services rendered. An agent buys an object, product, or service from a seller for a price. Reciprocal of SellAction. */
    BuyAction,
    /** A service which provides access to media programming like TV or radio. Access may be via cable or satellite. */
    CableOrSatelliteService,
    /** A cafe or coffee shop. */
    CafeOrCoffeeShop,
    /** A camping site, campsite, or <a class="localLink" href="http://schema.org/Campground">Campground</a> is a place used for overnight stay in the outdoors, typically containing individual <a class="localLink" href="http://schema.org/CampingPitch">CampingPitch</a> locations. <br/><br/>
    
    In British English a campsite is an area, usually divided into a number of pitches, where people can camp overnight using tents or camper vans or caravans; this British English use of the word is synonymous with the American English expression campground. In American English the term campsite generally means an area where an individual, family, group, or military unit can pitch a tent or park a camper; a campground may contain many campsites (Source: Wikipedia see <a href="https://en.wikipedia.org/wiki/Campsite">https://en.wikipedia.org/wiki/Campsite</a>).<br/><br/>
    
    See also the dedicated <a href="/docs/hotels.html">document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    Campground,
    /** A <a class="localLink" href="http://schema.org/CampingPitch">CampingPitch</a> is an individual place for overnight stay in the outdoors, typically being part of a larger camping site, or <a class="localLink" href="http://schema.org/Campground">Campground</a>.<br/><br/>
    
    In British English a campsite, or campground, is an area, usually divided into a number of pitches, where people can camp overnight using tents or camper vans or caravans; this British English use of the word is synonymous with the American English expression campground. In American English the term campsite generally means an area where an individual, family, group, or military unit can pitch a tent or park a camper; a campground may contain many campsites.
    (Source: Wikipedia see <a href="https://en.wikipedia.org/wiki/Campsite">https://en.wikipedia.org/wiki/Campsite</a>).<br/><br/>
    
    See also the dedicated <a href="/docs/hotels.html">document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    CampingPitch,
    /** A canal, like the Panama Canal. */
    Canal,
    /** The act of asserting that a future event/action is no longer going to happen.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/ConfirmAction">ConfirmAction</a>: The antonym of CancelAction.</li>
    </ul>
     */
    CancelAction,
    /** A car is a wheeled, self-powered motor vehicle used for transportation. */
    Car,
    /** A casino. */
    Casino,
    /** A Catholic church. */
    CatholicChurch,
    /** A graveyard. */
    Cemetery,
    /** An agent inspects, determines, investigates, inquires, or examines an object's accuracy, quality, condition, or state. */
    CheckAction,
    /** The act of an agent communicating (service provider, social media, etc) their arrival by registering/confirming for a previously reserved service (e.g. flight check in) or at a place (e.g. hotel), possibly resulting in a result (boarding pass, etc).<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/CheckOutAction">CheckOutAction</a>: The antonym of CheckInAction.</li>
    <li><a class="localLink" href="http://schema.org/ArriveAction">ArriveAction</a>: Unlike ArriveAction, CheckInAction implies that the agent is informing/confirming the start of a previously reserved service.</li>
    <li><a class="localLink" href="http://schema.org/ConfirmAction">ConfirmAction</a>: Unlike ConfirmAction, CheckInAction implies that the agent is informing/confirming the <em>start</em> of a previously reserved service rather than its validity/existence.</li>
    </ul>
     */
    CheckInAction,
    /** The act of an agent communicating (service provider, social media, etc) their departure of a previously reserved service (e.g. flight check in) or place (e.g. hotel).<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/CheckInAction">CheckInAction</a>: The antonym of CheckOutAction.</li>
    <li><a class="localLink" href="http://schema.org/DepartAction">DepartAction</a>: Unlike DepartAction, CheckOutAction implies that the agent is informing/confirming the end of a previously reserved service.</li>
    <li><a class="localLink" href="http://schema.org/CancelAction">CancelAction</a>: Unlike CancelAction, CheckOutAction implies that the agent is informing/confirming the end of a previously reserved service.</li>
    </ul>
     */
    CheckOutAction,
    /** Web page type: Checkout page. */
    CheckoutPage,
    /** A Childcare center. */
    ChildCare,
    /** Event type: Children's event. */
    ChildrensEvent,
    /** The act of expressing a preference from a set of options or a large or unbounded set of choices/options. */
    ChooseAction,
    /** A church. */
    Church,
    /** A city or town. */
    City,
    /** A city hall. */
    CityHall,
    /** A public structure, such as a town hall or concert hall. */
    CivicStructure,
    /** A fact-checking review of claims made (or reported) in some creative work (referenced via itemReviewed). */
    ClaimReview,
    /** A short TV or radio program or a segment/part of a program. */
    Clip,
    /** A clothing store. */
    ClothingStore,
    /** Computer programming source code. Example: Full (compile ready) solutions, code snippet samples, scripts, templates. */
    Code,
    /** Web page type: Collection page. */
    CollectionPage,
    /** A college, university, or other third-level educational institution. */
    CollegeOrUniversity,
    /** A comedy club. */
    ComedyClub,
    /** Event type: Comedy event. */
    ComedyEvent,
    /** A comment on an item - for example, a comment on a blog post. The comment's content is expressed via the <a class="localLink" href="http://schema.org/text">text</a> property, and its topic via <a class="localLink" href="http://schema.org/about">about</a>, properties shared with all CreativeWorks. */
    Comment,
    /** The act of generating a comment about a subject. */
    CommentAction,
    /** The act of conveying information to another person via a communication medium (instrument) such as speech, email, or telephone conversation. */
    CommunicateAction,
    /** A compound price specification is one that bundles multiple prices that all apply in combination for different dimensions of consumption. Use the name property of the attached unit price specification for indicating the dimension of a price component (e.g. "electricity" or "final cleaning"). */
    CompoundPriceSpecification,
    /** This type covers computer programming languages such as Scheme and Lisp, as well as other language-like computer representations. Natural languages are best represented with the <a class="localLink" href="http://schema.org/Language">Language</a> type. */
    ComputerLanguage,
    /** A computer store. */
    ComputerStore,
    /** The act of notifying someone that a future event/action is going to happen as expected.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/CancelAction">CancelAction</a>: The antonym of ConfirmAction.</li>
    </ul>
     */
    ConfirmAction,
    /** The act of ingesting information/resources/food. */
    ConsumeAction,
    /** Web page type: Contact page. */
    ContactPage,
    /** A contact point&#x2014;for example, a Customer Complaints department. */
    ContactPoint,
    /** Enumerated options related to a ContactPoint. */
    ContactPointOption,
    /** One of the continents (for example, Europe or Africa). */
    Continent,
    /** An agent controls a device or application. */
    ControlAction,
    /** A convenience store. */
    ConvenienceStore,
    /** One or more messages between organizations or people on a particular topic. Individual messages can be linked to the conversation with isPartOf or hasPart properties. */
    Conversation,
    /** The act of producing/preparing food. */
    CookAction,
    /** Organization: A business corporation. */
    Corporation,
    /** A country. */
    Country,
    /** A description of an educational course which may be offered as distinct instances at which take place at different times or take place at different locations, or be offered through different media or modes of study. An educational course is a sequence of one or more educational events and/or creative works which aims to build knowledge, competence or ability of learners. */
    Course,
    /** An instance of a <a class="localLink" href="http://schema.org/Course">Course</a> which is distinct from other instances because it is offered at a different time or location or through different media or modes of study or to a specific section of students. */
    CourseInstance,
    /** A courthouse. */
    Courthouse,
    /** The act of deliberately creating/producing/generating/building a result out of the agent. */
    CreateAction,
    /** The most generic kind of creative work, including books, movies, photographs, software programs, etc. */
    CreativeWork,
    /** A media season e.g. tv, radio, video game etc. */
    CreativeWorkSeason,
    /** A CreativeWorkSeries in schema.org is a group of related items, typically but not necessarily of the same kind. CreativeWorkSeries are usually organized into some order, often chronological. Unlike <a class="localLink" href="http://schema.org/ItemList">ItemList</a> which is a general purpose data structure for lists of things, the emphasis with CreativeWorkSeries is on published materials (written e.g. books and periodicals, or media such as tv, radio and games).<br/><br/>
    
    Specific subtypes are available for describing <a class="localLink" href="http://schema.org/TVSeries">TVSeries</a>, <a class="localLink" href="http://schema.org/RadioSeries">RadioSeries</a>, <a class="localLink" href="http://schema.org/MovieSeries">MovieSeries</a>, <a class="localLink" href="http://schema.org/BookSeries">BookSeries</a>, <a class="localLink" href="http://schema.org/Periodical">Periodical</a> and <a class="localLink" href="http://schema.org/VideoGameSeries">VideoGameSeries</a>. In each case, the <a class="localLink" href="http://schema.org/hasPart">hasPart</a> / <a class="localLink" href="http://schema.org/isPartOf">isPartOf</a> properties can be used to relate the CreativeWorkSeries to its parts. The general CreativeWorkSeries type serves largely just to organize these more specific and practical subtypes.<br/><br/>
    
    It is common for properties applicable to an item from the series to be usefully applied to the containing group. Schema.org attempts to anticipate some of these cases, but publishers should be free to apply properties of the series parts to the series as a whole wherever they seem appropriate. */
    CreativeWorkSeries,
    /** A card payment method of a particular brand or name.  Used to mark up a particular payment method and/or the financial product/service that supplies the card account.<br/><br/>
    
    Commonly used values:<br/><br/>
    
    <ul>
    <li>http://purl.org/goodrelations/v1#AmericanExpress</li>
    <li>http://purl.org/goodrelations/v1#DinersClub</li>
    <li>http://purl.org/goodrelations/v1#Discover</li>
    <li>http://purl.org/goodrelations/v1#JCB</li>
    <li>http://purl.org/goodrelations/v1#MasterCard</li>
    <li>http://purl.org/goodrelations/v1#VISA</li>
    </ul>
     */
    CreditCard,
    /** A crematorium. */
    Crematorium,
    /** A service to convert funds from one currency to another currency. */
    CurrencyConversionService,
    /** Event type: A social dance. */
    DanceEvent,
    /** A dance group&#x2014;for example, the Alvin Ailey Dance Theater or Riverdance. */
    DanceGroup,
    /** A collection of datasets. */
    DataCatalog,
    /** A dataset in downloadable form. */
    DataDownload,
    /** A single feed providing structured information about one or more entities or topics. */
    DataFeed,
    /** A single item within a larger data feed. */
    DataFeedItem,
    /** The basic data types such as Integers, Strings, etc. */
    DataType,
    /** A body of structured information describing some topic(s) of interest. */
    Dataset,
    /** A date value in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 date format</a>. */
    Date,
    /** A combination of date and time of day in the form [-]CCYY-MM-DDThh:mm:ss[Z|(+|-)hh:mm] (see Chapter 5.4 of ISO 8601). */
    DateTime,
    /** A DatedMoneySpecification represents monetary values with optional start and end dates. For example, this could represent an employee's salary over a specific period of time. <strong>Note:</strong> This type has been superseded by <a class="localLink" href="http://schema.org/MonetaryAmount">MonetaryAmount</a> use of that type is recommended */
    DatedMoneySpecification,
    /** The day of the week, e.g. used to specify to which day the opening hours of an OpeningHoursSpecification refer.<br/><br/>
    
    Originally, URLs from <a href="http://purl.org/goodrelations/v1">GoodRelations</a> were used (for <a class="localLink" href="http://schema.org/Monday">Monday</a>, <a class="localLink" href="http://schema.org/Tuesday">Tuesday</a>, <a class="localLink" href="http://schema.org/Wednesday">Wednesday</a>, <a class="localLink" href="http://schema.org/Thursday">Thursday</a>, <a class="localLink" href="http://schema.org/Friday">Friday</a>, <a class="localLink" href="http://schema.org/Saturday">Saturday</a>, <a class="localLink" href="http://schema.org/Sunday">Sunday</a> plus a special entry for <a class="localLink" href="http://schema.org/PublicHolidays">PublicHolidays</a>); these have now been integrated directly into schema.org. */
    DayOfWeek,
    /** A day spa. */
    DaySpa,
    /** The act of stopping or deactivating a device or application (e.g. stopping a timer or turning off a flashlight). */
    DeactivateAction,
    /** A defence establishment, such as an army or navy base. */
    DefenceEstablishment,
    /** The act of editing a recipient by removing one of its objects. */
    DeleteAction,
    /** The price for the delivery of an offer using a particular delivery method. */
    DeliveryChargeSpecification,
    /** An event involving the delivery of an item. */
    DeliveryEvent,
    /** A delivery method is a standardized procedure for transferring the product or service to the destination of fulfillment chosen by the customer. Delivery methods are characterized by the means of transportation used, and by the organization or group that is the contracting party for the sending organization or person.<br/><br/>
    
    Commonly used values:<br/><br/>
    
    <ul>
    <li>http://purl.org/goodrelations/v1#DeliveryModeDirectDownload</li>
    <li>http://purl.org/goodrelations/v1#DeliveryModeFreight</li>
    <li>http://purl.org/goodrelations/v1#DeliveryModeMail</li>
    <li>http://purl.org/goodrelations/v1#DeliveryModeOwnFleet</li>
    <li>http://purl.org/goodrelations/v1#DeliveryModePickUp</li>
    <li>http://purl.org/goodrelations/v1#DHL</li>
    <li>http://purl.org/goodrelations/v1#FederalExpress</li>
    <li>http://purl.org/goodrelations/v1#UPS</li>
    </ul>
     */
    DeliveryMethod,
    /** A demand entity represents the public, not necessarily binding, not necessarily exclusive, announcement by an organization or person to seek a certain type of goods or services. For describing demand using this type, the very same properties used for Offer apply. */
    Demand,
    /** A dentist. */
    Dentist,
    /** The act of  departing from a place. An agent departs from an fromLocation for a destination, optionally with participants. */
    DepartAction,
    /** A department store. */
    DepartmentStore,
    /** A type of Bank Account with a main purpose of depositing funds to gain interest or other benefits. */
    DepositAccount,
    /** An electronic file or document. */
    DigitalDocument,
    /** A permission for a particular person or group to access a particular file. */
    DigitalDocumentPermission,
    /** A type of permission which can be granted for accessing a digital document. */
    DigitalDocumentPermissionType,
    /** The act of expressing a difference of opinion with the object. An agent disagrees to/about an object (a proposition, topic or theme) with participants. */
    DisagreeAction,
    /** The act of discovering/finding an object. */
    DiscoverAction,
    /** A posting to a discussion forum. */
    DiscussionForumPosting,
    /** The act of expressing a negative sentiment about the object. An agent dislikes an object (a proposition, topic or theme) with participants. */
    DislikeAction,
    /** Properties that take Distances as values are of the form '&lt;Number&gt; &lt;Length unit of measure&gt;'. E.g., '7 ft'. */
    Distance,
    /** A distillery. */
    Distillery,
    /** The act of providing goods, services, or money without compensation, often for philanthropic reasons. */
    DonateAction,
    /** The act of downloading an object. */
    DownloadAction,
    /** The act of producing a visual/graphical representation of an object, typically with a pen/pencil and paper as instruments. */
    DrawAction,
    /** The act of swallowing liquids. */
    DrinkAction,
    /** A value indicating which roadwheels will receive torque. */
    DriveWheelConfigurationValue,
    /** A dry-cleaning business. */
    DryCleaningOrLaundry,
    /** Quantity: Duration (use <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 duration format</a>). */
    Duration,
    /** The act of swallowing solid objects. */
    EatAction,
    /** Event type: Education event. */
    EducationEvent,
    /** An EducationalAudience. */
    EducationalAudience,
    /** An educational organization. */
    EducationalOrganization,
    /** An electrician. */
    Electrician,
    /** An electronics store. */
    ElectronicsStore,
    /** An elementary school. */
    ElementarySchool,
    /** An email message. */
    EmailMessage,
    /** An embassy. */
    Embassy,
    /** An emergency service, such as a fire station or ER. */
    EmergencyService,
    /** A subclass of OrganizationRole used to describe employee relationships. */
    EmployeeRole,
    /** An aggregate rating of an Organization related to its role as an employer. */
    EmployerAggregateRating,
    /** An employment agency. */
    EmploymentAgency,
    /** An agent approves/certifies/likes/supports/sanction an object. */
    EndorseAction,
    /** An EndorsementRating is a rating that expresses some level of endorsement, for example inclusion in a "critic's pick" blog, a
    "Like" or "+1" on a social network. It can be considered the <a class="localLink" href="http://schema.org/result">result</a> of an <a class="localLink" href="http://schema.org/EndorseAction">EndorseAction</a> in which the <a class="localLink" href="http://schema.org/object">object</a> of the action is rated positively by
    some <a class="localLink" href="http://schema.org/agent">agent</a>. As is common elsewhere in schema.org, it is sometimes more useful to describe the results of such an action without explicitly describing the <a class="localLink" href="http://schema.org/Action">Action</a>.<br/><br/>
    
    An <a class="localLink" href="http://schema.org/EndorsementRating">EndorsementRating</a> may be part of a numeric scale or organized system, but this is not required: having an explicit type for indicating a positive,
    endorsement rating is particularly useful in the absence of numeric scales as it helps consumers understand that the rating is broadly positive. */
    EndorsementRating,
    /** Properties that take Energy as values are of the form '&lt;Number&gt; &lt;Energy unit of measure&gt;'. */
    Energy,
    /** Information about the engine of the vehicle. A vehicle can have multiple engines represented by multiple engine specification entities. */
    EngineSpecification,
    /** A business providing entertainment. */
    EntertainmentBusiness,
    /** An entry point, within some Web-based protocol. */
    EntryPoint,
    /** Lists or enumerations—for example, a list of cuisines or music genres, etc. */
    Enumeration,
    /** A media episode (e.g. TV, radio, video game) which can be part of a series or season. */
    Episode,
    /** An event happening at a certain time and location, such as a concert, lecture, or festival. Ticketing information may be added via the <a class="localLink" href="http://schema.org/offers">offers</a> property. Repeated events may be structured as separate Event objects. */
    Event,
    /** A reservation for an event like a concert, sporting event, or lecture.<br/><br/>
    
    Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
    EventReservation,
    /** EventStatusType is an enumeration type whose instances represent several states that an Event may be in. */
    EventStatusType,
    /** An event venue. */
    EventVenue,
    /** The act of participating in exertive activity for the purposes of improving health and fitness. */
    ExerciseAction,
    /** A gym. */
    ExerciseGym,
    /** Event type: Exhibition event, e.g. at a museum, library, archive, tradeshow, ... */
    ExhibitionEvent,
    /** A <a class="localLink" href="http://schema.org/FAQPage">FAQPage</a> is a <a class="localLink" href="http://schema.org/WebPage">WebPage</a> presenting one or more "<a href="https://en.wikipedia.org/wiki/FAQ">Frequently asked questions</a>" (see also <a class="localLink" href="http://schema.org/QAPage">QAPage</a>). */
    FAQPage,
    /** A radio channel that uses FM. */
    FMRadioChannel,
    /** A fast-food restaurant. */
    FastFoodRestaurant,
    /** Event type: Festival. */
    Festival,
    /** The act of capturing sound and moving images on film, video, or digitally. */
    FilmAction,
    /** A product provided to consumers and businesses by financial institutions such as banks, insurance companies, brokerage firms, consumer finance companies, and investment companies which comprise the financial services industry. */
    FinancialProduct,
    /** Financial services business. */
    FinancialService,
    /** The act of finding an object.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/SearchAction">SearchAction</a>: FindAction is generally lead by a SearchAction, but not necessarily.</li>
    </ul>
     */
    FindAction,
    /** A fire station. With firemen. */
    FireStation,
    /** An airline flight. */
    Flight,
    /** A reservation for air travel.<br/><br/>
    
    Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
    FlightReservation,
    /** Data type: Floating number. */
    Float,
    /** A florist. */
    Florist,
    /** The act of forming a personal connection with someone/something (object) unidirectionally/asymmetrically to get updates polled from.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/BefriendAction">BefriendAction</a>: Unlike BefriendAction, FollowAction implies that the connection is <em>not</em> necessarily reciprocal.</li>
    <li><a class="localLink" href="http://schema.org/SubscribeAction">SubscribeAction</a>: Unlike SubscribeAction, FollowAction implies that the follower acts as an active agent constantly/actively polling for updates.</li>
    <li><a class="localLink" href="http://schema.org/RegisterAction">RegisterAction</a>: Unlike RegisterAction, FollowAction implies that the agent is interested in continuing receiving updates from the object.</li>
    <li><a class="localLink" href="http://schema.org/JoinAction">JoinAction</a>: Unlike JoinAction, FollowAction implies that the agent is interested in getting updates from the object.</li>
    <li><a class="localLink" href="http://schema.org/TrackAction">TrackAction</a>: Unlike TrackAction, FollowAction refers to the polling of updates of all aspects of animate objects rather than the location of inanimate objects (e.g. you track a package, but you don't follow it).</li>
    </ul>
     */
    FollowAction,
    /** A food-related business. */
    FoodEstablishment,
    /** A reservation to dine at a food-related business.<br/><br/>
    
    Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. */
    FoodEstablishmentReservation,
    /** Event type: Food event. */
    FoodEvent,
    /** A food service, like breakfast, lunch, or dinner. */
    FoodService,
    /** A furniture store. */
    FurnitureStore,
    /** The Game type represents things which are games. These are typically rule-governed recreational activities, e.g. role-playing games in which players assume the role of characters in a fictional setting. */
    Game,
    /** Indicates whether this game is multi-player, co-op or single-player. */
    GamePlayMode,
    /** Server that provides game interaction in a multiplayer game. */
    GameServer,
    /** Status of a game server. */
    GameServerStatus,
    /** A garden store. */
    GardenStore,
    /** A gas station. */
    GasStation,
    /** Residence type: Gated community. */
    GatedResidenceCommunity,
    /** An enumeration of genders. */
    GenderType,
    /** A general contractor. */
    GeneralContractor,
    /** A GeoCircle is a GeoShape representing a circular geographic area. As it is a GeoShape
              it provides the simple textual property 'circle', but also allows the combination of postalCode alongside geoRadius.
              The center of the circle can be indicated via the 'geoMidpoint' property, or more approximately using 'address', 'postalCode'. */
    GeoCircle,
    /** The geographic coordinates of a place or event. */
    GeoCoordinates,
    /** The geographic shape of a place. A GeoShape can be described using several properties whose values are based on latitude/longitude pairs. Either whitespace or commas can be used to separate latitude and longitude; whitespace should be used when writing a list of several such points. */
    GeoShape,
    /** The act of transferring ownership of an object to a destination. Reciprocal of TakeAction.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/TakeAction">TakeAction</a>: Reciprocal of GiveAction.</li>
    <li><a class="localLink" href="http://schema.org/SendAction">SendAction</a>: Unlike SendAction, GiveAction implies that ownership is being transferred (e.g. I may send my laptop to you, but that doesn't mean I'm giving it to you).</li>
    </ul>
     */
    GiveAction,
    /** A golf course. */
    GolfCourse,
    /** A government building. */
    GovernmentBuilding,
    /** A government office&#x2014;for example, an IRS or DMV office. */
    GovernmentOffice,
    /** A governmental organization or agency. */
    GovernmentOrganization,
    /** A permit issued by a government agency. */
    GovernmentPermit,
    /** A service provided by a government organization, e.g. food stamps, veterans benefits, etc. */
    GovernmentService,
    /** A grocery store. */
    GroceryStore,
    /** A business that provide Heating, Ventilation and Air Conditioning services. */
    HVACBusiness,
    /** A hair salon. */
    HairSalon,
    /** A hardware store. */
    HardwareStore,
    /** Health and beauty. */
    HealthAndBeautyBusiness,
    /** A health club. */
    HealthClub,
    /** A high school. */
    HighSchool,
    /** A Hindu temple. */
    HinduTemple,
    /** A store that sells materials useful or necessary for various hobbies. */
    HobbyShop,
    /** A construction business.<br/><br/>
    
    A HomeAndConstructionBusiness is a <a class="localLink" href="http://schema.org/LocalBusiness">LocalBusiness</a> that provides services around homes and buildings.<br/><br/>
    
    As a <a class="localLink" href="http://schema.org/LocalBusiness">LocalBusiness</a> it can be described as a <a class="localLink" href="http://schema.org/provider">provider</a> of one or more <a class="localLink" href="http://schema.org/Service">Service</a>(s). */
    HomeAndConstructionBusiness,
    /** A home goods store. */
    HomeGoodsStore,
    /** A hospital. */
    Hospital,
    /** A hostel - cheap accommodation, often in shared dormitories.
    <br /><br />
    See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    Hostel,
    /** A hotel is an establishment that provides lodging paid on a short-term basis (Source: Wikipedia, the free encyclopedia, see http://en.wikipedia.org/wiki/Hotel).
    <br /><br />
    See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    Hotel,
    /** A hotel room is a single room in a hotel.
    <br /><br />
    See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    HotelRoom,
    /** A house is a building or structure that has the ability to be occupied for habitation by humans or other creatures (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/House">http://en.wikipedia.org/wiki/House</a>). */
    House,
    /** A house painting service. */
    HousePainter,
    /** Instructions that explain how to achieve a result by performing a sequence of steps. */
    HowTo,
    /** A direction indicating a single action to do in the instructions for how to achieve a result. */
    HowToDirection,
    /** An item used as either a tool or supply when performing the instructions for how to to achieve a result. */
    HowToItem,
    /** A sub-grouping of steps in the instructions for how to achieve a result (e.g. steps for making a pie crust within a pie recipe). */
    HowToSection,
    /** A step in the instructions for how to achieve a result. It is an ordered list with HowToDirection and/or HowToTip items. */
    HowToStep,
    /** A supply consumed when performing the instructions for how to achieve a result. */
    HowToSupply,
    /** An explanation in the instructions for how to achieve a result. It provides supplementary information about a technique, supply, author's preference, etc. It can explain what could be done, or what should not be done, but doesn't specify what should be done (see HowToDirection). */
    HowToTip,
    /** A tool used (but not consumed) when performing instructions for how to achieve a result. */
    HowToTool,
    /** An ice cream shop. */
    IceCreamShop,
    /** The act of intentionally disregarding the object. An agent ignores an object. */
    IgnoreAction,
    /** Web page type: Image gallery page. */
    ImageGallery,
    /** An image file. */
    ImageObject,
    /** A single, identifiable product instance (e.g. a laptop with a particular serial number). */
    IndividualProduct,
    /** The act of notifying someone of information pertinent to them, with no expectation of a response. */
    InformAction,
    /** The act of adding at a specific location in an ordered collection. */
    InsertAction,
    /** The act of installing an application. */
    InstallAction,
    /** An Insurance agency. */
    InsuranceAgency,
    /** A utility class that serves as the umbrella for a number of 'intangible' things such as quantities, structured values, etc. */
    Intangible,
    /** Data type: Integer. */
    Integer,
    /** The act of interacting with another person or organization. */
    InteractAction,
    /** A summary of how users have interacted with this CreativeWork. In most cases, authors will use a subtype to specify the specific type of interaction. */
    InteractionCounter,
    /** An internet cafe. */
    InternetCafe,
    /** A type of financial product that typically requires the client to transfer funds to a financial service in return for potential beneficial financial return. */
    InvestmentOrDeposit,
    /** The act of asking someone to attend an event. Reciprocal of RsvpAction. */
    InviteAction,
    /** A statement of the money due for goods or services; a bill. */
    Invoice,
    /** A list of possible product availability options. */
    ItemAvailability,
    /** A list of items of any sort&#x2014;for example, Top 10 Movies About Weathermen, or Top 100 Party Songs. Not to be confused with HTML lists, which are often used only for formatting. */
    ItemList,
    /** Enumerated for values for itemListOrder for indicating how an ordered ItemList is organized. */
    ItemListOrderType,
    /** A page devoted to a single item, such as a particular product or hotel. */
    ItemPage,
    /** A jewelry store. */
    JewelryStore,
    /** A listing that describes a job opening in a certain organization. */
    JobPosting,
    /** An agent joins an event/group with participants/friends at a location.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/RegisterAction">RegisterAction</a>: Unlike RegisterAction, JoinAction refers to joining a group/team of people.</li>
    <li><a class="localLink" href="http://schema.org/SubscribeAction">SubscribeAction</a>: Unlike SubscribeAction, JoinAction does not imply that you'll be receiving updates.</li>
    <li><a class="localLink" href="http://schema.org/FollowAction">FollowAction</a>: Unlike FollowAction, JoinAction does not imply that you'll be polling for updates.</li>
    </ul>
     */
    JoinAction,
    /** A lake (for example, Lake Pontrachain). */
    LakeBodyOfWater,
    /** A landform or physical feature.  Landform elements include mountains, plains, lakes, rivers, seascape and oceanic waterbody interface features such as bays, peninsulas, seas and so forth, including sub-aqueous terrain features such as submersed mountain ranges, volcanoes, and the great ocean basins. */
    Landform,
    /** An historical landmark or building. */
    LandmarksOrHistoricalBuildings,
    /** Natural languages such as Spanish, Tamil, Hindi, English, etc. Formal language code tags expressed in <a href="https://en.wikipedia.org/wiki/IETF_language_tag">BCP 47</a> can be used via the <a class="localLink" href="http://schema.org/alternateName">alternateName</a> property. The Language type previously also covered programming languages such as Scheme and Lisp, which are now best represented using <a class="localLink" href="http://schema.org/ComputerLanguage">ComputerLanguage</a>. */
    Language,
    /** An agent leaves an event / group with participants/friends at a location.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/JoinAction">JoinAction</a>: The antonym of LeaveAction.</li>
    <li><a class="localLink" href="http://schema.org/UnRegisterAction">UnRegisterAction</a>: Unlike UnRegisterAction, LeaveAction implies leaving a group/team of people rather than a service.</li>
    </ul>
     */
    LeaveAction,
    /** A LegalService is a business that provides legally-oriented services, advice and representation, e.g. law firms.<br/><br/>
    
    As a <a class="localLink" href="http://schema.org/LocalBusiness">LocalBusiness</a> it can be described as a <a class="localLink" href="http://schema.org/provider">provider</a> of one or more <a class="localLink" href="http://schema.org/Service">Service</a>(s). */
    LegalService,
    /** A legislative building&#x2014;for example, the state capitol. */
    LegislativeBuilding,
    /** The act of providing an object under an agreement that it will be returned at a later date. Reciprocal of BorrowAction.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/BorrowAction">BorrowAction</a>: Reciprocal of LendAction.</li>
    </ul>
     */
    LendAction,
    /** A library. */
    Library,
    /** The act of expressing a positive sentiment about the object. An agent likes an object (a proposition, topic or theme) with participants. */
    LikeAction,
    /** A shop that sells alcoholic drinks such as wine, beer, whisky and other spirits. */
    LiquorStore,
    /** An list item, e.g. a step in a checklist or how-to description. */
    ListItem,
    /** The act of consuming audio content. */
    ListenAction,
    /** Event type: Literary event. */
    LiteraryEvent,
    /** A blog post intended to provide a rolling textual coverage of an ongoing event through continuous updates. */
    LiveBlogPosting,
    /** A financial product for the loaning of an amount of money under agreed terms and charges. */
    LoanOrCredit,
    /** A particular physical business or branch of an organization. Examples of LocalBusiness include a restaurant, a particular branch of a restaurant chain, a branch of a bank, a medical practice, a club, a bowling alley, etc. */
    LocalBusiness,
    /** Specifies a location feature by providing a structured value representing a feature of an accommodation as a property-value pair of varying degrees of formality. */
    LocationFeatureSpecification,
    /** A DeliveryMethod in which an item is made available via locker. */
    LockerDelivery,
    /** A locksmith. */
    Locksmith,
    /** A lodging business, such as a motel, hotel, or inn. */
    LodgingBusiness,
    /** A reservation for lodging at a hotel, motel, inn, etc.<br/><br/>
    
    Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. */
    LodgingReservation,
    /** The act of being defeated in a competitive activity. */
    LoseAction,
    /** A map. */
    Map,
    /** An enumeration of several kinds of Map. */
    MapCategoryType,
    /** The act of marrying a person. */
    MarryAction,
    /** Properties that take Mass as values are of the form '&lt;Number&gt; &lt;Mass unit of measure&gt;'. E.g., '7 kg'. */
    Mass,
    /** A media object, such as an image, video, or audio object embedded in a web page or a downloadable dataset i.e. DataDownload. Note that a creative work may have many media objects associated with it on the same web page. For example, a page about a single song (MusicRecording) may have a music video (VideoObject), and a high and low bandwidth audio stream (2 AudioObject's). */
    MediaObject,
    /** A subscription which allows a user to access media including audio, video, books, etc. */
    MediaSubscription,
    /** A medical organization (physical or not), such as hospital, institution or clinic. */
    MedicalOrganization,
    /** A meeting room, conference room, or conference hall is a room provided for singular events such as business conferences and meetings (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/Conference_hall">http://en.wikipedia.org/wiki/Conference_hall</a>).
    <br /><br />
    See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    MeetingRoom,
    /** A men's clothing store. */
    MensClothingStore,
    /** A structured representation of food or drink items available from a FoodEstablishment. */
    Menu,
    /** A food or drink item listed in a menu or menu section. */
    MenuItem,
    /** A sub-grouping of food or drink items in a menu. E.g. courses (such as 'Dinner', 'Breakfast', etc.), specific type of dishes (such as 'Meat', 'Vegan', 'Drinks', etc.), or some other classification made by the menu provider. */
    MenuSection,
    /** A single message from a sender to one or more organizations or people. */
    Message,
    /** A middle school (typically for children aged around 11-14, although this varies somewhat). */
    MiddleSchool,
    /** A software application designed specifically to work well on a mobile device such as a telephone. */
    MobileApplication,
    /** A store that sells mobile phones and related accessories. */
    MobilePhoneStore,
    /** A monetary value or range. This type can be used to describe an amount of money such as $50 USD, or a range as in describing a bank account being suitable for a balance between £1,000 and £1,000,000 GBP, or the value of a salary, etc. It is recommended to use <a class="localLink" href="http://schema.org/PriceSpecification">PriceSpecification</a> Types to describe the price of an Offer, Invoice, etc. */
    MonetaryAmount,
    /** A statistical distribution of monetary amounts. */
    MonetaryAmountDistribution,
    /** A mosque. */
    Mosque,
    /** A motel.
    <br /><br />
    See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    Motel,
    /** A motorcycle dealer. */
    MotorcycleDealer,
    /** A motorcycle repair shop. */
    MotorcycleRepair,
    /** A mountain, like Mount Whitney or Mount Everest. */
    Mountain,
    /** The act of an agent relocating to a place.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/TransferAction">TransferAction</a>: Unlike TransferAction, the subject of the move is a living Person or Organization rather than an inanimate object.</li>
    </ul>
     */
    MoveAction,
    /** A movie. */
    Movie,
    /** A short segment/part of a movie. */
    MovieClip,
    /** A movie rental store. */
    MovieRentalStore,
    /** A series of movies. Included movies can be indicated with the hasPart property. */
    MovieSeries,
    /** A movie theater. */
    MovieTheater,
    /** A moving company. */
    MovingCompany,
    /** A museum. */
    Museum,
    /** A collection of music tracks. */
    MusicAlbum,
    /** Classification of the album by it's type of content: soundtrack, live album, studio album, etc. */
    MusicAlbumProductionType,
    /** The kind of release which this album is: single, EP or album. */
    MusicAlbumReleaseType,
    /** A musical composition. */
    MusicComposition,
    /** Event type: Music event. */
    MusicEvent,
    /** A musical group, such as a band, an orchestra, or a choir. Can also be a solo musician. */
    MusicGroup,
    /** A collection of music tracks in playlist form. */
    MusicPlaylist,
    /** A music recording (track), usually a single song. */
    MusicRecording,
    /** A MusicRelease is a specific release of a music album. */
    MusicRelease,
    /** Format of this release (the type of recording media used, ie. compact disc, digital media, LP, etc.). */
    MusicReleaseFormatType,
    /** A music store. */
    MusicStore,
    /** A music venue. */
    MusicVenue,
    /** A music video file. */
    MusicVideoObject,
    /** Organization: Non-governmental Organization. */
    NGO,
    /** A nail salon. */
    NailSalon,
    /** A NewsArticle is an article whose content reports news, or provides background context and supporting materials for understanding the news.<br/><br/>
    
    A more detailed overview of <a href="/docs/news.html">schema.org News markup</a> is also available. */
    NewsArticle,
    /** A nightclub or discotheque. */
    NightClub,
    /** A notary. */
    Notary,
    /** A file containing a note, primarily for the author. */
    NoteDigitalDocument,
    /** Data type: Number.<br/><br/>
    
    Usage guidelines:<br/><br/>
    
    <ul>
    <li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
    <li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
    </ul>
     */
    Number,
    /** Nutritional information about the recipe. */
    NutritionInformation,
    /** A profession, may involve prolonged training and/or a formal qualification. */
    Occupation,
    /** An ocean (for example, the Pacific). */
    OceanBodyOfWater,
    /** An offer to transfer some rights to an item or to provide a service — for example, an offer to sell tickets to an event, to rent the DVD of a movie, to stream a TV show over the internet, to repair a motorcycle, or to loan a book.<br/><br/>
    
    For <a href="http://www.gs1.org/barcodes/technical/idkeys/gtin">GTIN</a>-related fields, see <a href="http://www.gs1.org/barcodes/support/check_digit_calculator">Check Digit calculator</a> and <a href="http://www.gs1us.org/resources/standards/gtin-validation-guide">validation guide</a> from <a href="http://www.gs1.org/">GS1</a>. */
    Offer,
    /** An OfferCatalog is an ItemList that contains related Offers and/or further OfferCatalogs that are offeredBy the same provider. */
    OfferCatalog,
    /** A list of possible conditions for the item. */
    OfferItemCondition,
    /** An office equipment store. */
    OfficeEquipmentStore,
    /** A publication event e.g. catch-up TV or radio podcast, during which a program is available on-demand. */
    OnDemandEvent,
    /** A structured value providing information about the opening hours of a place or a certain service inside a place.<br/><br/>
    
    The place is <strong>open</strong> if the <a class="localLink" href="http://schema.org/opens">opens</a> property is specified, and <strong>closed</strong> otherwise.<br/><br/>
    
    If the value for the <a class="localLink" href="http://schema.org/closes">closes</a> property is less than the value for the <a class="localLink" href="http://schema.org/opens">opens</a> property then the hour range is assumed to span over the next day. */
    OpeningHoursSpecification,
    /** An order is a confirmation of a transaction (a receipt), which can contain multiple line items, each represented by an Offer that has been accepted by the customer. */
    Order,
    /** An agent orders an object/product/service to be delivered/sent. */
    OrderAction,
    /** An order item is a line of an order. It includes the quantity and shipping details of a bought offer. */
    OrderItem,
    /** Enumerated status values for Order. */
    OrderStatus,
    /** An organization such as a school, NGO, corporation, club, etc. */
    Organization,
    /** A subclass of Role used to describe roles within organizations. */
    OrganizationRole,
    /** The act of manipulating/administering/supervising/controlling one or more objects. */
    OrganizeAction,
    /** An outlet store. */
    OutletStore,
    /** A structured value providing information about when a certain organization or person owned a certain product. */
    OwnershipInfo,
    /** The act of producing a painting, typically with paint and canvas as instruments. */
    PaintAction,
    /** A painting. */
    Painting,
    /** The delivery of a parcel either via the postal service or a commercial service. */
    ParcelDelivery,
    /** A private parcel service as the delivery mode available for a certain offer.<br/><br/>
    
    Commonly used values:<br/><br/>
    
    <ul>
    <li>http://purl.org/goodrelations/v1#DHL</li>
    <li>http://purl.org/goodrelations/v1#FederalExpress</li>
    <li>http://purl.org/goodrelations/v1#UPS</li>
    </ul>
     */
    ParcelService,
    /** A set of characteristics describing parents, who can be interested in viewing some content. */
    ParentAudience,
    /** A park. */
    Park,
    /** A parking lot or other parking facility. */
    ParkingFacility,
    /** A shop that will buy, or lend money against the security of, personal possessions. */
    PawnShop,
    /** An agent pays a price to a participant. */
    PayAction,
    /** A payment method using a credit, debit, store or other card to associate the payment with an account. */
    PaymentCard,
    /** The costs of settling the payment using a particular payment method. */
    PaymentChargeSpecification,
    /** A payment method is a standardized procedure for transferring the monetary amount for a purchase. Payment methods are characterized by the legal and technical structures used, and by the organization or group carrying out the transaction.<br/><br/>
    
    Commonly used values:<br/><br/>
    
    <ul>
    <li>http://purl.org/goodrelations/v1#ByBankTransferInAdvance</li>
    <li>http://purl.org/goodrelations/v1#ByInvoice</li>
    <li>http://purl.org/goodrelations/v1#Cash</li>
    <li>http://purl.org/goodrelations/v1#CheckInAdvance</li>
    <li>http://purl.org/goodrelations/v1#COD</li>
    <li>http://purl.org/goodrelations/v1#DirectDebit</li>
    <li>http://purl.org/goodrelations/v1#GoogleCheckout</li>
    <li>http://purl.org/goodrelations/v1#PayPal</li>
    <li>http://purl.org/goodrelations/v1#PaySwarm</li>
    </ul>
     */
    PaymentMethod,
    /** A Service to transfer funds from a person or organization to a beneficiary person or organization. */
    PaymentService,
    /** A specific payment status. For example, PaymentDue, PaymentComplete, etc. */
    PaymentStatusType,
    /** A set of characteristics belonging to people, e.g. who compose an item's target audience. */
    PeopleAudience,
    /** The act of participating in performance arts. */
    PerformAction,
    /** A PerformanceRole is a Role that some entity places with regard to a theatrical performance, e.g. in a Movie, TVSeries etc. */
    PerformanceRole,
    /** A theater or other performing art center. */
    PerformingArtsTheater,
    /** A performance group, such as a band, an orchestra, or a circus. */
    PerformingGroup,
    /** A publication in any medium issued in successive parts bearing numerical or chronological designations and intended, such as a magazine, scholarly journal, or newspaper to continue indefinitely.<br/><br/>
    
    See also <a href="http://blog.schema.org/2014/09/schemaorg-support-for-bibliographic_2.html">blog post</a>. */
    Periodical,
    /** A permit issued by an organization, e.g. a parking pass. */
    Permit,
    /** A person (alive, dead, undead, or fictional). */
    Person,
    /** A pet store. */
    PetStore,
    /** A pharmacy or drugstore. */
    Pharmacy,
    /** A photograph. */
    Photograph,
    /** The act of capturing still images of objects using a camera. */
    PhotographAction,
    /** A doctor's office. */
    Physician,
    /** Entities that have a somewhat fixed, physical extension. */
    Place,
    /** Place of worship, such as a church, synagogue, or mosque. */
    PlaceOfWorship,
    /** The act of planning the execution of an event/task/action/reservation/plan to a future date. */
    PlanAction,
    /** The act of playing/exercising/training/performing for enjoyment, leisure, recreation, Competition or exercise.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/ListenAction">ListenAction</a>: Unlike ListenAction (which is under ConsumeAction), PlayAction refers to performing for an audience or at an event, rather than consuming music.</li>
    <li><a class="localLink" href="http://schema.org/WatchAction">WatchAction</a>: Unlike WatchAction (which is under ConsumeAction), PlayAction refers to showing/displaying for an audience or at an event, rather than consuming visual content.</li>
    </ul>
     */
    PlayAction,
    /** A playground. */
    Playground,
    /** A plumbing service. */
    Plumber,
    /** A police station. */
    PoliceStation,
    /** A pond. */
    Pond,
    /** A post office. */
    PostOffice,
    /** The mailing address. */
    PostalAddress,
    /** An agent orders a (not yet released) object/product/service to be delivered/sent. */
    PreOrderAction,
    /** The act of inserting at the beginning if an ordered collection. */
    PrependAction,
    /** A preschool. */
    Preschool,
    /** A file containing slides or used for a presentation. */
    PresentationDigitalDocument,
    /** A structured value representing a price or price range. Typically, only the subclasses of this type are used for markup. It is recommended to use <a class="localLink" href="http://schema.org/MonetaryAmount">MonetaryAmount</a> to describe independent amounts of money such as a salary, credit card limits, etc. */
    PriceSpecification,
    /** Any offered product or service. For example: a pair of shoes; a concert ticket; the rental of a car; a haircut; or an episode of a TV show streamed online. */
    Product,
    /** A datasheet or vendor specification of a product (in the sense of a prototypical description). */
    ProductModel,
    /** Original definition: "provider of professional services."<br/><br/>
    
    The general <a class="localLink" href="http://schema.org/ProfessionalService">ProfessionalService</a> type for local businesses was deprecated due to confusion with <a class="localLink" href="http://schema.org/Service">Service</a>. For reference, the types that it included were: <a class="localLink" href="http://schema.org/Dentist">Dentist</a>,
            <a class="localLink" href="http://schema.org/AccountingService">AccountingService</a>, <a class="localLink" href="http://schema.org/Attorney">Attorney</a>, <a class="localLink" href="http://schema.org/Notary">Notary</a>, as well as types for several kinds of <a class="localLink" href="http://schema.org/HomeAndConstructionBusiness">HomeAndConstructionBusiness</a>: <a class="localLink" href="http://schema.org/Electrician">Electrician</a>, <a class="localLink" href="http://schema.org/GeneralContractor">GeneralContractor</a>,
            <a class="localLink" href="http://schema.org/HousePainter">HousePainter</a>, <a class="localLink" href="http://schema.org/Locksmith">Locksmith</a>, <a class="localLink" href="http://schema.org/Plumber">Plumber</a>, <a class="localLink" href="http://schema.org/RoofingContractor">RoofingContractor</a>. <a class="localLink" href="http://schema.org/LegalService">LegalService</a> was introduced as a more inclusive supertype of <a class="localLink" href="http://schema.org/Attorney">Attorney</a>. */
    ProfessionalService,
    /** Web page type: Profile page. */
    ProfilePage,
    /** Used to describe membership in a loyalty programs (e.g. "StarAliance"), traveler clubs (e.g. "AAA"), purchase clubs ("Safeway Club"), etc. */
    ProgramMembership,
    /** A property-value pair, e.g. representing a feature of a product or place. Use the 'name' property for the name of the property. If there is an additional human-readable version of the value, put that into the 'description' property.<br/><br/>
    
    Always use specific schema.org properties when a) they exist and b) you can populate them. Using PropertyValue as a substitute will typically not trigger the same effect as using the original, specific property. */
    PropertyValue,
    /** A Property value specification. */
    PropertyValueSpecification,
    /** A public swimming pool. */
    PublicSwimmingPool,
    /** A PublicationEvent corresponds indifferently to the event of publication for a CreativeWork of any type e.g. a broadcast event, an on-demand event, a book/journal publication via a variety of delivery media. */
    PublicationEvent,
    /** A part of a successively published publication such as a periodical or publication volume, often numbered, usually containing a grouping of works such as articles.<br/><br/>
    
    See also <a href="http://blog.schema.org/2014/09/schemaorg-support-for-bibliographic_2.html">blog post</a>. */
    PublicationIssue,
    /** A part of a successively published publication such as a periodical or multi-volume work, often numbered. It may represent a time span, such as a year.<br/><br/>
    
    See also <a href="http://blog.schema.org/2014/09/schemaorg-support-for-bibliographic_2.html">blog post</a>. */
    PublicationVolume,
    /** A QAPage is a WebPage focussed on a specific Question and its Answer(s), e.g. in a question answering site or documenting Frequently Asked Questions (FAQs). */
    QAPage,
    /** A predefined value for a product characteristic, e.g. the power cord plug type 'US' or the garment sizes 'S', 'M', 'L', and 'XL'. */
    QualitativeValue,
    /** A point value or interval for product characteristics and other purposes. */
    QuantitativeValue,
    /** A statistical distribution of values. */
    QuantitativeValueDistribution,
    /** Quantities such as distance, time, mass, weight, etc. Particular instances of say Mass are entities like '3 Kg' or '4 milligrams'. */
    Quantity,
    /** A specific question - e.g. from a user seeking answers online, or collected in a Frequently Asked Questions (FAQ) document. */
    Question,
    /** An agent quotes/estimates/appraises an object/product/service with a price at a location/store. */
    QuoteAction,
    /** A place offering space for "Recreational Vehicles", Caravans, mobile homes and the like. */
    RVPark,
    /** A unique instance of a radio BroadcastService on a CableOrSatelliteService lineup. */
    RadioChannel,
    /** A short radio program or a segment/part of a radio program. */
    RadioClip,
    /** A radio episode which can be part of a series or season. */
    RadioEpisode,
    /** Season dedicated to radio broadcast and associated online delivery. */
    RadioSeason,
    /** CreativeWorkSeries dedicated to radio broadcast and associated online delivery. */
    RadioSeries,
    /** A radio station. */
    RadioStation,
    /** A rating is an evaluation on a numeric scale, such as 1 to 5 stars. */
    Rating,
    /** The act of responding instinctively and emotionally to an object, expressing a sentiment. */
    ReactAction,
    /** The act of consuming written content. */
    ReadAction,
    /** A real-estate agent. */
    RealEstateAgent,
    /** The act of physically/electronically taking delivery of an object thathas been transferred from an origin to a destination. Reciprocal of SendAction.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/SendAction">SendAction</a>: The reciprocal of ReceiveAction.</li>
    <li><a class="localLink" href="http://schema.org/TakeAction">TakeAction</a>: Unlike TakeAction, ReceiveAction does not imply that the ownership has been transfered (e.g. I can receive a package, but it does not mean the package is now mine).</li>
    </ul>
     */
    ReceiveAction,
    /** A recipe. For dietary restrictions covered by the recipe, a few common restrictions are enumerated via <a class="localLink" href="http://schema.org/suitableForDiet">suitableForDiet</a>. The <a class="localLink" href="http://schema.org/keywords">keywords</a> property can also be used to add more detail. */
    Recipe,
    /** A recycling center. */
    RecyclingCenter,
    /** The act of registering to be a user of a service, product or web page.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/JoinAction">JoinAction</a>: Unlike JoinAction, RegisterAction implies you are registering to be a user of a service, <em>not</em> a group/team of people.</li>
    <li>[FollowAction]]: Unlike FollowAction, RegisterAction doesn't imply that the agent is expecting to poll for updates from the object.</li>
    <li><a class="localLink" href="http://schema.org/SubscribeAction">SubscribeAction</a>: Unlike SubscribeAction, RegisterAction doesn't imply that the agent is expecting updates from the object.</li>
    </ul>
     */
    RegisterAction,
    /** The act of rejecting to/adopting an object.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/AcceptAction">AcceptAction</a>: The antonym of RejectAction.</li>
    </ul>
     */
    RejectAction,
    /** The act of giving money in return for temporary use, but not ownership, of an object such as a vehicle or property. For example, an agent rents a property from a landlord in exchange for a periodic payment. */
    RentAction,
    /** A reservation for a rental car.<br/><br/>
    
    Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. */
    RentalCarReservation,
    /** The act of editing a recipient by replacing an old object with a new object. */
    ReplaceAction,
    /** The act of responding to a question/message asked/sent by the object. Related to <a class="localLink" href="http://schema.org/AskAction">AskAction</a><br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/AskAction">AskAction</a>: Appears generally as an origin of a ReplyAction.</li>
    </ul>
     */
    ReplyAction,
    /** A Report generated by governmental or non-governmental organization. */
    Report,
    /** Describes a reservation for travel, dining or an event. Some reservations require tickets. <br/><br/>
    
    Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, restaurant reservations, flights, or rental cars, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
    Reservation,
    /** A group of multiple reservations with common values for all sub-reservations. */
    ReservationPackage,
    /** Enumerated status values for Reservation. */
    ReservationStatusType,
    /** Reserving a concrete object.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/ScheduleAction">ScheduleAction</a></a>: Unlike ScheduleAction, ReserveAction reserves concrete objects (e.g. a table, a hotel) towards a time slot / spatial allocation.</li>
    </ul>
     */
    ReserveAction,
    /** A reservoir of water, typically an artificially created lake, like the Lake Kariba reservoir. */
    Reservoir,
    /** The place where a person lives. */
    Residence,
    /** A resort is a place used for relaxation or recreation, attracting visitors for holidays or vacations. Resorts are places, towns or sometimes commercial establishment operated by a single company (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/Resort">http://en.wikipedia.org/wiki/Resort</a>).
    <br /><br />
    See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    Resort,
    /** A restaurant. */
    Restaurant,
    /** A diet restricted to certain foods or preparations for cultural, religious, health or lifestyle reasons. */
    RestrictedDiet,
    /** The act of resuming a device or application which was formerly paused (e.g. resume music playback or resume a timer). */
    ResumeAction,
    /** The act of returning to the origin that which was previously received (concrete objects) or taken (ownership). */
    ReturnAction,
    /** A review of an item - for example, of a restaurant, movie, or store. */
    Review,
    /** The act of producing a balanced opinion about the object for an audience. An agent reviews an object with participants resulting in a review. */
    ReviewAction,
    /** A river (for example, the broad majestic Shannon). */
    RiverBodyOfWater,
    /** Represents additional information about a relationship or property. For example a Role can be used to say that a 'member' role linking some SportsTeam to a player occurred during a particular time period. Or that a Person's 'actor' role in a Movie was for some particular characterName. Such properties can be attached to a Role entity, which is then associated with the main entities using ordinary properties like 'member' or 'actor'.<br/><br/>
    
    See also <a href="http://blog.schema.org/2014/06/introducing-role.html">blog post</a>. */
    Role,
    /** A roofing contractor. */
    RoofingContractor,
    /** A room is a distinguishable space within a structure, usually separated from other spaces by interior walls. (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/Room">http://en.wikipedia.org/wiki/Room</a>).
    <br /><br />
    See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    Room,
    /** The act of notifying an event organizer as to whether you expect to attend the event. */
    RsvpAction,
    /** RsvpResponseType is an enumeration type whose instances represent responding to an RSVP request. */
    RsvpResponseType,
    /** Event type: Sales event. */
    SaleEvent,
    /** Scheduling future actions, events, or tasks.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/ReserveAction">ReserveAction</a>: Unlike ReserveAction, ScheduleAction allocates future actions (e.g. an event, a task, etc) towards a time slot / spatial allocation.</li>
    </ul>
     */
    ScheduleAction,
    /** A scholarly article. */
    ScholarlyArticle,
    /** A school. */
    School,
    /** A screening of a movie or other video. */
    ScreeningEvent,
    /** A piece of sculpture. */
    Sculpture,
    /** A sea (for example, the Caspian sea). */
    SeaBodyOfWater,
    /** The act of searching for an object.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/FindAction">FindAction</a>: SearchAction generally leads to a FindAction, but not necessarily.</li>
    </ul>
     */
    SearchAction,
    /** Web page type: Search results page. */
    SearchResultsPage,
    /** A media season e.g. tv, radio, video game etc. */
    Season,
    /** Used to describe a seat, such as a reserved seat in an event reservation. */
    Seat,
    /** A self-storage facility. */
    SelfStorage,
    /** The act of taking money from a buyer in exchange for goods or services rendered. An agent sells an object, product, or service to a buyer for a price. Reciprocal of BuyAction. */
    SellAction,
    /** The act of physically/electronically dispatching an object for transfer from an origin to a destination.Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/ReceiveAction">ReceiveAction</a>: The reciprocal of SendAction.</li>
    <li><a class="localLink" href="http://schema.org/GiveAction">GiveAction</a>: Unlike GiveAction, SendAction does not imply the transfer of ownership (e.g. I can send you my laptop, but I'm not necessarily giving it to you).</li>
    </ul>
     */
    SendAction,
    /** A Series in schema.org is a group of related items, typically but not necessarily of the same kind. See also <a class="localLink" href="http://schema.org/CreativeWorkSeries">CreativeWorkSeries</a>, <a class="localLink" href="http://schema.org/EventSeries">EventSeries</a>. */
    Series,
    /** A service provided by an organization, e.g. delivery service, print services, etc. */
    Service,
    /** A means for accessing a service, e.g. a government office location, web site, or phone number. */
    ServiceChannel,
    /** The act of distributing content to people for their amusement or edification. */
    ShareAction,
    /** A shoe store. */
    ShoeStore,
    /** A shopping center or mall. */
    ShoppingCenter,
    /** Residence type: Single-family home. */
    SingleFamilyResidence,
    /** A navigation element of the page. */
    SiteNavigationElement,
    /** A ski resort. */
    SkiResort,
    /** Event type: Social event. */
    SocialEvent,
    /** A post to a social media platform, including blog posts, tweets, Facebook posts, etc. */
    SocialMediaPosting,
    /** A software application. */
    SoftwareApplication,
    /** Computer programming source code. Example: Full (compile ready) solutions, code snippet samples, scripts, templates. */
    SoftwareSourceCode,
    /** A placeholder for multiple similar products of the same kind. */
    SomeProducts,
    /** A SpeakableSpecification indicates (typically via <a class="localLink" href="http://schema.org/xpath">xpath</a> or <a class="localLink" href="http://schema.org/cssSelector">cssSelector</a>) sections of a document that are highlighted as particularly <a class="localLink" href="http://schema.org/speakable">speakable</a>. Instances of this type are expected to be used primarily as values of the <a class="localLink" href="http://schema.org/speakable">speakable</a> property. */
    SpeakableSpecification,
    /** Any branch of a field in which people typically develop specific expertise, usually after significant study, time, and effort. */
    Specialty,
    /** A sporting goods store. */
    SportingGoodsStore,
    /** A sports location, such as a playing field. */
    SportsActivityLocation,
    /** A sports club. */
    SportsClub,
    /** Event type: Sports event. */
    SportsEvent,
    /** Represents the collection of all sports organizations, including sports teams, governing bodies, and sports associations. */
    SportsOrganization,
    /** Organization: Sports team. */
    SportsTeam,
    /** A spreadsheet file. */
    SpreadsheetDigitalDocument,
    /** A stadium. */
    StadiumOrArena,
    /** A state or province of a country. */
    State,
    /** A value indicating a steering position. */
    SteeringPositionValue,
    /** A retail good store. */
    Store,
    /** Structured values are used when the value of a property has a more complex structure than simply being a textual value or a reference to another thing. */
    StructuredValue,
    /** The act of forming a personal connection with someone/something (object) unidirectionally/asymmetrically to get updates pushed to.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/FollowAction">FollowAction</a>: Unlike FollowAction, SubscribeAction implies that the subscriber acts as a passive agent being constantly/actively pushed for updates.</li>
    <li><a class="localLink" href="http://schema.org/RegisterAction">RegisterAction</a>: Unlike RegisterAction, SubscribeAction implies that the agent is interested in continuing receiving updates from the object.</li>
    <li><a class="localLink" href="http://schema.org/JoinAction">JoinAction</a>: Unlike JoinAction, SubscribeAction implies that the agent is interested in continuing receiving updates from the object.</li>
    </ul>
     */
    SubscribeAction,
    /** A subway station. */
    SubwayStation,
    /** A suite in a hotel or other public accommodation, denotes a class of luxury accommodations, the key feature of which is multiple rooms (Source: Wikipedia, the free encyclopedia, see <a href="http://en.wikipedia.org/wiki/Suite_(hotel)">http://en.wikipedia.org/wiki/Suite_(hotel)</a>).
    <br /><br />
    See also the <a href="/docs/hotels.html">dedicated document on the use of schema.org for marking up hotels and other forms of accommodations</a>. */
    Suite,
    /** The act of momentarily pausing a device or application (e.g. pause music playback or pause a timer). */
    SuspendAction,
    /** A synagogue. */
    Synagogue,
    /** A short TV program or a segment/part of a TV program. */
    TVClip,
    /** A TV episode which can be part of a series or season. */
    TVEpisode,
    /** Season dedicated to TV broadcast and associated online delivery. */
    TVSeason,
    /** CreativeWorkSeries dedicated to TV broadcast and associated online delivery. */
    TVSeries,
    /** A table on a Web page. */
    Table,
    /** The act of gaining ownership of an object from an origin. Reciprocal of GiveAction.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/GiveAction">GiveAction</a>: The reciprocal of TakeAction.</li>
    <li><a class="localLink" href="http://schema.org/ReceiveAction">ReceiveAction</a>: Unlike ReceiveAction, TakeAction implies that ownership has been transfered.</li>
    </ul>
     */
    TakeAction,
    /** A tattoo parlor. */
    TattooParlor,
    /** A taxi. */
    Taxi,
    /** A reservation for a taxi.<br/><br/>
    
    Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
    TaxiReservation,
    /** A service for a vehicle for hire with a driver for local travel. Fares are usually calculated based on distance traveled. */
    TaxiService,
    /** A taxi stand. */
    TaxiStand,
    /** A technical article - Example: How-to (task) topics, step-by-step, procedural troubleshooting, specifications, etc. */
    TechArticle,
    /** A unique instance of a television BroadcastService on a CableOrSatelliteService lineup. */
    TelevisionChannel,
    /** A television station. */
    TelevisionStation,
    /** A tennis complex. */
    TennisComplex,
    /** Data type: Text. */
    Text,
    /** A file composed primarily of text. */
    TextDigitalDocument,
    /** Event type: Theater performance. */
    TheaterEvent,
    /** A theater group or company, for example, the Royal Shakespeare Company or Druid Theatre. */
    TheaterGroup,
    /** The most generic type of item. */
    Thing,
    /** Used to describe a ticket to an event, a flight, a bus ride, etc. */
    Ticket,
    /** The act of reaching a draw in a competitive activity. */
    TieAction,
    /** A point in time recurring on multiple days in the form hh:mm:ss[Z|(+|-)hh:mm] (see <a href="http://www.w3.org/TR/xmlschema-2/#time">XML schema for details</a>). */
    Time,
    /** The act of giving money voluntarily to a beneficiary in recognition of services rendered. */
    TipAction,
    /** A tire shop. */
    TireShop,
    /** A tourist attraction.  In principle any Thing can be a <a class="localLink" href="http://schema.org/TouristAttraction">TouristAttraction</a>, from a <a class="localLink" href="http://schema.org/Mountain">Mountain</a> and <a class="localLink" href="http://schema.org/LandmarksOrHistoricalBuildings">LandmarksOrHistoricalBuildings</a> to a <a class="localLink" href="http://schema.org/LocalBusiness">LocalBusiness</a>.  This Type can be used on its own to describe a general <a class="localLink" href="http://schema.org/TouristAttraction">TouristAttraction</a>, or be used as an <a class="localLink" href="http://schema.org/additionalType">additionalType</a> to add tourist attraction properties to any other type.  (See examples below) */
    TouristAttraction,
    /** A tourist information center. */
    TouristInformationCenter,
    /** A toy store. */
    ToyStore,
    /** An agent tracks an object for updates.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/FollowAction">FollowAction</a>: Unlike FollowAction, TrackAction refers to the interest on the location of innanimates objects.</li>
    <li><a class="localLink" href="http://schema.org/SubscribeAction">SubscribeAction</a>: Unlike SubscribeAction, TrackAction refers to  the interest on the location of innanimate objects.</li>
    </ul>
     */
    TrackAction,
    /** The act of participating in an exchange of goods and services for monetary compensation. An agent trades an object, product or service with a participant in exchange for a one time or periodic payment. */
    TradeAction,
    /** A reservation for train travel.<br/><br/>
    
    Note: This type is for information about actual reservations, e.g. in confirmation emails or HTML pages with individual confirmations of reservations. For offers of tickets, use <a class="localLink" href="http://schema.org/Offer">Offer</a>. */
    TrainReservation,
    /** A train station. */
    TrainStation,
    /** A trip on a commercial train line. */
    TrainTrip,
    /** The act of transferring/moving (abstract or concrete) animate or inanimate objects from one place to another. */
    TransferAction,
    /** The act of traveling from an fromLocation to a destination by a specified mode of transport, optionally with participants. */
    TravelAction,
    /** A travel agency. */
    TravelAgency,
    /** A trip or journey. An itinerary of visits to one or more places. */
    Trip,
    /** A structured value indicating the quantity, unit of measurement, and business function of goods included in a bundle offer. */
    TypeAndQuantityNode,
    /** Data type: URL. */
    URL,
    /** The act of un-registering from a service.<br/><br/>
    
    Related actions:<br/><br/>
    
    <ul>
    <li><a class="localLink" href="http://schema.org/RegisterAction">RegisterAction</a>: antonym of UnRegisterAction.</li>
    <li><a class="localLink" href="http://schema.org/LeaveAction">LeaveAction</a>: Unlike LeaveAction, UnRegisterAction implies that you are unregistering from a service you werer previously registered, rather than leaving a team/group of people.</li>
    </ul>
     */
    UnRegisterAction,
    /** The price asked for a given offer by the respective organization or person. */
    UnitPriceSpecification,
    /** The act of managing by changing/editing the state of the object. */
    UpdateAction,
    /** The act of applying an object to its intended purpose. */
    UseAction,
    /** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
    UserBlocks,
    /** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
    UserCheckins,
    /** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
    UserComments,
    /** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
    UserDownloads,
    /** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
    UserInteraction,
    /** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
    UserLikes,
    /** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
    UserPageVisits,
    /** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
    UserPlays,
    /** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
    UserPlusOnes,
    /** UserInteraction and its subtypes is an old way of talking about users interacting with pages. It is generally better to use <a class="localLink" href="http://schema.org/Action">Action</a>-based vocabulary, alongside types such as <a class="localLink" href="http://schema.org/Comment">Comment</a>. */
    UserTweets,
    /** A vehicle is a device that is designed or used to transport people or cargo over land, water, air, or through space. */
    Vehicle,
    /** Web page type: Video gallery page. */
    VideoGallery,
    /** A video game is an electronic game that involves human interaction with a user interface to generate visual feedback on a video device. */
    VideoGame,
    /** A short segment/part of a video game. */
    VideoGameClip,
    /** A video game series. */
    VideoGameSeries,
    /** A video file. */
    VideoObject,
    /** The act of consuming static visual content. */
    ViewAction,
    /** Event type: Visual arts event. */
    VisualArtsEvent,
    /** A work of art that is primarily visual in character. */
    VisualArtwork,
    /** A volcano, like Fuji san. */
    Volcano,
    /** The act of expressing a preference from a fixed/finite/structured set of choices/options. */
    VoteAction,
    /** An advertising section of the page. */
    WPAdBlock,
    /** The footer section of the page. */
    WPFooter,
    /** The header section of the page. */
    WPHeader,
    /** A sidebar section of the page. */
    WPSideBar,
    /** The act of expressing a desire about the object. An agent wants an object. */
    WantAction,
    /** A structured value representing the duration and scope of services that will be provided to a customer free of charge in case of a defect or malfunction of a product. */
    WarrantyPromise,
    /** A range of of services that will be provided to a customer free of charge in case of a defect or malfunction of a product.<br/><br/>
    
    Commonly used values:<br/><br/>
    
    <ul>
    <li>http://purl.org/goodrelations/v1#Labor-BringIn</li>
    <li>http://purl.org/goodrelations/v1#PartsAndLabor-BringIn</li>
    <li>http://purl.org/goodrelations/v1#PartsAndLabor-PickUp</li>
    </ul>
     */
    WarrantyScope,
    /** The act of consuming dynamic/moving visual content. */
    WatchAction,
    /** A waterfall, like Niagara. */
    Waterfall,
    /** The act of dressing oneself in clothing. */
    WearAction,
    /** Web applications. */
    WebApplication,
    /** A web page. Every web page is implicitly assumed to be declared to be of type WebPage, so the various properties about that webpage, such as <code>breadcrumb</code> may be used. We recommend explicit declaration if these properties are specified, but if they are found outside of an itemscope, they will be assumed to be about the page. */
    WebPage,
    /** A web page element, like a table or an image. */
    WebPageElement,
    /** A WebSite is a set of related web pages and other items typically served from a single web domain and accessible via URLs. */
    WebSite,
    /** A wholesale store. */
    WholesaleStore,
    /** The act of achieving victory in a competitive activity. */
    WinAction,
    /** A winery. */
    Winery,
    /** A Workers Union (also known as a Labor Union, Labour Union, or Trade Union) is an organization that promotes the interests of its worker members by collectively bargaining with management, organizing, and political lobbying. */
    WorkersUnion,
    /** The act of authoring written creative content. */
    WriteAction,
    /** A zoo. */
    Zoo,
    /** The answer(s) that has been accepted as best, typically on a Question/Answer site. Sites vary in their selection mechanisms, e.g. drawing on community opinion and/or the view of the Question author. */
    acceptedAnswer,
    /** The offer(s) -- e.g., product, quantity and price combinations -- included in the order. */
    acceptedOffer,
    /** The payment method(s) accepted by seller for this offer. */
    acceptedPaymentMethod,
    /** Indicates whether a FoodEstablishment accepts reservations. Values can be Boolean, an URL at which reservations can be made or (for backwards compatibility) the strings <code>Yes</code> or <code>No</code>. */
    acceptsReservations,
    /** Password, PIN, or access code needed for delivery (e.g. from a locker). */
    accessCode,
    /** The human sensory perceptual system or cognitive faculty through which a person may process or perceive information. Expected values include: auditory, tactile, textual, visual, colorDependent, chartOnVisual, chemOnVisual, diagramOnVisual, mathOnVisual, musicOnVisual, textOnVisual. */
    accessMode,
    /** A list of single or combined accessModes that are sufficient to understand all the intellectual content of a resource. Expected values include:  auditory, tactile, textual, visual. */
    accessModeSufficient,
    /** Indicates that the resource is compatible with the referenced accessibility API (<a href="http://www.w3.org/wiki/WebSchemas/Accessibility">WebSchemas wiki lists possible values</a>). */
    accessibilityAPI,
    /** Identifies input methods that are sufficient to fully control the described resource (<a href="http://www.w3.org/wiki/WebSchemas/Accessibility">WebSchemas wiki lists possible values</a>). */
    accessibilityControl,
    /** Content features of the resource, such as accessible media, alternatives and supported enhancements for accessibility (<a href="http://www.w3.org/wiki/WebSchemas/Accessibility">WebSchemas wiki lists possible values</a>). */
    accessibilityFeature,
    /** A characteristic of the described resource that is physiologically dangerous to some users. Related to WCAG 2.0 guideline 2.3 (<a href="http://www.w3.org/wiki/WebSchemas/Accessibility">WebSchemas wiki lists possible values</a>). */
    accessibilityHazard,
    /** A human-readable summary of specific accessibility features or deficiencies, consistent with the other accessibility metadata but expressing subtleties such as "short descriptions are present but long descriptions will be needed for non-visual users" or "short descriptions are present and no long descriptions are needed." */
    accessibilitySummary,
    /** The identifier for the account the payment will be applied to. */
    accountId,
    /** Specifies the Person that is legally accountable for the CreativeWork. */
    accountablePerson,
    /** The organization or person from which the product was acquired. */
    acquiredFrom,
    /** A set of requirements that a must be fulfilled in order to perform an Action. If more than one value is specied, fulfilling one set of requirements will allow the Action to be performed. */
    actionAccessibilityRequirement,
    /** The high level platform(s) where the Action can be performed for the given URL. To specify a specific application or operating system instance, use actionApplication. */
    actionPlatform,
    /** Indicates the current disposition of the Action. */
    actionStatus,
    /** An actor, e.g. in tv, radio, movie, video games etc. Actors can be associated with individual items or with a series, episode, clip. */
    actors,
    /** An additional offer that can only be obtained in combination with the first base offer (e.g. supplements and extensions that are available for a surcharge). */
    addOn,
    /** An additional name for a Person, can be used for a middle name. */
    additionalName,
    /** If responding yes, the number of guests who will attend in addition to the invitee. */
    additionalNumberOfGuests,
    /** A property-value pair representing an additional characteristics of the entitity, e.g. a product feature or another characteristic for which there is no matching property in schema.org.<br/><br/>
    
    Note: Publishers should be aware that applications designed to use specific schema.org properties (e.g. http://schema.org/width, http://schema.org/color, http://schema.org/gtin13, ...) will typically expect such data to be provided using those properties, rather than using the generic property/value mechanism. */
    additionalProperty,
    /** An additional type for the item, typically used for adding more specific types from external vocabularies in microdata syntax. This is a relationship between something and a class that the thing is in. In RDFa syntax, it is better to use the native RDFa syntax - the 'typeof' attribute - for multiple types. Schema.org tools may have only weaker understanding of extra types, in particular those defined externally. */
    additionalType,
    /** Physical address of the item. */
    address,
    /** The country. For example, USA. You can also provide the two-letter <a href="http://en.wikipedia.org/wiki/ISO_3166-1">ISO 3166-1 alpha-2 country code</a>. */
    addressCountry,
    /** The locality in which the street address is, and which is in the region. For example, Mountain View. */
    addressLocality,
    /** The region in which the locality is, and which is in the country. For example, California or another appropriate first-level <a href="https://en.wikipedia.org/wiki/List_of_administrative_divisions_by_country">Administrative division</a> */
    addressRegion,
    /** The amount of time that is required between accepting the offer and the actual usage of the resource or service. */
    advanceBookingRequirement,
    /** An organization that this person is affiliated with. For example, a school/university, a club, or a team. */
    affiliation,
    /** A media object representing the circumstances after performing this direction. */
    afterMedia,
    /** The direct performer or driver of the action (animate or inanimate). e.g. <em>John</em> wrote a book. */
    agent,
    /** The overall rating, based on a collection of reviews or ratings, of the item. */
    aggregateRating,
    /** The kind of aircraft (e.g., "Boeing 747"). */
    aircraft,
    /** Classification of the album by it's type of content: soundtrack, live album, studio album, etc. */
    albumProductionType,
    /** The kind of release which this album is: single, EP or album. */
    albumReleaseType,
    /** A collection of music albums. */
    albums,
    /** A category of alignment between the learning resource and the framework node. Recommended values include: 'assesses', 'teaches', 'requires', 'textComplexity', 'readingLevel', 'educationalSubject', and 'educationalLevel'. */
    alignmentType,
    /** An alias for the item. */
    alternateName,
    /** A secondary title of the CreativeWork. */
    alternativeHeadline,
    /** An amenity feature (e.g. a characteristic or service) of the Accommodation. This generic property does not make a statement about whether the feature is included in an offer for the main accommodation or available at extra costs. */
    amenityFeature,
    /** The amount of money. */
    amount,
    /** The quantity of the goods included in the offer. */
    amountOfThisGood,
    /** The annual rate that is charged for borrowing (or made by investing), expressed as a single percentage number that represents the actual yearly cost of funds over the term of a loan. This includes any fees or additional costs associated with the transaction. */
    annualPercentageRate,
    /** The number of answers this question has received. */
    answerCount,
    /** An application that can complete the request. */
    application,
    /** Type of software application, e.g. 'Game, Multimedia'. */
    applicationCategory,
    /** Subcategory of the application, e.g. 'Arcade Game'. */
    applicationSubCategory,
    /** The name of the application suite to which the application belongs (e.g. Excel belongs to Office). */
    applicationSuite,
    /** The delivery method(s) to which the delivery charge or payment charge specification applies. */
    appliesToDeliveryMethod,
    /** The payment method(s) to which the payment charge specification applies. */
    appliesToPaymentMethod,
    /** The area within which users can expect to reach the broadcast service. */
    area,
    /** The airport where the flight terminates. */
    arrivalAirport,
    /** The stop or station from which the bus arrives. */
    arrivalBusStop,
    /** Identifier of the flight's arrival gate. */
    arrivalGate,
    /** The platform where the train arrives. */
    arrivalPlatform,
    /** The station where the train trip ends. */
    arrivalStation,
    /** Identifier of the flight's arrival terminal. */
    arrivalTerminal,
    /** The expected arrival time. */
    arrivalTime,
    /** The number of copies when multiple copies of a piece of artwork are produced - e.g. for a limited edition of 20 prints, 'artEdition' refers to the total number of copies (in this example "20"). */
    artEdition,
    /** The material used. (e.g. Oil, Watercolour, Acrylic, Linoprint, Marble, Cyanotype, Digital, Lithograph, DryPoint, Intaglio, Pastel, Woodcut, Pencil, Mixed Media, etc.) */
    artMedium,
    /** e.g. Painting, Drawing, Sculpture, Print, Photograph, Assemblage, Collage, etc. */
    artform,
    /** The actual body of the article. */
    articleBody,
    /** Articles may belong to one or more 'sections' in a magazine or newspaper, such as Sports, Lifestyle, etc. */
    articleSection,
    /** Library file name e.g., mscorlib.dll, system.web.dll. */
    assembly,
    /** Associated product/technology version. e.g., .NET Framework 4.5. */
    assemblyVersion,
    /** A NewsArticle associated with the Media Object. */
    associatedArticle,
    /** A media object that encodes this CreativeWork. This property is a synonym for encoding. */
    associatedMedia,
    /** A person that acts as performing member of a sports team; a player as opposed to a coach. */
    athlete,
    /** A person attending the event. */
    attendees,
    /** The target group associated with a given audience (e.g. veterans, car owners, musicians, etc.). */
    audienceType,
    /** An embedded audio object. */
    audio,
    /** The Organization responsible for authenticating the user's subscription. For example, many media apps require a cable/satellite provider to authenticate your subscription before playing media. */
    authenticator,
    /** The author of this content or rating. Please note that author is special in that HTML 5 provides a special mechanism for indicating authorship via the rel tag. That is equivalent to this and may be used interchangeably. */
    author,
    /** The availability of this item&#x2014;for example In stock, Out of stock, Pre-order, etc. */
    availability,
    /** The end of the availability of the product or service included in the offer. */
    availabilityEnds,
    /** The beginning of the availability of the product or service included in the offer. */
    availabilityStarts,
    /** The place(s) from which the offer can be obtained (e.g. store locations). */
    availableAtOrFrom,
    /** A means of accessing the service (e.g. a phone bank, a web site, a location, etc.). */
    availableChannel,
    /** The delivery method(s) available for this offer. */
    availableDeliveryMethod,
    /** When the item is available for pickup from the store, locker, etc. */
    availableFrom,
    /** A language someone may use with or at the item, service or place. Please use one of the language codes from the <a href="http://tools.ietf.org/html/bcp47">IETF BCP 47 standard</a>. See also <a class="localLink" href="http://schema.org/inLanguage">inLanguage</a> */
    availableLanguage,
    /** After this date, the item will no longer be available for pickup. */
    availableThrough,
    /** Awards won by or for this item. */
    awards,
    /** The away team in a sports event. */
    awayTeam,
    /** The base salary of the job or of an employee in an EmployeeRole. */
    baseSalary,
    /** A sub property of recipient. The recipient blind copied on a message. */
    bccRecipient,
    /** The type of bed or beds included in the accommodation. For the single case of just one bed of a certain type, you use bed directly with a text.
          If you want to indicate the quantity of a certain kind of bed, use an instance of BedDetails. For more detailed information, use the amenityFeature property. */
    bed,
    /** A media object representing the circumstances before performing this direction. */
    beforeMedia,
    /** Description of benefits associated with the job. */
    benefits,
    /** The highest value allowed in this rating system. If bestRating is omitted, 5 is assumed. */
    bestRating,
    /** The billing address for the order. */
    billingAddress,
    /** This property specifies the minimal quantity and rounding increment that will be the basis for the billing. The unit of measurement is specified by the unitCode property. */
    billingIncrement,
    /** The time interval used to compute the invoice. */
    billingPeriod,
    /** Date of birth. */
    birthDate,
    /** The place where the person was born. */
    birthPlace,
    /** The bitrate of the media object. */
    bitrate,
    /** The postings that are part of this blog. */
    blogPosts,
    /** The airline-specific indicator of boarding order / preference. */
    boardingGroup,
    /** The type of boarding policy used by the airline (e.g. zone-based or group-based). */
    boardingPolicy,
    /** The edition of the book. */
    bookEdition,
    /** The format of the book. */
    bookFormat,
    /** 'bookingAgent' is an out-dated term indicating a 'broker' that serves as a booking agent. */
    bookingAgent,
    /** The date and time the reservation was booked. */
    bookingTime,
    /** A sub property of participant. The person that borrows the object being lent. */
    borrower,
    /** A box is the area enclosed by the rectangle formed by two points. The first point is the lower corner, the second point is the upper corner. A box is expressed as two points separated by a space character. */
    box,
    /** A short textual code (also called "store code") that uniquely identifies a place of business. The code is typically assigned by the parentOrganization and used in structured URLs.<br/><br/>
    
    For example, in the URL http://www.starbucks.co.uk/store-locator/etc/detail/3047 the code "3047" is a branchCode for a particular branch. */
    branchCode,
    /** The larger organization that this local business is a branch of, if any. Not to be confused with (anatomical)<a class="localLink" href="http://schema.org/branch">branch</a>. */
    branchOf,
    /** The brand(s) associated with a product or service, or the brand(s) maintained by an organization or business person. */
    brand,
    /** A set of links that can help a user understand and navigate a website hierarchy. */
    breadcrumb,
    /** The media network(s) whose content is broadcast on this station. */
    broadcastAffiliateOf,
    /** The unique address by which the BroadcastService can be identified in a provider lineup. In US, this is typically a number. */
    broadcastChannelId,
    /** The name displayed in the channel guide. For many US affiliates, it is the network name. */
    broadcastDisplayName,
    /** The frequency used for over-the-air broadcasts. Numeric values or simple ranges e.g. 87-99. In addition a shortcut idiom is supported for frequences of AM and FM radio channels, e.g. "87 FM". */
    broadcastFrequency,
    /** The frequency in MHz for a particular broadcast. */
    broadcastFrequencyValue,
    /** The event being broadcast such as a sporting event or awards ceremony. */
    broadcastOfEvent,
    /** The type of service required to have access to the channel (e.g. Standard or Premium). */
    broadcastServiceTier,
    /** The timezone in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 format</a> for which the service bases its broadcasts */
    broadcastTimezone,
    /** The organization owning or operating the broadcast service. */
    broadcaster,
    /** Specifies browser requirements in human-readable text. For example, 'requires HTML5 support'. */
    browserRequirements,
    /** The name of the bus (e.g. Bolt Express). */
    busName,
    /** The unique identifier for the bus. */
    busNumber,
    /** The business function (e.g. sell, lease, repair, dispose) of the offer or component of a bundle (TypeAndQuantityNode). The default is http://purl.org/goodrelations/v1#Sell. */
    businessFunction,
    /** A sub property of participant. The participant/person/organization that bought the object. */
    buyer,
    /** The artist that performed this album or recording. */
    byArtist,
    /** The number of calories. */
    calories,
    /** A sub property of object. The candidate subject of this action. */
    candidate,
    /** The caption for this object. For downloadable machine formats (closed caption, subtitles etc.) use MediaObject and indicate the <a class="localLink" href="http://schema.org/encodingFormat">encodingFormat</a>. */
    caption,
    /** The number of grams of carbohydrates. */
    carbohydrateContent,
    /** The available volume for cargo or luggage. For automobiles, this is usually the trunk volume.<br/><br/>
    
    Typical unit code(s): LTR for liters, FTQ for cubic foot/feet<br/><br/>
    
    Note: You can use <a class="localLink" href="http://schema.org/minValue">minValue</a> and <a class="localLink" href="http://schema.org/maxValue">maxValue</a> to indicate ranges. */
    cargoVolume,
    /** 'carrier' is an out-dated term indicating the 'provider' for parcel delivery and flights. */
    carrier,
    /** Specifies specific carrier(s) requirements for the application (e.g. an application may only work on a specific carrier network). */
    carrierRequirements,
    /** A data catalog which contains this dataset. */
    catalog,
    /** The catalog number for the release. */
    catalogNumber,
    /** A category for the item. Greater signs or slashes can be used to informally indicate a category hierarchy. */
    category,
    /** A sub property of recipient. The recipient copied on a message. */
    ccRecipient,
    /** Fictional person connected with a creative work. */
    character,
    /** A piece of data that represents a particular aspect of a fictional character (skill, power, character points, advantage, disadvantage). */
    characterAttribute,
    /** The name of a character played in some acting or performing role, i.e. in a PerformanceRole. */
    characterName,
    /** Cheat codes to the game. */
    cheatCode,
    /** The earliest someone may check into a lodging establishment. */
    checkinTime,
    /** The latest someone may check out of a lodging establishment. */
    checkoutTime,
    /** Maximal age of the child. */
    childMaxAge,
    /** Minimal age of the child. */
    childMinAge,
    /** A child of the person. */
    children,
    /** The number of milligrams of cholesterol. */
    cholesterolContent,
    /** A circle is the circular region of a specified radius centered at a specified latitude and longitude. A circle is expressed as a pair followed by a radius in meters. */
    circle,
    /** A citation or reference to another creative work, such as another publication, web page, scholarly article, etc. */
    citation,
    /** A short summary of the specific claims reviewed in a ClaimReview. */
    claimReviewed,
    /** Position of the clip within an ordered group of clips. */
    clipNumber,
    /** The closing hour of the place or service on the given day(s) of the week. */
    closes,
    /** A person that acts in a coaching role for a sports team. */
    coach,
    /** Link to the repository where the un-compiled, human readable code and related code is located (SVN, github, CodePlex). */
    codeRepository,
    /** A colleague of the person. */
    colleagues,
    /** A sub property of object. The collection target of the action. */
    collection,
    /** The color of the product. */
    color,
    /** Comments, typically from users. */
    comment,
    /** The number of comments this CreativeWork (e.g. Article, Question or Answer) has received. This is most applicable to works published in Web sites with commenting system; additional comments may exist elsewhere. */
    commentCount,
    /** The text of the UserComment. */
    commentText,
    /** The time at which the UserComment was made. */
    commentTime,
    /** The person or organization who wrote a composition, or who is the composer of a work performed at some event. */
    composer,
    /** A number that confirms the given order or payment has been received. */
    confirmationNumber,
    /** An option available on this contact point (e.g. a toll-free number or support for hearing-impaired callers). */
    contactOption,
    /** A contact point for a person or organization. */
    contactPoints,
    /** A person or organization can have different contact points, for different purposes. For example, a sales contact point, a PR contact point and so on. This property is used to specify the kind of contact point. */
    contactType,
    /** The basic containment relation between a place and one that contains it. */
    containedIn,
    /** Official rating of a piece of content&#x2014;for example,'MPAA PG-13'. */
    contentRating,
    /** File size in (mega/kilo) bytes. */
    contentSize,
    /** The supported content type(s) for an EntryPoint response. */
    contentType,
    /** Actual bytes of the media object, for example the image file or video file. */
    contentUrl,
    /** A secondary contributor to the CreativeWork or Event. */
    contributor,
    /** The time it takes to actually cook the dish, in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 duration format</a>. */
    cookTime,
    /** The method of cooking, such as Frying, Steaming, ... */
    cookingMethod,
    /** The party holding the legal copyright to the CreativeWork. */
    copyrightHolder,
    /** The year during which the claimed copyright for the CreativeWork was first asserted. */
    copyrightYear,
    /** Countries for which the application is not supported. You can also provide the two-letter ISO 3166-1 alpha-2 country code. */
    countriesNotSupported,
    /** Countries for which the application is supported. You can also provide the two-letter ISO 3166-1 alpha-2 country code. */
    countriesSupported,
    /** The country of the principal offices of the production company or individual responsible for the movie or program. */
    countryOfOrigin,
    /** A sub property of location. The course where this action was taken. */
    course,
    /** The identifier for the <a class="localLink" href="http://schema.org/Course">Course</a> used by the course <a class="localLink" href="http://schema.org/provider">provider</a> (e.g. CS101 or 6.001). */
    courseCode,
    /** The medium or means of delivery of the course instance or the mode of study, either as a text label (e.g. "online", "onsite" or "blended"; "synchronous" or "asynchronous"; "full-time" or "part-time") or as a URL reference to a term from a controlled vocabulary (e.g. https://ceds.ed.gov/element/001311#Asynchronous ). */
    courseMode,
    /** Requirements for taking the Course. May be completion of another <a class="localLink" href="http://schema.org/Course">Course</a> or a textual description like "permission of instructor". Requirements may be a pre-requisite competency, referenced using <a class="localLink" href="http://schema.org/AlignmentObject">AlignmentObject</a>. */
    coursePrerequisites,
    /** The time when the live blog will stop covering the Event. Note that coverage may continue after the Event concludes. */
    coverageEndTime,
    /** The time when the live blog will begin covering the Event. Note that coverage may begin before the Event's start time. The LiveBlogPosting may also be created before coverage begins. */
    coverageStartTime,
    /** The creator/author of this CreativeWork. This is the same as the Author property for CreativeWork. */
    creator,
    /** The group the release is credited to if different than the byArtist. For example, Red and Blue is credited to "Stefani Germanotta Band", but by Lady Gaga. */
    creditedTo,
    /** A CSS selector, e.g. of a <a class="localLink" href="http://schema.org/SpeakableSpecification">SpeakableSpecification</a> or <a class="localLink" href="http://schema.org/WebPageElement">WebPageElement</a>. In the latter case, multiple matches within a page can constitute a single conceptual "Web page element". */
    cssSelector,
    /** The currency accepted.<br/><br/>
    
    Use standard formats: <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217 currency format</a> e.g. "USD"; <a href="https://en.wikipedia.org/wiki/List_of_cryptocurrencies">Ticker symbol</a> for cryptocurrencies e.g. "BTC"; well known names for <a href="https://en.wikipedia.org/wiki/Local_exchange_trading_system">Local Exchange Tradings Systems</a> (LETS) and other currency types e.g. "Ithaca HOUR". */
    currenciesAccepted,
    /** The currency in which the monetary amount is expressed.<br/><br/>
    
    Use standard formats: <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217 currency format</a> e.g. "USD"; <a href="https://en.wikipedia.org/wiki/List_of_cryptocurrencies">Ticker symbol</a> for cryptocurrencies e.g. "BTC"; well known names for <a href="https://en.wikipedia.org/wiki/Local_exchange_trading_system">Local Exchange Tradings Systems</a> (LETS) and other currency types e.g. "Ithaca HOUR". */
    currency,
    /** Party placing the order or paying the invoice. */
    customer,
    /** An item within in a data feed. Data feeds may have many elements. */
    dataFeedElement,
    /** The range of temporal applicability of a dataset, e.g. for a 2011 census dataset, the year 2011 (in ISO 8601 time interval format). */
    datasetTimeInterval,
    /** The date on which the CreativeWork was created or the item was added to a DataFeed. */
    dateCreated,
    /** The datetime the item was removed from the DataFeed. */
    dateDeleted,
    /** The date the ticket was issued. */
    dateIssued,
    /** The date on which the CreativeWork was most recently modified or when the item's entry was modified within a DataFeed. */
    dateModified,
    /** Publication date for the job posting. */
    datePosted,
    /** Date of first broadcast/publication. */
    datePublished,
    /** The date/time at which the message has been read by the recipient if a single recipient exists. */
    dateRead,
    /** The date/time the message was received if a single recipient exists. */
    dateReceived,
    /** The date/time at which the message was sent. */
    dateSent,
    /** The date of the first registration of the vehicle with the respective public authorities. */
    dateVehicleFirstRegistered,
    /** A <a href="https://en.wikipedia.org/wiki/Dateline">dateline</a> is a brief piece of text included in news articles that describes where and when the story was written or filed though the date is often omitted. Sometimes only a placename is provided.<br/><br/>
    
    Structured representations of dateline-related information can also be expressed more explicitly using <a class="localLink" href="http://schema.org/locationCreated">locationCreated</a> (which represents where a work was created e.g. where a news report was written).  For location depicted or described in the content, use <a class="localLink" href="http://schema.org/contentLocation">contentLocation</a>.<br/><br/>
    
    Dateline summaries are oriented more towards human readers than towards automated processing, and can vary substantially. Some examples: "BEIRUT, Lebanon, June 2.", "Paris, France", "December 19, 2017 11:43AM Reporting from Washington", "Beijing/Moscow", "QUEZON CITY, Philippines". */
    dateline,
    /** The day of the week for which these opening hours are valid. */
    dayOfWeek,
    /** Date of death. */
    deathDate,
    /** The place where the person died. */
    deathPlace,
    /** The default value of the input.  For properties that expect a literal, the default is a literal value, for properties that expect an object, it's an ID reference to one of the current values. */
    defaultValue,
    /** Destination address. */
    deliveryAddress,
    /** The typical delay between the receipt of the order and the goods either leaving the warehouse or being prepared for pickup, in case the delivery method is on site pickup. */
    deliveryLeadTime,
    /** A sub property of instrument. The method of delivery. */
    deliveryMethod,
    /** New entry added as the package passes through each leg of its journey (from shipment to final delivery). */
    deliveryStatus,
    /** A relationship between an organization and a department of that organization, also described as an organization (allowing different urls, logos, opening hours). For example: a store with a pharmacy, or a bakery with a cafe. */
    department,
    /** The airport where the flight originates. */
    departureAirport,
    /** The stop or station from which the bus departs. */
    departureBusStop,
    /** Identifier of the flight's departure gate. */
    departureGate,
    /** The platform from which the train departs. */
    departurePlatform,
    /** The station from which the train departs. */
    departureStation,
    /** Identifier of the flight's departure terminal. */
    departureTerminal,
    /** The expected departure time. */
    departureTime,
    /** Prerequisites needed to fulfill steps in article. */
    dependencies,
    /** The depth of the item. */
    depth,
    /** Device required to run the application. Used in cases where a specific make/model is required to run the application. */
    device,
    /** A director of e.g. tv, radio, movie, video games etc. content. Directors can be associated with individual items or with a series, episode, clip. */
    directors,
    /** A sub property of description. A short description of the item used to disambiguate from other, similar items. Information from other properties (in particular, name) may be necessary for the description to be useful for disambiguation. */
    disambiguatingDescription,
    /** Any discount applied (to an Order). */
    discount,
    /** Code used to redeem a discount. */
    discountCode,
    /** The currency of the discount.<br/><br/>
    
    Use standard formats: <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217 currency format</a> e.g. "USD"; <a href="https://en.wikipedia.org/wiki/List_of_cryptocurrencies">Ticker symbol</a> for cryptocurrencies e.g. "BTC"; well known names for <a href="https://en.wikipedia.org/wiki/Local_exchange_trading_system">Local Exchange Tradings Systems</a> (LETS) and other currency types e.g. "Ithaca HOUR". */
    discountCurrency,
    /** Specifies the CreativeWork associated with the UserComment. */
    discusses,
    /** A link to the page containing the comments of the CreativeWork. */
    discussionUrl,
    /** The date that this organization was dissolved. */
    dissolutionDate,
    /** The distance travelled, e.g. exercising or travelling. */
    distance,
    /** A downloadable form of this dataset, at a specific location, in a specific format. */
    distribution,
    /** The time admission will commence. */
    doorTime,
    /** If the file can be downloaded, URL to download the binary. */
    downloadUrl,
    /** The number of downvotes this question, answer or comment has received from the community. */
    downvoteCount,
    /** The drive wheel configuration, i.e. which roadwheels will receive torque from the vehicle's engine via the drivetrain. */
    driveWheelConfiguration,
    /** Where a rental car can be dropped off. */
    dropoffLocation,
    /** When a rental car can be dropped off. */
    dropoffTime,
    /** The Dun &amp; Bradstreet DUNS number for identifying an organization or business person. */
    duns,
    /** The duration of the warranty promise. Common unitCode values are ANN for year, MON for months, or DAY for days. */
    durationOfWarranty,
    /** A media object representing the circumstances while performing this direction. */
    duringMedia,
    /** Specifies the Person who edited the CreativeWork. */
    editor,
    /** An alignment to an established educational framework. */
    educationalAlignment,
    /** A description of the qualification, award, certificate, diploma or other educational credential awarded as a consequence of successful completion of this course or program. */
    educationalCredentialAwarded,
    /** The framework to which the resource being described is aligned. */
    educationalFramework,
    /** An educationalRole of an EducationalAudience. */
    educationalRole,
    /** The purpose of a work in the context of education; for example, 'assignment', 'group work'. */
    educationalUse,
    /** The elevation of a location (<a href="https://en.wikipedia.org/wiki/World_Geodetic_System">WGS 84</a>). Values may be of the form 'NUMBER UNIT<em>OF</em>MEASUREMENT' (e.g., '1,000 m', '3,200 ft') while numbers alone should be assumed to be a value in meters. */
    elevation,
    /** The type(s) of customers for which the given offer is valid. */
    eligibleCustomerType,
    /** The duration for which the given offer is valid. */
    eligibleDuration,
    /** The interval and unit of measurement of ordering quantities for which the offer or price specification is valid. This allows e.g. specifying that a certain freight charge is valid only for a certain quantity. */
    eligibleQuantity,
    /** The ISO 3166-1 (ISO 3166-1 alpha-2) or ISO 3166-2 code, the place, or the GeoShape for the geo-political region(s) for which the offer or delivery charge specification is valid.<br/><br/>
    
    See also <a class="localLink" href="http://schema.org/ineligibleRegion">ineligibleRegion</a>. */
    eligibleRegion,
    /** The transaction volume, in a monetary unit, for which the offer or price specification is valid, e.g. for indicating a minimal purchasing volume, to express free shipping above a certain order volume, or to limit the acceptance of credit cards to purchases to a certain minimal amount. */
    eligibleTransactionVolume,
    /** Email address. */
    email,
    /** A URL pointing to a player for a specific video. In general, this is the information in the <code>src</code> element of an <code>embed</code> tag and should not be the same as the content of the <code>loc</code> tag. */
    embedUrl,
    /** People working for this organization. */
    employees,
    /** Type of employment (e.g. full-time, part-time, contract, temporary, seasonal, internship). */
    employmentType,
    /** The supported encoding type(s) for an EntryPoint request. */
    encodingType,
    /** A media object that encodes this CreativeWork. */
    encodings,
    /** The end date and time of the item (in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 date format</a>). */
    endDate,
    /** The endTime of something. For a reserved event or service (e.g. FoodEstablishmentReservation), the time that it is expected to end. For actions that span a period of time, when the action was performed. e.g. John wrote a book from January to <em>December</em>. For media, including audio and video, it's the time offset of the end of a clip within a larger file.<br/><br/>
    
    Note that Event uses startDate/endDate instead of startTime/endTime, even when describing dates with times. This situation may be clarified in future revisions. */
    endTime,
    /** A sub property of participant. The person/organization being supported. */
    endorsee,
    /** A sub property of location. The entertainment business where the action occurred. */
    entertainmentBusiness,
    /** Position of the episode within an ordered group of episodes. */
    episodeNumber,
    /** An episode of a TV/radio series or season. */
    episodes,
    /** This ordering relation for qualitative values indicates that the subject is equal to the object. */
    equal,
    /** For failed actions, more information on the cause of the failure. */
    error,
    /** The estimated cost of the supply or supplies consumed when performing instructions. */
    estimatedCost,
    /** The estimated time the flight will take. */
    estimatedFlightDuration,
    /** An estimated salary for a job posting or occupation, based on a variety of variables including, but not limited to industry, job title, and location. Estimated salaries  are often computed by outside organizations rather than the hiring organization, who may not have committed to the estimated value. */
    estimatedSalary,
    /** An eventStatus of an event represents its status; particularly useful when an event is cancelled or rescheduled. */
    eventStatus,
    /** Upcoming or past events associated with this place or organization. */
    events,
    /** exif data for this object. */
    exifData,
    /** The earliest date the package may arrive. */
    expectedArrivalFrom,
    /** The latest date the package may arrive. */
    expectedArrivalUntil,
    /** An Offer which must be accepted before the user can perform the Action. For example, the user may need to buy a movie before being able to watch it. */
    expectsAcceptanceOf,
    /** Description of skills and experience needed for the position or Occupation. */
    experienceRequirements,
    /** Date the content expires and is no longer useful or available. For example a <a class="localLink" href="http://schema.org/VideoObject">VideoObject</a> or <a class="localLink" href="http://schema.org/NewsArticle">NewsArticle</a> whose availability or relevance is time-limited, or a <a class="localLink" href="http://schema.org/ClaimReview">ClaimReview</a> fact check whose publisher wants to indicate that it may no longer be relevant (or helpful to highlight) after some date. */
    expires,
    /** Family name. In the U.S., the last name of an Person. This can be used along with givenName instead of the name property. */
    familyName,
    /** The number of grams of fat. */
    fatContent,
    /** The fax number. */
    faxNumber,
    /** Features or modules provided by this application (and possibly required by other applications). */
    featureList,
    /** Description of fees, commissions, and other terms applied either to a class of financial product, or by a financial service organization. */
    feesAndCommissionsSpecification,
    /** The number of grams of fiber. */
    fiberContent,
    /** Media type, typically MIME format (see <a href="http://www.iana.org/assignments/media-types/media-types.xhtml">IANA site</a>) of the content e.g. application/zip of a SoftwareApplication binary. In cases where a CreativeWork has several media type representations, 'encoding' can be used to indicate each MediaObject alongside particular fileFormat information. Unregistered or niche file formats can be indicated instead via the most appropriate URL, e.g. defining Web page or a Wikipedia entry. */
    fileFormat,
    /** Size of the application / package (e.g. 18MB). In the absence of a unit (MB, KB etc.), KB will be assumed. */
    fileSize,
    /** The date and place the work was first performed. */
    firstPerformance,
    /** The distance of the flight. */
    flightDistance,
    /** The unique identifier for a flight including the airline IATA code. For example, if describing United flight 110, where the IATA code for United is 'UA', the flightNumber is 'UA110'. */
    flightNumber,
    /** The size of the accommodation, e.g. in square meter or squarefoot.
    Typical unit code(s): MTK for square meter, FTK for square foot, or YDK for square yard */
    floorSize,
    /** A sub property of object. The person or organization being followed. */
    followee,
    /** The most generic uni-directional social relation. */
    follows,
    /** A sub property of location. The specific food establishment where the action occurred. */
    foodEstablishment,
    /** A sub property of location. The specific food event where the action occurred. */
    foodEvent,
    /** A person who founded this organization. */
    founders,
    /** The date that this organization was founded. */
    foundingDate,
    /** The place where the Organization was founded. */
    foundingLocation,
    /** A flag to signal that the item, event, or place is accessible for free. */
    free,
    /** A sub property of location. The original location of the object or the agent before the action. */
    fromLocation,
    /** The amount of fuel consumed for traveling a particular distance or temporal duration with the given vehicle (e.g. liters per 100 km).<br/><br/>
    
    <ul>
    <li>Note 1: There are unfortunately no standard unit codes for liters per 100 km.  Use <a class="localLink" href="http://schema.org/unitText">unitText</a> to indicate the unit of measurement, e.g. L/100 km.</li>
    <li>Note 2: There are two ways of indicating the fuel consumption, <a class="localLink" href="http://schema.org/fuelConsumption">fuelConsumption</a> (e.g. 8 liters per 100 km) and <a class="localLink" href="http://schema.org/fuelEfficiency">fuelEfficiency</a> (e.g. 30 miles per gallon). They are reciprocal.</li>
    <li>Note 3: Often, the absolute value is useful only when related to driving speed ("at 80 km/h") or usage pattern ("city traffic"). You can use <a class="localLink" href="http://schema.org/valueReference">valueReference</a> to link the value for the fuel consumption to another value.</li>
    </ul>
     */
    fuelConsumption,
    /** The distance traveled per unit of fuel used; most commonly miles per gallon (mpg) or kilometers per liter (km/L).<br/><br/>
    
    <ul>
    <li>Note 1: There are unfortunately no standard unit codes for miles per gallon or kilometers per liter. Use <a class="localLink" href="http://schema.org/unitText">unitText</a> to indicate the unit of measurement, e.g. mpg or km/L.</li>
    <li>Note 2: There are two ways of indicating the fuel consumption, <a class="localLink" href="http://schema.org/fuelConsumption">fuelConsumption</a> (e.g. 8 liters per 100 km) and <a class="localLink" href="http://schema.org/fuelEfficiency">fuelEfficiency</a> (e.g. 30 miles per gallon). They are reciprocal.</li>
    <li>Note 3: Often, the absolute value is useful only when related to driving speed ("at 80 km/h") or usage pattern ("city traffic"). You can use <a class="localLink" href="http://schema.org/valueReference">valueReference</a> to link the value for the fuel economy to another value.</li>
    </ul>
     */
    fuelEfficiency,
    /** The type of fuel suitable for the engine or engines of the vehicle. If the vehicle has only one engine, this property can be attached directly to the vehicle. */
    fuelType,
    /** A person or organization that supports (sponsors) something through some kind of financial contribution. */
    funder,
    /** An item is an object within the game world that can be collected by a player or, occasionally, a non-player character. */
    gameItem,
    /** Real or fictional location of the game (or part of game). */
    gameLocation,
    /** The electronic systems used to play <a href="http://en.wikipedia.org/wiki/Category:Video_game_platforms">video games</a>. */
    gamePlatform,
    /** Links to tips, tactics, etc. */
    gameTip,
    /** Gender of the person. While http://schema.org/Male and http://schema.org/Female may be used, text strings are also acceptable for people who do not identify as a binary gender. */
    gender,
    /** Genre of the creative work, broadcast channel or group. */
    genre,
    /** The geo coordinates of the place. */
    geo,
    /** Represents a relationship between two geometries (or the places they represent), relating a containing geometry to a contained geometry. "a contains b iff no points of b lie in the exterior of a, and at least one point of the interior of b lies in the interior of a". As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
    geoContains,
    /** Represents a relationship between two geometries (or the places they represent), relating a geometry to another that covers it. As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
    geoCoveredBy,
    /** Represents a relationship between two geometries (or the places they represent), relating a covering geometry to a covered geometry. "Every point of b is a point of (the interior or boundary of) a". As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
    geoCovers,
    /** Represents a relationship between two geometries (or the places they represent), relating a geometry to another that crosses it: "a crosses b: they have some but not all interior points in common, and the dimension of the intersection is less than that of at least one of them". As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
    geoCrosses,
    /** Represents spatial relations in which two geometries (or the places they represent) are topologically disjoint: they have no point in common. They form a set of disconnected geometries." (a symmetric relationship, as defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>) */
    geoDisjoint,
    /** Represents spatial relations in which two geometries (or the places they represent) are topologically equal, as defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. "Two geometries are topologically equal if their interiors intersect and no part of the interior or boundary of one geometry intersects the exterior of the other" (a symmetric relationship) */
    geoEquals,
    /** Represents spatial relations in which two geometries (or the places they represent) have at least one point in common. As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
    geoIntersects,
    /** Indicates the GeoCoordinates at the centre of a GeoShape e.g. GeoCircle. */
    geoMidpoint,
    /** Represents a relationship between two geometries (or the places they represent), relating a geometry to another that geospatially overlaps it, i.e. they have some but not all points in common. As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
    geoOverlaps,
    /** Indicates the approximate radius of a GeoCircle (metres unless indicated otherwise via Distance notation). */
    geoRadius,
    /** Represents spatial relations in which two geometries (or the places they represent) touch: they have at least one boundary point in common, but no interior points." (a symmetric relationship, as defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a> ) */
    geoTouches,
    /** Represents a relationship between two geometries (or the places they represent), relating a geometry to one that contains it, i.e. it is inside (i.e. within) its interior. As defined in <a href="https://en.wikipedia.org/wiki/DE-9IM">DE-9IM</a>. */
    geoWithin,
    /** The geographic area associated with the audience. */
    geographicArea,
    /** Given name. In the U.S., the first name of a Person. This can be used along with familyName instead of the name property. */
    givenName,
    /** The <a href="http://www.gs1.org/gln">Global Location Number</a> (GLN, sometimes also referred to as International Location Number or ILN) of the respective organization, person, or place. The GLN is a 13-digit number used to identify parties and physical locations. */
    globalLocationNumber,
    /** The person, organization, contact point, or audience that has been granted this permission. */
    grantee,
    /** This ordering relation for qualitative values indicates that the subject is greater than the object. */
    greater,
    /** This ordering relation for qualitative values indicates that the subject is greater than or equal to the object. */
    greaterOrEqual,
    /** The GTIN-12 code of the product, or the product to which the offer refers. The GTIN-12 is the 12-digit GS1 Identification Key composed of a U.P.C. Company Prefix, Item Reference, and Check Digit used to identify trade items. See <a href="http://www.gs1.org/barcodes/technical/idkeys/gtin">GS1 GTIN Summary</a> for more details. */
    gtin12,
    /** The GTIN-13 code of the product, or the product to which the offer refers. This is equivalent to 13-digit ISBN codes and EAN UCC-13. Former 12-digit UPC codes can be converted into a GTIN-13 code by simply adding a preceeding zero. See <a href="http://www.gs1.org/barcodes/technical/idkeys/gtin">GS1 GTIN Summary</a> for more details. */
    gtin13,
    /** The GTIN-14 code of the product, or the product to which the offer refers. See <a href="http://www.gs1.org/barcodes/technical/idkeys/gtin">GS1 GTIN Summary</a> for more details. */
    gtin14,
    /** The <a href="http://apps.gs1.org/GDD/glossary/Pages/GTIN-8.aspx">GTIN-8</a> code of the product, or the product to which the offer refers. This code is also known as EAN/UCC-8 or 8-digit EAN. See <a href="http://www.gs1.org/barcodes/technical/idkeys/gtin">GS1 GTIN Summary</a> for more details. */
    gtin8,
    /** An offering of the course at a specific time and place or through specific media or mode of study or to a specific section of students. */
    hasCourseInstance,
    /** Method used for delivery or shipping. */
    hasDeliveryMethod,
    /** A permission related to the access to this document (e.g. permission to read or write an electronic document). For a public document, specify a grantee with an Audience with audienceType equal to "public". */
    hasDigitalDocumentPermission,
    /** A food or drink item contained in a menu or menu section. */
    hasMenuItem,
    /** A subgrouping of the menu (by dishes, course, serving time period, etc.). */
    hasMenuSection,
    /** The Person's occupation. For past professions, use Role for expressing dates. */
    hasOccupation,
    /** Indicates an OfferCatalog listing for this Organization, Person, or Service. */
    hasOfferCatalog,
    /** Points-of-Sales operated by the organization or person. */
    hasPOS,
    /** Headline of the article. */
    headline,
    /** The height of the item. */
    height,
    /** The highest price of all offers available.<br/><br/>
    
    Usage guidelines:<br/><br/>
    
    <ul>
    <li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
    <li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
    </ul>
     */
    highPrice,
    /** Organization offering the job position. */
    hiringOrganization,
    /** A contact location for a person's residence. */
    homeLocation,
    /** The home team in a sports event. */
    homeTeam,
    /** An honorific prefix preceding a Person's name such as Dr/Mrs/Mr. */
    honorificPrefix,
    /** An honorific suffix preceding a Person's name such as M.D. /PhD/MSCSW. */
    honorificSuffix,
    /** The organization (airline, travelers' club, etc.) the membership is made with. */
    hostingOrganization,
    /** The hours during which this service or contact is available. */
    hoursAvailable,
    /** An HTTP method that specifies the appropriate HTTP method for a request to an HTTP EntryPoint. Values are capitalized strings as used in HTTP. */
    httpMethod,
    /** IATA identifier for an airline or airport. */
    iataCode,
    /** ICAO identifier for an airport. */
    icaoCode,
    /** The illustrator of the book. */
    illustrator,
    /** The album to which this recording belongs. */
    inAlbum,
    /** The CableOrSatelliteService offering the channel. */
    inBroadcastLineup,
    /** The playlist to which this recording belongs. */
    inPlaylist,
    /** Description of bonus and commission compensation aspects of the job. */
    incentives,
    /** Smaller compositions included in this work (e.g. a movement in a symphony). */
    includedComposition,
    /** A data catalog which contains this dataset (this property was previously 'catalog', preferred name is now 'includedInDataCatalog'). */
    includedDataCatalog,
    /** This links to a node or nodes indicating the exact quantity of the products included in the offer. */
    includesObject,
    /** The industry associated with the job position. */
    industry,
    /** The ISO 3166-1 (ISO 3166-1 alpha-2) or ISO 3166-2 code, the place, or the GeoShape for the geo-political region(s) for which the offer or delivery charge specification is not valid, e.g. a region where the transaction is not allowed.<br/><br/>
    
    See also <a class="localLink" href="http://schema.org/eligibleRegion">eligibleRegion</a>. */
    ineligibleRegion,
    /** A single ingredient used in the recipe, e.g. sugar, flour or garlic. */
    ingredients,
    /** URL at which the app may be installed, if different from the URL of the item. */
    installUrl,
    /** A person assigned to instruct or provide instructional assistance for the <a class="localLink" href="http://schema.org/CourseInstance">CourseInstance</a>. */
    instructor,
    /** This property is deprecated, alongside the UserInteraction types on which it depended. */
    interactionCount,
    /** The WebSite or SoftwareApplication where the interactions took place. */
    interactionService,
    /** The Action representing the type of interaction. For up votes, +1s, etc. use <a class="localLink" href="http://schema.org/LikeAction">LikeAction</a>. For down votes use <a class="localLink" href="http://schema.org/DislikeAction">DislikeAction</a>. Otherwise, use the most specific Action. */
    interactionType,
    /** The predominant mode of learning supported by the learning resource. Acceptable values are 'active', 'expositive', or 'mixed'. */
    interactivityType,
    /** The interest rate, charged or paid, applicable to the financial product. Note: This is different from the calculated annualPercentageRate. */
    interestRate,
    /** The current approximate inventory level for the item or items. */
    inventoryLevel,
    /** A pointer to another product (or multiple products) for which this product is an accessory or spare part. */
    isAccessoryOrSparePartFor,
    /** A resource that was used in the creation of this resource. This term can be repeated for multiple sources. For example, http://example.com/great-multiplication-intro.html. */
    isBasedOnUrl,
    /** A pointer to another product (or multiple products) for which this product is a consumable. */
    isConsumableFor,
    /** Indicates whether this content is family friendly. */
    isFamilyFriendly,
    /** Was the offer accepted as a gift for someone other than the buyer. */
    isGift,
    /** True is the broadcast is of a live event. */
    isLiveBroadcast,
    /** A pointer to another, somehow related product (or multiple products). */
    isRelatedTo,
    /** A pointer to another, functionally similar product (or multiple products). */
    isSimilarTo,
    /** A pointer to a base product from which this product is a variant. It is safe to infer that the variant inherits all product features from the base model, unless defined locally. This is not transitive. */
    isVariantOf,
    /** The ISBN of the book. */
    isbn,
    /** The International Standard of Industrial Classification of All Economic Activities (ISIC), Revision 4 code for a particular organization, business person, or place. */
    isicV4,
    /** The International Standard Recording Code for the recording. */
    isrcCode,
    /** The International Standard Serial Number (ISSN) that identifies this serial publication. You can repeat this property to identify different formats of, or the linking ISSN (ISSN-L) for, this serial publication. */
    issn,
    /** Identifies the issue of publication; for example, "iii" or "2". */
    issueNumber,
    /** The organization issuing the ticket or permit. */
    issuedBy,
    /** The service through with the permit was granted. */
    issuedThrough,
    /** The International Standard Musical Work Code for the composition. */
    iswcCode,
    /** An entity represented by an entry in a list or data feed (e.g. an 'artist' in a list of 'artists')’. */
    item,
    /** A predefined value from OfferItemCondition or a textual description of the condition of the product or service, or the products or services included in the offer. */
    itemCondition,
    /** For itemListElement values, you can use simple strings (e.g. "Peter", "Paul", "Mary"), existing entities, or use ListItem.<br/><br/>
    
    Text values are best if the elements in the list are plain strings. Existing entities are best for a simple, unordered list of existing things in your data. ListItem is used with ordered lists when you want to provide additional context about the element in that list or when the same item might be in different places in different lists.<br/><br/>
    
    Note: The order of elements in your mark-up is not sufficient for indicating the order or elements.  Use ListItem with a 'position' property in such cases. */
    itemListElement,
    /** Type of ordering (e.g. Ascending, Descending, Unordered). */
    itemListOrder,
    /** The item being offered. */
    itemOffered,
    /** The item that is being reviewed/rated. */
    itemReviewed,
    /** Item(s) being shipped. */
    itemShipped,
    /** A (typically single) geographic location associated with the job position. */
    jobLocation,
    /** Keywords or tags used to describe this content. Multiple entries in a keywords list are typically delimited by commas. */
    keywords,
    /** A textual description of known damages, both repaired and unrepaired. */
    knownVehicleDamages,
    /** The most generic bi-directional social/work relation. */
    knows,
    /** A sub property of participant. The owner of the real estate property. */
    landlord,
    /** A sub property of instrument. The language used on this action. */
    language,
    /** Date on which the content on this web page was last reviewed for accuracy and/or completeness. */
    lastReviewed,
    /** The latitude of a location. For example <code>37.42242</code> (<a href="https://en.wikipedia.org/wiki/World_Geodetic_System">WGS 84</a>). */
    latitude,
    /** The predominant type or kind characterizing the learning resource. For example, 'presentation', 'handout'. */
    learningResourceType,
    /** The official name of the organization, e.g. the registered company name. */
    legalName,
    /** An organization identifier that uniquely identifies a legal entity as defined in ISO 17442. */
    leiCode,
    /** A sub property of participant. The person that lends the object being borrowed. */
    lender,
    /** This ordering relation for qualitative values indicates that the subject is lesser than the object. */
    lesser,
    /** This ordering relation for qualitative values indicates that the subject is lesser than or equal to the object. */
    lesserOrEqual,
    /** A license document that applies to this content, typically indicated by URL. */
    license,
    /** A line is a point-to-point path consisting of two or more points. A line is expressed as a series of two or more point objects separated by space. */
    line,
    /** An update to the LiveBlog. */
    liveBlogUpdate,
    /** The duration of the loan or credit agreement. */
    loanTerm,
    /** The location where the CreativeWork was created, which may not be the same as the location depicted in the CreativeWork. */
    locationCreated,
    /** A full description of the lodging unit. */
    lodgingUnitDescription,
    /** Textual description of the unit type (including suite vs. room, size of bed, etc.). */
    lodgingUnitType,
    /** An associated logo. */
    logo,
    /** The longitude of a location. For example <code>-122.08585</code> (<a href="https://en.wikipedia.org/wiki/World_Geodetic_System">WGS 84</a>). */
    longitude,
    /** A sub property of participant. The loser of the action. */
    loser,
    /** The lowest price of all offers available.<br/><br/>
    
    Usage guidelines:<br/><br/>
    
    <ul>
    <li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
    <li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
    </ul>
     */
    lowPrice,
    /** The person who wrote the words. */
    lyricist,
    /** The words in the song. */
    lyrics,
    /** Indicates if this web page element is the main subject of the page. */
    mainContentOfPage,
    /** The manufacturer of the product. */
    manufacturer,
    /** A URL to a map of the place. */
    map,
    /** Indicates the kind of Map, from the MapCategoryType Enumeration. */
    mapType,
    /** A URL to a map of the place. */
    maps,
    /** The highest price if the price is a range. */
    maxPrice,
    /** The upper value of some characteristic or property. */
    maxValue,
    /** The total number of individuals that may attend an event or venue. */
    maximumAttendeeCapacity,
    /** Description of the meals that will be provided or available for purchase. */
    mealService,
    /** The median value. */
    median,
    /** A member of this organization. */
    members,
    /** A unique identifier for the membership. */
    membershipNumber,
    /** Minimum memory requirements. */
    memoryRequirements,
    /** Indicates that the CreativeWork contains a reference to, but is not necessarily about a concept. */
    mentions,
    /** Either the actual menu as a structured representation, as text, or a URL of the menu. */
    menu,
    /** Additional menu item(s) such as a side dish of salad or side order of fries that can be added to this menu item. Additionally it can be a menu section containing allowed add-on menu items for this menu item. */
    menuAddOn,
    /** 'merchant' is an out-dated term for 'seller'. */
    merchant,
    /** A CreativeWork attached to the message. */
    messageAttachment,
    /** The total distance travelled by the particular vehicle since its initial production, as read from its odometer.<br/><br/>
    
    Typical unit code(s): KMT for kilometers, SMI for statute miles */
    mileageFromOdometer,
    /** The lowest price if the price is a range. */
    minPrice,
    /** The lower value of some characteristic or property. */
    minValue,
    /** The minimum payment required at this time. */
    minimumPaymentDue,
    /** The model of the product. Use with the URL of a ProductModel or a textual representation of the model identifier. The URL of the ProductModel can be from an external source. It is recommended to additionally provide strong product identifiers via the gtin8/gtin13/gtin14 and mpn properties. */
    model,
    /** The date and time the reservation was modified. */
    modifiedTime,
    /** The Manufacturer Part Number (MPN) of the product, or the product to which the offer refers. */
    mpn,
    /** Whether multiple values are allowed for the property.  Default is false. */
    multipleValues,
    /** An arrangement derived from the composition. */
    musicArrangement,
    /** The composer of the soundtrack. */
    musicBy,
    /** The type of composition (e.g. overture, sonata, symphony, etc.). */
    musicCompositionForm,
    /** A member of a music group&#x2014;for example, John, Paul, George, or Ringo. */
    musicGroupMember,
    /** Format of this release (the type of recording media used, ie. compact disc, digital media, LP, etc.). */
    musicReleaseFormat,
    /** The key, mode, or scale this composition uses. */
    musicalKey,
    /** The North American Industry Classification System (NAICS) code for a particular organization or business person. */
    naics,
    /** The name of the item. */
    name,
    /** A position played, performed or filled by a person or organization, as part of an organization. For example, an athlete in a SportsTeam might play in the position named 'Quarterback'. */
    namedPosition,
    /** Nationality of the person. */
    nationality,
    /** The total financial value of the person as calculated by subtracting assets from liabilities. */
    netWorth,
    /** A link to the ListItem that follows the current one. */
    nextItem,
    /** This ordering relation for qualitative values indicates that the subject is not equal to the object. */
    nonEqual,
    /** The number of adults staying in the unit. */
    numAdults,
    /** The number of children staying in the unit. */
    numChildren,
    /** The number of tracks in this album or playlist. */
    numTracks,
    /** The number or type of airbags in the vehicle. */
    numberOfAirbags,
    /** The number of axles.<br/><br/>
    
    Typical unit code(s): C62 */
    numberOfAxles,
    /** The quantity of the given bed type available in the HotelRoom, Suite, House, or Apartment. */
    numberOfBeds,
    /** The number of doors.<br/><br/>
    
    Typical unit code(s): C62 */
    numberOfDoors,
    /** The number of employees in an organization e.g. business. */
    numberOfEmployees,
    /** The number of episodes in this season or series. */
    numberOfEpisodes,
    /** The total number of forward gears available for the transmission system of the vehicle.<br/><br/>
    
    Typical unit code(s): C62 */
    numberOfForwardGears,
    /** The number of items in an ItemList. Note that some descriptions might not fully describe all items in a list (e.g., multi-page pagination); in such cases, the numberOfItems would be for the entire list. */
    numberOfItems,
    /** The number of pages in the book. */
    numberOfPages,
    /** Indicate how many people can play this game (minimum, maximum, or range). */
    numberOfPlayers,
    /** The number of owners of the vehicle, including the current one.<br/><br/>
    
    Typical unit code(s): C62 */
    numberOfPreviousOwners,
    /** The number of rooms (excluding bathrooms and closets) of the accommodation or lodging business.
    Typical unit code(s): ROM for room or C62 for no unit. The type of room can be put in the unitText property of the QuantitativeValue. */
    numberOfRooms,
    /** The number of seasons in this series. */
    numberOfSeasons,
    /** A number associated with a role in an organization, for example, the number on an athlete's jersey. */
    numberedPosition,
    /** Nutrition information about the recipe or menu item. */
    nutrition,
    /** The allowed total occupancy for the accommodation in persons (including infants etc). For individual accommodations, this is not necessarily the legal maximum but defines the permitted usage as per the contractual agreement (e.g. a double room used by a single person).
    Typical unit code(s): C62 for person */
    occupancy,
    /** The region/country for which this occupational description is appropriate. Note that educational requirements and qualifications can vary between jurisdictions. */
    occupationLocation,
    /** A category describing the job, preferably using a term from a taxonomy such as <a href="http://www.onetcenter.org/taxonomy.html">BLS O*NET-SOC</a>, <a href="https://www.ilo.org/public/english/bureau/stat/isco/isco08/">ISCO-08</a> or similar, with the property repeated for each applicable value. Ideally the taxonomy should be identified, and both the textual label and formal code for the category should be provided.<br/><br/>
    
    Note: for historical reasons, any textual label and formal code provided as a literal may be assumed to be from O*NET-SOC. */
    occupationalCategory,
    /** The number of offers for the product. */
    offerCount,
    /** An offer to provide this item&#x2014;for example, an offer to sell a product, rent the DVD of a movie, perform a service, or give away tickets to an event. */
    offers,
    /** The general opening hours for a business. Opening hours can be specified as a weekly time range, starting with days, then times per day. Multiple days can be listed with commas ',' separating each day. Day or time ranges are specified using a hyphen '-'.<br/><br/>
    
    <ul>
    <li>Days are specified using the following two-letter combinations: <code>Mo</code>, <code>Tu</code>, <code>We</code>, <code>Th</code>, <code>Fr</code>, <code>Sa</code>, <code>Su</code>.</li>
    <li>Times are specified using 24:00 time. For example, 3pm is specified as <code>15:00</code>. </li>
    <li>Here is an example: <code>&lt;time itemprop="openingHours" datetime=&quot;Tu,Th 16:00-20:00&quot;&gt;Tuesdays and Thursdays 4-8pm&lt;/time&gt;</code>.</li>
    <li>If a business is open 7 days a week, then it can be specified as <code>&lt;time itemprop=&quot;openingHours&quot; datetime=&quot;Mo-Su&quot;&gt;Monday through Sunday, all day&lt;/time&gt;</code>.</li>
    </ul>
     */
    openingHours,
    /** The opening hours of a certain place. */
    openingHoursSpecification,
    /** The opening hour of the place or service on the given day(s) of the week. */
    opens,
    /** Operating systems supported (Windows 7, OSX 10.6, Android 1.6). */
    operatingSystem,
    /** A sub property of participant. The opponent on this action. */
    opponent,
    /** A sub property of object. The options subject to this action. */
    option,
    /** Date order was placed. */
    orderDate,
    /** The delivery of the parcel related to this order or order item. */
    orderDelivery,
    /** The identifier of the order item. */
    orderItemNumber,
    /** The current status of the order item. */
    orderItemStatus,
    /** The identifier of the transaction. */
    orderNumber,
    /** The number of the item ordered. If the property is not set, assume the quantity is one. */
    orderQuantity,
    /** The current status of the order. */
    orderStatus,
    /** The item ordered. */
    orderedItem,
    /** An organizer of an Event. */
    organizer,
    /** Shipper's address. */
    originAddress,
    /** The date and time of obtaining the product. */
    ownedFrom,
    /** The date and time of giving up ownership on the product. */
    ownedThrough,
    /** Products owned by the organization or person. */
    owns,
    /** The page on which the work ends; for example "138" or "xvi". */
    pageEnd,
    /** The page on which the work starts; for example "135" or "xiii". */
    pageStart,
    /** Any description of pages that is not separated into pageStart and pageEnd; for example, "1-6, 9, 55" or "10-12, 46-49". */
    pagination,
    /** The parent of a question, answer or item in general. */
    parentItem,
    /** A broadcast service to which the broadcast service may belong to such as regional variations of a national channel. */
    parentService,
    /** A parents of the person. */
    parents,
    /** The episode to which this clip belongs. */
    partOfEpisode,
    /** The order is being paid as part of the referenced Invoice. */
    partOfInvoice,
    /** The overall order the items in this delivery were included in. */
    partOfOrder,
    /** The season to which this episode belongs. */
    partOfSeason,
    /** The TV series to which this episode or season belongs. */
    partOfTVSeries,
    /** Number of people the reservation should accommodate. */
    partySize,
    /** The priority status assigned to a passenger for security or boarding (e.g. FastTrack or Priority). */
    passengerPriorityStatus,
    /** The passenger's sequence number as assigned by the airline. */
    passengerSequenceNumber,
    /** Cash, Credit Card, Cryptocurrency, Local Exchange Tradings System, etc. */
    paymentAccepted,
    /** The date that payment is due. */
    paymentDue,
    /** The name of the credit card or other method of payment for the order. */
    paymentMethod,
    /** An identifier for the method of payment used (e.g. the last 4 digits of the credit card). */
    paymentMethodId,
    /** The status of payment; whether the invoice has been paid or not. */
    paymentStatus,
    /** The URL for sending a payment. */
    paymentUrl,
    /** The 10th percentile value. */
    percentile10,
    /** The 25th percentile value. */
    percentile25,
    /** The 75th percentile value. */
    percentile75,
    /** The 90th percentile value. */
    percentile90,
    /** Event that this person is a performer or participant in. */
    performerIn,
    /** The main performer or performers of the event&#x2014;for example, a presenter, musician, or actor. */
    performers,
    /** The type of permission granted the person, organization, or audience. */
    permissionType,
    /** Permission(s) required to run the app (for example, a mobile app may require full internet access or may run only on wifi). */
    permissions,
    /** The target audience for this permit. */
    permitAudience,
    /** Indications regarding the permitted usage of the accommodation. */
    permittedUsage,
    /** Indicates whether pets are allowed to enter the accommodation or lodging business. More detailed information can be put in a text value. */
    petsAllowed,
    /** Photographs of this place. */
    photos,
    /** Where a taxi will pick up a passenger or a rental car can be picked up. */
    pickupLocation,
    /** When a taxi will pickup a passenger or a rental car can be picked up. */
    pickupTime,
    /** Indicates whether this game is multi-player, co-op or single-player.  The game can be marked as multi-player, co-op and single-player at the same time. */
    playMode,
    /** Player type required&#x2014;for example, Flash or Silverlight. */
    playerType,
    /** Number of players on the server. */
    playersOnline,
    /** A polygon is the area enclosed by a point-to-point path for which the starting and ending points are the same. A polygon is expressed as a series of four or more space delimited points where the first and final points are identical. */
    polygon,
    /** The post office box number for PO box addresses. */
    postOfficeBoxNumber,
    /** The postal code. For example, 94043. */
    postalCode,
    /** Indicates a potential Action, which describes an idealized action in which this thing would play an 'object' role. */
    potentialAction,
    /** A pointer from a previous, often discontinued variant of the product to its newer variant. */
    predecessorOf,
    /** The length of time it takes to prepare the items to be used in instructions or a direction, in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 duration format</a>. */
    prepTime,
    /** A link to the ListItem that preceeds the current one. */
    previousItem,
    /** Used in conjunction with eventStatus for rescheduled or cancelled events. This property contains the previously scheduled start date. For rescheduled events, the startDate property should be used for the newly scheduled start date. In the (rare) case of an event that has been postponed and rescheduled multiple times, this field may be repeated. */
    previousStartDate,
    /** The offer price of a product, or of a price component when attached to PriceSpecification and its subtypes.<br/><br/>
    
    Usage guidelines:<br/><br/>
    
    <ul>
    <li>Use the <a class="localLink" href="http://schema.org/priceCurrency">priceCurrency</a> property (with standard formats: <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217 currency format</a> e.g. "USD"; <a href="https://en.wikipedia.org/wiki/List_of_cryptocurrencies">Ticker symbol</a> for cryptocurrencies e.g. "BTC"; well known names for <a href="https://en.wikipedia.org/wiki/Local_exchange_trading_system">Local Exchange Tradings Systems</a> (LETS) and other currency types e.g. "Ithaca HOUR") instead of including <a href="http://en.wikipedia.org/wiki/Dollar_sign#Currencies_that_use_the_dollar_or_peso_sign">ambiguous symbols</a> such as '$' in the value.</li>
    <li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
    <li>Note that both <a href="http://www.w3.org/TR/xhtml-rdfa-primer/#using-the-content-attribute">RDFa</a> and Microdata syntax allow the use of a "content=" attribute for publishing simple machine-readable values alongside more human-friendly formatting.</li>
    <li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
    </ul>
     */
    price,
    /** This property links to all <a class="localLink" href="http://schema.org/UnitPriceSpecification">UnitPriceSpecification</a> nodes that apply in parallel for the <a class="localLink" href="http://schema.org/CompoundPriceSpecification">CompoundPriceSpecification</a> node. */
    priceComponent,
    /** The currency of the price, or a price component when attached to <a class="localLink" href="http://schema.org/PriceSpecification">PriceSpecification</a> and its subtypes.<br/><br/>
    
    Use standard formats: <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217 currency format</a> e.g. "USD"; <a href="https://en.wikipedia.org/wiki/List_of_cryptocurrencies">Ticker symbol</a> for cryptocurrencies e.g. "BTC"; well known names for <a href="https://en.wikipedia.org/wiki/Local_exchange_trading_system">Local Exchange Tradings Systems</a> (LETS) and other currency types e.g. "Ithaca HOUR". */
    priceCurrency,
    /** The price range of the business, for example <code>$$$</code>. */
    priceRange,
    /** One or more detailed price specifications, indicating the unit price and delivery or payment charges. */
    priceSpecification,
    /** A short text or acronym indicating multiple price specifications for the same offer, e.g. SRP for the suggested retail price or INVOICE for the invoice price, mostly used in the car industry. */
    priceType,
    /** The date after which the price is no longer available. */
    priceValidUntil,
    /** Indicates the main image on the page. */
    primaryImageOfPage,
    /** The number of the column in which the NewsArticle appears in the print edition. */
    printColumn,
    /** The edition of the print product in which the NewsArticle appears. */
    printEdition,
    /** If this NewsArticle appears in print, this field indicates the name of the page on which the article is found. Please note that this field is intended for the exact page name (e.g. A5, B18). */
    printPage,
    /** If this NewsArticle appears in print, this field indicates the print section in which the article appeared. */
    printSection,
    /** Estimated processing time for the service using this channel. */
    processingTime,
    /** Processor architecture required to run the application (e.g. IA64). */
    processorRequirements,
    /** The person or organization who produced the work (e.g. music album, movie, tv/radio series etc.). */
    producer,
    /** The tangible thing generated by the service, e.g. a passport, permit, etc. */
    produces,
    /** The product identifier, such as ISBN. For example: <code>meta itemprop="productID" content="isbn:123-456-789"</code>. */
    productID,
    /** The product or service this support contact point is related to (such as product support for a particular product line). This can be a specific product or product line (e.g. "iPhone") or a general category of products or services (e.g. "smartphones"). */
    productSupported,
    /** The production company or studio responsible for the item e.g. series, video game, episode etc. */
    productionCompany,
    /** The date of production of the item, e.g. vehicle. */
    productionDate,
    /** Proficiency needed for this content; expected values: 'Beginner', 'Expert'. */
    proficiencyLevel,
    /** Any membership in a frequent flyer, hotel loyalty program, etc. being applied to the reservation. */
    programMembershipUsed,
    /** The program providing the membership. */
    programName,
    /** The computer programming language. */
    programmingLanguage,
    /** Indicates whether API is managed or unmanaged. */
    programmingModel,
    /** A commonly used identifier for the characteristic represented by the property, e.g. a manufacturer or a standard code for a property. propertyID can be
    (1) a prefixed string, mainly meant to be used with standards for product properties; (2) a site-specific, non-prefixed string (e.g. the primary key of the property or the vendor-specific id of the property), or (3)
    a URL indicating the type of the property, either pointing to an external vocabulary, or a Web resource that describes the property (e.g. a glossary entry).
    Standards bodies should promote a standard prefix for the identifiers of properties from their standards. */
    propertyID,
    /** The number of grams of protein. */
    proteinContent,
    /** Indicates the mobility of a provided service (e.g. 'static', 'dynamic'). */
    providerMobility,
    /** The service provided by this channel. */
    providesService,
    /** A flag to signal that the <a class="localLink" href="http://schema.org/Place">Place</a> is open to public visitors.  If this property is omitted there is no assumed default boolean value */
    publicAccess,
    /** A publication event associated with the item. */
    publication,
    /** A broadcast service associated with the publication event. */
    publishedOn,
    /** The publisher of the creative work. */
    publisher,
    /** The publishingPrinciples property indicates (typically via <a class="localLink" href="http://schema.org/URL">URL</a>) a document describing the editorial principles of an <a class="localLink" href="http://schema.org/Organization">Organization</a> (or individual e.g. a <a class="localLink" href="http://schema.org/Person">Person</a> writing a blog) that relate to their activities as a publisher, e.g. ethics or diversity policies. When applied to a <a class="localLink" href="http://schema.org/CreativeWork">CreativeWork</a> (e.g. <a class="localLink" href="http://schema.org/NewsArticle">NewsArticle</a>) the principles are those of the party primarily responsible for the creation of the <a class="localLink" href="http://schema.org/CreativeWork">CreativeWork</a>.<br/><br/>
    
    While such policies are most typically expressed in natural language, sometimes related information (e.g. indicating a <a class="localLink" href="http://schema.org/funder">funder</a>) can be expressed using schema.org terminology. */
    publishingPrinciples,
    /** The date the item e.g. vehicle was purchased by the current owner. */
    purchaseDate,
    /** A sub property of instrument. The query used on this action. */
    query,
    /** The task that a player-controlled character, or group of characters may complete in order to gain a reward. */
    quest,
    /** A sub property of object. A question. */
    question,
    /** The count of total number of ratings. */
    ratingCount,
    /** The rating for the content.<br/><br/>
    
    Usage guidelines:<br/><br/>
    
    <ul>
    <li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
    <li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
    </ul>
     */
    ratingValue,
    /** Whether or not a property is mutable.  Default is false. Specifying this for a property that also has a value makes it act similar to a "hidden" input in an HTML form. */
    readonlyValue,
    /** A sub property of participant. The real estate agent involved in the action. */
    realEstateAgent,
    /** A sub property of instrument. The recipe/instructions used to perform the action. */
    recipe,
    /** The category of the recipe—for example, appetizer, entree, etc. */
    recipeCategory,
    /** The cuisine of the recipe (for example, French or Ethiopian). */
    recipeCuisine,
    /** A step in making the recipe, in the form of a single item (document, video, etc.) or an ordered list with HowToStep and/or HowToSection items. */
    recipeInstructions,
    /** The quantity produced by the recipe (for example, number of people served, number of servings, etc). */
    recipeYield,
    /** The label that issued the release. */
    recordLabel,
    /** The reference quantity for which a certain price applies, e.g. 1 EUR per 4 kWh of electricity. This property is a replacement for unitOfMeasurement for the advanced cases where the price does not relate to a standard unit. */
    referenceQuantity,
    /** The Order(s) related to this Invoice. One or more Orders may be combined into a single Invoice. */
    referencesOrder,
    /** The regions where the media is allowed. If not specified, then it's assumed to be allowed everywhere. Specify the countries in <a href="http://en.wikipedia.org/wiki/ISO_3166">ISO 3166 format</a>. */
    regionsAllowed,
    /** A link related to this web page, for example to other related web pages. */
    relatedLink,
    /** The most generic familial relation. */
    relatedTo,
    /** The release date of a product or product model. This can be used to distinguish the exact variant of a product. */
    releaseDate,
    /** Description of what changed in this version. */
    releaseNotes,
    /** The place and time the release was issued, expressed as a PublicationEvent. */
    releasedEvent,
    /** The Occupation for the JobPosting. */
    relevantOccupation,
    /** The number of attendee places for an event that remain unallocated. */
    remainingAttendeeCapacity,
    /** A sub property of object. The object that is being replaced. */
    replacee,
    /** A sub property of object. The object that replaces. */
    replacer,
    /** The URL at which a reply may be posted to the specified UserComment. */
    replyToUrl,
    /** The number or other unique designator assigned to a Report by the publishing organization. */
    reportNumber,
    /** Indicates whether this image is representative of the content of the page. */
    representativeOfPage,
    /** Assets required to secure loan or credit repayments. It may take form of third party pledge, goods, financial instruments (cash, securities, etc.) */
    requiredCollateral,
    /** Audiences defined by a person's gender. */
    requiredGender,
    /** Audiences defined by a person's maximum age. */
    requiredMaxAge,
    /** Audiences defined by a person's minimum age. */
    requiredMinAge,
    /** The required quantity of the item(s). */
    requiredQuantity,
    /** Component dependency requirements for application. This includes runtime environments and shared libraries that are not included in the application distribution package, but required to run the application (Examples: DirectX, Java or .NET runtime). */
    requirements,
    /** Indicates if use of the media require a subscription  (either paid or free). Allowed values are <code>true</code> or <code>false</code> (note that an earlier version had 'yes', 'no'). */
    requiresSubscription,
    /** The thing -- flight, event, restaurant,etc. being reserved. */
    reservationFor,
    /** A unique identifier for the reservation. */
    reservationId,
    /** The current status of the reservation. */
    reservationStatus,
    /** A ticket associated with the reservation. */
    reservedTicket,
    /** Responsibilities associated with this role or Occupation. */
    responsibilities,
    /** A sub property of result. The Comment created or sent as a result of this action. */
    resultComment,
    /** A sub property of result. The review that resulted in the performing of the action. */
    resultReview,
    /** This Review or Rating is relevant to this part or facet of the itemReviewed. */
    reviewAspect,
    /** The actual body of the review. */
    reviewBody,
    /** The count of total number of reviews. */
    reviewCount,
    /** The rating given in this review. Note that reviews can themselves be rated. The <code>reviewRating</code> applies to rating given by the review. The <a class="localLink" href="http://schema.org/aggregateRating">aggregateRating</a> property applies to the review itself, as a creative work. */
    reviewRating,
    /** People or organizations that have reviewed the content on this web page for accuracy and/or completeness. */
    reviewedBy,
    /** Review of the item. */
    reviews,
    /** The response (yes, no, maybe) to the RSVP. */
    rsvpResponse,
    /** Runtime platform or script interpreter dependencies (Example - Java v1, Python2.3, .Net Framework 3.0). */
    runtime,
    /** The currency (coded using <a href="http://en.wikipedia.org/wiki/ISO_4217">ISO 4217</a> ) used for the main salary information in this job posting or for this employee. */
    salaryCurrency,
    /** URL of a reference Web page that unambiguously indicates the item's identity. E.g. the URL of the item's Wikipedia page, Wikidata entry, or official website. */
    sameAs,
    /** What type of code sample: full (compile ready) solution, code snippet, inline code, scripts, template. */
    sampleType,
    /** The number of grams of saturated fat. */
    saturatedFatContent,
    /** The date the invoice is scheduled to be paid. */
    scheduledPaymentDate,
    /** The time the object is scheduled to. */
    scheduledTime,
    /** Indicates (by URL or string) a particular version of a schema used in some CreativeWork. For example, a document could declare a schemaVersion using an URL such as http://schema.org/version/2.0/ if precise indication of schema version was required by some application. */
    schemaVersion,
    /** The number of screens in the movie theater. */
    screenCount,
    /** A link to a screenshot image of the app. */
    screenshot,
    /** Position of the season within an ordered group of seasons. */
    seasonNumber,
    /** A season in a media series. */
    seasons,
    /** The location of the reserved seat (e.g., 27). */
    seatNumber,
    /** The row location of the reserved seat (e.g., B). */
    seatRow,
    /** The section location of the reserved seat (e.g. Orchestra). */
    seatSection,
    /** The type/class of the seat. */
    seatingType,
    /** The type of security screening the passenger is subject to. */
    securityScreening,
    /** A pointer to products or services sought by the organization or person (demand). */
    seeks,
    /** A sub property of participant. The participant who is at the sending end of the action. */
    sender,
    /** Status of a game server. */
    serverStatus,
    /** The cuisine of the restaurant. */
    servesCuisine,
    /** The audience eligible for this service. */
    serviceAudience,
    /** The location (e.g. civic structure, local business, etc.) where a person can go to access the service. */
    serviceLocation,
    /** The operating organization, if different from the provider.  This enables the representation of services that are provided by an organization, but operated by another organization like a subcontractor. */
    serviceOperator,
    /** The phone number to use to access the service. */
    servicePhone,
    /** The address for accessing the service by mail. */
    servicePostalAddress,
    /** The number to access the service by text message. */
    serviceSmsNumber,
    /** The type of service being offered, e.g. veterans' benefits, emergency relief, etc. */
    serviceType,
    /** The website to access the service. */
    serviceUrl,
    /** The serving size, in terms of the number of volume or mass. */
    servingSize,
    /** A CreativeWork such as an image, video, or audio clip shared as part of this posting. */
    sharedContent,
    /** A sibling of the person. */
    siblings,
    /** The most significant URLs on the page. Typically, these are the non-navigation links that are clicked on the most. */
    significantLinks,
    /** Skills required to fulfill this role or in this Occupation. */
    skills,
    /** The Stock Keeping Unit (SKU), i.e. a merchant-specific identifier for a product or service, or the product to which the offer refers. */
    sku,
    /** A slogan or motto associated with the item. */
    slogan,
    /** Indicates whether it is allowed to smoke in the place, e.g. in the restaurant, hotel or hotel room. */
    smokingAllowed,
    /** The number of milligrams of sodium. */
    sodiumContent,
    /** Additional content for a software application. */
    softwareAddOn,
    /** Software application help. */
    softwareHelp,
    /** Version of the software instance. */
    softwareVersion,
    /** The Organization on whose behalf the creator was working. */
    sourceOrganization,
    /** The "spatial" property can be used in cases when more specific properties
    (e.g. <a class="localLink" href="http://schema.org/locationCreated">locationCreated</a>, <a class="localLink" href="http://schema.org/spatialCoverage">spatialCoverage</a>, <a class="localLink" href="http://schema.org/contentLocation">contentLocation</a>) are not known to be appropriate. */
    spatial,
    /** The spatialCoverage of a CreativeWork indicates the place(s) which are the focus of the content. It is a subproperty of
          contentLocation intended primarily for more technical and detailed materials. For example with a Dataset, it indicates
          areas that the dataset describes: a dataset of New York weather would have spatialCoverage which was the place: the state of New York. */
    spatialCoverage,
    /** Indicates sections of a Web page that are particularly 'speakable' in the sense of being highlighted as being especially appropriate for text-to-speech conversion. Other sections of a page may also be usefully spoken in particular circumstances; the 'speakable' property serves to indicate the parts most likely to be generally useful for speech.<br/><br/>
    
    The <em>speakable</em> property can be repeated an arbitrary number of times, with three kinds of possible 'content-locator' values:<br/><br/>
    
    1.) <em>id-value</em> URL references - uses <em>id-value</em> of an element in the page being annotated. The simplest use of <em>speakable</em> has (potentially relative) URL values, referencing identified sections of the document concerned.<br/><br/>
    
    2.) CSS Selectors - addresses content in the annotated page, eg. via class attribute. Use the <a class="localLink" href="http://schema.org/cssSelector">cssSelector</a> property.<br/><br/>
    
    3.)  XPaths - addresses content via XPaths (assuming an XML view of the content). Use the <a class="localLink" href="http://schema.org/xpath">xpath</a> property.<br/><br/>
    
    For more sophisticated markup of speakable sections beyond simple ID references, either CSS selectors or XPath expressions to pick out document section(s) as speakable. For this
    we define a supporting type, <a class="localLink" href="http://schema.org/SpeakableSpecification">SpeakableSpecification</a>  which is defined to be a possible value of the <em>speakable</em> property. */
    speakable,
    /** Any special commitments associated with this job posting. Valid entries include VeteranCommit, MilitarySpouseCommit, etc. */
    specialCommitments,
    /** The special opening hours of a certain place.<br/><br/>
    
    Use this to explicitly override general opening hours brought in scope by <a class="localLink" href="http://schema.org/openingHoursSpecification">openingHoursSpecification</a> or <a class="localLink" href="http://schema.org/openingHours">openingHours</a>. */
    specialOpeningHoursSpecification,
    /** One of the domain specialities to which this web page's content applies. */
    specialty,
    /** A type of sport (e.g. Baseball). */
    sport,
    /** A sub property of location. The sports activity location where this action occurred. */
    sportsActivityLocation,
    /** A sub property of location. The sports event where this action occurred. */
    sportsEvent,
    /** A sub property of participant. The sports team that participated on this action. */
    sportsTeam,
    /** The person's spouse. */
    spouse,
    /** An official rating for a lodging business or food establishment, e.g. from national associations or standards bodies. Use the author property to indicate the rating organization, e.g. as an Organization with name such as (e.g. HOTREC, DEHOGA, WHR, or Hotelstars). */
    starRating,
    /** The start date and time of the item (in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 date format</a>). */
    startDate,
    /** The startTime of something. For a reserved event or service (e.g. FoodEstablishmentReservation), the time that it is expected to start. For actions that span a period of time, when the action was performed. e.g. John wrote a book from <em>January</em> to December. For media, including audio and video, it's the time offset of the start of a clip within a larger file.<br/><br/>
    
    Note that Event uses startDate/endDate instead of startTime/endTime, even when describing dates with times. This situation may be clarified in future revisions. */
    startTime,
    /** The position of the steering wheel or similar device (mostly for cars). */
    steeringPosition,
    /** The stepValue attribute indicates the granularity that is expected (and required) of the value in a PropertyValueSpecification. */
    stepValue,
    /** A single step item (as HowToStep, text, document, video, etc.) or a HowToSection (originally misnamed 'steps'; 'step' is preferred). */
    steps,
    /** Storage requirements (free space required). */
    storageRequirements,
    /** The street address. For example, 1600 Amphitheatre Pkwy. */
    streetAddress,
    /** Events that are a part of this event. For example, a conference event includes many presentations, each subEvents of the conference. */
    subEvents,
    /** The individual reservations included in the package. Typically a repeated property. */
    subReservation,
    /** Languages in which subtitles/captions are available, in <a href="http://tools.ietf.org/html/bcp47">IETF BCP 47 standard format</a>. */
    subtitleLanguage,
    /** A pointer from a newer variant of a product  to its previous, often discontinued predecessor. */
    successorOf,
    /** The number of grams of sugar. */
    sugarContent,
    /** The gender of the person or audience. */
    suggestedGender,
    /** Maximal age recommended for viewing content. */
    suggestedMaxAge,
    /** Minimal age recommended for viewing content. */
    suggestedMinAge,
    /** Indicates a dietary restriction or guideline for which this recipe or menu item is suitable, e.g. diabetic, halal etc. */
    suitableForDiet,
    /** Supporting data for a SoftwareApplication. */
    supportingData,
    /** A material used as a surface in some artwork, e.g. Canvas, Paper, Wood, Board, etc. */
    surface,
    /** Indicates a target EntryPoint for an Action. */
    target,
    /** The description of a node in an established educational framework. */
    targetDescription,
    /** The name of a node in an established educational framework. */
    targetName,
    /** Type of app development: phone, Metro style, desktop, XBox, etc. */
    targetPlatform,
    /** Target Operating System / Product to which the code applies.  If applies to several versions, just the product name can be used. */
    targetProduct,
    /** The URL of a node in an established educational framework. */
    targetUrl,
    /** The Tax / Fiscal ID of the organization or person, e.g. the TIN in the US or the CIF/NIF in Spain. */
    taxID,
    /** The telephone number. */
    telephone,
    /** The "temporal" property can be used in cases where more specific properties
    (e.g. <a class="localLink" href="http://schema.org/temporalCoverage">temporalCoverage</a>, <a class="localLink" href="http://schema.org/dateCreated">dateCreated</a>, <a class="localLink" href="http://schema.org/dateModified">dateModified</a>, <a class="localLink" href="http://schema.org/datePublished">datePublished</a>) are not known to be appropriate. */
    temporal,
    /** The textual content of this CreativeWork. */
    text,
    /** Thumbnail image for an image or video. */
    thumbnail,
    /** A thumbnail image relevant to the Thing. */
    thumbnailUrl,
    /** The exchange traded instrument associated with a Corporation object. The tickerSymbol is expressed as an exchange and an instrument name separated by a space character. For the exchange component of the tickerSymbol attribute, we recommend using the controlled vocabulary of Market Identifier Codes (MIC) specified in ISO15022. */
    tickerSymbol,
    /** The unique identifier for the ticket. */
    ticketNumber,
    /** Reference to an asset (e.g., Barcode, QR code image or PDF) usable for entrance. */
    ticketToken,
    /** The seat associated with the ticket. */
    ticketedSeat,
    /** Approximate or typical time it takes to work with or through this learning resource for the typical intended target audience, e.g. 'PT30M', 'PT1H25M'. */
    timeRequired,
    /** The title of the job. */
    title,
    /** A sub property of location. The final location of the object or the agent after the action. */
    toLocation,
    /** A sub property of recipient. The recipient who was directly sent the message. */
    toRecipient,
    /** A sub property of instrument. An object used (but not consumed) when performing instructions or a direction. */
    tool,
    /** The total amount due. */
    totalPaymentDue,
    /** The total price for the reservation or ticket, including applicable taxes, shipping, etc.<br/><br/>
    
    Usage guidelines:<br/><br/>
    
    <ul>
    <li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
    <li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
    </ul>
     */
    totalPrice,
    /** The total time required to perform instructions or a direction (including time to prepare the supplies), in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 duration format</a>. */
    totalTime,
    /** Attraction suitable for type(s) of tourist. eg. Children, visitors from a particular country, etc. */
    touristType,
    /** Shipper tracking number. */
    trackingNumber,
    /** Tracking url for the parcel delivery. */
    trackingUrl,
    /** A music recording (track)&#x2014;usually a single song. */
    tracks,
    /** The trailer of a movie or tv/radio series, season, episode, etc. */
    trailer,
    /** The name of the train (e.g. The Orient Express). */
    trainName,
    /** The unique identifier for the train. */
    trainNumber,
    /** The number of grams of trans fat. */
    transFatContent,
    /** If this MediaObject is an AudioObject or VideoObject, the transcript of that object. */
    transcript,
    /** Organization or person who adapts a creative work to different languages, regional differences and technical requirements of a target market, or that translates during some event. */
    translator,
    /** The type of bed to which the BedDetail refers, i.e. the type of bed available in the quantity indicated by quantity. */
    typeOfBed,
    /** The product that this structured value is referring to. */
    typeOfGood,
    /** The typical expected age range, e.g. '7-9', '11-'. */
    typicalAgeRange,
    /** The person or organization the reservation or ticket is for. */
    underName,
    /** The unit of measurement given using the UN/CEFACT Common Code (3 characters) or a URL. Other codes than the UN/CEFACT Common Code may be used with a prefix followed by a colon. */
    unitCode,
    /** A string or text indicating the unit of measurement. Useful if you cannot provide a standard unit code for
    <a href='unitCode'>unitCode</a>. */
    unitText,
    /** The number of grams of unsaturated fat. */
    unsaturatedFatContent,
    /** Date when this media object was uploaded to this site. */
    uploadDate,
    /** The number of upvotes this question, answer or comment has received from the community. */
    upvoteCount,
    /** URL of the item. */
    url,
    /** An url template (RFC6570) that will be used to construct the target of the execution of the action. */
    urlTemplate,
    /** The number of interactions for the CreativeWork using the WebSite or SoftwareApplication. */
    userInteractionCount,
    /** The duration of validity of a permit or similar thing. */
    validFor,
    /** The date when the item becomes valid. */
    validFrom,
    /** The geographic area where a permit or similar thing is valid. */
    validIn,
    /** The date after when the item is not valid. For example the end of an offer, salary period, or a period of opening hours. */
    validThrough,
    /** The date when the item is no longer valid. */
    validUntil,
    /** The value of the quantitative value or property value node.<br/><br/>
    
    <ul>
    <li>For <a class="localLink" href="http://schema.org/QuantitativeValue">QuantitativeValue</a> and <a class="localLink" href="http://schema.org/MonetaryAmount">MonetaryAmount</a>, the recommended type for values is 'Number'.</li>
    <li>For <a class="localLink" href="http://schema.org/PropertyValue">PropertyValue</a>, it can be 'Text;', 'Number', 'Boolean', or 'StructuredValue'.</li>
    <li>Use values from 0123456789 (Unicode 'DIGIT ZERO' (U+0030) to 'DIGIT NINE' (U+0039)) rather than superficially similiar Unicode symbols.</li>
    <li>Use '.' (Unicode 'FULL STOP' (U+002E)) rather than ',' to indicate a decimal point. Avoid using these symbols as a readability separator.</li>
    </ul>
     */
    value,
    /** Specifies whether the applicable value-added tax (VAT) is included in the price specification or not. */
    valueAddedTaxIncluded,
    /** Specifies the allowed range for number of characters in a literal value. */
    valueMaxLength,
    /** Specifies the minimum allowed range for number of characters in a literal value. */
    valueMinLength,
    /** Indicates the name of the PropertyValueSpecification to be used in URL templates and form encoding in a manner analogous to HTML's input@name. */
    valueName,
    /** Specifies a regular expression for testing literal values according to the HTML spec. */
    valuePattern,
    /** A pointer to a secondary value that provides additional information on the original value, e.g. a reference temperature. */
    valueReference,
    /** Whether the property must be filled in to complete the action.  Default is false. */
    valueRequired,
    /** The Value-added Tax ID of the organization or person. */
    vatID,
    /** A short text indicating the configuration of the vehicle, e.g. '5dr hatchback ST 2.5 MT 225 hp' or 'limited edition'. */
    vehicleConfiguration,
    /** Information about the engine or engines of the vehicle. */
    vehicleEngine,
    /** The Vehicle Identification Number (VIN) is a unique serial number used by the automotive industry to identify individual motor vehicles. */
    vehicleIdentificationNumber,
    /** The color or color combination of the interior of the vehicle. */
    vehicleInteriorColor,
    /** The type or material of the interior of the vehicle (e.g. synthetic fabric, leather, wood, etc.). While most interior types are characterized by the material used, an interior type can also be based on vehicle usage or target audience. */
    vehicleInteriorType,
    /** The release date of a vehicle model (often used to differentiate versions of the same make and model). */
    vehicleModelDate,
    /** The number of passengers that can be seated in the vehicle, both in terms of the physical space available, and in terms of limitations set by law.<br/><br/>
    
    Typical unit code(s): C62 for persons. */
    vehicleSeatingCapacity,
    /** The type of component used for transmitting the power from a rotating power source to the wheels or other relevant component(s) ("gearbox" for cars). */
    vehicleTransmission,
    /** 'vendor' is an earlier term for 'seller'. */
    vendor,
    /** The version of the CreativeWork embodied by a specified resource. */
    version,
    /** An embedded video object. */
    video,
    /** The type of screening or video broadcast used (e.g. IMAX, 3D, SD, HD, etc.). */
    videoFormat,
    /** The frame size of the video. */
    videoFrameSize,
    /** The quality of the video. */
    videoQuality,
    /** Identifies the volume of publication or multi-part work; for example, "iii" or "2". */
    volumeNumber,
    /** The warranty promise(s) included in the offer. */
    warrantyPromise,
    /** The scope of the warranty promise. */
    warrantyScope,
    /** The time when a passenger can check into the flight online. */
    webCheckinTime,
    /** The weight of the product or person. */
    weight,
    /** The width of the item. */
    width,
    /** A sub property of participant. The winner of the action. */
    winner,
    /** The number of words in the text of the Article. */
    wordCount,
    /** The typical working hours for this job (e.g. 1st shift, night shift, 8am-5pm). */
    workHours,
    /** A contact location for a person's place of work. */
    workLocation,
    /** A work performed in some event, for example a play performed in a TheaterEvent. */
    workPerformed,
    /** The movie presented during this event. */
    workPresented,
    /** Organizations that the person works for. */
    worksFor,
    /** The lowest value allowed in this rating system. If worstRating is omitted, 1 is assumed. */
    worstRating,
    /** An XPath, e.g. of a <a class="localLink" href="http://schema.org/SpeakableSpecification">SpeakableSpecification</a> or <a class="localLink" href="http://schema.org/WebPageElement">WebPageElement</a>. In the latter case, multiple matches within a page can constitute a single conceptual "Web page element". */
    xpath,
    /** The size of the business in annual revenue. */
    yearlyRevenue,
    /** The age of the business. */
    yearsInOperation,
    /** An application that can complete the request. */
    actionApplication,
    /** A sub property of object. The options subject to this action. */
    actionOption,
    /** An actor, e.g. in tv, radio, movie, video games etc., or in an event. Actors can be associated with individual items or with a series, episode, clip. */
    actor,
    /** A music album. */
    album,
    /** A release of this album. */
    albumRelease,
    /** Alumni of an organization. */
    alumni,
    /** An organization that the person is an alumni of. */
    alumniOf,
    /** The supporting materials for the artwork, e.g. Canvas, Paper, Wood, Board, etc. */
    artworkSurface,
    /** A person or organization attending the event. */
    attendee,
    /** An intended audience, i.e. a group for whom something was created. */
    audience,
    /** Device required to run the application. Used in cases where a specific make/model is required to run the application. */
    availableOnDevice,
    /** An award won by or for this item. */
    award,
    /** A posting that is part of this blog. */
    blogPost,
    /** An entity that arranges for an exchange between a buyer and a seller.  In most cases a broker never acquires or releases ownership of a product or service involved in an exchange.  If it is not clear whether an entity is a broker, seller, or buyer, the latter two terms are preferred. */
    broker,
    /** What type of code sample: full (compile ready) solution, code snippet, inline code, scripts, template. */
    codeSampleType,
    /** A colleague of the person. */
    colleague,
    /** A contact point for a person or organization. */
    contactPoint,
    /** The basic containment relation between a place and another that it contains. */
    containsPlace,
    /** A season that is part of the media series. */
    containsSeason,
    /** The location depicted or described in the content. For example, the location in a photograph or painting. */
    contentLocation,
    /** A dataset contained in this catalog. */
    dataset,
    /** A description of the item. */
    description,
    /** A director of e.g. tv, radio, movie, video gaming etc. content, or of an event. Directors can be associated with individual items or with a series, episode, clip. */
    director,
    /** The duration of the item (movie, audio recording, event, etc.) in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 date format</a>. */
    duration,
    /** Someone working for this organization. */
    employee,
    /** The CreativeWork encoded by this media object. */
    encodesCreativeWork,
    /** Media type typically expressed using a MIME format (see <a href="http://www.iana.org/assignments/media-types/media-types.xhtml">IANA site</a> and <a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types">MDN reference</a>) e.g. application/zip for a SoftwareApplication binary, audio/mpeg for .mp3 etc.).<br/><br/>
    
    In cases where a <a class="localLink" href="http://schema.org/CreativeWork">CreativeWork</a> has several media type representations, <a class="localLink" href="http://schema.org/encoding">encoding</a> can be used to indicate each <a class="localLink" href="http://schema.org/MediaObject">MediaObject</a> alongside particular <a class="localLink" href="http://schema.org/encodingFormat">encodingFormat</a> information.<br/><br/>
    
    Unregistered or niche encoding and file formats can be indicated instead via the most appropriate URL, e.g. defining Web page or a Wikipedia/Wikidata entry. */
    encodingFormat,
    /** An episode of a tv, radio or game media within a series or season. */
    episode,
    /** Upcoming or past event associated with this place, organization, or action. */
    event,
    /** A creative work that this work is an example/instance/realization/derivation of. */
    exampleOfWork,
    /** Library file name e.g., mscorlib.dll, system.web.dll. */
    executableLibraryName,
    /** A sub property of location. The course where this action was taken. */
    exerciseCourse,
    /** A person who founded this organization. */
    founder,
    /** Video game which is played on this server. */
    game,
    /** The server on which  it is possible to play the game. */
    gameServer,
    /** A broadcast channel of a broadcast service. */
    hasBroadcastChannel,
    /** Either the actual menu as a structured representation, as text, or a URL of the menu. */
    hasMenu,
    /** The language of the content or performance or used in an action. Please use one of the language codes from the <a href="http://tools.ietf.org/html/bcp47">IETF BCP 47 standard</a>. See also <a class="localLink" href="http://schema.org/availableLanguage">availableLanguage</a>. */
    inLanguage,
    /** Description of bonus and commission compensation aspects of the job. */
    incentiveCompensation,
    /** The number of interactions for the CreativeWork using the WebSite or SoftwareApplication. The most specific child type of InteractionCounter should be used. */
    interactionStatistic,
    /** A flag to signal that the item, event, or place is accessible for free. */
    isAccessibleForFree,
    /** A resource from which this work is derived or from which it is a modification or adaption. */
    isBasedOn,
    /** Description of benefits associated with the job. */
    jobBenefits,
    /** Indicates the primary entity described in some page or other CreativeWork. */
    mainEntity,
    /** Indicates a page (or other CreativeWork) for which this thing is the main entity being described. See <a href="/docs/datamodel.html#mainEntityBackground">background notes</a> for details. */
    mainEntityOfPage,
    /** A pointer to products or services offered by the organization or person. */
    makesOffer,
    /** A pointer to the organization or person making the offer. */
    offeredBy,
    /** A parent of this person. */
    parent,
    /** The series to which this episode or season belongs. */
    partOfSeries,
    /** The date that payment is due. */
    paymentDueDate,
    /** The length of time it takes to perform instructions or a direction (not including time to prepare the supplies), in <a href="http://en.wikipedia.org/wiki/ISO_8601">ISO 8601 duration format</a>. */
    performTime,
    /** A performer at the event&#x2014;for example, a presenter, musician, musical group or actor. */
    performer,
    /** A photograph of this place. */
    photo,
    /** The service provider, service operator, or service performer; the goods producer. Another party (a seller) may offer those services or goods on behalf of the provider. A provider may also serve as the seller. */
    provider,
    /** The BroadcastService offered on this channel. */
    providesBroadcastService,
    /** A single ingredient used in the recipe, e.g. sugar, flour or garlic. */
    recipeIngredient,
    /** An audio recording of the work. */
    recordedAs,
    /** The Event where the CreativeWork was recorded. The CreativeWork may capture all or part of the event. */
    recordedAt,
    /** The CreativeWork that captured all or part of this Event. */
    recordedIn,
    /** The composition this track is a recording of. */
    recordingOf,
    /** The album this is a release of. */
    releaseOf,
    /** A review of the item. */
    review,
    /** A role played, performed or filled by a person or organization. For example, the team of creators for a comic book might fill the roles named 'inker', 'penciller', and 'letterer'; or an athlete in a SportsTeam might play in the position named 'Quarterback'. */
    roleName,
    /** Runtime platform or script interpreter dependencies (Example - Java v1, Python2.3, .Net Framework 3.0). */
    runtimePlatform,
    /** A season in a media series. */
    season,
    /** The serial number or any alphanumeric identifier of a particular product. When attached to an offer, it is a shortcut for the serial number of the product included in the offer. */
    serialNumber,
    /** The geographic area where the service is provided. */
    serviceArea,
    /** The tangible thing generated by the service, e.g. a passport, permit, etc. */
    serviceOutput,
    /** A sibling of the person. */
    sibling,
    /** One of the more significant URLs on the page. Typically, these are the non-navigation links that are clicked on the most. */
    significantLink,
    /** Component dependency requirements for application. This includes runtime environments and shared libraries that are not included in the application distribution package, but required to run the application (Examples: DirectX, Java or .NET runtime). */
    softwareRequirements,
    /** A person or organization that supports a thing through a pledge, promise, or financial contribution. e.g. a sponsor of a Medical Study or a corporate sponsor of an event. */
    sponsor,
    /** A relationship between two organizations where the first includes the second, e.g., as a subsidiary. See also: the more specific 'department' property. */
    subOrganization,
    /** A CreativeWork or Event about this Thing. */
    subjectOf,
    /** An answer (possibly one of several, possibly incorrect) to a Question, e.g. on a Question/Answer site. */
    suggestedAnswer,
    /** An event that this event is a part of. For example, a collection of individual music performances might each have a music festival as their superEvent. */
    superEvent,
    /** A sub property of object. The collection target of the action. */
    targetCollection,
    /** The temporalCoverage of a CreativeWork indicates the period that the content applies to, i.e. that it describes, either as a DateTime or as a textual string indicating a time period in <a href="https://en.wikipedia.org/wiki/ISO_8601#Time_intervals">ISO 8601 time interval format</a>. In
          the case of a Dataset it will typically indicate the relevant time period in a precise notation (e.g. for a 2011 census dataset, the year 2011 would be written "2011/2012"). Other forms of content e.g. ScholarlyArticle, Book, TVSeries or TVEpisode may indicate their temporalCoverage in broader terms - textually or via well-known URL.
          Written works such as books may sometimes have precise temporal coverage too, e.g. a work set in 1939 - 1945 can be indicated in ISO 8601 interval format format via "1939/1945".<br/><br/>
    
    Open-ended date ranges can be written with ".." in place of the end date. For example, "2015-11/.." indicates a range beginning in November 2015 and with no specified final date. This is tentative and might be updated in future when ISO 8601 is officially updated. */
    temporalCoverage,
    /** A music recording (track)&#x2014;usually a single song. If an ItemList is given, the list should contain items of type MusicRecording. */
    track,
    /** The warranty promise(s) included in the offer. */
    warranty,
    /** Example/instance/realization/derivation of the concept of this creative work. eg. The paperback edition, first edition, or eBook. */
    workExample,
    /** The quantity that results by performing instructions. For example, a paper airplane, 10 personalized candles. */
    yield: schemayield,
    /** The subject matter of the content. */
    about,
    /** A competitor in a sports event. */
    competitor,
    /** The basic containment relation between a place and one that contains it. */
    containedInPlace,
    /** A media object that encodes this CreativeWork. This property is a synonym for associatedMedia. */
    encoding,
    /** A URL to a map of the place. */
    hasMap,
    /** An image of the item. This can be a <a class="localLink" href="http://schema.org/URL">URL</a> or a fully described <a class="localLink" href="http://schema.org/ImageObject">ImageObject</a>. */
    image,
    /** A material that something is made from, e.g. leather, wool, cotton, paper. */
    material,
    /** An Organization (or ProgramMembership) to which this Person or Organization belongs. */
    memberOf,
    /** The larger organization that this organization is a <a class="localLink" href="http://schema.org/subOrganization">subOrganization</a> of, if any. */
    parentOrganization,
    /** The result produced in the action. e.g. John wrote <em>a book</em>. */
    result,
    /** An entity which offers (sells / leases / lends / loans) the services / goods.  A seller may also be a provider. */
    seller,
    /** A single step item (as HowToStep, text, document, video, etc.) or a HowToSection. */
    step,
    /** An Event that is part of this event. For example, a conference event includes many presentations, each of which is a subEvent of the conference. */
    subEvent,
    /** A sub-property of instrument. A supply consumed when performing instructions or a direction. */
    supply,
    /** A work featured in some event, e.g. exhibited in an ExhibitionEvent.
           Specific subproperties are available for workPerformed (e.g. a play), or a workPresented (a Movie at a ScreeningEvent). */
    workFeatured,
    /** The geographic area where a service or offered item is provided. */
    areaServed,
    /** A data catalog which contains this dataset. */
    includedInDataCatalog,
    /** A member of an Organization or a ProgramMembership. Organizations can be members of organizations; ProgramMembership is typically for individuals. */
    member,
    /** A sub property of participant. The participant who is at the receiving end of the action. */
    recipient,
    /** Indicates an item or CreativeWork that is part of this item, or CreativeWork (in some sense). */
    hasPart,
    /** Indicates an item or CreativeWork that this item, or CreativeWork (in some sense), is part of. */
    isPartOf,
    /** The position of an item in a series or sequence of items. */
    position,
    /** The object that helped the agent perform the action. e.g. John wrote a book with <em>a pen</em>. */
    instrument,
    /** The object upon which the action is carried out, whose state is kept intact or changed. Also known as the semantic roles patient, affected or undergoer (which change their state) or theme (which doesn't). e.g. John read <em>a book</em>. */
    object,
    /** The location of for example where the event is happening, an organization is located, or where an action takes place. */
    location,
    /** Other co-agents that participated in the action indirectly. e.g. John wrote a book with <em>Steve</em>. */
    participant,
    /** The identifier property represents any kind of identifier for any kind of <a class="localLink" href="http://schema.org/Thing">Thing</a>, such as ISBNs, GTIN codes, UUIDs etc. Schema.org provides dedicated properties for representing many of these, either as textual strings or as URL (URI) links. See <a href="/docs/datamodel.html#identifierBg">background notes</a> for more details. */
    identifier,
    /** An in-progress action (e.g, while watching the movie, or driving to a location). */
    ActiveActionStatus,
    /** AlbumRelease. */
    AlbumRelease,
    /** All-wheel Drive is a transmission layout where the engine drives all four wheels. */
    AllWheelDriveConfiguration,
    /** Book format: Audiobook. This is an enumerated value for use with the bookFormat property. There is also a type 'Audiobook' in the bib extension which includes Audiobook specific properties. */
    AudiobookFormat,
    /** BroadcastRelease. */
    BroadcastRelease,
    /** CDFormat. */
    CDFormat,
    /** CassetteFormat. */
    CassetteFormat,
    /** Play mode: CoOp. Co-operative games, where you play on the same team with friends. */
    CoOp,
    /** Permission to add comments to the document. */
    CommentPermission,
    /** CompilationAlbum. */
    CompilationAlbum,
    /** An action that has already taken place. */
    CompletedActionStatus,
    /** DJMixAlbum. */
    DJMixAlbum,
    /** DVDFormat. */
    DVDFormat,
    /** Indicates that the item is damaged. */
    DamagedCondition,
    /** DemoAlbum. */
    DemoAlbum,
    /** A diet appropriate for people with diabetes. */
    DiabeticDiet,
    /** DigitalAudioTapeFormat. */
    DigitalAudioTapeFormat,
    /** DigitalFormat. */
    DigitalFormat,
    /** Indicates that the item has been discontinued. */
    Discontinued,
    /** Book format: Ebook. */
    EBook,
    /** EPRelease. */
    EPRelease,
    /** The event has been cancelled. If the event has multiple startDate values, all are assumed to be cancelled. Either startDate or previousStartDate may be used to specify the event's cancelled date(s). */
    EventCancelled,
    /** The event has been postponed and no new date has been set. The event's previousStartDate should be set. */
    EventPostponed,
    /** The event has been rescheduled. The event's previousStartDate should be set to the old date and the startDate should be set to the event's new date. (If the event has been rescheduled multiple times, the previousStartDate property may be repeated). */
    EventRescheduled,
    /** The event is taking place or has taken place on the startDate as scheduled. Use of this value is optional, as it is assumed by default. */
    EventScheduled,
    /** An action that failed to complete. The action's error property and the HTTP return code contain more information about the failure. */
    FailedActionStatus,
    /** The boolean value false. */
    False,
    /** The female gender. */
    Female,
    /** Four-wheel drive is a transmission layout where the engine primarily drives two wheels with a part-time four-wheel drive capability. */
    FourWheelDriveConfiguration,
    /** The day of the week between Thursday and Saturday. */
    Friday,
    /** Front-wheel drive is a transmission layout where the engine drives the front wheels. */
    FrontWheelDriveConfiguration,
    /** A diet exclusive of gluten. */
    GlutenFreeDiet,
    /** The airline boards by groups based on check-in time, priority, etc. */
    GroupBoardingPolicy,
    /** A diet conforming to Islamic dietary practices. */
    HalalDiet,
    /** Book format: Hardcover. */
    Hardcover,
    /** Uses devices to support users with hearing impairments. */
    HearingImpairedSupported,
    /** A diet conforming to Hindu dietary practices, in particular, beef-free. */
    HinduDiet,
    /** Indicates that the item is in stock. */
    InStock,
    /** Indicates that the item is available only at physical locations. */
    InStoreOnly,
    /** An ItemList ordered with lower values listed first. */
    ItemListOrderAscending,
    /** An ItemList ordered with higher values listed first. */
    ItemListOrderDescending,
    /** An ItemList ordered with no explicit order. */
    ItemListUnordered,
    /** A diet conforming to Jewish dietary practices. */
    KosherDiet,
    /** LaserDiscFormat. */
    LaserDiscFormat,
    /** The steering position is on the left side of the vehicle (viewed from the main direction of driving). */
    LeftHandDriving,
    /** Indicates that the item has limited availability. */
    LimitedAvailability,
    /** LiveAlbum. */
    LiveAlbum,
    /** A diet focused on reduced calorie intake. */
    LowCalorieDiet,
    /** A diet focused on reduced fat and cholesterol intake. */
    LowFatDiet,
    /** A diet appropriate for people with lactose intolerance. */
    LowLactoseDiet,
    /** A diet focused on reduced sodium intake. */
    LowSaltDiet,
    /** The male gender. */
    Male,
    /** MixtapeAlbum. */
    MixtapeAlbum,
    /** The day of the week between Sunday and Tuesday. */
    Monday,
    /** Play mode: MultiPlayer. Requiring or allowing multiple human players to play simultaneously. */
    MultiPlayer,
    /** Indicates that the item is new. */
    NewCondition,
    /** Game server status: OfflinePermanently. Server is offline and not available. */
    OfflinePermanently,
    /** Game server status: OfflineTemporarily. Server is offline now but it can be online soon. */
    OfflineTemporarily,
    /** A DeliveryMethod in which an item is collected on site, e.g. in a store or at a box office. */
    OnSitePickup,
    /** Game server status: Online. Server is available. */
    Online,
    /** Game server status: OnlineFull. Server is online but unavailable. The maximum number of players has reached. */
    OnlineFull,
    /** Indicates that the item is available only online. */
    OnlineOnly,
    /** OrderStatus representing cancellation of an order. */
    OrderCancelled,
    /** OrderStatus representing successful delivery of an order. */
    OrderDelivered,
    /** OrderStatus representing that an order is in transit. */
    OrderInTransit,
    /** OrderStatus representing that payment is due on an order. */
    OrderPaymentDue,
    /** OrderStatus representing availability of an order for pickup. */
    OrderPickupAvailable,
    /** OrderStatus representing that there is a problem with the order. */
    OrderProblem,
    /** OrderStatus representing that an order is being processed. */
    OrderProcessing,
    /** OrderStatus representing that an order has been returned. */
    OrderReturned,
    /** Indicates that the item is out of stock. */
    OutOfStock,
    /** Book format: Paperback. */
    Paperback,
    /** A parking map. */
    ParkingMap,
    /** An automatic payment system is in place and will be used. */
    PaymentAutomaticallyApplied,
    /** The payment has been received and processed. */
    PaymentComplete,
    /** The payee received the payment, but it was declined for some reason. */
    PaymentDeclined,
    /** The payment is due, but still within an acceptable time to be received. */
    PaymentDue,
    /** The payment is due and considered late. */
    PaymentPastDue,
    /** A description of an action that is supported. */
    PotentialActionStatus,
    /** Indicates that the item is available for pre-order, but will be delivered when generally available. */
    PreOrder,
    /** Indicates that the item is available for ordering and delivery before general availability. */
    PreSale,
    /** This stands for any day that is a public holiday; it is a placeholder for all official public holidays in some particular location. While not technically a "day of the week", it can be used with <a class="localLink" href="http://schema.org/OpeningHoursSpecification">OpeningHoursSpecification</a>. In the context of an opening hours specification it can be used to indicate opening hours on public holidays, overriding general opening hours for the day of the week on which a public holiday occurs. */
    PublicHolidays,
    /** Permission to read or view the document. */
    ReadPermission,
    /** Real-wheel drive is a transmission layout where the engine drives the rear wheels. */
    RearWheelDriveConfiguration,
    /** Indicates that the item is refurbished. */
    RefurbishedCondition,
    /** RemixAlbum. */
    RemixAlbum,
    /** Researchers. */
    Researcher,
    /** The status for a previously confirmed reservation that is now cancelled. */
    ReservationCancelled,
    /** The status of a confirmed reservation. */
    ReservationConfirmed,
    /** The status of a reservation on hold pending an update like credit card number or flight changes. */
    ReservationHold,
    /** The status of a reservation when a request has been sent, but not confirmed. */
    ReservationPending,
    /** The steering position is on the right side of the vehicle (viewed from the main direction of driving). */
    RightHandDriving,
    /** The invitee may or may not attend. */
    RsvpResponseMaybe,
    /** The invitee will not attend. */
    RsvpResponseNo,
    /** The invitee will attend. */
    RsvpResponseYes,
    /** The day of the week between Friday and Sunday. */
    Saturday,
    /** A seating map. */
    SeatingMap,
    /** Play mode: SinglePlayer. Which is played by a lone player. */
    SinglePlayer,
    /** SingleRelease. */
    SingleRelease,
    /** Indicates that the item has sold out. */
    SoldOut,
    /** SoundtrackAlbum. */
    SoundtrackAlbum,
    /** SpokenWordAlbum. */
    SpokenWordAlbum,
    /** StudioAlbum. */
    StudioAlbum,
    /** The day of the week between Saturday and Monday. */
    Sunday,
    /** The day of the week between Wednesday and Friday. */
    Thursday,
    /** The associated telephone number is toll free. */
    TollFree,
    /** A transit map. */
    TransitMap,
    /** The boolean value true. */
    True,
    /** The day of the week between Monday and Wednesday. */
    Tuesday,
    /** Indicates that the item is used. */
    UsedCondition,
    /** A diet exclusive of all animal products. */
    VeganDiet,
    /** A diet exclusive of animal meat. */
    VegetarianDiet,
    /** A venue map (e.g. for malls, auditoriums, museums, etc.). */
    VenueMap,
    /** VinylFormat. */
    VinylFormat,
    /** The day of the week between Tuesday and Thursday. */
    Wednesday,
    /** Permission to write or edit the document. */
    WritePermission,
    /** The airline boards by zones of the plane. */
    ZoneBoardingPolicy
};
